require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0e8c594b4c753e562b1581b671ad6261/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0e8c594b4c753e562b1581b671ad6261'] = async function fn_0e8c594b4c753e562b1581b671ad6261(userName, pageData, usedIn) {
var dash, error, userName, _unused, tutorDateMidnight, MondayThisWeek, MondayLastWeek, todayNumber, mondayTimestamp, subject, UniqueSlots, subjects, tutorDateNow, formatMondayTimestamp, DSToffSet, testTimezone, tutorDateMidnightUTC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (userName === null) || (typeof userName === 'undefined') ? ['(email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' or MS_teacher_email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\') and accountType = \'BACKENDLESS\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.region', 'timezones.long_name'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    tutorDateNow = usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    console.log(tutorDateNow);
    console.log('TODAY NUMBER');
    console.log(todayNumber);
    pageData['todayNumber'] = todayNumber;
    MondayLastWeek = ((tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber)) - 86400000 * 7;
    MondayThisWeek = (tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber);
    console.log(MondayLastWeek);
    console.log('MondayThisWeek');
    console.log(MondayThisWeek);
    if (todayNumber < 3) {
      formatMondayTimestamp = ((tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0) - 86400000 * 7;
    } else {
      formatMondayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0;
    }
    DSToffSet = (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(testTimezone, 'region')), formatMondayTimestamp)) - (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(testTimezone, 'region')), tutorDateNow));
    mondayTimestamp = (getObjectProperty(testTimezone, 'region')) == 'US' ? formatMondayTimestamp + DSToffSet * 3600000 : formatMondayTimestamp - DSToffSet * 3600000;
    console.log('Format Monday Timestamp');
    console.log(formatMondayTimestamp);
    console.log('MondayTimestamp');
    console.log(mondayTimestamp);
    pageData['mondayTimestamp'] = mondayTimestamp;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetPastCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  await new Promise(r => setTimeout(r, 3000 || 0));
  try {
    console.log('----------------------------------------------------------------------------------------------');
    console.log(typeof userName === 'undefined');
    console.log((typeof userName === 'undefined') ? ['(start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\' ',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join('') : ['(start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug like \'%MS_GROUP%\' or slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join(''));
    console.log('----------------------------------------------------------------------------------------------');
    subjects = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/calendar')).query(({ [`where`]: (typeof userName === 'undefined') ? ['(start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\' ',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join('') : ['(start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug like \'%MS_GROUP%\' or slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',tutorDateNow,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join(''),[`property`]: ['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name as weeklyStudentName', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', 'Users[calendar].tutorType', 'weekly_slots[calendar].tutor_lifetime_slots', '*'],[`sortBy`]: 'start_time ASC',[`pageSize`]: 100 })).setEncoding('utf8').send());
    console.log('check');
    console.log(subjects);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetPastCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from the calendar DB / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    dash = [];
    UniqueSlots = [];
    for (var subject_index in subjects) {
      subject = subjects[subject_index];
      if (!(UniqueSlots.includes((getObjectProperty(subject, 'calendarObjectId'))))) {
        addItemToList(dash, ({ [`startDate`]: (getObjectProperty(subject, 'startDate')),[`parentIANA`]: undefined,[`tutorIANA`]: undefined,[`rubric`]: (getObjectProperty(subject, 'rubric')),[`contact_id`]: (getObjectProperty(subject, 'contact_id')),[`parent_name`]: (getObjectProperty(subject, 'parent_name')),[`student_name`]: (getObjectProperty(subject, 'weeklyStudentName')),[`subject`]: (getObjectProperty(subject, 'subject')),[`grade`]: (getObjectProperty(subject, 'grade')),[`slots_slug`]: (getObjectProperty(subject, 'slots_slug')),[`parentTimezone`]: (getObjectProperty(subject, 'parentTimezone')),[`tutorTimezone`]: (getObjectProperty(subject, 'tutorTimezone')),[`tutor_name`]: (getObjectProperty(subject, 'tutor')),[`scheduling`]: (getObjectProperty(subject, 'scheduling')),[`homework_sent`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? true : (((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? true : (getObjectProperty(subject, 'homework_sent'))),[`calendarObjectId`]: (getObjectProperty(subject, 'calendarObjectId')),[`tutorObjectId`]: (getObjectProperty(subject, 'tutorObjectId')),[`start_time`]: (getObjectProperty(subject, 'start_time')),[`lastHmwrk`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? (usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf())) : (((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? (usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf())) : ((new Date((getObjectProperty(subject, 'lastHmwrk')))).valueOf())),[`tutorSign`]: undefined,[`tutorOffset`]: undefined,[`parentSign`]: undefined,[`parentOffset`]: undefined,[`toBePaid`]: (getObjectProperty(subject, 'toBePaid')),[`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`event_title`]: (getObjectProperty(subject, 'event_title')),[`tutor_lifetime_slots`]: (getObjectProperty(subject, 'tutor_lifetime_slots')),[`tutorType`]: (getObjectProperty(subject, 'tutorType')) }));
        addItemToList(UniqueSlots, (getObjectProperty(subject, 'calendarObjectId')));
      }
    }
    pageData['startWeek'] = mondayTimestamp;
    pageData['calendarListRaw'] = dash;
    pageData['todayNumber'] = todayNumber;
    pageData['MondayLastWeek'] = MondayLastWeek;
    pageData['MondayThisWeek'] = MondayThisWeek;
    pageData['tutorDateMidnight'] = tutorDateMidnight;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetPastCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting the data to the dash / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }

return dash
}

})
define('./functions/10260388c33823767f7a7afc680de03f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_10260388c33823767f7a7afc680de03f'] = async function fn_10260388c33823767f7a7afc680de03f(userName, pageData, usedIn) {
var msStudentContainer, error, userName, _unused, tutorDateMidnight, MondayThisWeek, MondayLastWeek, todayNumber, mondayTimestamp, MSList, StudentList, gradeBand, gradeBandPrettyName, mainTeacher, mainWeeklySlot, i, FilterObjectId, MSStudent, ObjectIdDetail, item, subjects, GetObjectId, j, tutorDateNow, DSToffSet, testTimezone, tutorDateMidnightUTC, msSessions, temp, prop, classObject, students, classDescriptionConditions, classDescriptionTextArr, student, classCondition, description, uniqueObjId, query, condtions, educatorTimestamp, localMondayTimestamp, dayOfTheWeek, educatorLocalDateMidnight, educatorTimezone, educatorUTCDateMidnight;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function do_something() {
  try {
    educatorTimezone = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setProperties(['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.long_name', '*']).setPageSize(10)))[0];
    educatorTimestamp = (getObjectProperty(pageData, 'DateToday'));
    educatorUTCDateMidnight = (new Date((((new Date((new Date(educatorTimestamp)).getTime() + (((getObjectProperty(educatorTimezone, 'offSet')) * ((getObjectProperty(educatorTimezone, 'sign')) == '-' ? 3600 * -1 : 3600)) * 1000))).toISOString()).slice(0, 10))));
    educatorLocalDateMidnight = (new Date((educatorUTCDateMidnight.valueOf()).getTime() + (((getObjectProperty(educatorTimezone, 'offSet')) * ((getObjectProperty(educatorTimezone, 'sign')) == '-' ? 3600 : 3600 * -1)) * 1000)));
    dayOfTheWeek = (new Date(educatorLocalDateMidnight).getDay()) == 0 ? 7 : (new Date(educatorLocalDateMidnight).getDay());
    localMondayTimestamp = ((educatorLocalDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - dayOfTheWeek)) - (dayOfTheWeek < 3 ? 86400000 * 7 : 0);

  } catch (error) {

  }
  try {
    condtions = [['(start_date >= ',localMondayTimestamp,' AND start_date <= ',educatorTimestamp,' AND tutor_relations.name = ',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),' AND scheduling != \'is_rescheduled\'',' AND scheduling != \'is_pushed\' ','AND (Description LIKE \'MAX%\' AND scheduling != \'is_cancelled\')',' AND scheduling != \'is_paused\'',' AND scheduling != \'is_substituted\'',' AND ','(',['(','weekly_slots[ms_calendar].student_name NOT LIKE \'%[OFFBOARDED]%\'',' AND ',['(','weekly_slots[ms_calendar].status = \'churn\' ',' OR weekly_slots[ms_calendar].status = \'enrolled\'',' OR weekly_slots[ms_calendar].status = \'deleted\'',' OR weekly_slots[ms_calendar].status = \'long pause\'',')'].join(''),')',' OR ','(','weekly_slots[ms_calendar].objectId IS NULL',')'].join(''),')'].join(''), ['(','start_date >= ',localMondayTimestamp,' AND scheduling != \'is_substituted\'',' AND weekly_slots[ms_calendar].objectId is null',')'].join(''), ['(','start_date >= ',educatorTimestamp,'AND tutor_relations.name = ',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),' AND Description != \'Parent Teacher Conference\'',')'].join('')];
    query = [condtions[0],' OR ',condtions[1],' OR ',condtions[2],' AND Description NOT LIKE \'%MS_BREAK_NOT_ATTENDING%\''].join('');
    subjects = (await Backendless.Data.of('ms_calendar').find(Backendless.DataQueryBuilder.create().setWhereClause(query).setProperties(['weekly_slots[ms_calendar].slot_slug as slotSlug', 'weekly_slots[ms_calendar].lead_id as leadID', 'weekly_slots[ms_calendar].startDate', 'weekly_slots[ms_calendar].status as studentStatus', 'weekly_slots[ms_calendar].lastHmwrk', 'weekly_slots[ms_calendar].rubric', 'weekly_slots[ms_calendar].contact_id', 'weekly_slots[ms_calendar].parent_name', 'weekly_slots[ms_calendar].student_name', 'weekly_slots[ms_calendar].subject', 'weekly_slots[ms_calendar].grade', 'weekly_slots[ms_calendar].timezone as parentTimezone', 'tutor_relations.timezone as tutorTimezone', 'tutor_relations.objectId as tutorObjectId', 'objectId as calendarObjectId', 'tutor_relations.tutorType', 'weekly_slots[ms_calendar].tutor_lifetime_slots', '*']).setSortBy('start_date ASC').setPageSize(100)));

  } catch (error) {

  }
  try {
    uniqueObjId = [];
    var j_list = (subjects.map(item => item['calendarObjectId']));
    for (var j_index2 in j_list) {
      j = j_list[j_index2];
      if (!(uniqueObjId.includes(j))) {
        addItemToList(uniqueObjId, j);
      }
    }
    msSessions = [];
    for (var j_index3 in uniqueObjId) {
      j = uniqueObjId[j_index3];
      students = [];
      classObject = null;
      for (var student_index in subjects) {
        student = subjects[student_index];
        if ((getObjectProperty(student, 'calendarObjectId')) == j) {
          if (classObject === null) {
            classObject = student;
          }
          description = (getObjectProperty(student, 'Description'));
          classCondition = [(description.indexOf('-MICROSCHOOL-') !== -1), (description.indexOf('-MS_GROUP-') !== -1), (description.indexOf('-MS_ELECTIVE-') !== -1), (description.indexOf('Parent Teacher Conference') !== -1)];
          if (classCondition.includes(true)) {
            addItemToList(students, ({ [`student_name`]: (getObjectProperty(student, 'student_name')),[`lead_id`]: (getObjectProperty(student, 'lead_id')),[`leadID`]: (getObjectProperty(student, 'leadID')),[`slotSlug`]: (getObjectProperty(student, 'slotSlug')),[`parent_name`]: (getObjectProperty(student, 'parent_name')),[`grade`]: (getObjectProperty(student, 'grade')),[`subject`]: (getObjectProperty(student, 'subject')) }));
          }
        }
      }
      gradeBandPrettyName = '';
      mainTeacher = '';
      classDescriptionTextArr = (getObjectProperty(classObject, 'Description')).split('-');
      if ((classDescriptionTextArr.includes('COTEACHING')) && !!students.length) {
        mainWeeklySlot = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty((students[0]), 'leadID')),'\' and tutor != \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and assistant_teacher=\'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and student_name=\'',(getObjectProperty((students[0]), 'student_name')),'\' and status !=\'deleted\' and (slot_slug like \'%',String(classDescriptionTextArr[0]) + String(((getObjectProperty(classObject, 'Description')).indexOf('MAX1-') !== -1) ? '%\')' : ['-',classDescriptionTextArr[1],'%\' and slot_slug like \'%',classDescriptionTextArr[3],'-',classDescriptionTextArr[4],'%\')'].join(''))].join(''))).setPageSize(1)))[0];
        if (mainWeeklySlot !== null && !Array.isArray(mainWeeklySlot) && (typeof mainWeeklySlot === 'object')) {
          gradeBand = !(typeof (getObjectProperty(mainWeeklySlot, 'subject')) === 'undefined') ? ((((getObjectProperty(mainWeeklySlot, 'subject')).toLowerCase()).indexOf('ms') !== -1) ? subsequenceFromStartLast((getObjectProperty(mainWeeklySlot, 'subject')), 2) : (getObjectProperty(mainWeeklySlot, 'subject'))).split('_') : [];
          var i_end2 = gradeBand.length;
          var i_inc2 = 1;
          if (1 > i_end2) {
            i_inc2 = -i_inc2;
          }
          for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
            if ((gradeBand[(i - 1)].toLowerCase()).indexOf('summerschool') !== -1) {
              gradeBandPrettyName = String(gradeBandPrettyName) + String('Summer ');
            } else {
              gradeBandPrettyName = String(gradeBandPrettyName) + String(String(gradeBand[(i - 1)]) + String(' '));
            }
          }
          gradeBandPrettyName = String(gradeBandPrettyName) + String('School');
          mainTeacher = (getObjectProperty(mainWeeklySlot, 'tutor'));
        }
      }
      classDescriptionConditions = [({ [`condition`]: classDescriptionTextArr[1] == 'MICROSCHOOL',[`skip`]: (getObjectProperty(classObject, 'scheduling')) == 'is_cancelled' && (getObjectProperty(classObject, 'tutor')) != (getObjectProperty(pageData, 'userName')),[`data`]: ({ [`mainTeacher`]: mainTeacher,[`gradeBand`]: gradeBandPrettyName,[`subject`]: classDescriptionTextArr[2],[`grade`]: classDescriptionTextArr[1] }) }), ({ [`condition`]: classDescriptionTextArr[1] == 'MS_GROUP' || classDescriptionTextArr[1] == 'MS_ELECTIVE',[`skip`]: (getObjectProperty(classObject, 'scheduling')) == 'is_cancelled',[`data`]: ({ [`subject`]: classDescriptionTextArr[2],[`grade`]: classDescriptionTextArr[1] }) }), ({ [`condition`]: true,[`skip`]: false,[`data`]: ({ [`subject`]: ((getObjectProperty(MSList, 'Description')).indexOf('School Closed') !== -1) ? null : (((getObjectProperty(MSList, 'tutor')).indexOf('All Teachers') !== -1) ? (getObjectProperty(MSList, 'tutor')).toUpperCase() : null) }) })];
      for (var item_index in classDescriptionConditions) {
        item = classDescriptionConditions[item_index];
        if (getObjectProperty(item, 'condition')) {
          if (getObjectProperty(item, 'skip')) {
            break;
          }
          temp = ({ [`student_list`]: students,[`start_time`]: (getObjectProperty(classObject, 'start_date')),[`slots_slug`]: (getObjectProperty(classObject, 'Description')),[`scheduling`]: (getObjectProperty(classObject, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(classObject, 'objectId')),[`toBePaid`]: (getObjectProperty(classObject, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(classObject, 'status')),[`tutorObjectId`]: (getObjectProperty(classObject, 'tutorObjectId')),[`duration`]: (getObjectProperty(classObject, 'duration')),[`tutor`]: (getObjectProperty(classObject, 'tutor')),[`event_title`]: (getObjectProperty(classObject, 'event_title')),[`toBePaidList`]: !((getObjectProperty(classObject, 'toBePaidList')) === null) ? (getObjectProperty(classObject, 'toBePaidList')) : [] });
          var prop_list = (Object.keys(item));
          for (var prop_index in prop_list) {
            prop = prop_list[prop_index];
            temp[prop] = (getObjectProperty((getObjectProperty(item, 'data')), prop));
          }
          addItemToList(msSessions, temp);
          break;
        }
      }
    }
    return msSessions;

  } catch (error) {
    console.log(error);

  }
}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (userName === null) || (typeof userName === 'undefined') ? ['(MS_teacher_email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' or email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\') and accountType = \'BACKENDLESS\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.long_name', '*'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    tutorDateNow = usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    console.log(tutorDateNow);
    console.log('TODAY NUMBER');
    console.log(todayNumber);
    pageData['todayNumber'] = todayNumber;
    MondayLastWeek = ((tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber)) - 86400000 * 7;
    MondayThisWeek = (tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber);
    console.log(MondayLastWeek);
    console.log('MondayThisWeek');
    console.log(MondayThisWeek);
    console.log(tutorDateMidnight);
    if (todayNumber < 3) {
      mondayTimestamp = ((tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0) - 86400000 * 7;
    } else {
      mondayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0;
    }
    console.log('MondayTimestamp');
    console.log(mondayTimestamp);
    pageData['msMondayTimestamp'] = mondayTimestamp;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetMSCalendar_v2 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  console.log('Get ms calendar data');
  try {
    console.log(['(start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',mondayTimestamp,' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and Description != \'Parent Teacher Conference\'',')'].join(''));
    subjects = (await asyncListFilter((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar/find')).setEncoding('utf8').send(({ [`where`]: ['Description not like \'%MS_BREAK_NOT_ATTENDING%\' and (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),String('\' and scheduling != \'is_rescheduled\'') + String(''),' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),String('\' and Description != \'Parent Teacher Conference\'') + String(''),')'].join(''),[`property`]: ['weekly_slots[ms_calendar].slot_slug as slotSlug', 'weekly_slots[ms_calendar].lead_id as leadID', 'weekly_slots[ms_calendar].startDate', 'weekly_slots[ms_calendar].status as studentStatus', 'weekly_slots[ms_calendar].lastHmwrk', 'weekly_slots[ms_calendar].rubric', 'weekly_slots[ms_calendar].contact_id', 'weekly_slots[ms_calendar].parent_name', 'weekly_slots[ms_calendar].student_name', 'weekly_slots[ms_calendar].subject', 'weekly_slots[ms_calendar].grade', 'weekly_slots[ms_calendar].timezone as parentTimezone', 'tutor_relations.timezone as tutorTimezone', 'tutor_relations.objectId as tutorObjectId', 'objectId as calendarObjectId', 'tutor_relations.tutorType', 'weekly_slots[ms_calendar].tutor_lifetime_slots', '*'],[`sortBy`]: 'start_date ASC',[`pageSize`]: 100 }))), async (item) => {


     return (!((getObjectProperty(item, 'Description')).indexOf('MS_BREAK_NOT_ATTENDING') !== -1));
    }));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw2 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from the calendar DB / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    console.log('ms_calendar');
    console.log(subjects);
    GetObjectId = [];
    for (var j_index in subjects) {
      j = subjects[j_index];
      if (!(GetObjectId.includes((getObjectProperty(j, 'calendarObjectId'))))) {
        addItemToList(GetObjectId, (getObjectProperty(j, 'calendarObjectId')));
      }
    }
    msStudentContainer = [];
    for (var ObjectIdDetail_index in GetObjectId) {
      ObjectIdDetail = GetObjectId[ObjectIdDetail_index];
      FilterObjectId = (await asyncListFilter(subjects, async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == ObjectIdDetail);
      }));
      StudentList = [];
      for (var MSStudent_index in FilterObjectId) {
        MSStudent = FilterObjectId[MSStudent_index];
        if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MICROSCHOOL-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`slotSlug`]: (getObjectProperty(MSStudent, 'slotSlug')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_GROUP-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_ELECTIVE-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')) == 'Parent Teacher Conference') {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        }
      }
      MSList = FilterObjectId[0];
      gradeBandPrettyName = '';
      mainTeacher = '';
      if ((getObjectProperty(MSList, 'Description')).split('-')[2] == 'COTEACHING' || ((getObjectProperty(MSList, 'Description')).indexOf('COTEACHING') !== -1)) {
        if (!(typeof (StudentList[0]) === 'undefined')) {
          console.log(['lead_id=\'',(getObjectProperty((StudentList[0]), 'leadID')),'\' and tutor != \'',userName,'\' and assistant_teacher=\'',userName,'\' and student_name=\'',(getObjectProperty((StudentList[0]), 'student_name')),'\' and status !=\'deleted\' and (slot_slug like \'%',((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? (getObjectProperty(MSList, 'Description')).split('-')[0] : [(getObjectProperty(MSList, 'Description')).split('-')[0],'-',(getObjectProperty(MSList, 'Description')).split('-')[1]].join(''),((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? '%\')' : ['%\' and slot_slug like \'%',(getObjectProperty(MSList, 'Description')).split('-')[3],'-',(getObjectProperty(MSList, 'Description')).split('-')[4],'%\')'].join('')].join(''));
          mainWeeklySlot = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty((StudentList[0]), 'leadID')),'\' and tutor != \'',userName,'\' and assistant_teacher=\'',userName,'\' and student_name=\'',(getObjectProperty((StudentList[0]), 'student_name')),'\' and status !=\'deleted\' and (slot_slug like \'%',((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? (getObjectProperty(MSList, 'Description')).split('-')[0] : [(getObjectProperty(MSList, 'Description')).split('-')[0],'-',(getObjectProperty(MSList, 'Description')).split('-')[1]].join(''),((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? '%\')' : ['%\' and slot_slug like \'%',(getObjectProperty(MSList, 'Description')).split('-')[3],'-',(getObjectProperty(MSList, 'Description')).split('-')[4],'%\')'].join('')].join(''))).setPageSize(1)))[0];
          if (mainWeeklySlot !== null && !Array.isArray(mainWeeklySlot) && (typeof mainWeeklySlot === 'object')) {
            gradeBand = !(typeof (getObjectProperty(mainWeeklySlot, 'subject')) === 'undefined') && !(typeof (getObjectProperty(mainWeeklySlot, 'subject')) === 'undefined') ? ((((getObjectProperty(mainWeeklySlot, 'subject')).toLowerCase()).indexOf('ms') !== -1) ? subsequenceFromStartLast((getObjectProperty(mainWeeklySlot, 'subject')), 2) : (getObjectProperty(mainWeeklySlot, 'subject'))).split('_') : [];
            var i_end = gradeBand.length;
            var i_inc = 1;
            if (1 > i_end) {
              i_inc = -i_inc;
            }
            for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
              if ((gradeBand[(i - 1)].toLowerCase()).indexOf('summerschool') !== -1) {
                gradeBandPrettyName = String(gradeBandPrettyName) + String('Summer ');
              } else {
                gradeBandPrettyName = String(gradeBandPrettyName) + String(String(gradeBand[(i - 1)]) + String(' '));
              }
            }
            gradeBandPrettyName = String(gradeBandPrettyName) + String('School');
            mainTeacher = (getObjectProperty(mainWeeklySlot, 'tutor'));
          }
        }
      }
      if ((getObjectProperty(MSList, 'Description')).split('-')[1] == 'MICROSCHOOL') {
        if ((getObjectProperty(MSList, 'scheduling')) == 'is_cancelled') {
          continue;
        }
        if ((getObjectProperty(MSList, 'tutor')) != userName) {
          continue;
        }
        addItemToList(msStudentContainer, ({ [`mainTeacher`]: mainTeacher,[`student_list`]: StudentList,[`gradeBand`]: gradeBandPrettyName,[`subject`]: (getObjectProperty(MSList, 'Description')).split('-')[2],[`grade`]: (getObjectProperty(MSList, 'Description')).split('-')[1],[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      } else if ((getObjectProperty(MSList, 'Description')).split('-')[1] == 'MS_GROUP' || (getObjectProperty(MSList, 'Description')).split('-')[1] == 'MS_ELECTIVE') {
        if ((getObjectProperty(MSList, 'scheduling')) == 'is_cancelled') {
          continue;
        }
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: (getObjectProperty(MSList, 'Description')).split('-')[2],[`gradeBand`]: undefined,[`grade`]: (getObjectProperty(MSList, 'Description')).split('-')[1],[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      } else {
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: ((getObjectProperty(MSList, 'Description')).indexOf('School Closed') !== -1) ? null : (((getObjectProperty(MSList, 'tutor')).indexOf('All Teachers') !== -1) ? (getObjectProperty(MSList, 'tutor')).toUpperCase() : null),[`grade`]: undefined,[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      }
    }
    pageData['startWeek2'] = mondayTimestamp;
    pageData['msStudentContainer'] = msStudentContainer;
    pageData['todayNumber'] = todayNumber;
    pageData['MondayLastWeek'] = MondayLastWeek;
    pageData['MondayThisWeek'] = MondayThisWeek;
    pageData['tutorDateMidnight'] = tutorDateMidnight;

  } catch (error) {
    console.log(error);

  }

return msStudentContainer
}

})
define('./functions/163ad5c1239eb27a61ad4b15e1ea1022/code.js', () => { 

BackendlessUI.Functions.Custom['fn_163ad5c1239eb27a61ad4b15e1ea1022'] = async function fn_163ad5c1239eb27a61ad4b15e1ea1022(userName, pageData, usedIn) {
var msStudentContainer, error, userName, _unused, MSList, StudentList, FilterObjectId, MSStudent, ObjectIdDetail, item, subjects, GetObjectId, j, sundayTimestamp, tutorDateNow, mondayTimestamp, DSToffSet, todayNumber, tutorDateMidnight, testTimezone, MondayThisWeek, MondayLastWeek, tutorDateMidnightUTC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (userName === null) || (typeof userName === 'undefined') ? ['(MS_teacher_email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' or email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\') and accountType = \'BACKENDLESS\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.long_name', '*'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    tutorDateNow = usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    console.log(tutorDateNow);
    console.log('TODAY NUMBER');
    console.log(todayNumber);
    pageData['todayNumber'] = todayNumber;
    MondayLastWeek = ((tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber)) - 86400000 * 7;
    MondayThisWeek = (tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber);
    console.log(MondayLastWeek);
    console.log('MondayThisWeek');
    console.log(MondayThisWeek);
    console.log(tutorDateMidnight);
    if (todayNumber < 3) {
      mondayTimestamp = ((tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0) - 86400000 * 7;
    } else {
      mondayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0;
    }
    if (todayNumber < 3) {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 7;
    } else {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 14;
    }
    console.log('MondayTimestamp');
    console.log(mondayTimestamp);
    pageData['msMondayTimestamp'] = mondayTimestamp;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureMSCalendar / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    console.log(['(start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and Description != \'Parent Teacher Conference\'',')'].join(''));
    subjects = (await asyncListFilter((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar/find')).setEncoding('utf8').send(({ [`where`]: ['(start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and Description != \'Parent Teacher Conference\'',')'].join(''),[`property`]: ['weekly_slots[ms_calendar].lead_id', 'weekly_slots[ms_calendar].startDate', 'weekly_slots[ms_calendar].status as studentStatus', 'weekly_slots[ms_calendar].lastHmwrk', 'weekly_slots[ms_calendar].rubric', 'weekly_slots[ms_calendar].contact_id', 'weekly_slots[ms_calendar].parent_name', 'weekly_slots[ms_calendar].student_name', 'weekly_slots[ms_calendar].subject', 'weekly_slots[ms_calendar].grade', 'weekly_slots[ms_calendar].timezone as parentTimezone', 'tutor_relations.timezone as tutorTimezone', 'tutor_relations.objectId as tutorObjectId', 'objectId as calendarObjectId', 'tutor_relations.tutorType', 'weekly_slots[ms_calendar].tutor_lifetime_slots', '*'],[`sortBy`]: 'start_date ASC',[`pageSize`]: 100 }))), async (item) => {


     return (!((getObjectProperty(item, 'Description')).indexOf('MS_BREAK_NOT_ATTENDING') !== -1));
    }));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureMSCalendar / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from the ms_calendar DB / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    console.log('ms_calendar');
    console.log(subjects);
    GetObjectId = [];
    for (var j_index in subjects) {
      j = subjects[j_index];
      if (!(GetObjectId.includes((getObjectProperty(j, 'calendarObjectId'))))) {
        addItemToList(GetObjectId, (getObjectProperty(j, 'calendarObjectId')));
      }
    }
    msStudentContainer = [];
    for (var ObjectIdDetail_index in GetObjectId) {
      ObjectIdDetail = GetObjectId[ObjectIdDetail_index];
      FilterObjectId = (await asyncListFilter(subjects, async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == ObjectIdDetail);
      }));
      StudentList = [];
      for (var MSStudent_index in FilterObjectId) {
        MSStudent = FilterObjectId[MSStudent_index];
        if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MICROSCHOOL-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_GROUP-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_ELECTIVE-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')) == 'Parent Teacher Conference') {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')) }));
        }
      }
      MSList = FilterObjectId[0];
      if ((getObjectProperty(MSList, 'Description')).split('-')[1] == 'MICROSCHOOL') {
        if ((getObjectProperty(MSList, 'scheduling')) == 'is_cancelled') {
          continue;
        }
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: (getObjectProperty(MSList, 'Description')).split('-')[2],[`grade`]: (getObjectProperty(MSList, 'Description')).split('-')[1],[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      } else if ((getObjectProperty(MSList, 'Description')).split('-')[1] == 'MS_GROUP' || (getObjectProperty(MSList, 'Description')).split('-')[1] == 'MS_ELECTIVE') {
        if ((getObjectProperty(MSList, 'scheduling')) == 'is_cancelled') {
          continue;
        }
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: (getObjectProperty(MSList, 'Description')).split('-')[2],[`grade`]: (getObjectProperty(MSList, 'Description')).split('-')[1],[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      } else {
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: undefined,[`grade`]: undefined,[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      }
    }
    pageData['msFutureStudentContainer'] = msStudentContainer;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureMSCalendar / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting the data to the dash / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }

return msStudentContainer
}

})
define('./functions/184994440a04f7b16266320a3805a58f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'] = async function fn_184994440a04f7b16266320a3805a58f(methodName, logMessage, error) {
var errorObject, logger_name, slack;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  logger_name = methodName;
  Backendless.Logging.getLogger(logger_name).info(logMessage);
  slack = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/frontendCatchWithError`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'channelID': 'C02178TDDA7','channelMessage': (['Error encountered during the process.','\n','Method: ',logger_name,'\n','Message: ',logMessage,'\n','Error: ',(JSON.stringify((getObjectProperty(error, 'message'))))].join('')),'chatbotName': 'Backendless Error','bot_icon': ':x:' }));
  errorObject = (await Backendless.Data.of('errors').save( ({ [`message`]: (JSON.stringify((getObjectProperty(error, 'message')))),[`code`]: (JSON.stringify((getObjectProperty(error, 'code')))),[`channel`]: 'WARN',[`checked`]: false,[`time`]: (new Date()),[`method`]: methodName,[`data`]: error }) ));

return errorObject
}

})
define('./functions/1f22b9b531d33432a3832ab3b6a61ecc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc'] = async function fn_1f22b9b531d33432a3832ab3b6a61ecc(Rawlist, PageData) {
var studentContainer, error, item, tutorTimezone, FilterTimezone, Timezones, parentTimezone;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    Timezones = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/timezones')).query(({ [`groupBy`]: 'long_name',[`pageSize`]: 100 })).setEncoding('utf8').send());
    studentContainer = (await asyncListFilter(Rawlist, async (item) => {
       if ((getObjectProperty(item, 'parentTimezone')) != null) {
        parentTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


         return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'parentTimezone')));
        }))[0];
        item['parentIANA'] = (getObjectProperty(parentTimezone, 'iana'));
        item['parentSign'] = (getObjectProperty(parentTimezone, 'sign'));
        item['parentOffset'] = (getObjectProperty(parentTimezone, 'offSet'));
      }
      if ((getObjectProperty(item, 'tutorTimezone')) != null) {
        tutorTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


         return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'tutorTimezone')));
        }))[0];
        item['tutorIANA'] = (getObjectProperty(tutorTimezone, 'iana'));
        item['tutorSign'] = (getObjectProperty(tutorTimezone, 'sign'));
        item['tutorOffset'] = (getObjectProperty(tutorTimezone, 'offSet'));
      }
      item['messageRowClick'] = false;


     return (((getObjectProperty(item, 'slots_slug')) == 'Manual time' || (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf())) && ((getObjectProperty(item, 'scheduling')) == 'scheduled' || (getObjectProperty(item, 'scheduling')) == 'being_rescheduled'));
    }));
    console.log('Student Container');
    console.log(studentContainer);

  } catch (error) {
    console.log(error);

  }

return studentContainer
}

})
define('./functions/20be5f297d6e7011d3eb8aacdd98716c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_20be5f297d6e7011d3eb8aacdd98716c'] = function fn_20be5f297d6e7011d3eb8aacdd98716c(subject) {
var subject;


  subject = subject;
  if (subject == 'MS_Middle'.toUpperCase()) {
    subject = 'Microschool Middle';
  } else if (subject == 'MS_Elementary'.toUpperCase()) {
    subject = 'Microschool Elementary';
  } else if (subject == 'MS_Lower_Elem'.toUpperCase()) {
    subject = 'Microschool Lower Elementary';
  } else if (subject == 'MS_Upper_Elem'.toUpperCase()) {
    subject = 'Microschool Upper Elementary';
  } else if (subject == 'MS_High'.toUpperCase()) {
    subject = 'Microschool High';
  } else if (subject == 'MS_Elementary_Light'.toUpperCase()) {
    subject = 'Microschool Elementary';
  } else if (subject == 'MS_High_Light'.toUpperCase()) {
    subject = 'Microschool High';
  } else if (subject == 'MS_Lower_Elem_Light'.toUpperCase()) {
    subject = 'Microschool Lower Elementary';
  } else if (subject == 'MS_Middle_Light'.toUpperCase()) {
    subject = 'Microschool Middle';
  } else if (subject == 'MS_Upper_Elem_Light'.toUpperCase()) {
    subject = 'Microschool Upper Elementary';
  } else if (subject == 'MS_ESE_Elementary'.toUpperCase()) {
    subject = 'Microschool Elementary (ESE)';
  } else if (subject == 'MS_ESE_Middle-High'.toUpperCase() || subject == 'MS_ESE_Middle_High'.toUpperCase()) {
    subject = 'Microschool Middle-High (ESE)';
  } else if (subject == 'MS_Summerschool_ESE_Elementary'.toUpperCase()) {
    subject = 'Summerschool Elementary (ESE)';
  } else if (subject == 'MS_Summerschool_ESE_Middle-High'.toUpperCase() || subject == 'MS_Summerschool_ESE_Middle_High'.toUpperCase()) {
    subject = 'Summerschool Middle-High (ESE)';
  } else if (subject == 'MS_SummerSchool_Middle'.toUpperCase()) {
    subject = 'Summerschool Middle';
  } else if (subject == 'MS_SummerSchool_Upper_Elem'.toUpperCase()) {
    subject = 'Summerschool Upper Elementary';
  } else if (subject == 'MS_SummerSchool_High'.toUpperCase()) {
    subject = 'Summerschool High';
  } else if (subject == 'MS_Summerschool_Lower_Elem'.toUpperCase()) {
    subject = 'Summerschool Lower Elementary';
  } else if (subject == 'MS_Homeschool-Support_Middle-High'.toUpperCase()) {
    subject = 'Microschool Homeschool-Support Middle High';
  } else if (subject == 'MS_Junior_High'.toUpperCase()) {
    subject = 'Microschool Junior High';
  } else if (subject == 'MS_Senior_High'.toUpperCase()) {
    subject = 'Microschool Senior High';
  } else if (subject == 'MS_Lower_High'.toUpperCase()) {
    subject = 'Microschool Lower High';
  } else if (subject == 'MS_Upper_High'.toUpperCase()) {
    subject = 'Microschool Upper High';
  } else if (subject == 'MS_SummerSchool_Lower_High'.toUpperCase()) {
    subject = 'Summerschool Lower High';
  } else if (subject == 'MS_SummerSchool_Upper_High'.toUpperCase()) {
    subject = 'Summerschool Upper High';
  } else if (subject == 'MS_SummerSchool_Lower_Elem'.toUpperCase()) {
    subject = 'Summerschool Lower Elementary';
  } else if (subject == 'MS_SummerSchool_Upper_Elem'.toUpperCase()) {
    subject = 'Summerschool Upper Elementary';
  } else if (subject == 'MS_Kindergarten'.toUpperCase()) {
    subject = 'Microschool Kindergarten';
  } else {
    subject = subject;
  }

return subject
}

})
define('./functions/2995a34b4458592e95a4880af6757e2f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2995a34b4458592e95a4880af6757e2f'] = async function fn_2995a34b4458592e95a4880af6757e2f(calendarList, pageData) {
var hoursList, error, submittedHours, payableHoursFiltered, payableHours, pendingHours, item, sundayTimestamp, uniqueSlots, mondayTimestamp, TodaysDate, pendingHoursFinal, payableHoursFinal, additionalData, conditions, i, dayOfTheWeek;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function newWip() {
  try {
    payableHours = [];
    uniqueSlots = [];
    pendingHours = [];
    dayOfTheWeek = (getObjectProperty(pageData, 'dayOfTheWeek'));
    mondayTimestamp = (getObjectProperty(pageData, 'mondayTimestamp'));
    sundayTimestamp = TodaysDate >= 3 ? (getObjectProperty(pageData, 'DateToday')) : mondayTimestamp + 7 * 86400000;
    hoursList = (await asyncListFilter(calendarList, async (item) => {
       item['reportRowClick'] = false;
      item['messageRowClick'] = false;
      conditions = [(getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((21 * 86400) * 1000))).valueOf()), (getObjectProperty(item, 'start_time')) < sundayTimestamp, (getObjectProperty(item, 'scheduling')) == 'scheduled'];
      if (!(conditions.includes(false))) {
        conditions = [[(getObjectProperty(item, 'homework_sent')) == true, !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))), !(getObjectProperty(item, 'toBePaid'))], [(getObjectProperty(item, 'student_name')) == null ? null : ((getObjectProperty(item, 'student_name')).indexOf('[OFFBOARDED]') !== -1), !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))), !(getObjectProperty(item, 'toBePaid'))], [!(getObjectProperty(item, 'toBePaid')), (getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time'], [(getObjectProperty(item, 'scheduling')) == 'scheduled', !(getObjectProperty(item, 'toBePaid')), !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))]];
        var i_end = conditions.length;
        var i_inc = 1;
        if (1 > i_end) {
          i_inc = -i_inc;
        }
        for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
          if (!((conditions[(i - 1)]).includes(false))) {
            addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
            addItemToList((i == conditions.length ? pendingHours : payableHours), item);
            break;
          }
        }
      }
      conditions = [[(getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()), (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((21 * 86400) * 1000))).valueOf())], [(getObjectProperty(item, 'scheduling')) == 'scheduled', (getObjectProperty(item, 'toBePaid')), (getObjectProperty(item, 'scheduling')) == 'scheduled', !((getObjectProperty(item, 'parent_name')) === null), !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))], [(getObjectProperty(item, 'scheduling')) == 'scheduled', (getObjectProperty(item, 'toBePaid')), (getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time']];
      if (((conditions[0]).includes(false)) && (((conditions[1]).includes(false)) || ((conditions[2]).includes(false)))) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(submittedHours, item);
      }
      conditions = [(getObjectProperty(item, 'start_time')) < sundayTimestamp, (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((21 * 86400) * 1000))).valueOf()), (getObjectProperty(item, 'scheduling')) == 'scheduled', !(getObjectProperty(item, 'toBePaid')), (getObjectProperty(item, 'scheduling')) == 'scheduled', !((getObjectProperty(item, 'parent_name')) === null)];


     return (!(conditions.includes(false)));
    }));
    additionalData = ({ [`hoursList`]: hoursList,[`payableHours2`]: payableHours });
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {
       console.log(getObjectProperty(item, 'start_time'));


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'startWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
    }));
    Object.assign(additionalData, ({ [`payableHoursFiltered`]: payableHoursFiltered,[`pendingHours`]: pendingHours.length,[`submittedHours`]: submittedHours.length,[`payableHours`]: payableHoursFiltered.length }));

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('BackendGetHoursByParamV2', (JSON.stringify(({ [`message`]: 'Error when calculating educator\'s TS Hours',[`educator`]: (getObjectProperty(pageData, 'userName')),[`data`]: calendarList }))), error);

  }
  return additionalData
}


  try {
    pendingHours = [];
    payableHours = [];
    uniqueSlots = [];
    payableHoursFinal = [];
    pendingHoursFinal = [];
    submittedHours = [];
    TodaysDate = (getObjectProperty(pageData, 'todayNumber'));
    mondayTimestamp = (getObjectProperty(pageData, 'mondayTimestamp'));
    sundayTimestamp = TodaysDate >= 3 ? ((new Date()).valueOf()) : mondayTimestamp + 7 * 86400000;
    console.log('sunday timestamp ts');
    console.log(sundayTimestamp);
    hoursList = (await asyncListFilter(calendarList, async (item) => {
       item['reportRowClick'] = false;
      item['messageRowClick'] = false;
      if ((getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'start_time')) < sundayTimestamp && (getObjectProperty(item, 'scheduling')) == 'scheduled') {
        if (true && (getObjectProperty(item, 'homework_sent')) == true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || ((getObjectProperty(item, 'student_name')) == null ? null : ((getObjectProperty(item, 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || (getObjectProperty(item, 'toBePaid')) != true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(payableHours, item);
        } else if (true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) != true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))) {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(pendingHours, item);
        }
      }
      if ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && ((getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) || (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time'))) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(submittedHours, item);
      }


     return ((getObjectProperty(item, 'start_time')) < sundayTimestamp && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == false && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null));
    }));
    pageData['hoursList'] = hoursList;
    pageData['payableHours2'] = payableHours;
    console.log('today number');
    console.log(getObjectProperty(pageData, 'todayNumber'));
    console.log(payableHours);
    if ((getObjectProperty(pageData, 'todayNumber')) < 3) {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayLastWeek')) && (getObjectProperty(item, 'start_time')) < (getObjectProperty(pageData, 'MondayThisWeek')));
      }));
    } else {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayThisWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
      }));
    }
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {
       console.log(getObjectProperty(item, 'start_time'));


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'startWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
    }));
    pageData['payableHoursFiltered'] = payableHoursFiltered;
    pageData['pendingHours'] = (pendingHours.length);
    pageData['payableHours'] = (payableHoursFiltered.length);
    pageData['submittedHours'] = (submittedHours.length);

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('BackendGetHoursByParamV2', (JSON.stringify(({ [`message`]: 'Error when calculating educator\'s TS Hours',[`educator`]: (getObjectProperty(pageData, 'userName')),[`data`]: calendarList }))), error);

  }

return hoursList
}

})
define('./functions/317aadbf7629ddfe637a2cb5a97b2fb6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_317aadbf7629ddfe637a2cb5a97b2fb6'] = function fn_317aadbf7629ddfe637a2cb5a97b2fb6(teacherName) {
return 
}

})
define('./functions/34fd633c8d03816ddc83f64bf2eb921c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_34fd633c8d03816ddc83f64bf2eb921c'] = async function fn_34fd633c8d03816ddc83f64bf2eb921c(calendarList, pageData) {
var hoursList, submittedHours, payableHoursFiltered, payableHours, pendingHours, item, uniqueSlots, pendingHoursFinal, payableHoursFinal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  pendingHours = [];
  payableHours = [];
  uniqueSlots = [];
  payableHoursFinal = [];
  pendingHoursFinal = [];
  submittedHours = [];
  hoursList = (await asyncListFilter(calendarList, async (item) => {
     item['reportRowClick'] = false;
    item['messageRowClick'] = false;
    if ((getObjectProperty(item, 'start_time')) <= ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled') {
      if (true && (getObjectProperty(item, 'homework_sent')) == true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || ((getObjectProperty(item, 'student_name')) == null ? null : ((getObjectProperty(item, 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || (getObjectProperty(item, 'toBePaid')) != true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(payableHours, item);
      } else if (true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) != true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(pendingHours, item);
      } else if ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) || (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(submittedHours, item);
      }
    }


   return ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == false && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null));
  }));
  pageData['hoursList'] = hoursList;
  pageData['payableHours2'] = payableHours;
  console.log('today number');
  console.log(getObjectProperty(pageData, 'todayNumber'));
  console.log(payableHours);
  if ((getObjectProperty(pageData, 'todayNumber')) < 3) {
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayLastWeek')) && (getObjectProperty(item, 'start_time')) < (getObjectProperty(pageData, 'MondayThisWeek')));
    }));
  } else {
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayThisWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
    }));
  }
  payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


   return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'startWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
  }));
  pageData['payableHoursFiltered'] = payableHoursFiltered;
  pageData['pendingHours'] = (pendingHours.length);
  pageData['payableHours'] = (payableHoursFiltered.length);
  pageData['submittedHours'] = (submittedHours.length);

return hoursList
}

})
define('./functions/3521069f96c6b8ece43c6bd9a07ba2de/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'] = async function fn_3521069f96c6b8ece43c6bd9a07ba2de(calendarList, pageData) {
var hoursList, error, submittedHours, payableHoursFiltered, payableHours, pendingHours, item, sundayTimestamp, uniqueSlots, mondayTimestamp, TodaysDate, pendingHoursFinal, payableHoursFinal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    pendingHours = [];
    payableHours = [];
    uniqueSlots = [];
    payableHoursFinal = [];
    pendingHoursFinal = [];
    submittedHours = [];
    TodaysDate = (getObjectProperty(pageData, 'todayNumber'));
    mondayTimestamp = (getObjectProperty(pageData, 'mondayTimestamp'));
    sundayTimestamp = TodaysDate >= 3 ? ((new Date()).valueOf()) : mondayTimestamp + 7 * 86400000;
    console.log('sunday timestamp ts');
    console.log(sundayTimestamp);
    hoursList = (await asyncListFilter(calendarList, async (item) => {
       item['reportRowClick'] = false;
      item['messageRowClick'] = false;
      if ((getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'start_time')) < sundayTimestamp && (getObjectProperty(item, 'scheduling')) == 'scheduled') {
        if (true && (getObjectProperty(item, 'homework_sent')) == true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || ((getObjectProperty(item, 'student_name')) == null ? null : ((getObjectProperty(item, 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || (getObjectProperty(item, 'toBePaid')) != true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(payableHours, item);
        } else if (true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) != true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))) {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(pendingHours, item);
        }
      }
      if ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && ((getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) || (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time'))) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(submittedHours, item);
      }


     return ((getObjectProperty(item, 'start_time')) < sundayTimestamp && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == false && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null));
    }));
    pageData['hoursList'] = hoursList;
    pageData['payableHours2'] = payableHours;
    console.log('today number');
    console.log(getObjectProperty(pageData, 'todayNumber'));
    console.log(payableHours);
    if ((getObjectProperty(pageData, 'todayNumber')) < 3) {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayLastWeek')) && (getObjectProperty(item, 'start_time')) < (getObjectProperty(pageData, 'MondayThisWeek')));
      }));
    } else {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayThisWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
      }));
    }
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'startWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
    }));
    pageData['payableHoursFiltered'] = payableHoursFiltered;
    pageData['pendingHours'] = (pendingHours.length);
    pageData['payableHours'] = (payableHoursFiltered.length);
    pageData['submittedHours'] = (submittedHours.length);

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('BackendGetHoursByParamV2', (JSON.stringify(({ [`message`]: 'Error when calculating educator\'s TS Hours',[`educator`]: (getObjectProperty(pageData, 'userName')),[`data`]: calendarList }))), error);

  }

return hoursList
}

})
define('./functions/52beecb51cd79e6487216b2ea64c0022/code.js', () => { 

BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022'] = async function fn_52beecb51cd79e6487216b2ea64c0022(calendarList, pageData) {
var MessagingList, studentsToday, lateTime, item, uniqueSlots;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  studentsToday = [];
  uniqueSlots = [];
  MessagingList = [];
  if (!(typeof calendarList === 'undefined') && !(calendarList === null) && !!calendarList.length) {
    MessagingList = (await asyncListFilter(calendarList, async (item) => {
       item['reportRowClick'] = false;
      lateTime = (getObjectProperty(item, 'start_time')) + 1000 * 60 * 20;
      if (lateTime > ((new Date()).valueOf())) {
        if (!((getObjectProperty(item, 'startDate')) === null)) {
          if (((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) <= (getObjectProperty(item, 'start_time')) && ((new Date((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).getTime() + (86340 * 1000))).valueOf()) >= (getObjectProperty(item, 'start_time')) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))) {
            addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
            addItemToList(studentsToday, item);
          }
        }
      }


     return (lateTime > ((new Date()).valueOf()));
    }));
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  pageData['studentsToday'] = (studentsToday.length);
  pageData['MessageLimit'] = 1000;

return MessagingList
}

})
define('./functions/66753a955bef6fecfd1a080f3097df9d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_66753a955bef6fecfd1a080f3097df9d'] = async function fn_66753a955bef6fecfd1a080f3097df9d(calendarList, pageData) {
var hoursList, error, submittedHours, payableHoursFiltered, payableHours, pendingHours, item, sundayTimestamp, uniqueSlots, mondayTimestamp, TodaysDate, pendingHoursFinal, payableHoursFinal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    pendingHours = [];
    payableHours = [];
    uniqueSlots = [];
    payableHoursFinal = [];
    pendingHoursFinal = [];
    submittedHours = [];
    TodaysDate = (getObjectProperty(pageData, 'todayNumber'));
    mondayTimestamp = (getObjectProperty(pageData, 'mondayTimestamp'));
    sundayTimestamp = TodaysDate >= 3 ? ((new Date()).valueOf()) : mondayTimestamp + 7 * 86400000;
    console.log('sunday timestamp ts');
    console.log(sundayTimestamp);
    hoursList = (await asyncListFilter(calendarList, async (item) => {
       item['reportRowClick'] = false;
      item['messageRowClick'] = false;
      if ((getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'start_time')) < sundayTimestamp && (getObjectProperty(item, 'scheduling')) == 'scheduled') {
        if (true && (getObjectProperty(item, 'homework_sent')) == true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || ((getObjectProperty(item, 'student_name')) == null ? null : ((getObjectProperty(item, 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || (getObjectProperty(item, 'toBePaid')) != true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(payableHours, item);
        } else if (true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) != true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))) {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(pendingHours, item);
        }
      }
      if ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && ((getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) || (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time'))) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(submittedHours, item);
      }


     return ((getObjectProperty(item, 'start_time')) < sundayTimestamp && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == false && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null));
    }));
    pageData['hoursList'] = hoursList;
    pageData['payableHours2'] = payableHours;
    console.log('today number');
    console.log(getObjectProperty(pageData, 'todayNumber'));
    console.log(payableHours);
    if ((getObjectProperty(pageData, 'todayNumber')) < 3) {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayLastWeek')) && (getObjectProperty(item, 'start_time')) < (getObjectProperty(pageData, 'MondayThisWeek')));
      }));
    } else {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayThisWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
      }));
    }
    console.log(payableHoursFiltered);
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'startWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
    }));
    console.log(payableHoursFiltered);
    pageData['payableHoursFiltered'] = payableHoursFiltered;
    pageData['pendingHours'] = (pendingHours.length);
    pageData['payableHours'] = (payableHoursFiltered.length);
    pageData['submittedHours'] = (submittedHours.length);

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('BackendGetHoursByParamV2', (JSON.stringify(({ [`message`]: 'Error when calculating educator\'s TS Hours',[`educator`]: (getObjectProperty(pageData, 'userName')),[`data`]: calendarList }))), error);

  }

return hoursList
}

})
define('./functions/6e2bb70cbd6bab15b89338436752b81d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6e2bb70cbd6bab15b89338436752b81d'] = async function fn_6e2bb70cbd6bab15b89338436752b81d(pageData) {
var tutorSessions, item, tutorTimezone, FilterTimezone, Timezones, parentTimezone, studentContainer, subject, uniqueSlots, subjects, query, slotsSlugConditions, weeklySlotsStatuses, schedulingConditions, educatorTimestamp, mondayTimestampUTC, educatorTimezone, localMondayTimestamp, dayOfTheWeek, educatorLocalDateMidnight, educatorUTCDateMidnight;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    educatorTimezone = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND accountType = \'BACKENDLESS\''].join(''))).setProperties(['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.region', 'timezones.long_name', 'timezones.schedule_timezone']).setPageSize(10)))[0];
    educatorTimestamp = (getObjectProperty(pageData, 'DateToday'));
    educatorUTCDateMidnight = (new Date((((new Date((new Date(educatorTimestamp)).getTime() + (((getObjectProperty(educatorTimezone, 'offSet')) * ((getObjectProperty(educatorTimezone, 'sign')) == '-' ? 3600 * -1 : 3600)) * 1000))).toISOString()).slice(0, 10))));
    educatorLocalDateMidnight = (new Date((educatorUTCDateMidnight.valueOf()).getTime() + (((getObjectProperty(educatorTimezone, 'offSet')) * ((getObjectProperty(educatorTimezone, 'sign')) == '-' ? 3600 : 3600 * -1)) * 1000)));
    dayOfTheWeek = (new Date(educatorLocalDateMidnight).getDay()) == 0 ? 7 : (new Date(educatorLocalDateMidnight).getDay());
    localMondayTimestamp = ((educatorLocalDateMidnight.valueOf()) + 86400000 * (1 - dayOfTheWeek)) - (dayOfTheWeek < 3 ? 86400000 * 7 : 0);
    mondayTimestampUTC = ((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIConvertGMTDateExpressionsDSTByDate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'start_time': localMondayTimestamp,'timezoneOffset': (getObjectProperty(educatorTimezone, 'schedule_timezone')),'region': (getObjectProperty(educatorTimezone, 'region')) })).valueOf());

  } catch (error) {

  }
  try {
    schedulingConditions = ['scheduling != \'is_rescheduled\'',' AND scheduling != \'is_pushed\'',' AND scheduling != \'is_pause\'',' AND scheduling != \'is_substituted\''].join('');
    slotsSlugConditions = [['slots_slug LIKE \'%MS_GROUP%\'',' OR slots_slug NOT LIKE \'%-MS_%\'',' OR slots_slug LIKE \'MAX1-MICROSCHOOL%\''].join(''), String('slots_slug NOT LIKE \'%Microschool%\'') + String(' AND slots_slug NOT LIKE \'Mock%\'')];
    weeklySlotsStatuses = ['weekly_slots[calendar].status = \'churn\'',' OR weekly_slots[calendar].status = \'enrolled\'',' OR weekly_slots[calendar].status = \'deleted\'',' OR weekly_slots[calendar].status = \'long pause\''].join('');
    query = ['start_time >= ',mondayTimestampUTC,' AND start_time <= ',educatorTimestamp,' AND tutor = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND ((',schedulingConditions,' AND (','(','weekly_slots[calendar].student_name NOT LIKE \'%[OFFBOARDED]%\' ',' AND (',slotsSlugConditions[0],') AND (',weeklySlotsStatuses,'))',' OR',' (','weekly_slots[calendar].objectId IS NULL',' AND (',slotsSlugConditions[1],'))','))',' OR',' (slots_slug LIKE \'Mock%\'','  AND Users[calendar].name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\'))'].join('');
    subjects = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause(query).setProperties(['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name as weeklyStudentName', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', 'Users[calendar].tutorType', 'weekly_slots[calendar].tutor_lifetime_slots', '*']).setSortBy('start_time ASC').setPageSize(100)));

  } catch (error) {

  }
  try {
    tutorSessions = [];
    uniqueSlots = [];
    for (var subject_index in subjects) {
      subject = subjects[subject_index];
      if (!(uniqueSlots.includes((getObjectProperty(subject, 'calendarObjectId'))))) {
        addItemToList(tutorSessions, ({ [`startDate`]: (getObjectProperty(subject, 'startDate')),[`parentIANA`]: undefined,[`tutorIANA`]: undefined,[`rubric`]: (getObjectProperty(subject, 'rubric')),[`contact_id`]: (getObjectProperty(subject, 'contact_id')),[`parent_name`]: (getObjectProperty(subject, 'parent_name')),[`student_name`]: (getObjectProperty(subject, 'weeklyStudentName')),[`subject`]: (getObjectProperty(subject, 'subject')),[`grade`]: (getObjectProperty(subject, 'grade')),[`slots_slug`]: (getObjectProperty(subject, 'slots_slug')),[`parentTimezone`]: (getObjectProperty(subject, 'parentTimezone')),[`tutorTimezone`]: (getObjectProperty(subject, 'tutorTimezone')),[`tutor_name`]: (getObjectProperty(subject, 'tutor')),[`scheduling`]: (getObjectProperty(subject, 'scheduling')),[`homework_sent`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? true : (((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? true : (getObjectProperty(subject, 'homework_sent'))),[`calendarObjectId`]: (getObjectProperty(subject, 'calendarObjectId')),[`tutorObjectId`]: (getObjectProperty(subject, 'tutorObjectId')),[`start_time`]: (getObjectProperty(subject, 'start_time')),[`lastHmwrk`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) || ((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? (getObjectProperty(pageData, 'DateToday')) : ((new Date((getObjectProperty(subject, 'lastHmwrk')))).valueOf()),[`tutorSign`]: undefined,[`tutorOffset`]: undefined,[`parentSign`]: undefined,[`parentOffset`]: undefined,[`toBePaid`]: (getObjectProperty(subject, 'toBePaid')),[`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`event_title`]: (getObjectProperty(subject, 'event_title')),[`tutor_lifetime_slots`]: (getObjectProperty(subject, 'tutor_lifetime_slots')),[`tutorType`]: (getObjectProperty(subject, 'tutorType')) }));
        addItemToList(uniqueSlots, (getObjectProperty(subject, 'calendarObjectId')));
      }
    }

  } catch (error) {

  }
  try {
    Timezones = (await Backendless.Data.of('timezones').find(Backendless.DataQueryBuilder.create().setGroupBy('long_name').setPageSize(100)));
    studentContainer = (await asyncListFilter(tutorSessions, async (item) => {
       if ((getObjectProperty(item, 'parentTimezone')) != null) {
        parentTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


         return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'parentTimezone')));
        }))[0];
        item['parentIANA'] = (getObjectProperty(parentTimezone, 'iana'));
        item['parentSign'] = (getObjectProperty(parentTimezone, 'sign'));
        item['parentOffset'] = (getObjectProperty(parentTimezone, 'offSet'));
      }
      if ((getObjectProperty(item, 'tutorTimezone')) != null) {
        tutorTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


         return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'tutorTimezone')));
        }))[0];
        item['tutorIANA'] = (getObjectProperty(tutorTimezone, 'iana'));
        item['tutorSign'] = (getObjectProperty(tutorTimezone, 'sign'));
        item['tutorOffset'] = (getObjectProperty(tutorTimezone, 'offSet'));
      }
      item['messageRowClick'] = false;


     return (((getObjectProperty(item, 'slots_slug')) == 'Manual time' || (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf())) && ((getObjectProperty(item, 'scheduling')) == 'scheduled' || (getObjectProperty(item, 'scheduling')) == 'being_rescheduled'));
    }));

  } catch (error) {

  }

return tutorSessions
}

})
define('./functions/6e487819038b2948335e94670a593146/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6e487819038b2948335e94670a593146'] = async function fn_6e487819038b2948335e94670a593146(userName, pageData, usedIn) {
var mondayTimestamp, todayNumber, msStudentContainer, error, userName, _unused, MSList, StudentList, SchoolSubject, FilterObjectId, MSStudent, ObjectIdDetail, item, subjects, GetObjectId, j, LoggerName, sundayTimestamp, tutorDateNow, DSToffSet, tutorDateMidnight, testTimezone, MondayThisWeek, MondayLastWeek, tutorDateMidnightUTC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    LoggerName = 'BackendGetFutureMSCalendar_v2';
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    Backendless.Logging.getLogger(LoggerName).info('Getting Tutor Timezone - In progress');
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (userName === null) || (typeof userName === 'undefined') ? ['(MS_teacher_email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' or email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\') and accountType = \'BACKENDLESS\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.long_name', '*'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    Backendless.Logging.getLogger(LoggerName).info('Getting Tutor Timezone - Done');
    tutorDateNow = usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf());
    Backendless.Logging.getLogger(LoggerName).info('Converting Date Now - In progress');
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    Backendless.Logging.getLogger(LoggerName).info('Converting Date Now - Done');
    console.log(tutorDateNow);
    console.log('TODAY NUMBER');
    console.log(todayNumber);
    Backendless.Logging.getLogger(LoggerName).info('Getting relevant timestamps - In progress');
    MondayLastWeek = ((tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber)) - 86400000 * 7;
    MondayThisWeek = (tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber);
    console.log(MondayLastWeek);
    console.log('MondayThisWeek');
    console.log(MondayThisWeek);
    console.log(tutorDateMidnight);
    if (todayNumber < 3) {
      mondayTimestamp = ((tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0) - 86400000 * 7;
    } else {
      mondayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0;
    }
    if (todayNumber < 3) {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 7;
    } else {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 14;
    }
    console.log('MondayTimestamp');
    console.log(mondayTimestamp);
    Backendless.Logging.getLogger(LoggerName).info('Getting relevant timestamps - Done');

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureMSCalendar / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    Backendless.Logging.getLogger(LoggerName).info('Getting sessions from the DB - In progress');
    console.log(['(start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and Description != \'Parent Teacher Conference\'',')'].join(''));
    subjects = (await asyncListFilter((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar/find')).setEncoding('utf8').send(({ [`where`]: ['(start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',tutorDateNow - 1800000,' and start_date <= ',sundayTimestamp,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and Description != \'Parent Teacher Conference\'',')'].join(''),[`property`]: ['weekly_slots[ms_calendar].lead_id', 'weekly_slots[ms_calendar].startDate', 'weekly_slots[ms_calendar].status as studentStatus', 'weekly_slots[ms_calendar].lastHmwrk', 'weekly_slots[ms_calendar].rubric', 'weekly_slots[ms_calendar].contact_id', 'weekly_slots[ms_calendar].parent_name', 'weekly_slots[ms_calendar].student_name', 'weekly_slots[ms_calendar].subject', 'weekly_slots[ms_calendar].grade', 'weekly_slots[ms_calendar].timezone as parentTimezone', 'tutor_relations.timezone as tutorTimezone', 'tutor_relations.objectId as tutorObjectId', 'objectId as calendarObjectId', 'tutor_relations.tutorType', 'weekly_slots[ms_calendar].tutor_lifetime_slots', '*'],[`sortBy`]: 'start_date ASC',[`pageSize`]: 100 }))), async (item) => {


     return (!((getObjectProperty(item, 'Description')).indexOf('MS_BREAK_NOT_ATTENDING') !== -1));
    }));
    Backendless.Logging.getLogger(LoggerName).info('Getting sessions from the DB - Done');

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureMSCalendar / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from the ms_calendar DB / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    console.log('ms_calendar');
    console.log(subjects);
    GetObjectId = [];
    for (var j_index in subjects) {
      j = subjects[j_index];
      if (!(GetObjectId.includes((getObjectProperty(j, 'calendarObjectId'))))) {
        addItemToList(GetObjectId, (getObjectProperty(j, 'calendarObjectId')));
      }
    }
    msStudentContainer = [];
    for (var ObjectIdDetail_index in GetObjectId) {
      ObjectIdDetail = GetObjectId[ObjectIdDetail_index];
      FilterObjectId = (await asyncListFilter(subjects, async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == ObjectIdDetail);
      }));
      StudentList = [];
      for (var MSStudent_index in FilterObjectId) {
        MSStudent = FilterObjectId[MSStudent_index];
        if (((getObjectProperty(MSStudent, 'Description')).indexOf('-MICROSCHOOL-') !== -1) || ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_GROUP-') !== -1) || ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_ELECTIVE-') !== -1) || (getObjectProperty(MSStudent, 'Description')) == 'Parent Teacher Conference') {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')) }));
        }
      }
      MSList = FilterObjectId[0];
      SchoolSubject = (getObjectProperty(MSList, 'Description')).split('-')[1];
      if (SchoolSubject == 'MICROSCHOOL' || SchoolSubject == 'MS_GROUP' || SchoolSubject == 'MS_ELECTIVE') {
        if ((getObjectProperty(MSList, 'scheduling')) != 'is_cancelled') {
          addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: (getObjectProperty(MSList, 'Description')).split('-')[2],[`grade`]: (getObjectProperty(MSList, 'Description')).split('-')[1],[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
        }
      } else {
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: undefined,[`grade`]: undefined,[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      }
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureMSCalendar / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting the data to the dash / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }

return ({ [`studentContainer`]: msStudentContainer,[`todayNumber`]: todayNumber,[`mondayTimestamp`]: mondayTimestamp })
}

})
define('./functions/7fe619c987b8390c2af590e97037475a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a'] = async function fn_7fe619c987b8390c2af590e97037475a(calendarList, pageData) {
var hoursList, error, GetExtraHours, GetSubmittedHours, submittedHours, GetPayableHoursTest, GetPayableHours, payableHours, j, item, extraHours, payableHoursFiltered, uniqueSlots, sundayTimestamp, mondayTimestamp, TodaysDate, pendingHoursFinal, payableHoursFinal, pendingHours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    pendingHours = [];
    payableHours = [];
    uniqueSlots = [];
    payableHoursFinal = [];
    pendingHoursFinal = [];
    submittedHours = [];
    extraHours = [];
    TodaysDate = (getObjectProperty(pageData, 'todayNumber'));
    mondayTimestamp = (getObjectProperty(pageData, 'msMondayTimestamp'));
    sundayTimestamp = TodaysDate >= 3 ? ((new Date()).valueOf()) : mondayTimestamp + 7 * 86400000;
    console.log('Sunday Timestamp');
    console.log(sundayTimestamp);
    hoursList = (await asyncListFilter(calendarList, async (item) => {
       if ((getObjectProperty(item, 'start_time')) <= sundayTimestamp && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && ((getObjectProperty(item, 'sessionStatus')) == 'MS MEETING' || (getObjectProperty(item, 'sessionStatus')) == 'MS SESSION')) {
        if (true && !((getObjectProperty(item, 'toBePaidList')).includes((getObjectProperty(pageData, 'userName')))) && (getObjectProperty(item, 'toBePaid')) != true || (getObjectProperty(item, 'toBePaid')) != true && (getObjectProperty(item, 'slots_slug')) == 'Manual time') {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(payableHours, item);
        }
      }
      if (((getObjectProperty(item, 'toBePaidList')).includes((getObjectProperty(pageData, 'userName')))) || (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null) && true || (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(submittedHours, item);
      }


     return ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && ((getObjectProperty(item, 'sessionStatus')) == 'MS MEETING' || (getObjectProperty(item, 'sessionStatus')) == 'MS SESSION') && !(typeof (getObjectProperty(item, 'toBePaidList')) === 'undefined') && !((getObjectProperty(item, 'toBePaidList')).includes((getObjectProperty(pageData, 'userName')))));
    }));
    pageData['hoursMSList'] = hoursList;
    pageData['payableMSHours2'] = payableHours;
    extraHours = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'slots_slug')) == 'Manual time');
    }));
    console.log('extra hours');
    console.log(extraHours);
    if ((getObjectProperty(pageData, 'todayNumber')) < 3) {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayLastWeek')) && (getObjectProperty(item, 'start_time')) < (getObjectProperty(pageData, 'MondayThisWeek')));
      }));
    } else {
      payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayThisWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
      }));
    }
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'startWeek2')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
    }));
    pageData['payableHoursFilteredMS'] = payableHoursFiltered;
    if (extraHours.length != 0) {
      GetExtraHours = 0;
      for (var j_index in extraHours) {
        j = extraHours[j_index];
        GetExtraHours = (typeof GetExtraHours == 'number' ? GetExtraHours : 0) + (getObjectProperty(j, 'duration'));
      }
    } else {
      GetExtraHours = 0;
    }
    if (submittedHours.length != 0) {
      GetSubmittedHours = 0;
      for (var j_index2 in submittedHours) {
        j = submittedHours[j_index2];
        GetSubmittedHours = (typeof GetSubmittedHours == 'number' ? GetSubmittedHours : 0) + (getObjectProperty(j, 'duration'));
      }
    } else {
      GetSubmittedHours = 0;
    }
    if (payableHours.length != 0) {
      GetPayableHours = 0;
      var j_list = (await asyncListFilter(payableHours, async (item) => {


       return ((getObjectProperty(item, 'slots_slug')) != 'Manual time');
      }));
      for (var j_index3 in j_list) {
        j = j_list[j_index3];
        GetPayableHours = (typeof GetPayableHours == 'number' ? GetPayableHours : 0) + (getObjectProperty(j, 'duration'));
      }
    } else {
      GetPayableHours = 0;
    }
    console.log(payableHours);
    console.log(GetPayableHours);
    console.log(GetPayableHoursTest);
    pageData['payableMSHours'] = GetPayableHours;
    console.log(submittedHours);
    console.log(GetSubmittedHours);
    pageData['submittedMSHours'] = GetSubmittedHours;
    console.log(GetExtraHours);
    pageData['extraMSHours'] = GetExtraHours;
    console.log(getObjectProperty(pageData, 'extraMSHours'));

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('BackendGetMsHoursByParam', (JSON.stringify(({ [`educator`]: (getObjectProperty(pageData, 'userName')),[`message`]: 'Error when calculating educator\'s MS Hours',[`data`]: calendarList }))), error);

  }

return hoursList
}

})
define('./functions/820247ba30fce60b7d176e0f4b04c337/code.js', () => { 

BackendlessUI.Functions.Custom['fn_820247ba30fce60b7d176e0f4b04c337'] = async function fn_820247ba30fce60b7d176e0f4b04c337(userName, pageData, usedIn) {
var msStudentContainer, error, userName, _unused, tutorDateMidnight, MondayThisWeek, MondayLastWeek, todayNumber, mondayTimestamp, MSList, StudentList, gradeBand, gradeBandPrettyName, mainTeacher, mainWeeklySlot, i, FilterObjectId, MSStudent, ObjectIdDetail, item, subjects, GetObjectId, j, tutorDateNow, tempSubjects, offset, tempList, DSToffSet, testTimezone, tutorDateMidnightUTC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (userName === null) || (typeof userName === 'undefined') ? ['(MS_teacher_email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' or email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\') and accountType = \'BACKENDLESS\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.long_name', '*'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    tutorDateNow = usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    console.log(tutorDateNow);
    console.log('TODAY NUMBER');
    console.log(todayNumber);
    pageData['todayNumber'] = todayNumber;
    MondayLastWeek = ((tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber)) - 86400000 * 7;
    MondayThisWeek = (tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber);
    console.log(MondayLastWeek);
    console.log('MondayThisWeek');
    console.log(MondayThisWeek);
    console.log(tutorDateMidnight);
    if (todayNumber < 3) {
      mondayTimestamp = ((tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0) - 86400000 * 7;
    } else {
      mondayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (((getObjectProperty(testTimezone, 'long_name')) == 'US/Mountain' ? 0 : 1) - todayNumber) + 0;
    }
    console.log('MondayTimestamp');
    console.log(mondayTimestamp);
    pageData['msMondayTimestamp'] = mondayTimestamp;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetMSCalendar_v2 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  console.log('Get ms calendar data');
  try {
    console.log(['(start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),String('\' and scheduling != \'is_rescheduled\'') + String(''),' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),String('\' and Description != \'Parent Teacher Conference\'') + String(''),')'].join(''));
    if (true) {
      tempList = [1];
      tempSubjects = [];
      offset = 0;
      while (!!tempList.length) {
        tempList = (await Backendless.Data.of('ms_calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['(start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and Description != \'Parent Teacher Conference\'',' and weekly_slots[ms_calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[ms_calendar].status = \'churn\' or weekly_slots[ms_calendar].status = \'enrolled\' or weekly_slots[ms_calendar].status = \'deleted\' or weekly_slots[ms_calendar].status = \'long pause\')) or (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),String('\' and scheduling != \'is_rescheduled\'') + String(''),' and scheduling != \'is_pushed\' and (Description like \'MAX%\' and scheduling != \'is_cancelled\')',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[ms_calendar].objectId is null) or (start_date >= ',mondayTimestamp,' and start_date <= ',tutorDateNow + 0 * 86400000,' and tutor_relations.name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),String('\' and Description != \'Parent Teacher Conference\'') + String(''),')'].join(''))).setProperties(['weekly_slots[ms_calendar].slot_slug as slotSlug', 'weekly_slots[ms_calendar].lead_id as leadID', 'weekly_slots[ms_calendar].startDate', 'weekly_slots[ms_calendar].status as studentStatus', 'weekly_slots[ms_calendar].lastHmwrk', 'weekly_slots[ms_calendar].rubric', 'weekly_slots[ms_calendar].contact_id', 'weekly_slots[ms_calendar].parent_name', 'weekly_slots[ms_calendar].student_name', 'weekly_slots[ms_calendar].subject', 'weekly_slots[ms_calendar].grade', 'weekly_slots[ms_calendar].timezone as parentTimezone', 'tutor_relations.timezone as tutorTimezone', 'tutor_relations.objectId as tutorObjectId', 'objectId as calendarObjectId', 'tutor_relations.tutorType', 'weekly_slots[ms_calendar].tutor_lifetime_slots', '*']).setSortBy('start_date ASC').setPageSize(100).setOffset(offset)));
        addItemToList(tempSubjects, tempList);
        offset = (typeof offset == 'number' ? offset : 0) + 100;
      }
      subjects = (await asyncListFilter(tempSubjects, async (item) => {


       return (!((getObjectProperty(item, 'Description')).indexOf('MS_BREAK_NOT_ATTENDING') !== -1));
      }));
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw2 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from the calendar DB / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    console.log('ms_calendar');
    console.log(subjects);
    GetObjectId = [];
    for (var j_index in subjects) {
      j = subjects[j_index];
      if (!(GetObjectId.includes((getObjectProperty(j, 'calendarObjectId'))))) {
        addItemToList(GetObjectId, (getObjectProperty(j, 'calendarObjectId')));
      }
    }
    msStudentContainer = [];
    for (var ObjectIdDetail_index in GetObjectId) {
      ObjectIdDetail = GetObjectId[ObjectIdDetail_index];
      FilterObjectId = (await asyncListFilter(subjects, async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == ObjectIdDetail);
      }));
      StudentList = [];
      for (var MSStudent_index in FilterObjectId) {
        MSStudent = FilterObjectId[MSStudent_index];
        if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MICROSCHOOL-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`slotSlug`]: (getObjectProperty(MSStudent, 'slotSlug')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_GROUP-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')).indexOf('-MS_ELECTIVE-') !== -1) {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        } else if ((getObjectProperty(MSStudent, 'Description')) == 'Parent Teacher Conference') {
          addItemToList(StudentList, ({ [`student_name`]: (getObjectProperty(MSStudent, 'student_name')),[`lead_id`]: (getObjectProperty(MSStudent, 'lead_id')),[`leadID`]: (getObjectProperty(MSStudent, 'leadID')),[`parent_name`]: (getObjectProperty(MSStudent, 'parent_name')),[`grade`]: (getObjectProperty(MSStudent, 'grade')),[`subject`]: (getObjectProperty(MSStudent, 'subject')) }));
        }
      }
      MSList = FilterObjectId[0];
      gradeBandPrettyName = '';
      mainTeacher = '';
      if ((getObjectProperty(MSList, 'Description')).split('-')[2] == 'COTEACHING' || ((getObjectProperty(MSList, 'Description')).indexOf('COTEACHING') !== -1)) {
        if (!(typeof (StudentList[0]) === 'undefined')) {
          console.log(['lead_id=\'',(getObjectProperty((StudentList[0]), 'leadID')),'\' and tutor != \'',userName,'\' and assistant_teacher=\'',userName,'\' and student_name=\'',(getObjectProperty((StudentList[0]), 'student_name')),'\' and status !=\'deleted\' and (slot_slug like \'%',((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? (getObjectProperty(MSList, 'Description')).split('-')[0] : [(getObjectProperty(MSList, 'Description')).split('-')[0],'-',(getObjectProperty(MSList, 'Description')).split('-')[1]].join(''),((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? '%\')' : ['%\' and slot_slug like \'%',(getObjectProperty(MSList, 'Description')).split('-')[3],'-',(getObjectProperty(MSList, 'Description')).split('-')[4],'%\')'].join('')].join(''));
          mainWeeklySlot = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty((StudentList[0]), 'leadID')),'\' and tutor != \'',userName,'\' and assistant_teacher=\'',userName,'\' and student_name=\'',(getObjectProperty((StudentList[0]), 'student_name')),'\' and status !=\'deleted\' and (slot_slug like \'%',((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? (getObjectProperty(MSList, 'Description')).split('-')[0] : [(getObjectProperty(MSList, 'Description')).split('-')[0],'-',(getObjectProperty(MSList, 'Description')).split('-')[1]].join(''),((getObjectProperty(MSList, 'Description')).indexOf('MAX1-') !== -1) ? '%\')' : ['%\' and slot_slug like \'%',(getObjectProperty(MSList, 'Description')).split('-')[3],'-',(getObjectProperty(MSList, 'Description')).split('-')[4],'%\')'].join('')].join(''))).setPageSize(1)))[0];
          if (mainWeeklySlot !== null && !Array.isArray(mainWeeklySlot) && (typeof mainWeeklySlot === 'object')) {
            gradeBand = !(typeof (getObjectProperty(mainWeeklySlot, 'subject')) === 'undefined') && !(typeof (getObjectProperty(mainWeeklySlot, 'subject')) === 'undefined') ? ((((getObjectProperty(mainWeeklySlot, 'subject')).toLowerCase()).indexOf('ms') !== -1) ? subsequenceFromStartLast((getObjectProperty(mainWeeklySlot, 'subject')), 2) : (getObjectProperty(mainWeeklySlot, 'subject'))).split('_') : [];
            var i_end = gradeBand.length;
            var i_inc = 1;
            if (1 > i_end) {
              i_inc = -i_inc;
            }
            for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
              if ((gradeBand[(i - 1)].toLowerCase()).indexOf('summerschool') !== -1) {
                gradeBandPrettyName = String(gradeBandPrettyName) + String('Summer ');
              } else {
                gradeBandPrettyName = String(gradeBandPrettyName) + String(String(gradeBand[(i - 1)]) + String(' '));
              }
            }
            gradeBandPrettyName = String(gradeBandPrettyName) + String('School');
            mainTeacher = (getObjectProperty(mainWeeklySlot, 'tutor'));
          }
        }
      }
      if ((getObjectProperty(MSList, 'Description')).split('-')[1] == 'MICROSCHOOL') {
        if ((getObjectProperty(MSList, 'scheduling')) == 'is_cancelled') {
          continue;
        }
        if ((getObjectProperty(MSList, 'tutor')) != userName) {
          continue;
        }
        addItemToList(msStudentContainer, ({ [`mainTeacher`]: mainTeacher,[`student_list`]: StudentList,[`gradeBand`]: gradeBandPrettyName,[`subject`]: (getObjectProperty(MSList, 'Description')).split('-')[2],[`grade`]: (getObjectProperty(MSList, 'Description')).split('-')[1],[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      } else if ((getObjectProperty(MSList, 'Description')).split('-')[1] == 'MS_GROUP' || (getObjectProperty(MSList, 'Description')).split('-')[1] == 'MS_ELECTIVE') {
        if ((getObjectProperty(MSList, 'scheduling')) == 'is_cancelled') {
          continue;
        }
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: (getObjectProperty(MSList, 'Description')).split('-')[2],[`gradeBand`]: undefined,[`grade`]: (getObjectProperty(MSList, 'Description')).split('-')[1],[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      } else {
        addItemToList(msStudentContainer, ({ [`student_list`]: StudentList,[`subject`]: ((getObjectProperty(MSList, 'Description')).indexOf('School Closed') !== -1) ? null : (((getObjectProperty(MSList, 'tutor')).indexOf('All Teachers') !== -1) ? (getObjectProperty(MSList, 'tutor')).toUpperCase() : null),[`grade`]: undefined,[`start_time`]: (getObjectProperty(MSList, 'start_date')),[`slots_slug`]: (getObjectProperty(MSList, 'Description')),[`scheduling`]: (getObjectProperty(MSList, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(MSList, 'objectId')),[`toBePaid`]: (getObjectProperty(MSList, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(MSList, 'status')),[`tutorObjectId`]: (getObjectProperty(MSList, 'tutorObjectId')),[`duration`]: (getObjectProperty(MSList, 'duration')),[`tutor`]: (getObjectProperty(MSList, 'tutor')),[`event_title`]: (getObjectProperty(MSList, 'event_title')),[`toBePaidList`]: !((getObjectProperty(MSList, 'toBePaidList')) === null) ? (getObjectProperty(MSList, 'toBePaidList')) : [] }));
      }
    }
    pageData['startWeek2'] = mondayTimestamp;
    pageData['msStudentContainer'] = msStudentContainer;
    pageData['todayNumber'] = todayNumber;
    pageData['MondayLastWeek'] = MondayLastWeek;
    pageData['MondayThisWeek'] = MondayThisWeek;
    pageData['tutorDateMidnight'] = tutorDateMidnight;

  } catch (error) {
    console.log(error);

  }

return msStudentContainer
}

})
define('./functions/86b47202747aa38f566615595cf46822/code.js', () => { 

BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'] = async function fn_86b47202747aa38f566615595cf46822(isMS, isFuture, pageData) {
var msSessions, error, temp, item, classObject, students, classDescriptionConditions, classDescriptionTextArr, gradeBandPrettyName, mainTeacher, mainWeeklySlot, i, gradeBand, student, classCondition, description, j, records, uniqueObjId, allRecords, requestData, _offSet, _tempRecord, condtions, timeEnd, timeStart, sundayTimestampUTC, mondayTimestampUTC, educatorTimestamp, localMondayTimestamp, localSundayTimestamp, dayOfTheWeek, educatorUTCDateMidnight, educatorLocalDateMidnight, additionalProperties, Sessions, subjects, educatorTimezone, offsetDST, timeOffset, educatorTzOffset, finalTutorSessions, elem, timezoneObj, isTutorTz, isParentTz, Timezones, primaryTutorSessions, studentsToday, timeConditions, elemStartTime, uniqueFutureTutorSessions, midnightTimestampUTC, minuteOffset, tutorSessions, record, uniqueSlots, dynamicProps, props, staticProps;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function filterMSRecords(records) {
  try {
    uniqueObjId = [];
    var j_list = (records.map(item => item['calendarObjectId']));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (!(uniqueObjId.includes(j))) {
        addItemToList(uniqueObjId, j);
      }
    }
    msSessions = [];
    for (var j_index2 in uniqueObjId) {
      j = uniqueObjId[j_index2];
      students = [];
      classObject = null;
      for (var student_index in records) {
        student = records[student_index];
        if ((getObjectProperty(student, 'calendarObjectId')) == j) {
          if (classObject === null) {
            classObject = student;
          }
          description = (getObjectProperty(student, 'Description'));
          classCondition = [(description.indexOf('-MICROSCHOOL-') !== -1), (description.indexOf('-MS_GROUP-') !== -1), (description.indexOf('-MS_ELECTIVE-') !== -1), (description.indexOf('Parent Teacher Conference') !== -1)];
          if (classCondition.includes(true)) {
            temp = ({ [`student_name`]: (getObjectProperty(student, 'student_name')),[`lead_id`]: (getObjectProperty(student, 'lead_id')),[`leadID`]: (getObjectProperty(student, 'leadID')),[`parent_name`]: (getObjectProperty(student, 'parent_name')),[`grade`]: (getObjectProperty(student, 'grade')),[`subject`]: (getObjectProperty(student, 'subject')) });
            if (classCondition[0]) {
              temp['slotSlug'] = (getObjectProperty(student, 'slotSlug'));
            }
            addItemToList(students, temp);
          }
        }
      }
      gradeBandPrettyName = '';
      mainTeacher = '';
      classDescriptionTextArr = (getObjectProperty(classObject, 'Description')).split('-');
      if (!isFuture && (classDescriptionTextArr.includes('COTEACHING')) && !!students.length) {
        mainWeeklySlot = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty((students[0]), 'leadID')),'\' and tutor != \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and assistant_teacher=\'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and student_name=\'',(getObjectProperty((students[0]), 'student_name')),'\' and status !=\'deleted\' and (slot_slug like \'%',String(classDescriptionTextArr[0]) + String(((getObjectProperty(classObject, 'Description')).indexOf('MAX1-') !== -1) ? '%\')' : ['-',classDescriptionTextArr[1],'%\' and slot_slug like \'%',classDescriptionTextArr[3],'-',classDescriptionTextArr[4],'%\')'].join(''))].join(''))).setPageSize(1)))[0];
        if (mainWeeklySlot !== null && !Array.isArray(mainWeeklySlot) && (typeof mainWeeklySlot === 'object')) {
          gradeBand = !(typeof (getObjectProperty(mainWeeklySlot, 'subject')) === 'undefined') ? ((((getObjectProperty(mainWeeklySlot, 'subject')).toLowerCase()).indexOf('ms') !== -1) ? subsequenceFromStartLast((getObjectProperty(mainWeeklySlot, 'subject')), 2) : (getObjectProperty(mainWeeklySlot, 'subject'))).split('_') : [];
          var i_end = gradeBand.length;
          var i_inc = 1;
          if (1 > i_end) {
            i_inc = -i_inc;
          }
          for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
            if ((gradeBand[(i - 1)].toLowerCase()).indexOf('summerschool') !== -1) {
              gradeBandPrettyName = String(gradeBandPrettyName) + String('Summer ');
            } else {
              gradeBandPrettyName = String(gradeBandPrettyName) + String(String(gradeBand[(i - 1)]) + String(' '));
            }
          }
          gradeBandPrettyName = String(gradeBandPrettyName) + String('School');
          mainTeacher = (getObjectProperty(mainWeeklySlot, 'tutor'));
        }
      }
      classDescriptionConditions = [({ [`condition`]: classDescriptionTextArr[1] == 'MICROSCHOOL',[`skip`]: (getObjectProperty(classObject, 'scheduling')) == 'is_cancelled' && (getObjectProperty(classObject, 'tutor')) != (getObjectProperty(pageData, 'userName')),[`data`]: (Object.assign(({ [`subject`]: classDescriptionTextArr[2],[`grade`]: classDescriptionTextArr[1] }), (isFuture ? ({  }) : ({ [`mainTeacher`]: mainTeacher,[`gradeBand`]: gradeBandPrettyName })))) }), ({ [`condition`]: classDescriptionTextArr[1] == 'MS_GROUP' || classDescriptionTextArr[1] == 'MS_ELECTIVE',[`skip`]: (getObjectProperty(classObject, 'scheduling')) == 'is_cancelled',[`data`]: ({ [`subject`]: classDescriptionTextArr[2],[`grade`]: classDescriptionTextArr[1] }) }), ({ [`condition`]: true,[`skip`]: false,[`data`]: isFuture ? ({ [`subject`]: undefined }) : ({ [`subject`]: ((getObjectProperty(classObject, 'Description')).indexOf('Parent Teacher Conference') !== -1) ? (getObjectProperty(classObject, 'subject')).toUpperCase() : (((getObjectProperty(classObject, 'Description')).indexOf('School Closed') !== -1) ? null : (((getObjectProperty(classObject, 'tutor')).indexOf('All Teachers') !== -1) ? (getObjectProperty(classObject, 'tutor')).toUpperCase() : null)) }) })];
      for (var item_index in classDescriptionConditions) {
        item = classDescriptionConditions[item_index];
        if (getObjectProperty(item, 'condition')) {
          if (getObjectProperty(item, 'skip')) {
            break;
          }
          temp = ({ [`student_list`]: students,[`start_time`]: (getObjectProperty(classObject, 'start_date')),[`slots_slug`]: (getObjectProperty(classObject, 'Description')),[`scheduling`]: (getObjectProperty(classObject, 'scheduling')),[`calendarObjectId`]: (getObjectProperty(classObject, 'objectId')),[`toBePaid`]: (getObjectProperty(classObject, 'toBePaid')),[`sessionStatus`]: (getObjectProperty(classObject, 'status')),[`tutorObjectId`]: (getObjectProperty(classObject, 'tutorObjectId')),[`duration`]: (getObjectProperty(classObject, 'duration')),[`tutor`]: (getObjectProperty(classObject, 'tutor')),[`event_title`]: (getObjectProperty(classObject, 'event_title')),[`toBePaidList`]: !((getObjectProperty(classObject, 'toBePaidList')) === null) ? (getObjectProperty(classObject, 'toBePaidList')) : [] });
          Object.assign(temp, (getObjectProperty(item, 'data')));
          addItemToList(msSessions, temp);
          break;
        }
      }
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / BackendGetSessions custom function', (JSON.stringify(({ [`message`]: 'Error caught while invoking filterMSRecords',[`data`]: ({ [`name`]: (getObjectProperty(pageData, 'userName')),[`time`]: isFuture ? 'Future' : 'Past',[`service`]: isMS ? 'Microschool' : 'Tutoring' }) }))), error);

  }
  return msSessions
}

/**
 * Describe this function...
 */
async function getRecords() {
  try {
    if (isMS) {
      timeStart = localMondayTimestamp;
      timeEnd = localSundayTimestamp;
      condtions = [['(',['start_date >= ',timeStart,' AND start_date <= ',timeEnd,' AND tutor_relations.name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\'',' AND scheduling != \'is_rescheduled\'',' AND scheduling != \'is_pushed\'',' AND Description LIKE \'MAX%\'',' AND scheduling != \'is_cancelled\'',' AND ','(',['(',['Description != \'Parent Teacher Conference\'',' AND Description NOT LIKE \'%MS_STUDENT_COUNCIL%\'',' AND weekly_slots[ms_calendar].student_name NOT LIKE \'%[OFFBOARDED]%\' ',' AND ','(',['weekly_slots[ms_calendar].status = \'churn\'',' OR weekly_slots[ms_calendar].status = \'enrolled\'',' OR weekly_slots[ms_calendar].status = \'deleted\'',' OR weekly_slots[ms_calendar].status = \'long pause\''].join(''),')'].join(''),')',' OR ','(','weekly_slots[ms_calendar].objectId IS NULL',')'].join(''),')'].join(''),')'].join(''), ['(',['start_date >= ',timeStart,' AND start_date <= ',timeEnd,' AND tutor_relations.name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\'',' AND Description != \'Parent Teacher Conference\'',' AND Description NOT LIKE \'%MS_STUDENT_COUNCIL%\''].join(''),')'].join(''), ['(','Description NOT LIKE \'%MS_BREAK_NOT_ATTENDING%\'',')'].join('')];
      requestData = ({ [`table`]: 'ms_calendar',[`sortBy`]: 'start_date ASC',[`query`]: [condtions[0],' OR ',condtions[1],' AND ',condtions[2]].join(''),[`props`]: ['weekly_slots[ms_calendar].slot_slug as slotSlug', 'weekly_slots[ms_calendar].lead_id as leadID', 'weekly_slots[ms_calendar].startDate', 'weekly_slots[ms_calendar].status as studentStatus', 'weekly_slots[ms_calendar].lastHmwrk', 'weekly_slots[ms_calendar].rubric', 'weekly_slots[ms_calendar].contact_id', 'weekly_slots[ms_calendar].parent_name', 'weekly_slots[ms_calendar].student_name', 'weekly_slots[ms_calendar].subject', 'weekly_slots[ms_calendar].grade', 'weekly_slots[ms_calendar].timezone as parentTimezone', 'tutor_relations.timezone as tutorTimezone', 'tutor_relations.objectId as tutorObjectId', 'objectId as calendarObjectId', 'tutor_relations.tutorType', 'weekly_slots[ms_calendar].tutor_lifetime_slots', '*'] });
    } else {
      timeStart = mondayTimestampUTC;
      timeEnd = sundayTimestampUTC;
      condtions = [String('start_time >= ') + String(timeStart), String('start_time <= ') + String(timeEnd), ['tutor = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''), ['(',['(',['scheduling != \'is_rescheduled\'',' AND scheduling != \'is_pushed\'',' AND scheduling != \'is_paused\'',' AND scheduling != \'is_substituted\'',' AND ','(',['(',['weekly_slots[calendar].student_name NOT LIKE \'%[OFFBOARDED]%\' ',' AND ','(',['slots_slug LIKE \'%MS_GROUP%\'',' OR slots_slug NOT LIKE \'%-MS_%\'',' OR slots_slug LIKE \'%MAX1-MICROSCHOOL%\'','OR slots_slug like \'%MAX1-MS_ELECTIVE%\''].join(''),')',' AND ','(',['weekly_slots[calendar].status = \'churn\'',' OR weekly_slots[calendar].status = \'enrolled\'',' OR weekly_slots[calendar].status = \'deleted\'',' OR weekly_slots[calendar].status = \'long pause\''].join(''),')'].join(''),')',' OR ','(',['weekly_slots[calendar].objectId IS NULL',' AND ','(',String('slots_slug NOT LIKE \'%Microschool%\'') + String(' AND slots_slug NOT LIKE \'Mock%\''),')'].join(''),')'].join(''),')'].join(''),')',' OR ','(',['slots_slug LIKE \'Mock%\'',' AND Users[calendar].name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''),')'].join(''),')'].join('')];
      console.log('**********************Calendar Query');
      console.log([condtions[0],' AND ',condtions[1],' AND ',condtions[2],' AND ',condtions[3]].join(''));
      requestData = ({ [`table`]: 'calendar',[`sortBy`]: 'start_time ASC',[`query`]: [condtions[0],' AND ',condtions[1],' AND ',condtions[2],' AND ',condtions[3]].join(''),[`props`]: ['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name as weeklyStudentName', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', 'Users[calendar].tutorType', 'weekly_slots[calendar].tutor_lifetime_slots', '*'] });
    }
    _tempRecord = [1];
    _offSet = 0;
    allRecords = [];
    while (!!_tempRecord.length) {
      _tempRecord = (await Backendless.Data.of((getObjectProperty(requestData, 'table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(requestData, 'query'))).setProperties((getObjectProperty(requestData, 'props'))).setSortBy((getObjectProperty(requestData, 'sortBy'))).setGroupBy('objectId').setPageSize(100).setOffset(_offSet)));
      addItemToList(allRecords, _tempRecord);
      _offSet = (typeof _offSet == 'number' ? _offSet : 0) + 100;
    }
    console.log(getObjectProperty(requestData, 'query'));

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / BackendGetSessions custom function', (JSON.stringify(({ [`message`]: 'Error caught while invoking getRecords',[`data`]: ({ [`name`]: (getObjectProperty(pageData, 'userName')),[`time`]: isFuture ? 'Future' : 'Past',[`service`]: isMS ? 'Microschool' : 'Tutoring' }) }))), error);

  }
  return allRecords
}

/**
 * Describe this function...
 */
async function printTimestamps() {
  console.log(String('educatorTimestamp: ') + String(educatorTimestamp));
  console.log(String('educatorLocalDateMidnight: ') + String(educatorLocalDateMidnight));
  console.log(String('educatorUTCDateMidnight: ') + String(educatorUTCDateMidnight));
  console.log(String('localMondayTimestamp: ') + String(localMondayTimestamp));
  console.log(String('localSundayTimestamp: ') + String(localSundayTimestamp));
  console.log(String('mondayTimestampUTC: ') + String(mondayTimestampUTC));
  console.log(String('sundayTimeStampUTC: ') + String(sundayTimestampUTC));
  console.log(String('dayOfTheWeek: ') + String(dayOfTheWeek));
}

/**
 * Describe this function...
 */
async function getTutorSessions(primaryTutorSessions) {
  try {
    finalTutorSessions = [];
    if (isFuture) {
      studentsToday = 0;
      uniqueFutureTutorSessions = [];
      minuteOffset = (20 * 60) * 1000;
      midnightTimestampUTC = ((new Date(([(new Date((getObjectProperty(pageData, 'DateToday'))).getMonth() + 1),'/',(new Date((getObjectProperty(pageData, 'DateToday'))).getDate()),'/',(new Date((getObjectProperty(pageData, 'DateToday'))).getFullYear())].join('')))).valueOf());
      for (var elem_index in primaryTutorSessions) {
        elem = primaryTutorSessions[elem_index];
        elemStartTime = (getObjectProperty(elem, 'start_time'));
        timeConditions = [!((getObjectProperty(elem, 'startDate')) === null) || (getObjectProperty(elem, 'slots_slug')) == 'Manual time', elemStartTime + minuteOffset > (getObjectProperty(pageData, 'DateToday')), midnightTimestampUTC <= elemStartTime, midnightTimestampUTC + (1439 * 60) * 1000 >= elemStartTime, !(uniqueFutureTutorSessions.includes(elemStartTime)), !((getObjectProperty(elem, 'slots_slug')) == 'Manual time')];
        if (!(timeConditions.includes(false))) {
          addItemToList(uniqueFutureTutorSessions, elemStartTime);
          studentsToday = (typeof studentsToday == 'number' ? studentsToday : 0) + 1;
        }
        if (timeConditions[0]) {
          addItemToList(finalTutorSessions, elem);
        }
      }
      additionalProperties['studentsToday'] = studentsToday;
      additionalProperties['MessageLimit'] = 1000;
    } else {
      Timezones = (await Backendless.Data.of('timezones').find(Backendless.DataQueryBuilder.create().setGroupBy('long_name').setPageSize(100)));
      for (var elem_index2 in primaryTutorSessions) {
        elem = primaryTutorSessions[elem_index2];
        if (((getObjectProperty(elem, 'slots_slug')) == 'Manual time' || (getObjectProperty(elem, 'scheduling')) == 'scheduled' || (getObjectProperty(elem, 'scheduling')) == 'being_rescheduled') && ((getObjectProperty(elem, 'scheduling')) == 'scheduled' || (getObjectProperty(elem, 'scheduling')) == 'being_rescheduled')) {
          isParentTz = (getObjectProperty(elem, 'parentTimezone')) != null;
          isTutorTz = (getObjectProperty(elem, 'tutorTimezone')) != null;
          if (isParentTz || isTutorTz) {
            var i_end2 = Timezones.length;
            var i_inc2 = 1;
            if (1 > i_end2) {
              i_inc2 = -i_inc2;
            }
            for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
              timezoneObj = Timezones[(i - 1)];
              if ((getObjectProperty(timezoneObj, 'long_name')) == (getObjectProperty(elem, 'parentTimezone')) && isParentTz) {
                Object.assign(elem, ({ [`parentIANA`]: (getObjectProperty(timezoneObj, 'iana')),[`parentSign`]: (getObjectProperty(timezoneObj, 'sign')),[`parentOffset`]: (getObjectProperty(timezoneObj, 'offset')) }));
              }
              if ((getObjectProperty(timezoneObj, 'long_name')) == (getObjectProperty(elem, 'tutorTimezone')) && isTutorTz) {
                Object.assign(elem, ({ [`tutorIANA`]: (getObjectProperty(timezoneObj, 'iana')),[`tutorSign`]: (getObjectProperty(timezoneObj, 'sign')),[`tutorOffset`]: (getObjectProperty(timezoneObj, 'offset')) }));
              }
            }
          }
          addItemToList(finalTutorSessions, elem);
        }
      }
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / BackendGetSessions custom function', (JSON.stringify(({ [`message`]: 'Error caught while invoking getTutorSessions',[`data`]: ({ [`name`]: (getObjectProperty(pageData, 'userName')),[`time`]: isFuture ? 'Future' : 'Past',[`service`]: isMS ? 'Microschool' : 'Tutoring' }) }))), error);

  }
  return finalTutorSessions
}

/**
 * Describe this function...
 */
async function filterTutorRecords(records) {
  try {
    tutorSessions = [];
    uniqueSlots = [];
    staticProps = ['startDate', 'rubric', 'contact_id', 'parent_name', 'event_title', 'subject', 'grade', 'slots_slug', 'parentTimezone', 'tutorTimezone', 'toBePaid', 'scheduling', 'calendarObjectId', 'tutorObjectId', 'start_time'];
    if (!isFuture) {
      addItemToList(staticProps, 'tutor_lifetime_slots');
      addItemToList(staticProps, 'tutorType');
    }
    for (var record_index in records) {
      record = records[record_index];
      if ((isFuture ? (getObjectProperty(record, 'status')) == 'enrolled' || (getObjectProperty(record, 'slots_slug')) == 'Manual time' : true) && !(uniqueSlots.includes((getObjectProperty(record, 'calendarObjectId'))))) {
        temp = ({  });
        for (var props_index in staticProps) {
          props = staticProps[props_index];
          temp[props] = (getObjectProperty(record, props));
        }
        Object.assign(temp, ({ [`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`student_name`]: (getObjectProperty(record, 'weeklyStudentName')),[`tutor_name`]: (getObjectProperty(record, 'tutor')) }));
        if (isFuture) {
          dynamicProps = ({ [`homework_sent`]: (getObjectProperty(record, 'homework_sent')),[`lastHmwrk`]: ((new Date((getObjectProperty(record, 'lastHmwrk')))).valueOf()) });
        } else {
          dynamicProps = ({ [`homework_sent`]: ((getObjectProperty(record, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? true : (((getObjectProperty(record, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? true : (getObjectProperty(record, 'homework_sent'))),[`lastHmwrk`]: ((getObjectProperty(record, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) || ((getObjectProperty(record, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? (getObjectProperty(pageData, 'DateToday')) : ((new Date((getObjectProperty(record, 'lastHmwrk')))).valueOf()) });
        }
        Object.assign(temp, dynamicProps);
        addItemToList(tutorSessions, temp);
        addItemToList(uniqueSlots, (getObjectProperty(record, 'calendarObjectId')));
      }
    }
    additionalProperties['primarySessions'] = tutorSessions;

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / BackendGetSessions custom function', (JSON.stringify(({ [`message`]: 'Error caught while invoking filterTutorRecords',[`data`]: ({ [`name`]: (getObjectProperty(pageData, 'userName')),[`time`]: isFuture ? 'Future' : 'Past',[`service`]: isMS ? 'Microschool' : 'Tutoring' }) }))), error);

  }
  return await getTutorSessions(tutorSessions)
}


  try {
    console.log(JSON.stringify(({ [`time`]: isFuture ? 'Future' : 'Past',[`service`]: isMS ? 'Microschool' : 'Tutoring' })));
    additionalProperties = ({  });
    educatorTimezone = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND accountType = \'BACKENDLESS\''].join(''))).setProperties(['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.region', 'timezones.long_name', 'timezones.schedule_timezone']).setPageSize(10)))[0];
    educatorTimestamp = (getObjectProperty(pageData, 'DateToday'));
    educatorTzOffset = (getObjectProperty(educatorTimezone, 'offSet')) * ((getObjectProperty(educatorTimezone, 'sign')) == '-' ? 3600 * -1 : 3600);
    educatorLocalDateMidnight = (new Date((((new Date((new Date(educatorTimestamp)).getTime() + (educatorTzOffset * 1000))).toISOString()).slice(0, 10))));
    educatorUTCDateMidnight = (new Date(educatorLocalDateMidnight.getTime() + ((educatorTzOffset * -1) * 1000)));
    dayOfTheWeek = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/getDayOfTheWeek`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`timestamp`]: (educatorLocalDateMidnight.valueOf()) })))) == 0 ? 7 : (await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/getDayOfTheWeek`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`timestamp`]: (educatorLocalDateMidnight.valueOf()) }))));
    if (isFuture) {
      timeOffset = dayOfTheWeek < 3 ? 86400000 * 0 : 86400000 * 7;
    } else {
      timeOffset = dayOfTheWeek < 3 ? 86400000 * 7 * -1 : 86400000 * 0;
    }
    localMondayTimestamp = (educatorUTCDateMidnight.valueOf()) + 86400000 * (((true ? true : (getObjectProperty(educatorTimezone, 'sign')) == '-') ? 1 : 0) - dayOfTheWeek) + timeOffset;
    localSundayTimestamp = localMondayTimestamp + ((7 * 86400) - (1 * 60)) * 1000;
    offsetDST = isMS ? 0 : (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(educatorTimezone, 'region')), localMondayTimestamp)) - (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(educatorTimezone, 'region')), educatorTimestamp));
    mondayTimestampUTC = localMondayTimestamp + offsetDST * ((getObjectProperty(educatorTimezone, 'region')) == 'US' ? 3600000 : 3600000 * -1);
    offsetDST = isMS ? 0 : (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(educatorTimezone, 'region')), localSundayTimestamp)) - (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(educatorTimezone, 'region')), educatorTimestamp));
    sundayTimestampUTC = localSundayTimestamp + offsetDST * ((getObjectProperty(educatorTimezone, 'region')) == 'US' ? 3600000 : 3600000 * -1);
    await printTimestamps();
    if (!isFuture) {
      Object.assign(additionalProperties, ({ [`mondayThisWeek`]: ((new Date(educatorUTCDateMidnight.getTime() - ((dayOfTheWeek * 86400) * 1000))).valueOf()),[`mondayLastWeek`]: ((new Date(educatorUTCDateMidnight.getTime() - (((dayOfTheWeek + 7) * 86400) * 1000))).valueOf()),[`dayOfTheWeek`]: dayOfTheWeek,[`mondayTimestamp`]: mondayTimestampUTC,[`startWeek`]: mondayTimestampUTC }));
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / BackendGetSessions Custom Function ', (JSON.stringify(({ [`message`]: 'Error caught while calculating timestamps',[`data`]: ({ [`name`]: (getObjectProperty(pageData, 'userName')) }) }))), error);

  }
  try {
    subjects = await getRecords();
    console.log('Unfiltered Sessions');
    console.log(subjects);
    Sessions = isMS ? await filterMSRecords(subjects) : await filterTutorRecords(subjects);
    console.log('Filtered Sessions');
    console.log(Sessions);

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / BackendGetSessions Custom Function ', (JSON.stringify(({ [`message`]: 'Error caught while fetching sessions',[`data`]: ({ [`name`]: (getObjectProperty(pageData, 'userName')),[`time`]: isFuture ? 'Future' : 'Past',[`service`]: isMS ? 'Microschool' : 'Tutoring' }) }))), error);

  }

return ({ [`sessions`]: Sessions,[`additionalData`]: additionalProperties })
}

})
define('./functions/86f20d1eeba34475855af3893e06404a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a'] = function fn_86f20d1eeba34475855af3893e06404a(tz, DateNow) {
var offSet, au, region, us, eu, DateNow;


  region = tz == 'GB' ? 'EU' : tz;
  if ((typeof DateNow === 'undefined') || (DateNow === null)) {
    DateNow = (new Date());
  } else {
    DateNow = DateNow;
  }
  eu = (DateNow.valueOf()) > ((new Date((String(new Date((new Date())).getFullYear()) + String('-03-31')))).valueOf()) && (DateNow.valueOf()) < ((new Date((String(new Date((new Date())).getFullYear()) + String('-10-27')))).valueOf());
  us = (DateNow.valueOf()) > ((new Date((String(new Date((new Date())).getFullYear()) + String('-03-10')))).valueOf()) && (DateNow.valueOf()) < ((new Date((String(new Date((new Date())).getFullYear()) + String('-11-03')))).valueOf());
  au = (DateNow.valueOf()) > ((new Date((String(new Date((new Date())).getFullYear()) + String('-04-02')))).valueOf()) && (DateNow.valueOf()) < ((new Date((String(new Date((new Date())).getFullYear()) + String('-10-01')))).valueOf());
  if (region == 'EU' && eu == true) {
    offSet = 0 + 1;
  } else if (region == 'EU' && eu == false) {
    offSet = 0;
  } else if (region == 'US' && us == true) {
    offSet = 0 - 1;
  } else if (region == 'US' && us == false) {
    offSet = 0;
  } else if (region == 'AU' && au == true) {
    offSet = 0 - 1;
  } else if (region == 'AU' && au == false) {
    offSet = 0;
  } else {
    offSet = 0;
  }

return offSet
}

})
define('./functions/88c1d4cb3f6a8127141f5aefef1b604d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_88c1d4cb3f6a8127141f5aefef1b604d'] = async function fn_88c1d4cb3f6a8127141f5aefef1b604d(userName, pageData, usedIn) {
var dash, error, userName, _unused, educatorLocalDateMidnight, MondayThisWeek, MondayLastWeek, todayNumber, mondayTimestamp, subject, uniqueSlots, subjects, educatorTimestamp, formatMondayTimestamp, DSToffSet, testTimezone, educatorUTCDateMidnight, studentContainer, item, tutorTimezone, FilterTimezone, Timezones, parentTimezone, tutorSessions, query, slotsSlugConditions, weeklySlotsStatuses, schedulingConditions, educatorTimezone, dayOfTheWeek;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function refactored() {
  try {
    educatorTimezone = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(pageData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND accountType = \'BACKENDLESS\''].join(''))).setProperties(['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.region', 'timezones.long_name']).setPageSize(10)))[0];
    educatorTimestamp = (getObjectProperty(pageData, 'DateToday'));
    educatorUTCDateMidnight = (new Date((((new Date((new Date(educatorTimestamp)).getTime() + (((getObjectProperty(educatorTimezone, 'offSet')) * ((getObjectProperty(educatorTimezone, 'sign')) == '-' ? 3600 * -1 : 3600)) * 1000))).toISOString()).slice(0, 10))));
    educatorLocalDateMidnight = (new Date((educatorUTCDateMidnight.valueOf()).getTime() + (((getObjectProperty(educatorTimezone, 'offSet')) * ((getObjectProperty(educatorTimezone, 'sign')) == '-' ? 3600 : 3600 * -1)) * 1000)));
    dayOfTheWeek = (new Date(educatorLocalDateMidnight).getDay()) == 0 ? 7 : (new Date(educatorLocalDateMidnight).getDay());
    formatMondayTimestamp = ((educatorLocalDateMidnight.valueOf()) + 86400000 * (1 - dayOfTheWeek)) - (dayOfTheWeek < 3 ? 86400000 * 7 : 0);
    DSToffSet = (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(educatorTimezone, 'region')), formatMondayTimestamp)) - (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(educatorTimezone, 'region')), educatorTimestamp));
    mondayTimestamp = (getObjectProperty(educatorTimezone, 'region')) == 'US' ? formatMondayTimestamp + DSToffSet * 3600000 : formatMondayTimestamp - DSToffSet * 3600000;

  } catch (error) {

  }
  await new Promise(r => setTimeout(r, 3000 || 0));
  try {
    schedulingConditions = ['scheduling != \'is_rescheduled\'',' AND scheduling != \'is_pushed\'',' AND scheduling != \'is_pause\'',' AND scheduling != \'is_substituted\''].join('');
    slotsSlugConditions = [['slots_slug LIKE \'%MS_GROUP%\'',' OR slots_slug NOT LIKE \'%-MS_%\'',' OR slots_slug LIKE \'MAX1-MICROSCHOOL%\''].join(''), String('slots_slug NOT LIKE \'%Microschool%\'') + String(' AND slots_slug NOT LIKE \'Mock%\'')];
    weeklySlotsStatuses = ['weekly_slots[calendar].status = \'churn\'',' OR weekly_slots[calendar].status = \'enrolled\'',' OR weekly_slots[calendar].status = \'deleted\'',' OR weekly_slots[calendar].status = \'long pause\''].join('');
    query = ['start_time >= ',mondayTimestamp,' AND start_time <= ',educatorTimestamp,' AND tutor = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND ((',schedulingConditions,' AND (','(','weekly_slots[calendar].student_name NOT LIKE \'%[OFFBOARDED]%\' ',' AND (',slotsSlugConditions[0],') AND (',weeklySlotsStatuses,'))',' OR',' (','weekly_slots[calendar].objectId IS NULL',' AND (',slotsSlugConditions[1],'))','))',' OR',' (slots_slug LIKE \'Mock%\'','  AND Users[calendar].name = \'',((getObjectProperty(pageData, 'userName')).replace((new RegExp('\'', 'g')), '\'\'')),'\'))'].join('');
    subjects = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause(query).setProperties(['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name as weeklyStudentName', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', 'Users[calendar].tutorType', 'weekly_slots[calendar].tutor_lifetime_slots', '*']).setSortBy('start_time ASC').setPageSize(100)));

  } catch (error) {

  }
  try {
    tutorSessions = [];
    uniqueSlots = [];
    for (var subject_index2 in subjects) {
      subject = subjects[subject_index2];
      if (!(uniqueSlots.includes((getObjectProperty(subject, 'calendarObjectId'))))) {
        addItemToList(tutorSessions, ({ [`startDate`]: (getObjectProperty(subject, 'startDate')),[`parentIANA`]: undefined,[`tutorIANA`]: undefined,[`rubric`]: (getObjectProperty(subject, 'rubric')),[`contact_id`]: (getObjectProperty(subject, 'contact_id')),[`parent_name`]: (getObjectProperty(subject, 'parent_name')),[`student_name`]: (getObjectProperty(subject, 'weeklyStudentName')),[`subject`]: (getObjectProperty(subject, 'subject')),[`grade`]: (getObjectProperty(subject, 'grade')),[`slots_slug`]: (getObjectProperty(subject, 'slots_slug')),[`parentTimezone`]: (getObjectProperty(subject, 'parentTimezone')),[`tutorTimezone`]: (getObjectProperty(subject, 'tutorTimezone')),[`tutor_name`]: (getObjectProperty(subject, 'tutor')),[`scheduling`]: (getObjectProperty(subject, 'scheduling')),[`homework_sent`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? true : (((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? true : (getObjectProperty(subject, 'homework_sent'))),[`calendarObjectId`]: (getObjectProperty(subject, 'calendarObjectId')),[`tutorObjectId`]: (getObjectProperty(subject, 'tutorObjectId')),[`start_time`]: (getObjectProperty(subject, 'start_time')),[`lastHmwrk`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? (usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf())) : (((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? (usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf())) : ((new Date((getObjectProperty(subject, 'lastHmwrk')))).valueOf())),[`tutorSign`]: undefined,[`tutorOffset`]: undefined,[`parentSign`]: undefined,[`parentOffset`]: undefined,[`toBePaid`]: (getObjectProperty(subject, 'toBePaid')),[`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`event_title`]: (getObjectProperty(subject, 'event_title')),[`tutor_lifetime_slots`]: (getObjectProperty(subject, 'tutor_lifetime_slots')),[`tutorType`]: (getObjectProperty(subject, 'tutorType')) }));
        addItemToList(uniqueSlots, (getObjectProperty(subject, 'calendarObjectId')));
      }
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetPastCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting the data to the dash / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    Timezones = (await Backendless.Data.of('timezones').find(Backendless.DataQueryBuilder.create().setGroupBy('long_name').setPageSize(100)));
    studentContainer = (await asyncListFilter(tutorSessions, async (item) => {
       if ((getObjectProperty(item, 'parentTimezone')) != null) {
        parentTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


         return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'parentTimezone')));
        }))[0];
        item['parentIANA'] = (getObjectProperty(parentTimezone, 'iana'));
        item['parentSign'] = (getObjectProperty(parentTimezone, 'sign'));
        item['parentOffset'] = (getObjectProperty(parentTimezone, 'offSet'));
      }
      if ((getObjectProperty(item, 'tutorTimezone')) != null) {
        tutorTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


         return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'tutorTimezone')));
        }))[0];
        item['tutorIANA'] = (getObjectProperty(tutorTimezone, 'iana'));
        item['tutorSign'] = (getObjectProperty(tutorTimezone, 'sign'));
        item['tutorOffset'] = (getObjectProperty(tutorTimezone, 'offSet'));
      }
      item['messageRowClick'] = false;


     return (((getObjectProperty(item, 'slots_slug')) == 'Manual time' || (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf())) && ((getObjectProperty(item, 'scheduling')) == 'scheduled' || (getObjectProperty(item, 'scheduling')) == 'being_rescheduled'));
    }));

  } catch (error) {
    console.log(error);

  }
  return studentContainer
}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (userName === null) || (typeof userName === 'undefined') ? ['(email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' or MS_teacher_email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\') and accountType = \'BACKENDLESS\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign', 'timezones.iana', 'timezones.region', 'timezones.long_name'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    educatorTimestamp = usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      educatorUTCDateMidnight = (new Date(((JSON.stringify((new Date((educatorTimestamp - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      educatorLocalDateMidnight = (new Date(((educatorUTCDateMidnight.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      educatorUTCDateMidnight = (new Date(((JSON.stringify((new Date((educatorTimestamp + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      educatorLocalDateMidnight = (new Date(((educatorUTCDateMidnight.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(educatorLocalDateMidnight).getDay()) == 0 ? 7 : (new Date(educatorLocalDateMidnight).getDay());
    console.log(educatorTimestamp);
    console.log('TODAY NUMBER');
    console.log(todayNumber);
    pageData['todayNumber'] = todayNumber;
    MondayLastWeek = ((educatorLocalDateMidnight.valueOf()) + 86400000 * (0 - todayNumber)) - 86400000 * 7;
    MondayThisWeek = (educatorLocalDateMidnight.valueOf()) + 86400000 * (0 - todayNumber);
    console.log(MondayLastWeek);
    console.log('MondayThisWeek');
    console.log(MondayThisWeek);
    if (todayNumber < 3) {
      formatMondayTimestamp = ((educatorLocalDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0) - 86400000 * 7;
    } else {
      formatMondayTimestamp = (educatorLocalDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0;
    }
    DSToffSet = (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(testTimezone, 'region')), formatMondayTimestamp)) - (await BackendlessUI.Functions.Custom['fn_86f20d1eeba34475855af3893e06404a']((getObjectProperty(testTimezone, 'region')), educatorTimestamp));
    mondayTimestamp = (getObjectProperty(testTimezone, 'region')) == 'US' ? formatMondayTimestamp + DSToffSet * 3600000 : formatMondayTimestamp - DSToffSet * 3600000;
    console.log('Format Monday Timestamp');
    console.log(formatMondayTimestamp);
    console.log('MondayTimestamp');
    console.log(mondayTimestamp);
    pageData['mondayTimestamp'] = mondayTimestamp;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetPastCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  await new Promise(r => setTimeout(r, 3000 || 0));
  try {
    console.log('----------------------------------------------------------------------------------------------');
    console.log(typeof userName === 'undefined');
    console.log((typeof userName === 'undefined') ? ['(start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\' ',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join('') : ['(start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug like \'%MS_GROUP%\' or slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join(''));
    console.log('----------------------------------------------------------------------------------------------');
    subjects = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/calendar')).query(({ [`where`]: (typeof userName === 'undefined') ? ['(start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\' ',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join('') : ['(start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug like \'%MS_GROUP%\' or slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\')',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',educatorTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join(''),[`property`]: ['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name as weeklyStudentName', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', 'Users[calendar].tutorType', 'weekly_slots[calendar].tutor_lifetime_slots', '*'],[`sortBy`]: 'start_time ASC',[`pageSize`]: 100 })).setEncoding('utf8').send());
    console.log('check');
    console.log(subjects);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetPastCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from the calendar DB / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    dash = [];
    uniqueSlots = [];
    for (var subject_index in subjects) {
      subject = subjects[subject_index];
      if (!(uniqueSlots.includes((getObjectProperty(subject, 'calendarObjectId'))))) {
        addItemToList(dash, ({ [`startDate`]: (getObjectProperty(subject, 'startDate')),[`parentIANA`]: undefined,[`tutorIANA`]: undefined,[`rubric`]: (getObjectProperty(subject, 'rubric')),[`contact_id`]: (getObjectProperty(subject, 'contact_id')),[`parent_name`]: (getObjectProperty(subject, 'parent_name')),[`student_name`]: (getObjectProperty(subject, 'weeklyStudentName')),[`subject`]: (getObjectProperty(subject, 'subject')),[`grade`]: (getObjectProperty(subject, 'grade')),[`slots_slug`]: (getObjectProperty(subject, 'slots_slug')),[`parentTimezone`]: (getObjectProperty(subject, 'parentTimezone')),[`tutorTimezone`]: (getObjectProperty(subject, 'tutorTimezone')),[`tutor_name`]: (getObjectProperty(subject, 'tutor')),[`scheduling`]: (getObjectProperty(subject, 'scheduling')),[`homework_sent`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? true : (((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? true : (getObjectProperty(subject, 'homework_sent'))),[`calendarObjectId`]: (getObjectProperty(subject, 'calendarObjectId')),[`tutorObjectId`]: (getObjectProperty(subject, 'tutorObjectId')),[`start_time`]: (getObjectProperty(subject, 'start_time')),[`lastHmwrk`]: ((getObjectProperty(subject, 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) ? (usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf())) : (((getObjectProperty(subject, 'slots_slug')).indexOf('MS_GROUP') !== -1) ? (usedIn == 'tutor_dash_ms' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf())) : ((new Date((getObjectProperty(subject, 'lastHmwrk')))).valueOf())),[`tutorSign`]: undefined,[`tutorOffset`]: undefined,[`parentSign`]: undefined,[`parentOffset`]: undefined,[`toBePaid`]: (getObjectProperty(subject, 'toBePaid')),[`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`event_title`]: (getObjectProperty(subject, 'event_title')),[`tutor_lifetime_slots`]: (getObjectProperty(subject, 'tutor_lifetime_slots')),[`tutorType`]: (getObjectProperty(subject, 'tutorType')) }));
        addItemToList(uniqueSlots, (getObjectProperty(subject, 'calendarObjectId')));
      }
    }
    pageData['startWeek'] = mondayTimestamp;
    pageData['calendarListRaw'] = dash;
    pageData['todayNumber'] = todayNumber;
    pageData['MondayLastWeek'] = MondayLastWeek;
    pageData['MondayThisWeek'] = MondayThisWeek;
    pageData['tutorDateMidnight'] = educatorLocalDateMidnight;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetPastCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting the data to the dash / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }

return dash
}

})
define('./functions/a76b1a4ea7f5d5dedb2d3b1195c168d7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7'] = async function fn_a76b1a4ea7f5d5dedb2d3b1195c168d7(userName, pageData, usedIn) {
var dash, error, userName, _unused, subject, UniqueCalendarObjects, subjects, sundayTimestamp, tutorDateNow, DSToffSet, todayNumber, tutorDateMidnight, testTimezone, tutorDateMidnightUTC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (typeof userName === 'undefined') ? ['(email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' or MS_teacher_email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\') and accountType = \'BACKENDLESS\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    tutorDateNow = usedIn == 'tutor_dash_ms_test' ? (getObjectProperty(pageData, 'DateToday')) : ((new Date()).valueOf());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((tutorDateNow + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    console.log(todayNumber);
    if (todayNumber < 3) {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 7;
    } else {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 14;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    console.log((typeof userName === 'undefined') ? ['(start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\'',' and scheduling != \'is_paused\') or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join('') : ['(start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\'',' and scheduling != \'is_paused\') or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join(''));
    subjects = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/calendar/find')).setEncoding('utf8').send(({ [`where`]: (typeof userName === 'undefined') ? ['(start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\'',' and scheduling != \'is_paused\') or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join('') : ['(start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and (slots_slug not like \'%-MS_%\' or slots_slug like \'MAX1-MICROSCHOOL%\' or slots_slug like \'%MS_GROUP%\')',' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\'',' and scheduling != \'is_paused\') or (start_time >= ',tutorDateNow - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join(''),[`property`]: ['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name as weeklyStudentName', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', '*'],[`sortBy`]: 'start_time ASC',[`pageSize`]: 100 })));

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from calendar / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    dash = [];
    UniqueCalendarObjects = [];
    for (var subject_index in subjects) {
      subject = subjects[subject_index];
      if ((getObjectProperty(subject, 'status')) == 'enrolled' && !(UniqueCalendarObjects.includes((getObjectProperty(subject, 'calendarObjectId'))))) {
        addItemToList(UniqueCalendarObjects, (getObjectProperty(subject, 'calendarObjectId')));
        addItemToList(dash, ({ [`startDate`]: (getObjectProperty(subject, 'startDate')),[`parentIANA`]: undefined,[`tutorIANA`]: undefined,[`rubric`]: (getObjectProperty(subject, 'rubric')),[`contact_id`]: (getObjectProperty(subject, 'contact_id')),[`parent_name`]: (getObjectProperty(subject, 'parent_name')),[`student_name`]: (getObjectProperty(subject, 'weeklyStudentName')),[`subject`]: (getObjectProperty(subject, 'subject')),[`grade`]: (getObjectProperty(subject, 'grade')),[`slots_slug`]: (getObjectProperty(subject, 'slots_slug')),[`parentTimezone`]: (getObjectProperty(subject, 'parentTimezone')),[`tutorTimezone`]: (getObjectProperty(subject, 'tutorTimezone')),[`tutor_name`]: (getObjectProperty(subject, 'tutor')),[`scheduling`]: (getObjectProperty(subject, 'scheduling')),[`homework_sent`]: (getObjectProperty(subject, 'homework_sent')),[`calendarObjectId`]: (getObjectProperty(subject, 'calendarObjectId')),[`tutorObjectId`]: (getObjectProperty(subject, 'tutorObjectId')),[`start_time`]: (getObjectProperty(subject, 'start_time')),[`lastHmwrk`]: ((new Date((getObjectProperty(subject, 'lastHmwrk')))).valueOf()),[`tutorSign`]: undefined,[`tutorOffset`]: undefined,[`parentSign`]: undefined,[`parentOffset`]: undefined,[`toBePaid`]: (getObjectProperty(subject, 'toBePaid')),[`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`event_title`]: (getObjectProperty(subject, 'event_title')) }));
      }
    }
    pageData['calendarListRaw3'] = dash;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function BackendGetFutureCalendarListByParam / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting data to the dashboard / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }

return dash
}

})
define('./functions/ba7314e68c4b6abd4bdf1ad56bcd9a5d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ba7314e68c4b6abd4bdf1ad56bcd9a5d'] = async function fn_ba7314e68c4b6abd4bdf1ad56bcd9a5d(TutorName) {
var result, error, GetList, futureTuesdayTime, pastWednesdayTime, wednesdayNumber, DateToday;


  try {
    DateToday = (new Date(((new Date()).toUTCString())));
    wednesdayNumber = (new Date((new Date(DateToday))).getDay()) == 3 ? 7 : ((new Date((new Date(DateToday))).getDay()) == 2 ? 6 : ((new Date((new Date(DateToday))).getDay()) == 1 ? 5 : ((new Date((new Date(DateToday))).getDay()) == 0 ? 4 : (new Date((new Date(DateToday))).getDay()) - 3)));
    pastWednesdayTime = (new Date((new Date(([(new Date(DateToday).getFullYear()),'-',(new Date(DateToday).getMonth() + 1),'-',(new Date(DateToday).getDate()),' 00:00 UTC'].join('')))).getTime() - ((86400 * wednesdayNumber) * 1000)));
    futureTuesdayTime = (new Date((new Date(([(new Date((new Date(pastWednesdayTime))).getFullYear()),'-',(new Date((new Date(pastWednesdayTime))).getMonth() + 1),'-',(new Date((new Date(pastWednesdayTime))).getDate()),' 00:00 UTC'].join('')))).getTime() + ((7 * 86400) * 1000)));
    GetList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/9F43D21E-BF75-4D25-B709-77649C0E9DAF/data/tutorHours')).query(({ [`where`]: ['created >= \'',((new Date(pastWednesdayTime)).valueOf()),'\' and created < \'',((new Date(futureTuesdayTime)).valueOf()),'\' and service = \'MS\' and tutor = \'',(TutorName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and MSAnswer != null '].join(''),[`pageSize`]: 100 })).setEncoding('utf8').send());
    if (!!GetList.length) {
      result = true;
    } else {
      result = false;
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('CheckMSTutorQuestionnaire', 'An error was encountered during the process', error);

  }

return result
}

})
define('./functions/cad53b2c8115106fd3afcda20303acdc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cad53b2c8115106fd3afcda20303acdc'] = function fn_cad53b2c8115106fd3afcda20303acdc(method, message) {
  Backendless.Logging.getLogger(method).info(message);

return 
}

})
define('./functions/e1368ab112384907e31f5a48678e6ca4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'] = function fn_e1368ab112384907e31f5a48678e6ca4(LoggerName, LogMessage, LogChannel, LoggingStatus) {
  if (LoggingStatus) {
    if (LogChannel.indexOf('INFO') !== -1) {
      Backendless.Logging.getLogger(LoggerName).info(LogMessage);
    } else if (LogChannel.indexOf('WARN') !== -1) {
      Backendless.Logging.getLogger(LoggerName).warn(LogMessage);
    }
  } else {
    return null;
  }

return 
}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5a8b9b8e9f847485a03400888c80b17', (await Backendless.Data.of('subjects').find(Backendless.DataQueryBuilder.create().setWhereClause('tutor = \'Shlok Verma\'').setPageSize(10))));

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/Main_Page/components/61d448da23eaeea50aecdbc54fdc5c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, CreateEmail, CheckEmail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'sendEmail')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'sendEmail')).length) {
    (function (message) { alert(message) })('You need to enter an email to proceed.');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'sendEmail')).startsWith(' ')) {
    (function (message) { alert(message) })('Check email if it\'s correct.');
    return null;
  }
  CheckEmail = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\' or MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\''].join(''))).setPageSize(10)))[0];
  if ((typeof CheckEmail === 'undefined') || (CheckEmail === null)) {
    (function (message) { alert(message) })('Please enter an email that is registered on Brilliant Grades.');
    return null;
  } else {
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/BackendlessLoginAuthRestBlock`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`action`]: 'update',[`method`]: 'tutor_dash main page',[`databaseName`]: 'Users',[`requestType`]: 'serverSide',[`createObject`]: ({ [`password`]: ((getObjectProperty(CheckEmail, 'tutorType')) == 'Flex' || (getObjectProperty(CheckEmail, 'tutorType')) == 'Flex/Certified') && (getObjectProperty(CheckEmail, 'access_level')) == 'Teacher' ? (getObjectProperty(CheckEmail, 'zoomid')) : (getObjectProperty(CheckEmail, 'MS_teacher_password')),[`objectId`]: (getObjectProperty(CheckEmail, 'objectId')) }) })));
      CreateEmail = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': ((new Date()).valueOf()),'lead_id': (getObjectProperty(CheckEmail, 'lead_id')),'sender_name': 'Brilliant Grades','sender_email': 'notifications@brilliantgrades.com','to': (getObjectProperty(___arguments.context.pageData, 'sendEmail')),'body_html': (['Your account has been reset, please try entering with email = ',(getObjectProperty(CheckEmail, 'email')),'',String(' and password= ') + String(((getObjectProperty(CheckEmail, 'tutorType')) == 'Flex' || (getObjectProperty(CheckEmail, 'tutorType')) == 'Flex/Certified') && (getObjectProperty(CheckEmail, 'access_level')) == 'Teacher' ? (getObjectProperty(CheckEmail, 'zoomid')) : (getObjectProperty(CheckEmail, 'MS_teacher_password'))),'. <br><br>','Thank you!'].join('')),'subject': 'Forgot Password' }));
      (function (message) { alert(message) })('Your password has been sent. Kindly check your email. Thank you!');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc99353c6efa6e72a386bf3ba68587c', false);
      Backendless.Logging.getLogger('Main_Page').info((['Password was sent to the email:',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\\nEmail Content:',CreateEmail].join('')));

    } catch (error) {
      console.log(error);
      Backendless.Logging.getLogger('Main_Page').error((String('There was an error in sending the email. Error:\\n') + String(error)));

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    
  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var checkUser, LoginData, error, StudentDIRObject, password, email, Parameter, ParameterList, UTMValue, UTMName, AnsweredQuestion, Parameters, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) == true) {
    console.log(['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''));
    checkUser = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(1)))[0];
    console.log(checkUser);
    try {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'zoomid')), false  ));

    } catch (error) {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'MS_teacher_password')), false  ));

    }
    if ((getObjectProperty(checkUser, 'name')) == 'TestNicolasTutor Live') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_refactored', ({ [`LoginData`]: LoginData,[`userEmail`]: (typeof (getObjectProperty(checkUser, 'MS_teacher_email')) === 'undefined') || ((getObjectProperty(checkUser, 'MS_teacher_email')) === null) ? (getObjectProperty(checkUser, 'email')) : (getObjectProperty(checkUser, 'MS_teacher_email')) }));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_ms', ({ [`LoginData`]: LoginData,[`userEmail`]: (typeof (getObjectProperty(checkUser, 'MS_teacher_email')) === 'undefined') || ((getObjectProperty(checkUser, 'MS_teacher_email')) === null) ? (getObjectProperty(checkUser, 'email')) : (getObjectProperty(checkUser, 'MS_teacher_email')) }));
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Main_Page/components/c452784297afc3ca082dbd58a2eecd79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  await socialLogin('googleplus', ({ [`email`]: 'email',[`name`]: 'name' }), null, null, 'googleRedirectClever_refactored', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/e878644a01da6cdc1a1fe8c3f71b5f6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string') || (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/605d81c2f7e4c4b27af8544eac4cdf82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoginData, tutorData, adminData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'email')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your email address';
      return null;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'phoneNumber')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your phone number';
      return null;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'Admin') {
      adminData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType != \'Teacher\''].join(''))).setPageSize(10)))[0];
      if (!(typeof adminData === 'undefined')) {
        try {
          LoginData = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'phoneNumber')), true  ));
          Backendless.Logging.getLogger('Main_Page').info((['Admin Login successfully.\nEmail used:',(getObjectProperty(___arguments.context.pageData, 'email')),'\nLogged in User Name:',(getObjectProperty(LoginData, 'name')),'\nEmail:',(getObjectProperty(LoginData, 'email')),'\nData:',(JSON.stringify(LoginData))].join('')));
          if (typeof (getObjectProperty(___arguments.context.pageData, 'fromLeadsUI')) === 'string') {
            (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Core Administrator' }),'redirectPage': 'Leads UI' })), false, ({ [`q`]: (getObjectProperty(___arguments.context.pageData, 'fromLeadsUI')) }));
          }
          (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Core Administrator' }) })), false, ({ [`adminEmail`]: (getObjectProperty(LoginData, 'email')),[`phoneNumber`]: (getObjectProperty(___arguments.context.pageData, 'phoneNumber')),[`fromMainPortal`]: true }));

        } catch (error) {
          console.log(String('There was an error in logging in as Admin. \nError:') + String(error));
          Backendless.Logging.getLogger('Main_Page').debug((['There was an error in logging in as Admin. \nError:',error,'\nEmail: ',(getObjectProperty(___arguments.context.pageData, 'email')),'\nPassword: ',(getObjectProperty(___arguments.context.pageData, 'phoneNumber'))].join('')));

        }
      } else {
        (function (message) { alert(message) })('Please use your registered Admin Account!');
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'tutor') {
      tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((((getObjectProperty(___arguments.context.pageData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? ['MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join('') : ['email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join(''))).setPageSize(10)))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'email')).indexOf('brilliantmicroschool.org') !== -1) {
        if (tutorData !== null && !Array.isArray(tutorData) && (typeof tutorData === 'object')) {
          (function (message) { alert(message) })('It looks like you\'re trying to login using your School Email. Please use the Teacher Account login instead!');
          await Backendless.Data.of('Users').save( ({ [`objectId`]: (getObjectProperty(tutorData, 'objectId')),[`password`]: (getObjectProperty(tutorData, 'MS_teacher_password')) }) );
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': ((new Date()).valueOf()),'lead_id': (getObjectProperty(tutorData, 'lead_id')),'sender_name': 'BMS Administration','sender_email': 'help@brilliantmicroschool.org','to': (((getObjectProperty(tutorData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? (getObjectProperty(tutorData, 'email')) : (getObjectProperty(tutorData, 'MS_teacher_email'))),'body_html': (['Hi ',(getObjectProperty(tutorData, 'name')),',','<br><br>','Here is your BMS Google Account credential','<br>','Email Address: ',(getObjectProperty(tutorData, 'MS_teacher_email')),'<br>Password: ',(getObjectProperty(tutorData, 'MS_teacher_password'))].join('')),'subject': 'BMS School Portal Login Credential' });
        } else {
          (function (message) { alert(message) })('Invalid login credentials. Please try again!');
        }
      } else {
        if (!(typeof tutorData === 'undefined')) {
          if ((getObjectProperty(tutorData, 'MS_teacher_email')) === null) {
            try {
              LoginData = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'phoneNumber')), true  ));
              Backendless.Logging.getLogger('Main_Page').info((['Tutor Login successfully.\nEmail used:',(getObjectProperty(___arguments.context.pageData, 'email')),'\nLogged in User Name:',(getObjectProperty(LoginData, 'name')),'\nEmail:',(getObjectProperty(LoginData, 'email')),'\nData:',(JSON.stringify(LoginData))].join('')));
              (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Tutor' }) })), false, ({ [`tutorName`]: ((getObjectProperty(tutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`userEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`fromMainPortal`]: true }));

            } catch (error) {
              Backendless.Logging.getLogger('Main_Page').debug((['Wrong Tutor Credentials. \nError:',error,'\nCredentials:\nEmail:',(getObjectProperty(___arguments.context.pageData, 'email')),'\nPassword:',(getObjectProperty(___arguments.context.pageData, 'phoneNumber'))].join('')));
              (function (message) { alert(message) })('Invalid login credentials. Please try again!');

            }
          } else {
            if ((getObjectProperty(___arguments.context.pageData, 'phoneNumber')) == (getObjectProperty(tutorData, 'zoomid'))) {
              (function (message) { alert(message) })('It looks like your password was updated. Please check your email registered in BMS School for the updated password! Thank you!');
              await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': ((new Date()).valueOf()),'lead_id': (getObjectProperty(tutorData, 'lead_id')),'sender_name': 'BMS Administration','sender_email': 'help@brilliantmicroschool.org','to': (((getObjectProperty(tutorData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? (getObjectProperty(tutorData, 'email')) : (getObjectProperty(tutorData, 'MS_teacher_email'))),'body_html': (['Hi ',(getObjectProperty(tutorData, 'name')),',','<br><br>','Here is your login credential on the BMS School Tutor Portal','<br>','Email Address: ',(getObjectProperty(tutorData, 'email')),'<br>','Password: ',(getObjectProperty(tutorData, 'MS_teacher_password'))].join('')),'subject': 'BMS School Portal Login Credential' });
            } else {
              try {
                LoginData = (await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(___arguments.context.pageData, 'phoneNumber')), true  ));
                (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Tutor' }) })), false, ({ [`tutorName`]: ((getObjectProperty(tutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`userEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`fromMainPortal`]: true }));
                Backendless.Logging.getLogger('Main_Page').info((['Teacher login manually.\nEmail used:',(getObjectProperty(___arguments.context.pageData, 'email')),'\nLogged in User Name:',(getObjectProperty(LoginData, 'name')),'\nEmail:',(getObjectProperty(LoginData, 'email')),'\nData:',(JSON.stringify(LoginData))].join('')));

              } catch (error) {
                Backendless.Logging.getLogger('Main_Page').debug((['Wrong Tutor Credentials. \nError:',error,'\nCredentials:\nEmail:',(getObjectProperty(___arguments.context.pageData, 'email')),'\nPassword:',(getObjectProperty(___arguments.context.pageData, 'phoneNumber'))].join('')));
                (function (message) { alert(message) })('Invalid login credentials. Please try again!');

              }
            }
          }
        } else {
          (function (message) { alert(message) })('Please use your registered email Tutor Account!');
        }
      }
    }

  } catch (error) {
    Backendless.Logging.getLogger('Main_Page').info((['Problem with logging in manually. \nError:',error,'\nCredentials:\nEmail:',(getObjectProperty(___arguments.context.pageData, 'email')),'\nPassword:',(getObjectProperty(___arguments.context.pageData, 'phoneNumber'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/668814050db6f454cfd2480960c390a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc99353c6efa6e72a386bf3ba68587c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/82cab10ae09d5e537bc8b1dccea832a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'teacher' || (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'student'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/30456e88e23de205184a0ba3ea71ccd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'Admin';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/714f3231a8173c960e4c2818be28a98a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'teacher';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/5261e619e3df555b028515fc3d683ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'student';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/f5ba947804386f0edebdf656cfe63923/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'Admin' || (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'tutor'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/41115e9a4d6d0e49303b33f8810a5428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/d2fbfb49e6cda32a3a3c2539a09e7a19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;
  ___arguments.context.pageData['sendPasswordVisibility'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/98f2983d039dac84d344ef1cb896fab2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'loginAs')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/80d5e9b9253437470641face3a2ef099/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'tutor';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/2b3732fa66d8e0b2289343b700eb89be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'Parent';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/f09557bd9cfcb2b894c58391fdf624c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, parentData, date, CreateEmail, _result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  try {
    if ((typeof (getObjectProperty(___arguments.context.pageData, 'sendEmail')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'sendEmail')).length) {
      (function (message) { alert(message) })('You need to enter an email to proceed.');
      return null;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'sendEmail')).indexOf(' ') !== -1) {
      (function (message) { alert(message) })('Check email if it\'s correct.');
      return null;
    }
    _result = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['email=\'',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\' or parent_email=\'',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\' and status = \'enrolled\''].join(''))).setProperties('email,lead_id').setPageSize(10)))[0];
    if (typeof _result === 'undefined') {
      (function (message) { alert(message) })('The email you entered is not registered or has been disabled. Please contact our support team at help@brilliantmicroschool.org');
      ___arguments.context.pageData['errorMessage'] = 'Email is not registered.';
      ___arguments.context.pageData['errorMessageDisplay'] = false;
      return null;
    } else {
      parentData = _result;
    }
    ___arguments.context.pageData['otp'] = (mathRandomInt(1, 999999));
    await Backendless.Cache.put((String('parentOTP-') + String(getObjectProperty(parentData, 'lead_id'))), (getObjectProperty(___arguments.context.pageData, 'otp')), 7200);
    date = (new Date((new Date()).getTime() + (600 * 1000)));
    ___arguments.context.pageData['parentData'] = parentData;
    console.log(await Backendless.Cache.get((String('parentOTP-') + String(getObjectProperty(parentData, 'lead_id')))));
    console.log(getObjectProperty(___arguments.context.pageData, 'parentData'));
    CreateEmail = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'outbox','lead_id': (getObjectProperty(parentData, 'lead_id')),'sender_name': 'Brilliant Microschools','sender_email': 'otp@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.pageData, 'sendEmail')),'body_html': (['Your OTP is ',(getObjectProperty(___arguments.context.pageData, 'otp')),'<br><br>Please enter your OTP in the corresponding text box to access the Student Information Form.','<br>Please note that the OTP will expire in 2 hours<br><br>','Thank you!','<br><br>Please do not reply to this email. <br>If you need to reach us, contact us at help@brilliantmicroschool.org.'].join('')),'subject': 'OTP for Student Information Form' }));
    ___arguments.context.pageData['loginAs'] = 'OTP';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/ce5328873ca96d53a7d2290160440d25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'Parent')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/c72dd1d60c4e4516fc2f910b3a277571/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/b3161c0458abedad11dea24932f34e33/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'OTP')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/8077be9110cd860615f20bcff0f60957/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/eacd792aa0a10d16bc19a41fc49f4de8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, OTPfromCache;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    OTPfromCache = (await Backendless.Cache.get((String('parentOTP-') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'parentData')), 'lead_id')))));
    if (!(typeof OTPfromCache === 'number' && !isNaN(OTPfromCache))) {
      (function (message) { alert(message) })('One time pin expired. Please send a new one and try again');
      return null;
    }
    console.log(OTPfromCache);
    console.log(getObjectProperty(___arguments.context.pageData, 'OneTimePin'));
    if (OTPfromCache == (getObjectProperty(___arguments.context.pageData, 'OneTimePin'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Parent' }) })), false, ({ [`fromMainPortal`]: true,[`lead_id`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'parentData')), 'lead_id')) }));
    } else {
      (function (message) { alert(message) })('Invalid one time pin. Please check and try again');
    }

  } catch (error) {
    Backendless.Logging.getLogger('Parent Login OTP').debug((String('There was an error with the Parent Login OTP ') + String(getObjectProperty(error, 'message'))));
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/9ab5596d56f533660d058379ce855d63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  await socialLogin('googleplus', ({ [`email`]: 'email',[`name`]: 'name' }), null, null, 'googleRedirectClever_refactored', null);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'loginAs')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'Admin')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/5a41c6fd4fc76a594f68df681c023452/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  await socialLogin('googleplus', ({ [`email`]: 'email',[`name`]: 'name' }), null, null, 'googleRedirectClever_refactored', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/431683cead2f9fe636b9ec579d46194b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'loginAs')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'Admin')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page_Test_Mode/components/458cee1694c930d5daebeaef7344837a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, checkUser, LoginData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'email')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your email address';
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'zoomid')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your Zoom ID';
    }
    checkUser = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['(MS_teacher_email = \'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' or email = \'',(getObjectProperty(___arguments.context.pageData, 'email')),'\') and accountType = \'BACKENDLESS\''].join(''),[`pageSize`]: 1,[`property`]: ['timezones.offsetHour', '*'] })).setEncoding('utf8').send())[0];
    LoginData = (await Backendless.UserService.login( ((checkUser !== null && !Array.isArray(checkUser) && (typeof checkUser === 'object')) ? (getObjectProperty(checkUser, 'email')) : (getObjectProperty(___arguments.context.pageData, 'email'))), (getObjectProperty(___arguments.context.pageData, 'zoomid')), (getObjectProperty(___arguments.context.pageData, 'rememberMe'))  ));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_ms', ({ [`LoginData`]: LoginData,[`userEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`test_mode`]: true,[`SystemDate`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'SystemDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'SystemDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'SystemDate'))).getFullYear()),' 23:59 GMT',((getObjectProperty(checkUser, 'offsetHour')).replace((new RegExp('h', '')), ''))].join('')))).valueOf()) }));
    console.log({ [`LoginData`]: LoginData,[`userEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`test_mode`]: true,[`SystemDate`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'SystemDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'SystemDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'SystemDate'))).getFullYear()),' 23:59 GMT',((getObjectProperty(checkUser, 'offsetHour')).replace((new RegExp('h', '')), ''))].join('')))).valueOf()) });

  } catch (error) {
    checkUser = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['email = \'',(getObjectProperty(___arguments.context.pageData, 'email')),'\''].join(''),[`pageSize`]: 1 })).setEncoding('utf8').send());
    if (!checkUser.length) {
      ___arguments.context.pageData['status'] = 'Please use the email registered with Brilliant Grades';
    } else {
      if ((getObjectProperty((checkUser[0]), 'userStatus')) == 'ENABLED') {
        ___arguments.context.pageData['status'] = 'Please use the Zoom ID registered with Brilliant Grades';
      } else {
        ___arguments.context.pageData['status'] = 'Please contact Brilliant Grades regarding your account';
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ee6cfee8e729bc2db348203ef54331b', true);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_Test_Mode/components/86bf51bd353e63cf1222e8f56c29e939/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(await Backendless.UserService.isValidLogin());
  console.log(getObjectProperty(___arguments.context.pageData, 'rememberMe'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_Test_Mode/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var betaList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (await Backendless.UserService.isValidLogin()) {
    Backendless.setCurrentUserToken((Backendless.getCurrentUserToken()));
    console.log(await Backendless.UserService.getCurrentUser(true));
    betaList = ['andreas@choplinventures.com', 'nicolas@brilliantgrades.com', 'nicolas+44@brilliantgrades.com', 'marigrace.rosenberry@gmail.com', 'qmccaulley@yahoo.com', 'bradymolly365@gmail.com', 'shevieb@gmail.com'];
    if (betaList.includes((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('NewHomeworkUITestPage', ({ [`LoginData`]: (await Backendless.UserService.getCurrentUser(false)),[`userEmail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }));
    }
  }

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var checkUser, LoginData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) == true) {
    checkUser = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(1)))[0];
    LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'zoomid')), false  ));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_ms_test', ({ [`LoginData`]: LoginData,[`userEmail`]: (getObjectProperty(checkUser, 'email')) }));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Main_Page_old/components/61d448da23eaeea50aecdbc54fdc5c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var CheckEmail, CreateEmail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'sendEmail')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'sendEmail')).length) {
    (function (message) { alert(message) })('You need to enter an email to proceed.');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'sendEmail')).startsWith(' ')) {
    (function (message) { alert(message) })('Check email if it\'s correct.');
    return null;
  }
  CheckEmail = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\' or MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\''].join(''))).setPageSize(10)))[0];
  if ((typeof CheckEmail === 'undefined') || (CheckEmail === null)) {
    (function (message) { alert(message) })('Please enter an email that is registered on Brilliant Grades.');
    return null;
  } else {
    await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/BackendlessLoginAuthRestBlock`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`action`]: 'update',[`method`]: 'tutor_dash main page',[`databaseName`]: 'Users',[`requestType`]: 'serverSide',[`createObject`]: ({ [`password`]: (getObjectProperty(CheckEmail, 'userType')) == 'Teacher' ? (getObjectProperty(CheckEmail, 'zoomid')) : String('') + String(getObjectProperty(CheckEmail, 'zoomid')),[`objectId`]: (getObjectProperty(CheckEmail, 'objectId')) }) })));
    CreateEmail = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': ((new Date()).valueOf()),'lead_id': (getObjectProperty(CheckEmail, 'lead_id')),'sender_name': 'Brilliant Grades','sender_email': 'notifications@brilliantgrades.com','to': (getObjectProperty(___arguments.context.pageData, 'sendEmail')),'body_html': (['Your account has been reset, please try entering with email = ',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'',String(' and zoomid = ') + String(getObjectProperty(CheckEmail, 'zoomid')),'. <br><br>','Thank you!'].join('')),'subject': 'Forgot Password' }));
    (function (message) { alert(message) })('Successfully sent email!');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc99353c6efa6e72a386bf3ba68587c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    
  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, checkUser, LoginData, urlData, StudentDIRObject, password, email, Parameter, ParameterList, UTMValue, UTMName, AnsweredQuestion, Parameters, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) == true) {
      console.log(['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''));
      checkUser = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setProperties('email,zoomid,MS_teacher_password').setPageSize(1)))[0];
      try {
        LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'zoomid')), false  ));

      } catch (error) {
        LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'MS_teacher_password')), false  ));

      }
      urlData = ({ [`LoginData`]: ({ [`name`]: (getObjectProperty(LoginData, 'name')) }),[`userEmail`]: (typeof (getObjectProperty(checkUser, 'MS_teacher_email')) === 'undefined') || ((getObjectProperty(checkUser, 'MS_teacher_email')) === null) ? (getObjectProperty(checkUser, 'email')) : (getObjectProperty(checkUser, 'MS_teacher_email')) });
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
        urlData['fromAP'] = true;
        urlData['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
        urlData['fromSA'] = true;
        urlData['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      }
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_ms', urlData);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Main Page').debug((String('Problem encounter in Page Enter | Error: ') + String(error)));

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Main_Page_old/components/c452784297afc3ca082dbd58a2eecd79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  await socialLogin('googleplus', ({ [`email`]: 'email',[`name`]: 'name' }), null, null, 'googleRedirectClever', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/e878644a01da6cdc1a1fe8c3f71b5f6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string') || (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page_old/components/605d81c2f7e4c4b27af8544eac4cdf82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var checkUser, LoginData, tutorData, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'loginAs'));
  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'email')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your email address';
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'phoneNumber')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your phone number';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'PS') {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'phoneNumber')), true  ));
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Admin/index.html?page=admin_index_page&data=', false, ({ [`adminEmail`]: (getObjectProperty(LoginData, 'email')),[`phoneNumber`]: (getObjectProperty(___arguments.context.pageData, 'phoneNumber')),[`fromMainPortal`]: true }));
    } else if ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'tutor') {
      if ((getObjectProperty(___arguments.context.pageData, 'email')).indexOf('brilliantmicroschool.org') !== -1) {
        tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((((getObjectProperty(___arguments.context.pageData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? ['MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join('') : ['email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join(''))).setPageSize(10)))[0];
        (function (message) { alert(message) })('It looks like you\'re trying to login using your School Email, Please use the teacher account login instead');
        if (tutorData !== null && !Array.isArray(tutorData) && (typeof tutorData === 'object')) {
          await Backendless.Data.of('Users').save( ({ [`objectId`]: (getObjectProperty(tutorData, 'objectId')),[`password`]: (getObjectProperty(tutorData, 'zoomid')) }) );
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': ((new Date()).valueOf()),'lead_id': (getObjectProperty(tutorData, 'lead_id')),'sender_name': 'BMS Administration','sender_email': 'help@brilliantmicroschool.org','to': (((getObjectProperty(tutorData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? (getObjectProperty(tutorData, 'MS_teacher_email')) : (getObjectProperty(tutorData, 'email'))),'body_html': (['Hi ',(getObjectProperty(tutorData, 'name')),',','<br><br>','Here is your login credential on the BMS School Portal','<br>','Email Address: ',(getObjectProperty(tutorData, 'email')),'<br>','Password: ',(getObjectProperty(tutorData, 'zoomid'))].join('')),'subject': 'BMS School Portal Login Credential' });
        }
      } else {
        tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((((getObjectProperty(___arguments.context.pageData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? ['MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join('') : ['email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join(''))).setPageSize(10)))[0];
        try {
          LoginData = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'phoneNumber')), true  ));

        } catch (error) {
          console.log('1');
          console.log(error);
          console.log(getObjectProperty(error, 'message'));
          if ((getObjectProperty(tutorData, 'MS_teacher_email')) === null) {
            LoginData = (await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'zoomid')), true  ));
          } else {
            if ((getObjectProperty(tutorData, 'zoomid')) == (getObjectProperty(___arguments.context.pageData, 'phoneNumber'))) {
              (function (message) { alert(message) })('It looks like your password was updated. Please check your email registered in BMS School for the updated password! Thank you!');
              await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': ((new Date()).valueOf()),'lead_id': (getObjectProperty(tutorData, 'lead_id')),'sender_name': 'BMS Administration','sender_email': 'help@brilliantmicroschool.org','to': (((getObjectProperty(tutorData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? (getObjectProperty(tutorData, 'MS_teacher_email')) : (getObjectProperty(tutorData, 'email'))),'body_html': (['Hi ',(getObjectProperty(tutorData, 'name')),',','<br><br>','Here is your login credential on the BMS School Portal','<br>','Email Address: ',(getObjectProperty(tutorData, 'email')),'<br>','Password: ',(getObjectProperty(tutorData, 'MS_teacher_password'))].join('')),'subject': 'BMS School Portal Login Credential' });
            } else {
              (function (message) { alert(message) })('Invalid login credentials. Please use the registered Tutor Account!');
            }
          }

        }
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_ms', ({ [`LoginData`]: LoginData,[`userEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`fromMainPortal`]: true }));
      }
    }

  } catch (error) {
    console.log('2');
    console.log(error);
    console.log(getObjectProperty(error, 'message'));
    tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((((getObjectProperty(___arguments.context.pageData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? ['MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join('') : ['email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join(''))).setPageSize(10)))[0];
    LoginData = (await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'zoomid')), true  ));
    if ((getObjectProperty(tutorData, 'name')) == 'TestNicolasTutor Live') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_refactored', ({ [`LoginData`]: LoginData,[`userEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`fromMainPortal`]: true }));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_dash_ms', ({ [`LoginData`]: LoginData,[`userEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`fromMainPortal`]: true }));
    }
    if (false) {
      checkUser = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['(email = \'',(getObjectProperty(___arguments.context.pageData, 'email')),'or MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\') and accountType=\'BACKENDLESS\''].join(''))).setPageSize(1)));
      if (!checkUser.length) {
        ___arguments.context.pageData['status'] = 'Please use the email registered with Brilliant Grades';
      } else {
        if ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'PS') {
          ___arguments.context.pageData['status'] = 'Please use the phone number registered with Brilliant Grades as the password';
        } else {
          ___arguments.context.pageData['status'] = 'We have sent you login credential on your BMS Account. Please check and retry again.';
        }
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a12d78fa3fface8e46d419d9a0de6554', true);
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/668814050db6f454cfd2480960c390a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc99353c6efa6e72a386bf3ba68587c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/82cab10ae09d5e537bc8b1dccea832a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'teacher' || (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'student'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page_old/components/30456e88e23de205184a0ba3ea71ccd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'PS';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/714f3231a8173c960e4c2818be28a98a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'teacher';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/5261e619e3df555b028515fc3d683ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'student';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/f5ba947804386f0edebdf656cfe63923/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'PS' || (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'tutor'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page_old/components/41115e9a4d6d0e49303b33f8810a5428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/d2fbfb49e6cda32a3a3c2539a09e7a19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;
  ___arguments.context.pageData['sendPasswordVisibility'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page_old/components/98f2983d039dac84d344ef1cb896fab2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'loginAs')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page_old/components/80d5e9b9253437470641face3a2ef099/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'tutor';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/card_carousel/components/d1ac79689add8f4b1101caa6d7ea2933/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'main_card_no'));
  if ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) + 1 >= (getObjectProperty(___arguments.context.pageData, 'card_list')).length) {
    ___arguments.context.pageData['main_card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_list')).length);
  } else if ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) + 1 < (getObjectProperty(___arguments.context.pageData, 'card_list')).length) {
    ___arguments.context.pageData['main_card_no'] = ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) + 1);
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'main_card_no'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) >= (getObjectProperty(___arguments.context.pageData, 'card_list')).length)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/card_carousel/components/782803b6b3e9a6a320119861ecb6116a/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    var card_list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`card_title`]: (getObjectProperty((card_list[0]), 'card_name')),[`main_card_no`]: (getObjectProperty((card_list[0]), 'card_no')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/card_carousel/components/99efd2def4bd5b87007c2134005c5dfd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'card_list'))[((getObjectProperty(___arguments.context.pageData, 'main_card_no')) - 1)]), 'card_name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/card_carousel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['card_list'] = [({ [`card_name`]: 'CARD 1',[`card_no`]: 1 }), ({ [`card_name`]: 'CARD 2',[`card_no`]: 2 }), ({ [`card_name`]: 'CARD 3',[`card_no`]: 3 })];
  ___arguments.context.pageData['main_card_no'] = 1;
  ___arguments.context.pageData['card_no'] = 1;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/card_carousel/components/072f97a7e9a955edcf8e9b4463321d75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) - 1 <= 1) {
    ___arguments.context.pageData['main_card_no'] = 1;
  } else if ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) - 1 > 1) {
    ___arguments.context.pageData['main_card_no'] = ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) - 1);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'main_card_no')) == 1)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/card_carousel/components/df4b6391fce686c432b6dc526194ccac/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var records, i;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  records = [];
  records = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Onboarding Training (Microschool Only)',[`card_instruction`]: 'Have you dedicated any hours to onboarding training?',[`card_instruction2`]: 'If so, please indicate the number of hours spent and provide a description of the training process.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Extra Meetings (Microschool Only)',[`card_instruction`]: 'Were there any additional meetings scheduled for the week?',[`card_instruction2`]: 'If so, please provide the number of hours spent in each meeting along with a brief description.',[`card_instruction3`]: 'Kindly exclude the grade band meeting, as it will be accounted for automatically.',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 4,[`card_name`]: 'House Leader (Microschool Only)',[`card_instruction`]: 'This is exclusively intended for use by house leaders.',[`card_instruction2`]: 'Kindly include your hours related to the house administration.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 5,[`card_name`]: 'Curriculum Design (Microschool Only)',[`card_instruction`]: 'Have you been involved in Curriculum Design work for the week?',[`card_instruction2`]: 'If so, please provide the hours dedicated to it below, along with a description of the specific sections you worked on.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 6,[`card_name`]: 'Admin Hours (Microschool Only)',[`card_instruction`]: 'Do you have any administrative hours to report?',[`card_instruction2`]: 'If so, please specify the number of hours and describe the tasks undertaken during that time.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 7,[`card_name`]: 'Shadowing Hours (Microschool Only)',[`card_instruction`]: 'Have you engaged in any Shadowing Hours this week?',[`card_instruction2`]: 'If so, kindly list the hours below and provide a description detailing which classes you shadowed and the primary teacher for each.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 8,[`card_name`]: 'Progress Reports (Microschool Only)',[`card_instruction`]: 'Have you sent progress reports?',[`card_instruction2`]: 'If so, please specify the number of hours allocated for this task and provide a brief description of the process involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 9,[`card_name`]: 'Progress Reports (Microschool Only)',[`card_instruction`]: 'Have you been involved in any Special Projects?',[`card_instruction2`]: 'If so, please specify the number of hours dedicated to them and provide a brief description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '' }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 10,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: 'Caution: If the project hours could fit into a previous category, please use that category instead.',[`card_warning1`]: 'This category (Other Hours) should not include meetings, training, shadowing, or any activities previously described.' })];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('df4b6391fce686c432b6dc526194ccac', records);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/card_carousel/components/3e37d5d1ff36e11a9ca261ebca9dff9a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'UUID'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3e37d5d1ff36e11a9ca261ebca9dff9a'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/card_carousel/components/ef9f08333b1935d1ca5304438f3bf1e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac'));
  console.log(getObjectProperty(___arguments.context.pageData, 'card_no'));
  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac')).length) {
    ___arguments.context.pageData['card_no'] = (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac')).length);
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac'))[(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac')).length - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 < ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac')).length) {
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'card_no'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac')).length)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/card_carousel/components/fdbd56c9c08a37432bdd7518d59f34b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 <= 1) {
    ___arguments.context.pageData['card_no'] = 1;
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac'))[0]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 > 1) {
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1);
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('df4b6391fce686c432b6dc526194ccac'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) == 1)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/card_carousel/components/b959f88849a9ac99562f1f4e01a6cfd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e37d5d1ff36e11a9ca261ebca9dff9a'), 'card_warning'))) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/card_carousel/components/e071336ac113ffa70e8552daebe1a9f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e37d5d1ff36e11a9ca261ebca9dff9a'), 'card_warning'))) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/card_carousel/components/e489bc8ab499fac93c7cc1120c3eb725/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e37d5d1ff36e11a9ca261ebca9dff9a'), 'card_warning1'))) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/card_carousel/components/433dcfe822c52a6e7572bf6b00454ae9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e37d5d1ff36e11a9ca261ebca9dff9a'), 'card_instruction3'))) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/googleRedirectClever/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var TeacherData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((await Backendless.UserService.getCurrentUser(false)) === null) || (typeof (await Backendless.UserService.getCurrentUser(false)) === 'undefined')) {
    return null;
  }
  console.log(await Backendless.UserService.isValidLogin());
  console.log(await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=parent_student_sso&data=', false, ({ [`fromMainPortal`]: true }));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('brilliantmicroschool.org') !== -1) {
    TeacherData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=tutor_sso&data=', false, ({ [`fromMainPortal`]: true,[`email`]: (getObjectProperty(TeacherData, 'email')) }));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/googleRedirectClever_refactored/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, UserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(await Backendless.UserService.getCurrentUser(false));
  if (((await Backendless.UserService.getCurrentUser(false)) === null) || (typeof (await Backendless.UserService.getCurrentUser(false)) === 'undefined')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);
  }
  try {
    UserData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name like \'%',((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'%\' and accountType=\'BACKENDLESS\' and (email =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\' or MS_teacher_email =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\') or (MS_teacher_email = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\' and accountType = \'BACKENDLESS\')'].join(''))).setProperties('name, email,userType,access_level,tutorType').setPageSize(10)))[0];
    console.log(UserData);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('googleRedirectClever_refactored').error((['Error in getting the user data | Error:\n',error,'\nUser Data:\n',(await Backendless.UserService.getCurrentUser(false))].join('')));

  }
  try {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1) {
      UserData = ({ [`access_level`]: 'Student' });
      try {
        Backendless.Logging.getLogger('googleRedirectClever').info((String('Login successfully. User:\n') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))));
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': UserData })), false, ({ [`fromMainPortal`]: true }));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('googleRedirectClever').debug((['Login Error: Student:\n',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

      }
    }
    if (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('brilliantmicroschool.org') !== -1) && ((getObjectProperty(UserData, 'userType')).indexOf('Teacher') !== -1) && !((getObjectProperty(UserData, 'tutorType')).indexOf('Flex') !== -1)) {
      try {
        Backendless.Logging.getLogger('googleRedirectClever').info((String('Login successfully. User:\n') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))));
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': UserData })), false, ({ [`fromMainPortal`]: true,[`name`]: (getObjectProperty(UserData, 'name')),[`email`]: (getObjectProperty(UserData, 'email')) }));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('googleRedirectClever_refactored').debug((['Login Error: Teacher:\n',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

      }
    } else if (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('brilliantmicroschool.org') !== -1) && ((getObjectProperty(UserData, 'userType')).indexOf('Teacher') !== -1) && ((getObjectProperty(UserData, 'tutorType')).indexOf('Flex') !== -1)) {
      try {
        Backendless.Logging.getLogger('googleRedirectClever').info((String('Login successfully. User:\n') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))));
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Tutor' }) })), false, ({ [`fromMainPortal`]: true,[`tutorName`]: ((getObjectProperty(UserData, 'name')).replace((new RegExp('\\s', '')), '_')),[`userEmail`]: (getObjectProperty(UserData, 'email')) }));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('googleRedirectClever').debug((['Login Error: Tutor:\n',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

      }
    }
    if (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('brilliantmicroschool.org') !== -1) && !((getObjectProperty(UserData, 'userType')).indexOf('Teacher') !== -1)) {
      try {
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Core Administrator' }) })), false, ((getObjectProperty(UserData, 'access_level')) == 'Core Administrator' ? ({ [`adminEmail`]: (getObjectProperty(UserData, 'email')) }) : ({ [`fromMainPortal`]: true,[`email`]: (getObjectProperty(UserData, 'email')),[`name`]: (getObjectProperty(UserData, 'name')) })));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('Teacher Login Error').debug((['Login Error: Teacher:\n',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

      }
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('googleRedirectClever').debug((['Error in redirection. User:',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var tutor, userName, welcomeNotes, error, returnData, i, loadTextVal, hoursMSList, hoursList, announcements, checkUser, LoginData, test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

/**
 * Describe this function...
 */
async function initializePageData() {
  welcomeNotes = [', remember to start with a clear lesson objective!', ', remember to use crisp lesson segments in your session 🙂', ', just a reminder to use a "warm-up" today (aka \'Do Now\')', ', will you use an exit ticket at the end of your session today?', ', feel free to cold-call if your student is not talking enough.', ', try to have your student talk at least 50% of the time 🙏', ', just a reminder: precise is better than general praise!', ', a check for understanding can help you adjust your lesson mid-way...', ', may your session report be precise, thorough, and helpful for the student!'];
  return { [`houseLeader`]: ((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause('opp_status=\'enrolled\' and house_leader != null and house_leader != \'JomarTutor Live\'').setProperties('house_leader').setGroupBy('house_leader').setPageSize(100).setDistinct(true))).map(item => item['house_leader'])),[`card_no`]: 1,[`userName`]: userName,[`tutorSubjects`]: (getObjectProperty(tutor, 'subjects')),[`zoom`]: (getObjectProperty(tutor, 'zoom')),[`zoomid`]: (getObjectProperty(tutor, 'zoomid')),[`lead_id`]: (getObjectProperty(tutor, 'lead_id')),[`short_name`]: (getObjectProperty(tutor, 'short_name')),[`offSet`]: (getObjectProperty(tutor, 'offSet')),[`sign`]: (getObjectProperty(tutor, 'sign')),[`timezone`]: (getObjectProperty(tutor, 'timezone')),[`iana`]: (getObjectProperty(tutor, 'iana')),[`DriveTokenObject`]: (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0],[`MSExtraTimeList`]: [],[`DateToday`]: 1745280000000,[`loader`]: ['Hi ',userName.split(' ')[0],listsGetRandomItem(welcomeNotes, false)].join(''),[`loading_spinnerVisible`]: true,[`tutorSelector`]: ({ [`value`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`label`]: (getObjectProperty(___arguments.context.pageData, 'userName')) }),[`announcements`]: [],[`title`]: ['Hi ',userName.split(' ')[0],', welcome back!'].join(''),[`selector`]: 'reports',[`hasBMS`]: (typeof (getObjectProperty(tutor, 'MS_teacher_email')) === 'string') ? (((getObjectProperty(tutor, 'MS_teacher_email')).indexOf('@brilliantmicroschool.org') !== -1) ? true : false) : false }
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function showTest() {
  if (true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('98c34b8e62aaeb432ada42173c02448b', true);
    await new Promise(r => setTimeout(r, 250 || 0));
    test = [({ [`target`]: 'body',[`content`]: ['Hi ',userName,'! You can use this portal to review and submit your sessions or classes.'].join(''),[`disableBeacon`]: true,[`placement`]: 'center' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e')), 'el')),[`content`]: 'Click here to access your Tutoring & Private Sessions',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring & Private Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9be21fae0eef29a7b8cd16674d3411fe')), 'el')),[`content`]: 'Click here to access your Microschool Classes',[`placement`]: 'left',[`placementBeacon`]: 'left',[`title`]: 'Microschool Classes',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('39075dbc9d74db38793c3159bbf4fe59')), 'el')),[`content`]: 'Click here to see your past and current sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Past Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc17716809b5e5a5cd8913dd92bd72e9')), 'el')),[`content`]: 'Click here to see your future sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Future Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6f83a1196e4d9f887a4e0ba1e3b9284')), 'el')),[`content`]: 'Submit a ticket and we will get back to you within 24hrs.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Support',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db69da57441b0c5f05bee60c9ed3a0be')), 'el')),[`content`]: 'Click this to access more links/resources.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Explore',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79ab7744549adaff5491eed85f942c98')), 'el')),[`content`]: 'Click here to send your reports to the Student and Parent',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Reports',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2bc7badc91dd24529b363d8ac0c1338a')), 'el')),[`content`]: 'Click this plus button to access the tutoring extra hour section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac33164fd012e85afbe73d1e4c72c86f')), 'el')),[`content`]: 'This is where you can select a category for your extra hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Category',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d784a003d94b3000672f9938a65a8')), 'el')),[`content`]: 'This is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Input Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3287b7d1ed141a3e7ea27aa2c94652af')), 'el')),[`content`]: 'This is where you will add the description of the extra hour that you are going to enter',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e29cbb94966f7ad1371a1a0aa85e1f71')), 'el')),[`content`]: 'Click this button to add your extra hour in the hour to be submitted',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de')), 'el')),[`content`]: 'Submit your tutoring hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutor Hours Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34afc59ab7bf285faf9ac3f9c936faf9')), 'el')),[`content`]: 'Click the class name to see the student list of this specific class',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Student List',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('353be564809844c2ae8c2c66c1843b03')), 'el')),[`content`]: 'Click this bin icon to cancel a specific class before submitting it.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Cancel Class',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad13b5c129c3720e61ec643f4b8f52d8')), 'el')),[`content`]: 'Click this plus button to access the microschool extra hours section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('341e69ee2f6f94eb01681d5d151ffc67')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c03dd593e64185b5d0226e377eb0b31')), 'el')),[`content`]: 'This button will let you choose the next extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e80240f566633de7cda34bef372c9ff5')), 'el')),[`content`]: 'This button will let you choose the previous extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('389378220a8ed62cd0e392c2caeeac9a')), 'el')),[`content`]: 'This button will let you access the Add Hour Form of the chosen card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Add Hour Form',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a89e4ef41ca9a8ce33ff4dd20e93d95f')), 'el')),[`content`]: 'Input your extra hours here',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('82524489318c4a636811f3f45cacdd55')), 'el')),[`content`]: 'This is where you will enter the description of your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89bf71fbf8c4b4c7477c0139ab58584a')), 'el')),[`content`]: 'Click this to add your extra hours for review',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours to Review',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8d343d9778c0df6673d7d26cb0d0121')), 'el')),[`content`]: 'Click this to review your extra hours before submitting your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28b759ed749ebd638fcb7ed85a3981e7')), 'el')),[`content`]: 'This section is where you can review your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('71686cc3e1e32301badc353c2c9d8deb')), 'el')),[`content`]: 'Submit your MS Extra Hours once you are satisfied with the Extra Hours you input',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Submit MS Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065')), 'el')),[`content`]: 'Submit your Microschool Hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Hours',[`offset`]: 10,[`event`]: 'click' })];
    ___arguments.context.pageData['TourGuideOptions'] = test;
    ___arguments.context.pageData['loading_spinnerVisible'] = false;
    ___arguments.context.pageData['loader'] = '';
    await new Promise(r => setTimeout(r, 100 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).reset() })('8dbead2f0339fe91688571fa545216dc');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).start() })('8dbead2f0339fe91688571fa545216dc');
  }
}


  ___arguments.context.pageData['hasLoaded'] = false;
  try {
    await Backendless.UserService.logout();
    if (false) {
      await Backendless.UserService.login( 'nicolas+900@brilliantgrades.com', 'XLF%rMAX&Vu%7qC>', true  );
    } else {
      await Backendless.UserService.login( 'jessicamhawk@gmail.com', 'jhawk1e7889k', true  );
    }

  } catch (error) {
    console.log(error);

  }
  try {
    Backendless.Logging.getLogger('tutor_dash_ms').info((['User Info','\nLogged in User Name: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),'\nEmail: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\nData: ',(JSON.stringify((await Backendless.UserService.getCurrentUser(true))))].join('')));

  } catch (error) {
    console.log(error);

  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    try {

      ;(function() {
        const callback = async () => {
            ___arguments.context.pageData['currentTime'] = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: 'long',[`hour12`]: undefined,[`month`]: undefined,[`day`]: undefined,[`hour`]: undefined,[`minute`]: undefined,[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((new Date())));

        };

        const timerId = '';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
      ___arguments.context.pageData['LoginData'] = ({ [`user-token`]: (Backendless.getCurrentUserToken()) });
      userName = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      ___arguments.context.pageData['userEmail'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email'));
      console.log(JSON.stringify(({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) })));
      tutor = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\' and subjects is not null'].join(''),[`property`]: ['name', 'tip_level', 'timezones.short_name', 'timezones.iana', 'zoom', 'zoomid', 'timezones.offSet', 'timezones.sign', '*'],[`pageSize`]: 1 })).setEncoding('utf8').send())[0];
      if (!(tutor !== null && !Array.isArray(tutor) && (typeof tutor === 'object'))) {
        return null;
      }
      Object.assign(___arguments.context.pageData, (await initializePageData()));
      await BackendlessUI.Functions.Custom['fn_cad53b2c8115106fd3afcda20303acdc']('Page Enter / Tutor Dash', (['Tutor ',userName,' logged in on ',((new Date()).toUTCString()),' / ',((getObjectProperty(___arguments.context.pageData, 'userEmail')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userEmail')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) : (getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')));
      announcements = (await Backendless.Data.of('announcements').find(Backendless.DataQueryBuilder.create().setWhereClause((['(Tutor_Category = \'',((getObjectProperty(tutor, 'timezone')).indexOf('US') !== -1) ? 'US' : 'ROW','\' or Tutor_Category = \'ALL\') and announcement_live = true'].join(''))).setPageSize(100)));
      addItemToList((getObjectProperty(___arguments.context.pageData, 'announcements')), announcements);

    } catch (error) {
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / Page Enter', (JSON.stringify(({ [`message`]: 'Error caught while initializing data',[`data`]: ({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) }) }))), error);

    }
    try {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowTS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowMS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      hoursMSList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msQuestionnaire'] = (await BackendlessUI.Functions.Custom['fn_ba7314e68c4b6abd4bdf1ad56bcd9a5d'](userName));
      loadTextVal = [({ [`condition`]: !(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length,[`text`]: 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions.' }), ({ [`condition`]: !(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length,[`text`]: 'To locate your recently completed classes and confirm hours for payment, go to the \'Microschool\' tab for microschool classes.' }), ({ [`condition`]: !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length,[`text`]: 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions, or the \'Microschool\' tab for microschool classes.' })];
      ___arguments.context.pageData['LoadText'] = '';
      var i_end = loadTextVal.length;
      var i_inc = 1;
      if (1 > i_end) {
        i_inc = -i_inc;
      }
      for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
        if (getObjectProperty((loadTextVal[(i - 1)]), 'condition')) {
          ___arguments.context.pageData['LoadText'] = (getObjectProperty((loadTextVal[(i - 1)]), 'text'));
          break;
        }
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);

    } catch (error) {
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / Page Enter', (JSON.stringify(({ [`message`]: 'Error encountered while fetching past sessions',[`data`]: ({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) }) }))), error);

    }
    try {
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
      ___arguments.context.pageData['extraHours'] = 0;
      await showTest();

    } catch (error) {
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / Page Enter', (JSON.stringify(({ [`message`]: 'Error encountered while fetching future sessions',[`data`]: ({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) }) }))), error);

    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/4756d4ddb332497515dc236f06169a05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'test_mode')) === null) && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page_Test_Mode', undefined);
  } else if (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/31852522e433679db69ddb12ee22dcf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) >= (new Date())) {
    (function (message) { alert(message) })('Can\'t send homework before start time');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'reportRowClick')) == false) {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = false;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var endTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  endTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 50;

  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (false ? (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' : ((new Date()).valueOf()) > endTime) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/c53a30fa950184dccd71ea0fb4d8b60d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'is_cancelled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).startsWith('[OFFBOARDED]'))) && lateTime >= ((new Date()).valueOf()) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'messageRowClick')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ee1465bff9c2bec6941d08222ba5ec26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'parent_name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/66cd90547bf88f0ec556661ce6996da6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var slotsSlugText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) != 0) {
        slotsSlugText = String('Last homework was sent on ') + String(new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`year`]: 'numeric',[`timeZoneName`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
      }
    }
  } else if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    slotsSlugText = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug'));
    if (slotsSlugText == 'Substitute session' || slotsSlugText == 'Extra Session') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('66cd90547bf88f0ec556661ce6996da6'))['color'] = '#F4703C';
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) {
    slotsSlugText = 'Self-paced MS 1on1';
  }

  return slotsSlugText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/cc17716809b5e5a5cd8913dd92bd72e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'UI / Tutor Dash Page / messageMenu Block';
  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'hasLoaded')) || (typeof (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'futureStudentContainer')) === 'undefined')) {
      return null;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer')).length && !(getObjectProperty(___arguments.context.pageData, 'futureStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      return null;
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at check content and user / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    ___arguments.context.pageData['loader'] = (String((getObjectProperty(___arguments.context.pageData, 'userName')).match((new RegExp('\\w+', '')))) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at set visibility to off / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    ___arguments.context.pageData['selector'] = 'messaging';
    ___arguments.context.pageData['studentContainer'] = (getObjectProperty(___arguments.context.pageData, 'futureStudentContainer'));
    ___arguments.context.pageData['msStudentContainer'] = (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer'));

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at update containers and selectors / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at set visiblity to on / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/08770bb54b931f72b9a4291830a2fefe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://airtable.com/appY4H22rBsR5hG1g/shre8VCU9FnC23bFi/tblrD92p5tHt8Fq6u', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/56bc538f1eb9f9fd9bc6656fcf34eecb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) == 'scheduled' && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, objectToDelete, Task, item, LeadHolder, LeadTask, studentContainer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  logger_name = 'deleteManualHour';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9abceacc5bed5876e09f989a33d83bed', true);
  if (false) {
    try {
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHours2')), ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
      studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
      removeItemInList(studentContainer, ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
      ___arguments.context.pageData['studentContainer'] = studentContainer;
      ___arguments.context.pageData['payableHours2'] = (getObjectProperty(___arguments.context.pageData, 'payableHours2'));
      if ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) != 0) {
        ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) - 1);
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

    }
    try {
      objectToDelete = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['event_title = \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
      LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
      if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
        return null;
      }
      if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
        return null;
      }
      if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
        return null;
      }
      if ((getObjectProperty(objectToDelete, 'slots_slug')) != 'Manual time') {
        return null;
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

    }
    try {
      await Backendless.Data.of('calendar').save( ({ [`scheduling`]: 'is_deleted',[`objectId`]: (getObjectProperty(objectToDelete, 'objectId')) }) );
      LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
         if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
        }


       return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
      }));
      Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/06391894f8d7144146e5b0413ef74286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  logger_name = 'tutor_dash_submitMessage';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (String('MessageContent - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent'))), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#d3d3d3';
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')) == null) {
      Backendless.Logging.getLogger(logger_name).debug('Message Content is Empty');
      return null;
    }
    Backendless.Logging.getLogger(logger_name).info((String('tutor_dash_submitMessage Data: ') + String(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })))));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the start sequence - Error / Parent Lead: ', error));

  }
  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/messaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })));
    Backendless.Logging.getLogger(logger_name).info((String('tutor_dash_submitMessage sent') + String(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })))));
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Message Sent - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was a problem sending the message - Error / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), error));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a48471e0ee74216f8254f582a3438b1'))['color'] = '#fd6541';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Error';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageContent'] = '';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Submitted!';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6efdad730a47b90a1d6e79bbc2f53aa8', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the end sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/be21d4c346140134069b5ce1dc4c22ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')) === null) ? null : ['Hi ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),', this is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).indexOf(' ') + 1) - 1),' from Brilliant Grades. I\'m in the zoom room waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),'. Our session started 5 minutes ago. Are you joining? Thanks a ton!','\n_____\n\nzoom link: ',(getObjectProperty(___arguments.context.pageData, 'zoom')),'\n\nmeeting id: ',(getObjectProperty(___arguments.context.pageData, 'zoomid'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/edb59f2e49f5518df1c18cc541d37a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'studentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/39075dbc9d74db38793c3159bbf4fe59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, msHourBlock, returnData, hourBlock, LoggerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'ReportContainer';
  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'hasLoaded')) || (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    ___arguments.context.pageData['msStudentContainer'] = [];
    ___arguments.context.pageData['studentContainer'] = [];
    ___arguments.context.pageData['loader'] = (String((getObjectProperty(___arguments.context.pageData, 'userName')).match((new RegExp('\\w+', '')))) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    ___arguments.context.pageData['selector'] = 'reports';

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', (String('Error encountered at set visibility to off / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'primarySessions')) === 'undefined')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowTS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      hourBlock = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    }
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowMS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      msHourBlock = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / reportsMenuBlock', (String('Error encountered at fetch sessions / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      console.log('msStudentContainer');
      console.log(getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / reportsMenuBlock', (String('Error encountered at set visibility to on / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e29cbb94966f7ad1371a1a0aa85e1f71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, msHoursList, returnData, hoursList, resultMsg, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, manualTimeHours, customEventTitle, event_title, manualTimeCategory, item, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, tutorObject, TodayNumber, startTime, message;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function generateAlert(message) {
  (function (message) { alert(message) })(message);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', true);
}


  try {
    resultMsg = String('Extra hours added successfully!') + String((getObjectProperty(___arguments.context.pageData, 'dowTS')) < 3 ? ' You can find them in the FUTURE sessions tab.' : ' You can find them in the PAST sessions tab.');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', false);
    logger_name = 'tutor_dash_submitManualHours';
    LoggingStatus = false;
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    manualTimeCategory = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeCategory'));
    manualTimeHours = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeHours'))));
    event_title = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'event_title'));
    TodayNumber = 0;
    extraHours = [];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0 || !(manualTimeHours % 1 == 0)) {
      await generateAlert('Hours need to be a positive whole number');
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      await generateAlert('Please choose a category');
      return null;
    }
    if (!(typeof event_title === 'string')) {
      await generateAlert('Please add a short description');
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 220)) {
      await generateAlert('Please keep your description between 10 to 250 characters');
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    for (var count = 0; count < manualTimeHours; count++) {
      startTime = ((new Date()).valueOf()) - TodayNumber * 86400000;
      customEventTitle = [manualTimeCategory,'#',subsequenceFromEndFromEnd((JSON.stringify(startTime)), 4, 1),'-',event_title].join('');
      CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/saveObjectToDB`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle }))));
      extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`subject`]: null,[`grade`]: null,[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor_name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle,[`student_name`]: null,[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`lastHmwrk`]: 0,[`messageRowClick`]: false,[`reportRowClick`]: false,[`tutor_lifetime_slots`]: null,[`tutorType`]: 'Partner' });
      await Backendless.Data.of('Users').addRelation(tutorObject, 'calendar', [(getObjectProperty(CalendarObject, 'objectId'))]);
      addItemToList(extraHours, extraTime);
      studentContainer.push(extraTime);
      (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).push(extraTime);
      await new Promise(r => setTimeout(r, 50 || 0));
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while adding manual hours for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));
    resultMsg = 'Error encountered at Save manual hour object';

  }
  try {
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',manualTimeHours,manualTimeHours == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',manualTimeCategory,', ',event_title,', ',customEventTitle.split('#').slice(-1)[0].split('-')[0]].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' });
    ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) + (Number(manualTimeHours)));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeCategory'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeHours'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['event_title'] = null;
    ___arguments.context.pageData['calendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ba3eeb1bed397379ff878c222e61cda', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);

  } catch (error) {
    console.log(error);
    resultMsg = 'Error encountered at Task creation';

  }
  (function (message) { alert(message) })(resultMsg);
  try {
    ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while refreshing containers / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    
  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/55fdb589c2cb251c7599918848144a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/05644c3fee79e4b5f2f8142ff511c59f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['MessageContentLength'] = (___arguments.value.length);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) < 1000) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) >= 10) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', false);
    }
  } else {
    (function (message) { alert(message) })('You have reached the limit');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8f91b6cb4293f2cdcdb6095aa07d7cb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('http://tutors.brilliantgrades.com/', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f91b6cb4293f2cdcdb6095aa07d7cb2'))['fontWeight'] = 700;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/eeba337b1abad2e2064a177d173eb112/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://zoom.us/signin', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/4cdc223f17b4a008501abf4bc2f579a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != '')

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null ? 'Companion Rubric' : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/55a2daa21ae3fd7d7c4344d11bf8e523/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.loom.com/share/e61474c1a9374f509c3586165875d842', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b2f38edae191dcee756e2c6e9e1f8f55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString, parentTimezone, tutorTimezone;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'tutor_away') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'tutor' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'contact' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') {
      localeDateString = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).split('#')[0];
    }
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/a6f83a1196e4d9f887a4e0ba1e3b9284/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Backendless.Logging.getLogger('tutor_dash_ms').info((['Redirect to Tutor Ticket Page','\nLogged in User Name: ',(getObjectProperty(___arguments.context.pageData, 'userName')),'\nUser Data: ',(JSON.stringify((await Backendless.UserService.getCurrentUser(false))))].join('')));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/?page=tutor_ticketing','#firstname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ')[0],'&lastname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ').slice(-1)[0]].join('')), true, undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/db69da57441b0c5f05bee60c9ed3a0be/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
  }

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64b22f2e967708cd2f23f0118fe71b96'))['marginTop'] = '0px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e7f84404d74f7eec8dd8f4b55566cdb1'))['fontWeight'] = 100;
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    }
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/98dd39b1912f926d6a0d7c5eef9e1773/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', false);

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e68a3f08b3383fbd9fa9cf9d6ee6ef67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/2c3cfb8f9666b2d16976e8ac5ab77697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['requestHours'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/292e0c59fc5ab5ecbfed410e938466b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, TaskCreate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'RequestHours';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered on starting sequence', error));

  }
  try {
    TaskCreate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/requestHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ 'event': ({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'requestHours': (getObjectProperty(___arguments.context.pageData, 'requestHours')),'userName': (getObjectProperty(___arguments.context.pageData, 'userName')) }) }))));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered while requesting for hours', error));

  }
  try {
    if (TaskCreate == 'success') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', false);
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', true);
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('853804cc12dfa569027d0603dd724dc4'))['content'] = 'Error: Try Again';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered ending sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/960fd48380c22f77d3063aee7edecec3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) === null) ? 'Student On Pause' : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('Mock') !== -1) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/48be111a6e73f9496192001254069b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/a738b596c568ca5c432a97d459156531/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/855cb05fd1fc8512b116fa12718e647e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toLocaleString());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/6ba3eeb1bed397379ff878c222e61cda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/6c7ce06f475737eaf549e27facb992de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus, PseudoCreatedTimestamp, payableHoursMS, payableHoursTS, item, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, studentEvent, CheckIfTthere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  logger_name = 'Submit Hours Button';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#EBEBE4';

  } catch (error) {
    (function (message) { alert(message) })('Error encountered while submitting hours');
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    for (var studentEvent_index in studentContainer) {
      studentEvent = studentContainer[studentEvent_index];
      CheckIfTthere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
      }));
      if (!CheckIfTthere.length) {
        continue;
      }
      if ((getObjectProperty(studentEvent, 'homework_sent')) == true) {
        studentEvent['toBePaid'] = true;
      } else if ((getObjectProperty(studentEvent, 'slots_slug')) == 'Mock Session') {
        studentEvent['homework_sent'] = true;
        studentEvent['toBePaid'] = true;
      }
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'primarySessions'));
    for (var calendarEvent_index in calendarListRaw) {
      calendarEvent = calendarListRaw[calendarEvent_index];
      studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
      if (studentContainerPosition > 0) {
        calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
      }
    }
    ___arguments.context.pageData['primarySessions'] = calendarListRaw;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length == 0) {
      (function (message) { alert(message) })('You have no hours to be submitted');
    } else {
      PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
      payableHoursMS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && !((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      payableHoursTS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (!((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) || ((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && ((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      if (!!payableHoursTS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursTS,[`tutorService`]: 'TS',[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      if (!!payableHoursMS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursMS,[`tutorService`]: 'MS',[`PseudoCreatedTimestamp`]: false ? PseudoCreatedTimestamp : null,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      ___arguments.context.pageData['hoursStatusValue'] = 'Submitted!';
      ___arguments.context.pageData['submittedHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedHours')) + (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      ___arguments.context.pageData['payableHoursFiltered'] = [];
      ___arguments.context.pageData['payableHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    ___arguments.context.pageData['extraHours'] = 0;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Submit ',(getObjectProperty(___arguments.context.pageData, 'payableHours')),(getObjectProperty(___arguments.context.pageData, 'payableHours')) > 1 || (getObjectProperty(___arguments.context.pageData, 'payableHours')) == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f6f1e22a76dcd32af28397b3a5a8fa29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) == 'scheduled') {
    isVisible = true;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    isVisible = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled') {
    isVisible = false;
  } else {
    isVisible = false;
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/6c382dc562077f3dc8158e63420bfc9d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')), 'display')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#C1E1C1';
    } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#F1E8E7';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#fffff';
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/d2229337fcf815d30396549f2cc39705/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b031feb6c1e3aca2c4925425596f4b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/7f13a0fb81a33d11c448d8c8b44774a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'studentsToday')),(getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 1 || (getObjectProperty(___arguments.context.pageData, 'studentsToday')) == 0 ? ' sessions ' : ' session ','today!'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/a702c6aef57358e195b6b50a731d96f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/fff98e419ad78ce4d61f9566a48e117b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e1430179fc6b6f21c9dc9c6f22ca4ad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true ? false : true) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000))) {
    content2 = 'Pending Homework';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8617494c75fd6e5a303d80d7d4b1d333/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var message, Slot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
    message = 'Cancelled session';
  } else if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
    message = 'Session did not occur';
  }

  return message

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/74fc1f77230994ed26cd09bf3af662fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/45cd08bfd6849c17b7389f4b5471f992/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/42d4dcea40048a699c427a9a854238bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f42f0f48f9bc1f49ff2641e976690d34/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength(___arguments.value));
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b3843647ae5862a445e1352bacc1471c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ed786cc2c66bb26c2f4c8813c6319276/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ca23ee2ee51cea994404dd26d03bd69e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/7e39c413d2c245c3a4c3fd548e489754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = 'The student(s) made progress';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/17dd941e77be48f6117d1392d966840a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/010c10094d98413c56497d23fafb8e17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e072bb290098c74cf7230c269dbc63db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f8d8039e403d93534ff14dac3a318f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b26c14ace999f11d509bd7364029d8e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b1d660f5bbf75c5d2dd8b04d8f965b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'isPresent')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1faed4cd936a8483af596d0462ef141a/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error, RenamedFile, GetFile, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  try {
    if (true) {
      RenamedFile = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName'));
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/authcodes')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }));
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      GetFile = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v3/files/') + String(getObjectProperty(___arguments.context.pageData, 'uploadedIdFile'))))).query(({ [`fields`]: ['webContentLink'] })).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send());
      await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
    } else {
      RenamedFile = (await Backendless.Files.renameFile( encodePath((String('homework/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName')))), encodePath((['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),'.',___arguments.uploadedFiles.split('/').slice(-1)[0].split('.').slice(-1)[0]].join(''))) ));
    }
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6fb5c65420f143dee94c402ec10a72ad', [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length < 3) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length >= 3) {
      (function (message) { alert(message) })('Please keep each homework to 3 attachments. You can send a second report to include additional attachments. Thank you.');
    }
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport'))));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_dash_upload_file').warn(([(JSON.parse(error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  }

  },
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (true) {
    try {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = 0;
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55df951b180944c84e9d0c54a82dac8e')), 'display')) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', false);
      }
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''),[`parents`]: ['1Je3aUb8YMYTsCW78CFsioOMSEVy25wbw'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
      ___arguments.context.pageData['uploadedIdFile'] = (getObjectProperty(Metadata, 'id'));
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''));

    } catch (error) {
      console.log(JSON.stringify(error));
      Backendless.Logging.getLogger('tutor_dash_before_upload_file').warn(([(JSON.stringify(error)),' - ',(JSON.stringify(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'))),' File Type:',(getObjectProperty((___arguments.files[0]), 'type')),' File Name:',(getObjectProperty((___arguments.files[0]), 'name')),' File:',(JSON.stringify((___arguments.files[0])))].join('')));

    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (getObjectProperty((___arguments.files[0]), 'name'));
  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')).length);
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8551301ddc6d2c2fae763ec3774f959f')), 'display'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
  }
  Backendless.Logging.getLogger('tutor_dash_failed_upload_file').warn(([(JSON.parse(___arguments.error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var filename;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  filename = ((getObjectProperty(___arguments.file, 'name')).replace((new RegExp('(?:\\.(?![^.]+$)|[^\\w.])+', 'g')), '_'));

  return filename

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/7745a3e392ad5ff6dbdae5f47933a651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onMouseOut */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['border-radius'] = '50%';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/55df951b180944c84e9d0c54a82dac8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b07e189d45cd1f8ab6d831c9c40dfbbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/0c879ba8c2de9b2613175df1f12162f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ff04f66b2abaa26cd40ac75a3bd40a8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['FeedbackBTNClicked'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ad1cc4046b92cdce3bef541b0b287011/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/83ee4ec93215aafe7376dc165717a9d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8551301ddc6d2c2fae763ec3774f959f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) > 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) < 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/6fb5c65420f143dee94c402ec10a72ad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined')) {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/d532e8462b3948653f0f9fc248526aef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/d97ebc8bcb09e1fdcc836c4ad1bac727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Student Issue';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/7cae4d7c127f4c5169edddfcdb625189/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Suggestions';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f9461ed7c0e9e0f3f60a3555d37d7d6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Other';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/0c389e7ff11c4e4ec227103b3dddc80d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/190c483fac06d0d5ab4ecabfbc016fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f7ad243951b8ae8d464590037c99e4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    setBoolean = false;
  } else {
    setBoolean = true;
  }

  return setBoolean

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1cd7e871600396535b2844fcbc2277d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, FL_Score, _unused, logger_name, calendarListRaw, studentContainer, hoursList, dash, studentContainerPast, LoggingStatus, student, calendarListRawPosition, studentContainerPosition, attachments, studentList, uniqueSlots, item, attachment;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    logger_name = 'tutor_dash_submitHomework';
    LoggingStatus = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit Button clicked - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#d3d3d3';
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).length) {
      attachments = null;
    } else {
      attachments = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).map(async attachment => {; return (getObjectProperty(attachment, 'file'));})));
    }
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Collect Attachments - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'primarySessions'));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) == true) {
      studentList = (await asyncListFilter(studentContainer, async (item) => {


       return ((getObjectProperty(item, 'slots_slug')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')) && (getObjectProperty(item, 'start_time')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'start_time')));
      }));
    } else {
      studentList = [___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')];
    }
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Get data necessary for submission - SUCCESS',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in retrieving data for the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }
  try {
    for (var student_index in studentList) {
      student = studentList[student_index];
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/homework`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(student, 'parent_name')),[`student_name`]: (getObjectProperty(student, 'student_name')),[`homework_sent`]: true,[`subject`]: (getObjectProperty(student, 'subject')),[`grade`]: (getObjectProperty(student, 'grade')),[`tutor_name`]: (getObjectProperty(student, 'tutor_name')),[`report`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')),[`calendarObjectId`]: (getObjectProperty(student, 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(student, 'slots_slug')),[`sessionQuality`]: ['Q1 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q1Ans')),'\nQ2 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q2Ans')),'\nQ3 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q3Ans'))].join(''),[`bgFeedback`]: (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === null) ? null : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'bgFeedback'))].join(''),[`contactParent`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')),[`attachments`]: attachments })));

      })();
      await new Promise(r => setTimeout(r, 250 || 0));
      studentContainerPosition = studentContainer.indexOf(student) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(student) + 1;
      if (studentContainerPosition > 0) {
        studentContainer[(studentContainerPosition - 1)] = student;
        calendarListRaw[(calendarListRawPosition - 1)] = student;
      }
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit homework - Success / Parent Lead: ',(getObjectProperty(student, 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', true);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in submitting the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', false);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared progress report - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['bgFeedback'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared bg feedback - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Contact Parent set to false - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['homework_sent'] = true;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Homework set to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#0a1352';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Set status visibility to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d96e3562b933d045d64b180c471b7d11', true);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared docs - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Clear form fields - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in clearing the fields - Error / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), error));

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['reportRowClick'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](studentContainer, ___arguments.context.pageData));
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['primarySessions'] = calendarListRaw;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in updating the object in the raw list - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/498c21f9cb5f164912448c47d278a46c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/9418a1aba1fd4033450f16695735b1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b2132b5d8a74e88511b603ef358f5843/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8eae5cd8e32b77eb831fbb46a36676fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/984e2a28e63db3a68453ff794f68df03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.dataModel, 'read')) === 'string') && ((getObjectProperty(___arguments.context.dataModel, 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e76dd2cf23afcb977336e7ae69c2e423/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1c5529a18c276de5a74fec66241749b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/396350ff94ffb283fecee818981c9727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8ec186d9ea189f6782a2232bd55f0331/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/502108db508b967541ba142e40a79b81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/474be277ed82933a3a1218dbea262757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/a3ac1f9ed6db33d8afaab0d31f2a89eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/273aca3a2f47ec4254bd8974edbf5e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, LoggerName, _unused, studentContainerFuture, msStudentContainerPast, studentContainerPast, msHoursList, dash, hoursList, dash2;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/2bc7badc91dd24529b363d8ac0c1338a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/de26e0bacccc43811e337c2354ef780a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    text = 'Was your student present?';
  } else {
    text = 'Were your students present?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/362d5467896a664a436ca45175ba9c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/346a274c03153293703e2f6cd9f3318f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = false;
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' was absent today. Please let me know if there is something I can do to support you. Otherwise, I will be waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' in our next session.'].join(''));
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/2ba2eb34a96cc8b30bda933b45ca376c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['read'] = (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join(''));
    await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/BackendlessLoginAuthRestBlock`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`action`]: 'update',[`method`]: 'HR_Admin_Panel',[`databaseName`]: 'announcements',[`requestType`]: 'clientSide',[`query`]: ({ [`user-token`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LoginData')), 'user-token')) }),[`createObject`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'objectId')),[`read`]: !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('') }) })));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'Yes';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'No';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/dc5c3f24cb57a4539e2d77d9ac762071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    Value = 'No';
  } else {
    Value = 'Yes';
  }

  return Value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/6e11fc75c9b6e6382873be088a2e752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var show;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === null)) {
    show = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf())) {
    show = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')).indexOf('Partner') !== -1);
  } else {
    show = false;
  }

  return show

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/39174bc3cdf5a7b64801e1be2dc610cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) == 0 ? '0' : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 100 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 10 ? ['0','0',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))].join('') : String('0') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/958b37f8fe89f72498d5e3e28c657cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 800;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/970b6c0790ab5e2533b198c248a7c47c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/3fe3fff351e3b7f33663ec02d3fbb18f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' || (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f7b151d3f20e3cc51195fba8032815af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/d2d5947e69b973cd56a3d61e3b4b587f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var FormatToTeacherTimezone, FormatToUTC, list, localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'School Closed') {
    FormatToTeacherTimezone = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    FormatToUTC = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: 'Etc/GMT',[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    localeDateString = [FormatToUTC[0],' ',FormatToUTC[1],' ',FormatToUTC[2],' ','00:00',' ',FormatToTeacherTimezone[4]].join('');
  } else {
    localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/fc5dd2dafd27503b990bdf0a7c412741/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'scheduled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))) == false && lateTime <= ((new Date()).valueOf()) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'scheduled' && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/a8abf4e79a810da4c4e4394e3bd9a801/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1d22c0a3a68461359766a57431328907/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'is_substituted')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b75e2b28827248f5a56e9f2753018984/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName'))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/85bd330ec0ef100ffb336893dd84761b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, NewData, TutorHours, ObjectIdToDelete, item, objectToDelete, Task, LeadHolder, LeadTask, CheckAssistantTeacher;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  console.log(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'));
  logger_name = 'cancelMSManualHour';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', true);
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
    ___arguments.context.pageData['payableHoursFilteredMS'] = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'slots_slug')) == 'Manual time') {
      if ((Number((getObjectProperty(___arguments.context.pageData, 'extraMSHours')))) != 0) {
        ___arguments.context.pageData['extraMSHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'extraMSHours')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'duration')));
      }
    } else if ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) != 0) {
      ___arguments.context.pageData['payableMSHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'duration')));
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('ms_calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) != 'Planning Time') {
    try {
      CheckAssistantTeacher = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).query(({ [`where`]: ['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join('') })).setEncoding('utf8').send())[0];
      if ((getObjectProperty(CheckAssistantTeacher, 'assistant_teacher')) === null) {
        NewData = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),[`scheduling`]: 'is_cancelled' })));
        ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772')['scheduling'] = (getObjectProperty(NewData, 'scheduling'));
      } else {
        await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'slots_slug')) == 'Manual time') {
        LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
           if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
          }


         return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
        }));
        Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));
      }
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS MEETING' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) == 'Planning Time') {
    try {
      await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ad13b5c129c3720e61ec643f4b8f52d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b83298ed2753d53d622bdb5fbd6f0c8e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b62c065139737a347f7e7a27592589ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  ___arguments.context.pageData['MSExtraTimeList'] = [];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['show_add_hours'] = false;
    j['manualMSTimeHours'] = null;
    j['msDescription'] = null;
    j['approvalName'] = null;
  }
  ___arguments.context.pageData['card_no'] = 1;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/617aeeb949a1dac5eeb74c53a21fbf19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek2'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/c6a13b95bc64a2a1c73e0703e9aad3d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var SumOfHours, formatString, item, Description, Hour, j, OtherHours, SpecialProjects, ProgressReports, ShadowingHours, AdminHours, CurriculumDesign, HouseLeaderMeeting, MeetGreetMeeting, ExtraMeetings, OnboardingTraining, error, logger_name, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, manualTimeHours, eventTitle, event_title, manualTimeCategory, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, approvalName, _unused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', true);
  formatString = '';
  console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
  OnboardingTraining = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ExtraMeetings = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  MeetGreetMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  HouseLeaderMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  CurriculumDesign = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  AdminHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ShadowingHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ProgressReports = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  SpecialProjects = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  OtherHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OnboardingTraining.length) {
      for (var j_index in OnboardingTraining) {
        j = OnboardingTraining[j_index];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ExtraMeetings.length) {
      for (var j_index2 in ExtraMeetings) {
        j = ExtraMeetings[j_index2];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!MeetGreetMeeting.length) {
      for (var j_index3 in MeetGreetMeeting) {
        j = MeetGreetMeeting[j_index3];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',Hour / 0.5,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!HouseLeaderMeeting.length) {
      for (var j_index4 in HouseLeaderMeeting) {
        j = HouseLeaderMeeting[j_index4];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!CurriculumDesign.length) {
      for (var j_index5 in CurriculumDesign) {
        j = CurriculumDesign[j_index5];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!AdminHours.length) {
      for (var j_index6 in AdminHours) {
        j = AdminHours[j_index6];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ShadowingHours.length) {
      for (var j_index7 in ShadowingHours) {
        j = ShadowingHours[j_index7];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ProgressReports.length) {
      for (var j_index8 in ProgressReports) {
        j = ProgressReports[j_index8];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!SpecialProjects.length) {
      for (var j_index9 in SpecialProjects) {
        j = SpecialProjects[j_index9];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OtherHours.length) {
      for (var j_index10 in OtherHours) {
        j = OtherHours[j_index10];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  SumOfHours = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')).map(async item => {; return (getObjectProperty(item, 'manualMSTimeHours'));}))).reduce(function(x, y) {return x + y;});
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatExtraTime'] = (SumOfHours == 0 ? '' : formatString);
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatNoExtraTime'] = (SumOfHours == 0 ? 'No Extra Hours Added' : 'Review Extra Hours');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e6dcc3e1e7e4dd1a21f57ef92ecf7065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
    (function (message) { alert(message) })('There\'s no Microschool session to submit.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) == false) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ca3280537e60abefc51f52f46d2c4da')));
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var totalHours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  totalHours = (getObjectProperty(___arguments.context.pageData, 'payableMSHours')) + (getObjectProperty(___arguments.context.pageData, 'extraMSHours'));

  return (['Submit ',totalHours,totalHours > 1 || totalHours == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e41ae3499aa1023b7a456117a80b89ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/94a25aee66288cb122f76b6b70948052/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS MEETING' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'School Closed' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : (await BackendlessUI.Functions.Custom['fn_20be5f297d6e7011d3eb8aacdd98716c']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')))).toUpperCase()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b2eda5d4da066dd2ed267037f345e274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/166f6de4ebe7c54f3fd9c3ab22d9b6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/0284b7b24a821e9cdb5b0b62a8ce04a9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.dataModel, 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#C1E1C1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#F1E8E7';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8f1dddc1ed6b68b74c36bbf9ea6cb832/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/9f09749e2f5815afcd4b1bd3294c8a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/d1c1a9931ef7177cfcc1a49fa16b13f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/887e6454024682c30a5f7e27755c472d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e5d7397d645689137cabd81d8d56d322/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  console.log(___arguments.value);
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/67d1b072060be60825b175a30b6c656e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
      return null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/a03846b3716b0d7b7292135aa3644e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/401aed0df3ca1a2b60919fbe4d451a09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/23bd7218dffe31de83fdef3e47facf37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/34f2b281028902c1f38a4af22386fdc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/54ae53f554d761b89e65dd07c6e2469d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/986513bd2dd43a1ed6e86a2ff4d1a5be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/2829d02674bea67c6e73c35550394e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e09301622cad56dce201c733ae5d579a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/09d624d5c24ea221fdc288d8f074fc4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09d624d5c24ea221fdc288d8f074fc4b')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f5e442d2527d7b0d002b8c05f7a28034/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f5e442d2527d7b0d002b8c05f7a28034')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ee02a47b3d4dc49cbdcd4edfd068e61d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee02a47b3d4dc49cbdcd4edfd068e61d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/9249997aa4c292a2f86be59f9cb11e83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9249997aa4c292a2f86be59f9cb11e83')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ed614d4ff047eb6a345a4e77b4dfd103/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed614d4ff047eb6a345a4e77b4dfd103')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/c53dff2850ec4ad6d6d9ab21f3aae558/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c53dff2850ec4ad6d6d9ab21f3aae558')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e73b9d72e48f95fc19669463d31eca01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e73b9d72e48f95fc19669463d31eca01')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/bf0ba5be04ac101781d6bf8eea7168bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf0ba5be04ac101781d6bf8eea7168bb')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/595fafa6a32ea512de22bd0df4485d21/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q5answer'] = [];
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q8answer'] = '';
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q9answer'] = '';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/7ddac0256742e8f9124be8d5e157bb02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ddac0256742e8f9124be8d5e157bb02')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/42784913cf23a393b76fe0a91f9b136c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42784913cf23a393b76fe0a91f9b136c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/c9c32de38c2dc088b69ddc9f69060a3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9c32de38c2dc088b69ddc9f69060a3e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/5777f4435b3fc6eb3c3a045582e23d28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5777f4435b3fc6eb3c3a045582e23d28')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/09ce8b8e77b3d1b97265676a9082e899/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09ce8b8e77b3d1b97265676a9082e899')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/4b5c353f46d55f0892b33bbb74ceeb9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b5c353f46d55f0892b33bbb74ceeb9c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b3799dfeeb9796763c26ed41b22b5b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/7229ee6cecd4e7c44a9dbb6df89f2495/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length <= 50) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/2a32c8295622fcf5b005d0cb18bb6be4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q8answer')).length > 10)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/4cad321c51d3617e153bbba3013b0bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length > 50)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/dc8279e1eda851cc253f437e15af79d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, FL_Score, logger_name, LoggingStatus, durationPayable, j, PseudoCreatedTimestamp, studentEvent, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, item, CheckIfThere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', false);
  if (true) {
    logger_name = 'Submit MS Hours Button';
    LoggingStatus = false;
    try {
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', true);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#EBEBE4';

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      for (var studentEvent_index in studentContainer) {
        studentEvent = studentContainer[studentEvent_index];
        CheckIfThere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), async (item) => {


         return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
        }));
        if (!CheckIfThere.length) {
          continue;
        }
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          studentEvent['toBePaid'] = true;
        }
      }
      ___arguments.context.pageData['msStudentContainer'] = studentContainer;
      studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
      console.log(studentContainerIds);
      calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarMSListRaw'));
      for (var calendarEvent_index in calendarListRaw) {
        calendarEvent = calendarListRaw[calendarEvent_index];
        studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
        console.log('studentContainerPosition');
        console.log(studentContainerPosition);
        calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
        if (studentContainerPosition > 0) {
          calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
        }
      }
      ___arguments.context.pageData['calendarMSListRaw'] = calendarListRaw;
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      var studentEvent_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      for (var studentEvent_index2 in studentEvent_list) {
        studentEvent = studentEvent_list[studentEvent_index2];
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          if (typeof (getObjectProperty(studentEvent, 'toBePaidList')) === 'undefined') {
            studentEvent['toBePaidList'] = [];
          }
          addItemToList((getObjectProperty(studentEvent, 'toBePaidList')), (getObjectProperty(___arguments.context.pageData, 'userName')));
          studentEvent['toBePaid'] = true;
        }
      }
      await new Promise(r => setTimeout(r, 1000 || 0));
      console.log('payable hours');
      console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
        (function (message) { alert(message) })('You have no hours to be submitted');
      } else {
        PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/msHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')),[`tutorService`]: 'MS',[`MSAnswer`]: ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'),[`TutorName`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`msQuestioner`]: (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')),[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
        ___arguments.context.pageData['hoursMSStatusValue'] = 'Submitted!';
        durationPayable = 0;
        var j_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          durationPayable = (typeof durationPayable == 'number' ? durationPayable : 0) + (getObjectProperty(j, 'duration'));
        }
        ___arguments.context.pageData['submittedMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedMSHours')) + durationPayable);
        ___arguments.context.pageData['payableHoursFilteredMS'] = [];
        ___arguments.context.pageData['payableMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length);
        await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      ___arguments.context.pageData['extraMSHours'] = 0;
      ___arguments.context.pageData['msQuestionnaire'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8ac777b8772affc6e2ce2032e938bc1', true);
      await new Promise(r => setTimeout(r, 5000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', false);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = false;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#0a1352';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the end sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'FScoreRaw')) === 'undefined')) {
        FL_Score = (Number((getObjectProperty(___arguments.context.pageData, 'FScoreRaw'))));
        console.log(String('Feeling Score: ') + String(FL_Score));
        if ((typeof FL_Score === 'number' && !isNaN(FL_Score)) && FL_Score <= 6) {
          _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/Low_Feeling_Score_Tutor`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`score`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q1answer')) }))));
        } else {
        }
      }
      FL_Score = 0;

    } catch (error) {
      console.log(error);

    }
    try {
      if (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
        _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/One_on_One_App_Training`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`AppList`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')) }))));
      }

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e2eb6cc9b2f36415c472018c6c9ddf3c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/601f5118947dd9e3f09faf4c5321da6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/d4947e4eab7b5685ef33742d5872fe9f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b532bb949a0a6a0220fbdcae9b8dbc62/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/2cdb27d75f9340271127dca71053ab35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/38bf97e56321eb774eae6fa844e4329e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1899137b4cdf7af97763cfc709761c86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ae044db4641eccaf4aa2da0b15a9480b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1a073794f27789130524b8fc60fa7c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1c2e819947b9ef743a531af229225184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/99527bf533d14ad7ce42d6fdd32a1c1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/26a5ef11960ccfbaaeafd4bb03f812d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/524374174fbfeb5c471ea1c8b9eda934/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/920459fd2fbd2d44c90c7dbfcb622d9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) != true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/204a99b4d8eca6c814ea9d02a16df748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: undefined,[`day`]: undefined,[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split('#')[0] : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')).startsWith('MAX')) ? ['Your ',localeDateString,' ',textToTitleCase(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).replace((new RegExp('MS_', '')), '')).replace((new RegExp('_', 'g')), ' ')),' School class'].join('') : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')).length) {
    return null;
  }
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12fe332cac06910a7c6d4801efd2981b')), 'display')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', false);
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8c6c6704422db291a4d470567b594934/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('12fe332cac06910a7c6d4801efd2981b'), 'student_list'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/03538403f3f7afc497a253c1c8d5c022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'currentTime'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1617628cbcbc4abb0e34a28bccf8cb2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/44cfadd5fcfe1efe234e0e52929ed598/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'submittedHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/5f999f1b796766cac0a891d51d1bae4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your questionnaire form for this week! You can submit your remaining hour.';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/6b6a055f8ace72c3c9a8ff4d0e42af3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your answer for questionnaire this week! You can submit your remaining hours now!';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/eb562517050d0e24f5c230c12475f8b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),' hour(s)','<br/>',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split((new RegExp('#\\d\\d\\d\\d-', '')), )).slice(-1)[0]].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/9ca3280537e60abefc51f52f46d2c4da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging' && (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, msHoursList, returnData, hoursList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    LoggerName = 'UI / Tutor Dash Page / refreshBlock';
    ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
    ___arguments.context.pageData['dowTS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowMS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered while refreshing containers / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/00b276c2b0c5baaa9282670dd683dc65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/410f28513c7e12343ef1d956e9f6a294/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'card_no')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) < ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f885dc8d25c417286c1e1bfd663a8848/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 <= 1) {
    ___arguments.context.pageData['card_no'] = 1;
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 > 1) {
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) == 1)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) != 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/58d98c73120a88eac77b66836906df47/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var GetCurrentRepeater, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  GetCurrentRepeater = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '450px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) != 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b83298ed2753d53d622bdb5fbd6f0c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'UUID'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b83298ed2753d53d622bdb5fbd6f0c8e'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/97eeff3b29311305a4e5e5fb2b65fb82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/bdcca712e5096c7193feabd5cbd6a52d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item, CheckHouseLeader, CreateSubjectList, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'houseLeader')) === 'undefined') {
    return null;
  }
  CheckHouseLeader = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'houseLeader')), async (item) => {


   return (item == (getObjectProperty(___arguments.context.pageData, 'userName')));
  }));
  CreateSubjectList = (getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).split(',');
  if (((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined')) {
    ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    return null;
  }
  if (!!CheckHouseLeader.length) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  } else {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/4a9fc23dae555ebd728bbfe169bdf0c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, records, GetCurrentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  records = [];
  GetCurrentData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(GetCurrentData, 'card_name')) == (getObjectProperty(j, 'card_name'))) {
      j['show_add_hours'] = true;
    } else {
      addItemToList(records, j);
    }
  }
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f7bafd0b847e466d2b27a647b6ecf16d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, error, logger_name, _unused, approvalName, manualTimeCategory, event_title, manualTimeHours, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', false);
    logger_name = 'Adding Manual hours to list';
    LoggingStatus = false;
    manualTimeCategory = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name'));
    manualTimeHours = (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours'))));
    event_title = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription'));
    approvalName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', true);
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0) {
      (function (message) { alert(message) })('Hours need to be a positive number');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (manualTimeHours % 0.5 != 0) {
      (function (message) { alert(message) })('Hours need to be 0.5, 1, 1.5, 2, 2.5, and so on.');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      (function (message) { alert(message) })('Please choose a category');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof event_title === 'string')) {
      (function (message) { alert(message) })('Please add a short description');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 500)) {
      (function (message) { alert(message) })('Please keep your description between 10 to 500 characters');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if ((manualTimeCategory == 'Curriculum Design (Microschool Only)' || manualTimeCategory == 'Special Projects (Microschool Only)' || manualTimeCategory == 'Other Hours (Microschool Only)') && !(typeof approvalName === 'string')) {
      (function (message) { alert(message) })('Please add an Approval Name');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/39745d989538c85beed89f66cd65143c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, msHoursList, returnData, hoursList, resultMsg, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, isSuccessful, eventTitle, j, item, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, FormatMSExtraTime, event_title, manualTimeCategory, manualTimeHours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  resultMsg = String('Extra hours added successfully!') + String((getObjectProperty(___arguments.context.pageData, 'dowMS')) < 3 ? ' You can find them in the FUTURE sessions tab.' : ' You can find them in the PAST sessions tab.');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd955a1720296708a4c5aa9efec33999', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  logger_name = 'tutor_dash_submitMSManualHours';
  LoggingStatus = true;
  FormatMSExtraTime = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if (!FormatMSExtraTime.length) {
    return null;
  }
  TodayNumber = 0;
  studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
  extraHours = [];
  tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
  if (false) {
  } else {
    for (var j_index in FormatMSExtraTime) {
      j = FormatMSExtraTime[j_index];
      try {
        eventTitle = [(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],'#',subsequenceFromEndFromEnd((JSON.stringify((((new Date()).valueOf()) - TodayNumber * 86400000))), 4, 1),'-',(getObjectProperty(j, 'msDescription'))].join('');
        CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/FrontendSaveMSCalendar`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`Description`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_date`]: (new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))),[`event_title`]: eventTitle,[`status`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`approvalName`]: (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Curriculum Design' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Special Projects' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Other Hours' ? (getObjectProperty(j, 'approvalName')) : null }))));
        extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_time`]: ((new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))).valueOf()),[`event_title`]: eventTitle,[`sessionStatus`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`student_list`]: [],[`toBePaidList`]: [] });
        addItemToList(extraHours, extraTime);
        ___arguments.context.pageData['extraMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'extraMSHours')) + (getObjectProperty(extraTime, 'duration')));
        studentContainer.push(extraTime);
        (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).push(extraTime);
        await new Promise(r => setTimeout(r, 50 || 0));
        ___arguments.context.pageData['msStudentContainer'] = (await asyncListSort(studentContainer, 1, async (item) => {


         return (getObjectProperty(item, 'start_time'));
        }));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));
        resultMsg = 'Error encountered at Save object to calendar db';

      }
      try {
        LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',(getObjectProperty(j, 'manualMSTimeHours')),(Number((getObjectProperty(j, 'manualMSTimeHours')))) == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],', ',(getObjectProperty(j, 'msDescription')),', ',eventTitle.split('-')[0].split('#').slice(-1)[0],(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Curriculum Design' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Special Projects' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Other Hours' ? String(', Approved by: ') + String(getObjectProperty(j, 'approvalName')) : ''].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' });
        ___arguments.context.pageData['payableMSHours'] = (Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours'))));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));
        isSuccessful = false;
        resultMsg = 'Error encountered at Task creation';

      }
    }
    console.log('here');
    ___arguments.context.pageData['MSExtraTimeList'] = [];
    ___arguments.context.pageData['card_no'] = 1;
    ___arguments.context.pageData['msCalendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a480ae62e306a535eeaf66a4e8e403', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  }
  console.log(___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d'));
  (function (message) { alert(message) })(resultMsg);
  try {
    ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while refreshing containers / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/10b4dd1e2ab552a169337fbcfa757772/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Curriculum Design (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Special Projects (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Other Hours (Microschool Only)')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/61e494f398a8c43987fae7be42e96672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
  await new Promise(r => setTimeout(r, 10 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edb59f2e49f5518df1c18cc541d37a9e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b4bce7ddd4ca41aeac3bfd56f1f1f43e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/edac5e8a6da9a7b4eba642e8e289ea77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);
    await new Promise(r => setTimeout(r, 1 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f1dddc1ed6b68b74c36bbf9ea6cb832', true);

  } catch (error) {
    console.log('error at microschool-show-on');
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/9be21fae0eef29a7b8cd16674d3411fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/8dbead2f0339fe91688571fa545216dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['tourState'], 'type')) == 'skip' || (getObjectProperty(___arguments['tourState'], 'type')) == 'tour:end' || (getObjectProperty(___arguments['tourState'], 'action')) == 'close') {
    await ( async function (componentUid, index) {  ___arguments.context.getComponentByUid(componentUid).goTo(index) })('8dbead2f0339fe91688571fa545216dc', 0);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8dbead2f0339fe91688571fa545216dc');
  }
  ___arguments.context.pageData['hasLoaded'] = true;

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TourGuideOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/0f4f2f61b94239ef4beae092ea8c3fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging' ? 'TUTORING - Here you can view your upcoming private sessions' : 'TUTORING - Here you can review and submit your private sessions')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/711d2aae60d3eb21eddd3f02d0be19f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/?page=Main_Page', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/a6c5ef2fdd0bd2bd831b680eb5918ef6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  GetTutorData = (await Backendless.UserService.getCurrentUser(false));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=tutor_sso','','','','',''].join('')), false, ({ [`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`fromPortal`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`email`]: (getObjectProperty(GetTutorData, 'email')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/1f360448c5246c7cc68704ada38198d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b369987b46aac3fba99d1988a3a3b29f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/71964ea6d526a89afe3c46c30376524f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  display = (await Backendless.UserService.isValidLogin()) && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tutorType')) == 'Microschool';

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b4f9d3a828224a463fb785ac1249d85e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/fa09f342d838a30d9bde856d099665d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Class Duration: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),'h'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/55d95ee477bf968d8c1ae31445de508c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === null) ? null : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).indexOf('ESE') !== -1) ? 'ESE' : 'GENED'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/35d7a958121fbbd8c7a5b3a3f5acff0d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'submittedHours'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e25c40ca7bf7e3ff85efc315e5df783f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'submittedMSHours'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/cd03689f63f1814eacd114427e6e8139/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, objectToDelete, Task, item, LeadHolder, LeadTask, studentContainer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  logger_name = 'deleteManualHour';
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHours2')), ___arguments.context.getComponentDataStoreByUid('9abceacc5bed5876e09f989a33d83bed'), '');
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    removeItemInList(studentContainer, ___arguments.context.getComponentDataStoreByUid('9abceacc5bed5876e09f989a33d83bed'), '');
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['payableHours2'] = (getObjectProperty(___arguments.context.pageData, 'payableHours2'));
    if ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) != 0) {
      ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) - 1);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['event_title = \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9abceacc5bed5876e09f989a33d83bed'), 'event_title')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }
    if ((getObjectProperty(objectToDelete, 'slots_slug')) != 'Manual time') {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  try {
    await Backendless.Data.of('calendar').save( ({ [`scheduling`]: 'is_deleted',[`objectId`]: (getObjectProperty(objectToDelete, 'objectId')) }) );
    LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
       if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
      }


     return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
    }));
    Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_3L0gg9cIHcped8UJj8eiZAgwRB7lF4DLpJLRUeGDrNo' }));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/e22e8a2df3a6e667a61623ab19b5db47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9abceacc5bed5876e09f989a33d83bed', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/7b232a98944de94b6699782409517e77/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var isComplete;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isComplete = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf());
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', isComplete);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', (!isComplete));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/12b70fec6504de450c0da255355691c8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var isComplete;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isComplete = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', isComplete);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? isComplete : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/bd27f88e163dc6d59d6ec131135dfb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q1answer')),' - ',(getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8cb44e6a1a433963c1cbe981ff6e20d')), 'el')), 'value'))].join(''));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/b8cb44e6a1a433963c1cbe981ff6e20d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd27f88e163dc6d59d6ec131135dfb4f', (getValueLength(___arguments.value) > 10));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/94e167dff2636b31875deccb8b5dba86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/4bfcdf5346279e4629740d933a2d0dce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParam = ({  });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParam['fromAP'] = (getObjectProperty(___arguments.context.pageData, 'fromAP'));
      urlParam['fromDashboard'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParam['fromSA'] = (getObjectProperty(___arguments.context.pageData, 'fromAP'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/6c25abc61e44caa4676a35e740e11715/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')),[`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/ec968a07d84761b209e54436b188956c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/f025db93b28eea7cacc558cfeb4d72a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging' ? 'MICROSCHOOL - Here you can view your upcoming Microschool Classes' : 'MICROSCHOOL - Here you can review and submit your Microschool Classes')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_check_last_week/components/d90beb9afbca0f8e56214252140f2aed/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hasBMS')) ? 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/images/bms-logo.png' : 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/images/logo_name.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, userName, _unused, test, TutorName, messagingList, uniqueSlots, studentsToday, dash, GetFutureMSCalendar, msStudentContainer, studentContainer, hoursList, hoursMSList, announcements, tutor, welcomeNotes, DriveTokenObject, CounterValue, checkUser, LoginData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) == true) {
    console.log(['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''));
    checkUser = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(1)))[0];
    console.log(checkUser);
    try {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'zoomid')), false  ));

    } catch (error) {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'MS_teacher_password')), false  ));

    }
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    try {
      Backendless.Logging.getLogger('tutor_dash_ms').info((['User Info','\nLogged in User Name:',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),'\nEmail:',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\nData:',(JSON.stringify((await Backendless.UserService.getCurrentUser(true))))].join('')));

      ;(function() {
        const callback = async () => {
            ___arguments.context.pageData['currentTime'] = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: 'long',[`hour12`]: undefined,[`month`]: undefined,[`day`]: undefined,[`hour`]: undefined,[`minute`]: undefined,[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((new Date())));

        };

        const timerId = '';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
      ___arguments.context.pageData['LoginData'] = ({ [`user-token`]: (Backendless.getCurrentUserToken()) });
      userName = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      ___arguments.context.pageData['userName'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      CounterValue = 0;
      while (typeof userName === 'undefined') {
        userName = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      }
      console.log(['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''));
      tutor = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\' and subjects is not null'].join(''),[`property`]: ['name', 'tip_level', 'timezones.short_name', 'timezones.iana', 'zoom', 'zoomid', 'timezones.offSet', 'timezones.sign', '*'],[`pageSize`]: 1 })).setEncoding('utf8').send())[0];
      if ((tutor === null) || (typeof tutor === 'undefined')) {
        return null;
      }
      await BackendlessUI.Functions.Custom['fn_cad53b2c8115106fd3afcda20303acdc']('Page Enter / Tutor Dash', (['Tutor ',userName,' logged in on ',((new Date()).toUTCString()),' / ',((getObjectProperty(___arguments.context.pageData, 'userEmail')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userEmail')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) : (getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')));
      ___arguments.context.pageData['houseLeader'] = ['Jordan Knoetgen', 'Kelly Radigan', 'River Lotus'];
      ___arguments.context.pageData['card_no'] = 1;
      ___arguments.context.pageData['userName'] = ((userName === null) || (typeof userName === 'undefined') ? (getObjectProperty(tutor, 'name')) : userName);
      ___arguments.context.pageData['tutorSubjects'] = (getObjectProperty(tutor, 'subjects'));
      ___arguments.context.pageData['zoom'] = (getObjectProperty(tutor, 'zoom'));
      ___arguments.context.pageData['zoomid'] = (getObjectProperty(tutor, 'zoomid'));
      ___arguments.context.pageData['lead_id'] = (getObjectProperty(tutor, 'lead_id'));
      ___arguments.context.pageData['short_name'] = (getObjectProperty(tutor, 'short_name'));
      ___arguments.context.pageData['offSet'] = (getObjectProperty(tutor, 'offSet'));
      ___arguments.context.pageData['sign'] = (getObjectProperty(tutor, 'sign'));
      ___arguments.context.pageData['timezone'] = (getObjectProperty(tutor, 'timezone'));
      ___arguments.context.pageData['iana'] = (getObjectProperty(tutor, 'iana'));
      DriveTokenObject = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0];
      ___arguments.context.pageData['DriveTokenObject'] = DriveTokenObject;
      ___arguments.context.pageData['MSExtraTimeList'] = [];

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Page Enter / tutor_dash', (['Error found while getting user data / ',userName,' / ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

    }
    try {
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
        ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
      } else {
        ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
      }
      welcomeNotes = [', remember to start with a clear lesson objective!', ', remember to use crisp lesson segments in your session 🙂', ', just a reminder to use a "warm-up" today (aka \'Do Now\')', ', will you use an exit ticket at the end of your session today?', ', feel free to cold-call if your student is not talking enough.', ', try to have your student talk at least 50% of the time 🙏', ', just a reminder: precise is better than general praise!', ', a check for understanding can help you adjust your lesson mid-way...', ', may your session report be precise, thorough, and helpful for the student!'];
      ___arguments.context.pageData['loader'] = (['Hi ',userName.slice(0, (userName.indexOf(' ') + 1) - 1),listsGetRandomItem(welcomeNotes, false)].join(''));
      ___arguments.context.pageData['loading_spinnerVisible'] = true;
      ___arguments.context.pageData['tutorSelector'] = ({ [`value`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`label`]: (getObjectProperty(___arguments.context.pageData, 'userName')) });
      ___arguments.context.pageData['announcements'] = [];
      announcements = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/announcements')).query(({ [`where`]: ['(Tutor_Category = \'',((getObjectProperty(tutor, 'timezone')).indexOf('US') !== -1) ? 'US' : 'ROW','\' or Tutor_Category = \'ALL\') and announcement_live = true'].join(''),[`pageSize`]: 100 })).setEncoding('utf8').send());
      addItemToList((getObjectProperty(___arguments.context.pageData, 'announcements')), announcements);
      console.log('Get/Set data');
      dash = (await BackendlessUI.Functions.Custom['fn_0e8c594b4c753e562b1581b671ad6261']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      studentContainer = (await BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw')), ___arguments.context.pageData));
      ___arguments.context.pageData['studentContainer'] = studentContainer;
      ___arguments.context.pageData['msStudentContainer'] = [];
      msStudentContainer = (await BackendlessUI.Functions.Custom['fn_820247ba30fce60b7d176e0f4b04c337']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      ___arguments.context.pageData['msStudentContainer'] = msStudentContainer;
      console.log('msStudentContainer **************************************');
      console.log(msStudentContainer);
      console.log('msStudentContainer **************************************');
      ___arguments.context.pageData['msQuestionnaire'] = (await BackendlessUI.Functions.Custom['fn_ba7314e68c4b6abd4bdf1ad56bcd9a5d'](userName));
      hoursMSList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      console.log(___arguments.context.pageData);
      hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw')), ___arguments.context.pageData));
      ___arguments.context.pageData['title'] = (['Hi ',userName.slice(0, (userName.indexOf(' ') + 1) - 1),', welcome back!'].join(''));
      if (!msStudentContainer.length && !!studentContainer.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions.';
      } else if (!studentContainer.length && !!msStudentContainer.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = 'To locate your recently completed classes and confirm hours for payment, go to the \'Microschool\' tab for microschool classes.';
      } else if (!!studentContainer.length && !!msStudentContainer.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions, or the \'Microschool\' tab for microschool classes.';
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = ' ';
      }
      ___arguments.context.pageData['selector'] = 'reports';

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Page Enter / tutor_dash', (['Error found while generating all past sessions / ',userName,' / ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

    }
    try {
      GetFutureMSCalendar = (await BackendlessUI.Functions.Custom['fn_163ad5c1239eb27a61ad4b15e1ea1022']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      console.log('future MS session');
      console.log(GetFutureMSCalendar);
      ___arguments.context.pageData['msFutureStudentContainer'] = GetFutureMSCalendar;
      dash = (await BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      studentsToday = [];
      uniqueSlots = [];
      messagingList = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')), ___arguments.context.pageData));
      ___arguments.context.pageData['extraHours'] = 0;
      console.log('future TS session');
      console.log(getObjectProperty(___arguments.context.pageData, 'calendarListRaw3'));
      if (true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
        console.log('show MS');
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
        console.log('show TS Hour Block');
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
        console.log('show MS Hour Block');
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('98c34b8e62aaeb432ada42173c02448b', true);
        await new Promise(r => setTimeout(r, 250 || 0));
        TutorName = (getObjectProperty(___arguments.context.pageData, 'userName'));
        test = [({ [`target`]: 'body',[`content`]: ['Hi ',TutorName,'! You can use this portal to review and submit your sessions or classes.'].join(''),[`disableBeacon`]: true,[`placement`]: 'center' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e')), 'el')),[`content`]: 'Click here to access your Tutoring & Private Sessions',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring & Private Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9be21fae0eef29a7b8cd16674d3411fe')), 'el')),[`content`]: 'Click here to access your Microschool Classes',[`placement`]: 'left',[`placementBeacon`]: 'left',[`title`]: 'Microschool Classes',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('39075dbc9d74db38793c3159bbf4fe59')), 'el')),[`content`]: 'Click here to see your past and current sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Past Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc17716809b5e5a5cd8913dd92bd72e9')), 'el')),[`content`]: 'Click here to see your future sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Future Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6f83a1196e4d9f887a4e0ba1e3b9284')), 'el')),[`content`]: 'Submit a ticket and we will get back to you within 24hrs.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Support',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db69da57441b0c5f05bee60c9ed3a0be')), 'el')),[`content`]: 'Click this to access more links/resources.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Explore',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79ab7744549adaff5491eed85f942c98')), 'el')),[`content`]: 'Click here to send your reports to the Student and Parent',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Reports',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2bc7badc91dd24529b363d8ac0c1338a')), 'el')),[`content`]: 'Click this plus button to access the tutoring extra hour section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac33164fd012e85afbe73d1e4c72c86f')), 'el')),[`content`]: 'This is where you can select a category for your extra hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Category',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d784a003d94b3000672f9938a65a8')), 'el')),[`content`]: 'This is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Input Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3287b7d1ed141a3e7ea27aa2c94652af')), 'el')),[`content`]: 'This is where you will add the description of the extra hour that you are going to enter',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e29cbb94966f7ad1371a1a0aa85e1f71')), 'el')),[`content`]: 'Click this button to add your extra hour in the hour to be submitted',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de')), 'el')),[`content`]: 'Submit your tutoring hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutor Hours Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34afc59ab7bf285faf9ac3f9c936faf9')), 'el')),[`content`]: 'Click the class name to see the student list of this specific class',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Student List',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('353be564809844c2ae8c2c66c1843b03')), 'el')),[`content`]: 'Click this bin icon to cancel a specific class before submitting it.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Cancel Class',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad13b5c129c3720e61ec643f4b8f52d8')), 'el')),[`content`]: 'Click this plus button to access the microschool extra hours section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('341e69ee2f6f94eb01681d5d151ffc67')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c03dd593e64185b5d0226e377eb0b31')), 'el')),[`content`]: 'This button will let you choose the next extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e80240f566633de7cda34bef372c9ff5')), 'el')),[`content`]: 'This button will let you choose the previous extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('389378220a8ed62cd0e392c2caeeac9a')), 'el')),[`content`]: 'This button will let you access the Add Hour Form of the chosen card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Add Hour Form',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a89e4ef41ca9a8ce33ff4dd20e93d95f')), 'el')),[`content`]: 'Input your extra hours here',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('82524489318c4a636811f3f45cacdd55')), 'el')),[`content`]: 'This is where you will enter the description of your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89bf71fbf8c4b4c7477c0139ab58584a')), 'el')),[`content`]: 'Click this to add your extra hours for review',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours to Review',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8d343d9778c0df6673d7d26cb0d0121')), 'el')),[`content`]: 'Click this to review your extra hours before submitting your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28b759ed749ebd638fcb7ed85a3981e7')), 'el')),[`content`]: 'This section is where you can review your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('71686cc3e1e32301badc353c2c9d8deb')), 'el')),[`content`]: 'Submit your MS Extra Hours once you are satisfied with the Extra Hours you input',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Submit MS Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065')), 'el')),[`content`]: 'Submit your Microschool Hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Hours',[`offset`]: 10,[`event`]: 'click' })];
        ___arguments.context.pageData['TourGuideOptions'] = test;
        ___arguments.context.pageData['loading_spinnerVisible'] = false;
        ___arguments.context.pageData['loader'] = '';
        await new Promise(r => setTimeout(r, 100 || 0));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).reset() })('8dbead2f0339fe91688571fa545216dc');
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).start() })('8dbead2f0339fe91688571fa545216dc');
      }

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Page Enter / tutor_dash', (['Error found while generating all future sessions / ',userName,' / ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/tutor_dash_ms/components/4756d4ddb332497515dc236f06169a05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!((getObjectProperty(___arguments.context.pageData, 'test_mode')) === null) && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
      await Backendless.UserService.logout();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page_Test_Mode', undefined);
    } else {
      await Backendless.UserService.logout();
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/31852522e433679db69ddb12ee22dcf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) >= (new Date())) {
    (function (message) { alert(message) })('Can\'t send homework before start time');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'reportRowClick')) == false) {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = false;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var endTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  endTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 50;

  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/c53a30fa950184dccd71ea0fb4d8b60d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'is_cancelled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).startsWith('[OFFBOARDED]'))) && lateTime >= ((new Date()).valueOf()) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'messageRowClick')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ee1465bff9c2bec6941d08222ba5ec26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'parent_name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/66cd90547bf88f0ec556661ce6996da6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var slotsSlugText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) != 0) {
        slotsSlugText = String('Last homework was sent on ') + String(new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`year`]: 'numeric',[`timeZoneName`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
      }
    }
  } else if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    slotsSlugText = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug'));
    if (slotsSlugText == 'Substitute session' || slotsSlugText == 'Extra Session') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('66cd90547bf88f0ec556661ce6996da6'))['color'] = '#F4703C';
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) {
    slotsSlugText = 'Self-paced MS 1on1';
  }

  return slotsSlugText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/cc17716809b5e5a5cd8913dd92bd72e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, messagingList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')) === 'undefined')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    return null;
  }
  if (((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined')) {
    return null;
  }
  LoggerName = 'MessagingContainer';
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
      ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
    } else {
      ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    }
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !((getObjectProperty(___arguments.context.pageData, 'studentContainer')) === null) && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    }
    ___arguments.context.pageData['loader'] = (String((getObjectProperty(___arguments.context.pageData, 'userName')).slice(0, ((getObjectProperty(___arguments.context.pageData, 'userName')).indexOf(' ') + 1) - 1)) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('There was an error in the starting sequence / username: ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    ___arguments.context.pageData['selector'] = 'messaging';
    messagingList = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')), ___arguments.context.pageData));
    ___arguments.context.pageData['studentContainer'] = messagingList;
    ___arguments.context.pageData['msStudentContainer'] = (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer'));

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('There was an error while getting the messaging list / username: ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !((getObjectProperty(___arguments.context.pageData, 'studentContainer')) === null) && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === null) && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'There was an error in the ending sequence', error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms/components/08770bb54b931f72b9a4291830a2fefe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://airtable.com/appY4H22rBsR5hG1g/shre8VCU9FnC23bFi/tblrD92p5tHt8Fq6u', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms/components/56bc538f1eb9f9fd9bc6656fcf34eecb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _unused, error, item, LeadHolder, LeadTask, logger_name, objectToDelete, studentContainer, Task;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  console.log('deleteManualHour');
  logger_name = 'deleteManualHour';
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHours2')), ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    removeItemInList(studentContainer, ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['payableHours2'] = (getObjectProperty(___arguments.context.pageData, 'payableHours2'));
    if ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) != 0) {
      ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) - 1);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['event_title = \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }
    if ((getObjectProperty(objectToDelete, 'slots_slug')) != 'Manual time') {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  try {
    await Backendless.Data.of('calendar').save( ({ [`scheduling`]: 'is_deleted',[`objectId`]: (getObjectProperty(objectToDelete, 'objectId')) }) );
    LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
       if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
      }


     return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
    }));
    Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/06391894f8d7144146e5b0413ef74286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  logger_name = 'tutor_dash_submitMessage';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (String('MessageContent - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent'))), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#d3d3d3';
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')) == null) {
      Backendless.Logging.getLogger(logger_name).debug('Message Content is Empty');
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the start sequence - Error / Parent Lead: ', error));

  }
  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/messaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })));
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Message Sent - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was a problem sending the message - Error / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), error));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a48471e0ee74216f8254f582a3438b1'))['color'] = '#fd6541';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Error';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageContent'] = '';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Submitted!';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6efdad730a47b90a1d6e79bbc2f53aa8', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the end sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/be21d4c346140134069b5ce1dc4c22ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')) === null) ? null : ['Hi ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),', this is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).indexOf(' ') + 1) - 1),' from Brilliant Grades. I\'m in the zoom room waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),'. Our session started 5 minutes ago. Are you joining? Thanks a ton!','\n_____\n\nzoom link: ',(getObjectProperty(___arguments.context.pageData, 'zoom')),'\n\nmeeting id: ',(getObjectProperty(___arguments.context.pageData, 'zoomid'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/edb59f2e49f5518df1c18cc541d37a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'studentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/39075dbc9d74db38793c3159bbf4fe59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, msFutureStudentContainer, MSStudentContainer, msHourBlock, messagingList, dash, StudentContainer, hourBlock, LoggerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'ReportContainer';
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
      ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
    } else {
      ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    }
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      console.log('msStudentContainer');
      console.log(getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      }
    }
    console.log('studentContainer');
    console.log(getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    }
    ___arguments.context.pageData['msStudentContainer'] = [];
    ___arguments.context.pageData['studentContainer'] = [];
    ___arguments.context.pageData['loader'] = (String((((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) : (getObjectProperty(___arguments.context.pageData, 'userName'))).slice(0, ((((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) : (getObjectProperty(___arguments.context.pageData, 'userName'))).indexOf(' ') + 1) - 1)) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    ___arguments.context.pageData['selector'] = 'reports';

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', (['There is an error in the start sequence / email: ',((getObjectProperty(___arguments.context.pageData, 'userEmail')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userEmail')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) : (getObjectProperty(___arguments.context.pageData, 'userEmail')),' / name: ',((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) : (getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));

  }
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'calendarListRaw')) === 'undefined')) {
      StudentContainer = (await BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw')), ___arguments.context.pageData));
      hourBlock = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](StudentContainer, ___arguments.context.pageData));
      ___arguments.context.pageData['studentContainer'] = StudentContainer;
      dash = (await BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash'));
      messagingList = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')), ___arguments.context.pageData));
    }
    if (((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) && !(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined')) {
      MSStudentContainer = (await BackendlessUI.Functions.Custom['fn_820247ba30fce60b7d176e0f4b04c337']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      msHourBlock = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a'](MSStudentContainer, ___arguments.context.pageData));
      ___arguments.context.pageData['msStudentContainer'] = MSStudentContainer;
      msFutureStudentContainer = (await BackendlessUI.Functions.Custom['fn_163ad5c1239eb27a61ad4b15e1ea1022']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      ___arguments.context.pageData['msFutureStudentContainer'] = msFutureStudentContainer;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', 'There is an error while getting the repots', error));

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    console.log('studentContainer');
    console.log(getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('MS_') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A2') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B2') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C2') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D2') !== -1)) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) != true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      console.log('msStudentContainer');
      console.log(getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && (((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('MS_') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D2') !== -1))) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      }
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', 'There is an error in the end sequence', error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e29cbb94966f7ad1371a1a0aa85e1f71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, manualTimeHours, customEventTitle, event_title, manualTimeCategory, item, LeadHolder, LeadTask, _unused, extraTime, extraHours, CalendarObject, tutorObject, TodayNumber, startTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', false);
    logger_name = 'tutor_dash_submitManualHours';
    LoggingStatus = false;
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    manualTimeCategory = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeCategory'));
    manualTimeHours = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeHours'))));
    event_title = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'event_title'));
    TodayNumber = (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 2 || (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 1 ? (getObjectProperty(___arguments.context.pageData, 'todayNumber')) : 0;
    extraHours = [];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0) {
      (function (message) { alert(message) })('Hours need to be a positive number');
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      (function (message) { alert(message) })('Please choose a category');
      return null;
    }
    if (!(typeof event_title === 'string')) {
      (function (message) { alert(message) })('Please add a short description');
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 220)) {
      (function (message) { alert(message) })('Please keep your description between 10 to 250 characters');
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    for (var count = 0; count < manualTimeHours; count++) {
      startTime = ((new Date()).valueOf()) - TodayNumber * 86400000;
      customEventTitle = [manualTimeCategory,'#',subsequenceFromEndFromEnd((JSON.stringify(startTime)), 4, 1),'-',event_title].join('');
      CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/saveObjectToDB`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle }))));
      extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`subject`]: null,[`grade`]: null,[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor_name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle,[`student_name`]: null,[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`lastHmwrk`]: 0,[`messageRowClick`]: false,[`reportRowClick`]: false });
      await Backendless.Data.of('Users').addRelation(tutorObject, 'calendar', [(getObjectProperty(CalendarObject, 'objectId'))]);
      addItemToList(extraHours, extraTime);
      studentContainer.push(extraTime);
      (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).push(extraTime);
      await new Promise(r => setTimeout(r, 50 || 0));
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while adding manual hours for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',manualTimeHours,manualTimeHours == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',manualTimeCategory,', ',event_title,', ',customEventTitle.split('#').slice(-1)[0].split('-')[0]].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' });
    ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) + (Number(manualTimeHours)));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeCategory'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeHours'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['event_title'] = null;
    ___arguments.context.pageData['calendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ba3eeb1bed397379ff878c222e61cda', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    
  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/55fdb589c2cb251c7599918848144a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/05644c3fee79e4b5f2f8142ff511c59f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['MessageContentLength'] = (___arguments.value.length);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) < 1000) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) >= 10) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', false);
    }
  } else {
    (function (message) { alert(message) })('You have reached the limit');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8f91b6cb4293f2cdcdb6095aa07d7cb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('http://tutors.brilliantgrades.com/', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f91b6cb4293f2cdcdb6095aa07d7cb2'))['fontWeight'] = 700;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms/components/eeba337b1abad2e2064a177d173eb112/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://zoom.us/signin', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms/components/4cdc223f17b4a008501abf4bc2f579a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != '')

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null ? 'Companion Rubric' : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/55a2daa21ae3fd7d7c4344d11bf8e523/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.loom.com/share/e61474c1a9374f509c3586165875d842', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b2f38edae191dcee756e2c6e9e1f8f55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString, parentTimezone, tutorTimezone;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'tutor_away') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'tutor' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'contact' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') {
      localeDateString = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).split('#')[0];
    }
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/a6f83a1196e4d9f887a4e0ba1e3b9284/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Backendless.Logging.getLogger('tutor_dash_ms').info((['Redirect to Tutor Ticket Page','\nLogged in User Name:',(getObjectProperty(___arguments.context.pageData, 'userName')),'\nUser Data:',(JSON.stringify((await Backendless.UserService.getCurrentUser(false))))].join('')));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Tutor Ticket' })),'#firstname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ')[0],'&lastname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ').slice(-1)[0]].join('')), true, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_dash_ms').error((['Problem redirecting to Tutor Ticket.\nError:',error,'\nUsername:',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms/components/db69da57441b0c5f05bee60c9ed3a0be/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
  }

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64b22f2e967708cd2f23f0118fe71b96'))['marginTop'] = '0px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e7f84404d74f7eec8dd8f4b55566cdb1'))['fontWeight'] = 100;
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    }
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/98dd39b1912f926d6a0d7c5eef9e1773/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', false);

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e68a3f08b3383fbd9fa9cf9d6ee6ef67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/2c3cfb8f9666b2d16976e8ac5ab77697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['requestHours'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/292e0c59fc5ab5ecbfed410e938466b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, TaskCreate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'RequestHours';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered on starting sequence', error));

  }
  try {
    TaskCreate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/requestHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ 'event': ({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'requestHours': (getObjectProperty(___arguments.context.pageData, 'requestHours')),'userName': (getObjectProperty(___arguments.context.pageData, 'userName')) }) }))));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered while requesting for hours', error));

  }
  try {
    if (TaskCreate == 'success') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', false);
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', true);
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('853804cc12dfa569027d0603dd724dc4'))['content'] = 'Error: Try Again';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered ending sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/960fd48380c22f77d3063aee7edecec3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) === null) ? 'Student On Pause' : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('Mock') !== -1) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/48be111a6e73f9496192001254069b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/a738b596c568ca5c432a97d459156531/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/855cb05fd1fc8512b116fa12718e647e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toLocaleString());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/6ba3eeb1bed397379ff878c222e61cda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/6c7ce06f475737eaf549e27facb992de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus, PseudoCreatedTimestamp, payableHoursMS, payableHoursTS, item, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, studentEvent, CheckIfTthere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  logger_name = 'Submit Hours Button';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#EBEBE4';

  } catch (error) {
    (function (message) { alert(message) })('Error encountered while submitting hours');
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    for (var studentEvent_index in studentContainer) {
      studentEvent = studentContainer[studentEvent_index];
      CheckIfTthere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
      }));
      if (!CheckIfTthere.length) {
        continue;
      }
      if ((getObjectProperty(studentEvent, 'homework_sent')) == true) {
        studentEvent['toBePaid'] = true;
      } else if ((getObjectProperty(studentEvent, 'slots_slug')) == 'Mock Session') {
        studentEvent['homework_sent'] = true;
        studentEvent['toBePaid'] = true;
      }
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarListRaw'));
    for (var calendarEvent_index in calendarListRaw) {
      calendarEvent = calendarListRaw[calendarEvent_index];
      studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
      if (studentContainerPosition > 0) {
        calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
      }
    }
    ___arguments.context.pageData['calendarListRaw'] = calendarListRaw;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length == 0) {
      (function (message) { alert(message) })('You have no hours to be submitted');
    } else {
      PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
      payableHoursMS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && !((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      payableHoursTS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (!((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) || ((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && ((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      if (!!payableHoursTS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursTS,[`tutorService`]: 'TS',[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      if (!!payableHoursMS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursMS,[`tutorService`]: 'MS',[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      ___arguments.context.pageData['hoursStatusValue'] = 'Submitted!';
      ___arguments.context.pageData['submittedHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedHours')) + (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      ___arguments.context.pageData['payableHoursFiltered'] = [];
      ___arguments.context.pageData['payableHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    ___arguments.context.pageData['extraHours'] = 0;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the end sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Submit ',(getObjectProperty(___arguments.context.pageData, 'payableHours')),(getObjectProperty(___arguments.context.pageData, 'payableHours')) > 1 || (getObjectProperty(___arguments.context.pageData, 'payableHours')) == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f6f1e22a76dcd32af28397b3a5a8fa29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) == 'scheduled') {
    isVisible = true;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    isVisible = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled') {
    isVisible = false;
  } else {
    isVisible = false;
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/820270be67d64d464a98818ff8f39324/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/6c382dc562077f3dc8158e63420bfc9d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')), 'display')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#C1E1C1';
    } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#F1E8E7';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#fffff';
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/d2229337fcf815d30396549f2cc39705/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/11f45aa3e9a459f987a5058dd938e974/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf()))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/7d43457eb75181be4f6b6c726fffaeae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) > ((new Date()).valueOf()))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/c18c5c114225502a47e3c9f98228e873/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true ? false : true) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b031feb6c1e3aca2c4925425596f4b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/7f13a0fb81a33d11c448d8c8b44774a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'studentsToday')),(getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 1 || (getObjectProperty(___arguments.context.pageData, 'studentsToday')) == 0 ? ' sessions ' : ' session ','today!'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/a702c6aef57358e195b6b50a731d96f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/fff98e419ad78ce4d61f9566a48e117b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e1430179fc6b6f21c9dc9c6f22ca4ad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true ? false : true) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000))) {
    content2 = 'Pending Homework';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8617494c75fd6e5a303d80d7d4b1d333/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var message, Slot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
    message = 'Cancelled session';
  } else if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
    message = 'Session did not occur';
  }

  return message

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/74fc1f77230994ed26cd09bf3af662fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/45cd08bfd6849c17b7389f4b5471f992/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/42d4dcea40048a699c427a9a854238bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f42f0f48f9bc1f49ff2641e976690d34/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (___arguments.value.length);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b3843647ae5862a445e1352bacc1471c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ed786cc2c66bb26c2f4c8813c6319276/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ca23ee2ee51cea994404dd26d03bd69e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/7e39c413d2c245c3a4c3fd548e489754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = 'The student(s) made progress';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/17dd941e77be48f6117d1392d966840a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/010c10094d98413c56497d23fafb8e17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e072bb290098c74cf7230c269dbc63db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f8d8039e403d93534ff14dac3a318f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b26c14ace999f11d509bd7364029d8e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b1d660f5bbf75c5d2dd8b04d8f965b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'isPresent')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1faed4cd936a8483af596d0462ef141a/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error, RenamedFile, GetFile, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (true) {
      RenamedFile = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName'));
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/authcodes')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }));
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      GetFile = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v3/files/') + String(getObjectProperty(___arguments.context.pageData, 'uploadedIdFile'))))).query(({ [`fields`]: ['webContentLink'] })).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send());
      await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
    } else {
      RenamedFile = (await Backendless.Files.renameFile( encodePath((String('homework/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName')))), encodePath((['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),'.',___arguments.uploadedFiles.split('/').slice(-1)[0].split('.').slice(-1)[0]].join(''))) ));
    }
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6fb5c65420f143dee94c402ec10a72ad', [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length < 3) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length >= 3) {
      (function (message) { alert(message) })('Please keep each homework to 3 attachments. You can send a second report to include additional attachments. Thank you.');
    }
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')).length);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_dash_upload_file').warn(([(JSON.parse(error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  }

  },
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var _unused, accessTokenObject, accessTokenString, error, Metadata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (true) {
    try {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = 0;
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55df951b180944c84e9d0c54a82dac8e')), 'display')) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', false);
      }
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        try {
          await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );

        } catch (error) {
          console.log(error);
          await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/authcodes')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }));

        }
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''),[`parents`]: ['1Je3aUb8YMYTsCW78CFsioOMSEVy25wbw'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
      ___arguments.context.pageData['uploadedIdFile'] = (getObjectProperty(Metadata, 'id'));
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''));

    } catch (error) {
      console.log(JSON.stringify(error));
      Backendless.Logging.getLogger('tutor_dash_before_upload_file').warn(([(JSON.stringify(error)),' - ',(JSON.stringify(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'))),' File Type:',(getObjectProperty((___arguments.files[0]), 'type')),' File Name:',(getObjectProperty((___arguments.files[0]), 'name')),' File:',(JSON.stringify((___arguments.files[0])))].join('')));

    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (getObjectProperty((___arguments.files[0]), 'name'));
  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')).length);
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8551301ddc6d2c2fae763ec3774f959f')), 'display'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
  }
  Backendless.Logging.getLogger('tutor_dash_failed_upload_file').warn(([(JSON.parse(___arguments.error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var filename;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  filename = ((getObjectProperty(___arguments.file, 'name')).replace((new RegExp('(?:\\.(?![^.]+$)|[^\\w.])+', 'g')), '_'));

  return filename

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/7745a3e392ad5ff6dbdae5f47933a651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onMouseOut */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['border-radius'] = '50%';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/55df951b180944c84e9d0c54a82dac8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b07e189d45cd1f8ab6d831c9c40dfbbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/0c879ba8c2de9b2613175df1f12162f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ff04f66b2abaa26cd40ac75a3bd40a8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['FeedbackBTNClicked'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ad1cc4046b92cdce3bef541b0b287011/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/83ee4ec93215aafe7376dc165717a9d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8551301ddc6d2c2fae763ec3774f959f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) > 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) < 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/6fb5c65420f143dee94c402ec10a72ad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined')) {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms/components/d532e8462b3948653f0f9fc248526aef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/d97ebc8bcb09e1fdcc836c4ad1bac727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Student Issue';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/7cae4d7c127f4c5169edddfcdb625189/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Suggestions';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f9461ed7c0e9e0f3f60a3555d37d7d6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Other';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/0c389e7ff11c4e4ec227103b3dddc80d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms/components/190c483fac06d0d5ab4ecabfbc016fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f7ad243951b8ae8d464590037c99e4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    setBoolean = false;
  } else {
    setBoolean = true;
  }

  return setBoolean

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1cd7e871600396535b2844fcbc2277d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, FL_Score, _unused, logger_name, calendarListRaw, studentContainer, hoursList, dash, studentContainerPast, LoggingStatus, student, calendarListRawPosition, studentContainerPosition, attachments, studentList, uniqueSlots, item, attachment;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    logger_name = 'tutor_dash_submitHomework';
    LoggingStatus = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit Button clicked - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#d3d3d3';
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).length) {
      attachments = null;
    } else {
      attachments = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).map(async attachment => {; return (getObjectProperty(attachment, 'file'));})));
    }
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Collect Attachments - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarListRaw'));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) == true) {
      studentList = (await asyncListFilter(studentContainer, async (item) => {


       return ((getObjectProperty(item, 'slots_slug')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')) && (getObjectProperty(item, 'start_time')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'start_time')));
      }));
    } else {
      studentList = [___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')];
    }
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Get data necessary for submission - SUCCESS',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in retrieving data for the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }
  try {
    for (var student_index in studentList) {
      student = studentList[student_index];
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/homework`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(student, 'parent_name')),[`student_name`]: (getObjectProperty(student, 'student_name')),[`homework_sent`]: true,[`subject`]: (getObjectProperty(student, 'subject')),[`grade`]: (getObjectProperty(student, 'grade')),[`tutor_name`]: (getObjectProperty(student, 'tutor_name')),[`report`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')),[`calendarObjectId`]: (getObjectProperty(student, 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(student, 'slots_slug')),[`sessionQuality`]: ['Q1 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q1Ans')),'\nQ2 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q2Ans')),'\nQ3 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q3Ans'))].join(''),[`bgFeedback`]: (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === null) ? null : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'bgFeedback'))].join(''),[`contactParent`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')),[`attachments`]: attachments })));

      })();
      await new Promise(r => setTimeout(r, 250 || 0));
      studentContainerPosition = studentContainer.indexOf(student) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(student) + 1;
      if (studentContainerPosition > 0) {
        studentContainer[(studentContainerPosition - 1)] = student;
        calendarListRaw[(calendarListRawPosition - 1)] = student;
      }
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit homework - Success / Parent Lead: ',(getObjectProperty(student, 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', true);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in submitting the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', false);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared progress report - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['bgFeedback'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared bg feedback - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Contact Parent set to false - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['homework_sent'] = true;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Homework set to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#0a1352';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Set status visibility to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d96e3562b933d045d64b180c471b7d11', true);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared docs - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Clear form fields - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in clearing the fields - Error / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), error));

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['reportRowClick'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](studentContainer, ___arguments.context.pageData));
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['calendarListRaw'] = calendarListRaw;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in updating the object in the raw list - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/498c21f9cb5f164912448c47d278a46c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms/components/9418a1aba1fd4033450f16695735b1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b2132b5d8a74e88511b603ef358f5843/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8eae5cd8e32b77eb831fbb46a36676fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/984e2a28e63db3a68453ff794f68df03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.dataModel, 'read')) === 'string') && ((getObjectProperty(___arguments.context.dataModel, 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e76dd2cf23afcb977336e7ae69c2e423/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1c5529a18c276de5a74fec66241749b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/396350ff94ffb283fecee818981c9727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8ec186d9ea189f6782a2232bd55f0331/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/502108db508b967541ba142e40a79b81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/474be277ed82933a3a1218dbea262757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/a3ac1f9ed6db33d8afaab0d31f2a89eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/273aca3a2f47ec4254bd8974edbf5e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, LoggerName, _unused, studentContainerFuture, msStudentContainerPast, studentContainerPast, msHoursList, dash, hoursList, dash2;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/2bc7badc91dd24529b363d8ac0c1338a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/de26e0bacccc43811e337c2354ef780a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    text = 'Was your student present?';
  } else {
    text = 'Were your students present?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/362d5467896a664a436ca45175ba9c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/346a274c03153293703e2f6cd9f3318f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = false;
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' was absent today. Please let me know if there is something I can do to support you. Otherwise, I will be waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' in our next session.'].join(''));
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/2ba2eb34a96cc8b30bda933b45ca376c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['read'] = (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join(''));
    await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/BackendlessLoginAuthRestBlock`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`action`]: 'update',[`method`]: 'HR_Admin_Panel',[`databaseName`]: 'announcements',[`requestType`]: 'clientSide',[`query`]: ({ [`user-token`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LoginData')), 'user-token')) }),[`createObject`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'objectId')),[`read`]: !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('') }) })));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'Yes';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'No';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/dc5c3f24cb57a4539e2d77d9ac762071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    Value = 'No';
  } else {
    Value = 'Yes';
  }

  return Value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/6e11fc75c9b6e6382873be088a2e752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var show;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === null)) {
    show = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf())) {
    show = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')).indexOf('Partner') !== -1);
  } else {
    show = false;
  }

  return show

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/39174bc3cdf5a7b64801e1be2dc610cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var timeSlot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) == 0 ? '0' : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 100 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 10 ? ['0','0',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))].join('') : String('0') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/958b37f8fe89f72498d5e3e28c657cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 800;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/970b6c0790ab5e2533b198c248a7c47c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/3fe3fff351e3b7f33663ec02d3fbb18f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' || (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f7b151d3f20e3cc51195fba8032815af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/d2d5947e69b973cd56a3d61e3b4b587f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var FormatToTeacherTimezone, FormatToUTC, list, localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'School Closed') {
    FormatToTeacherTimezone = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    FormatToUTC = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: 'Etc/GMT',[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    localeDateString = [FormatToUTC[0],' ',FormatToUTC[1],' ',FormatToUTC[2],' ','00:00',' ',FormatToTeacherTimezone[4]].join('');
  } else {
    localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/fc5dd2dafd27503b990bdf0a7c412741/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'scheduled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))) == false && lateTime <= ((new Date()).valueOf()))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/a8abf4e79a810da4c4e4394e3bd9a801/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1d22c0a3a68461359766a57431328907/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'is_substituted')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b75e2b28827248f5a56e9f2753018984/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName'))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/85bd330ec0ef100ffb336893dd84761b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, NewData, TutorHours, ObjectIdToDelete, item, objectToDelete, Task, LeadHolder, LeadTask, CheckAssistantTeacher;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  console.log(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'));
  console.log('cancelMSManualHour');
  logger_name = 'cancelMSManualHour';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', true);
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
    ___arguments.context.pageData['payableHoursFilteredMS'] = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
    if ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) != 0) {
      ___arguments.context.pageData['payableMSHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'duration')));
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('ms_calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) != 'Planning Time') {
    try {
      CheckAssistantTeacher = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).query(({ [`where`]: ['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join('') })).setEncoding('utf8').send())[0];
      if ((getObjectProperty(CheckAssistantTeacher, 'assistant_teacher')) === null) {
        NewData = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),[`scheduling`]: 'is_cancelled' })));
        ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772')['scheduling'] = (getObjectProperty(NewData, 'scheduling'));
      } else {
        await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'slots_slug')) == 'Manual time') {
        LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
           if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
          }


         return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
        }));
        Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));
      }
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS MEETING' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) == 'Planning Time') {
    try {
      await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ad13b5c129c3720e61ec643f4b8f52d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b83298ed2753d53d622bdb5fbd6f0c8e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b62c065139737a347f7e7a27592589ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  ___arguments.context.pageData['MSExtraTimeList'] = [];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['show_add_hours'] = false;
    j['manualMSTimeHours'] = null;
    j['msDescription'] = null;
    j['approvalName'] = null;
  }
  ___arguments.context.pageData['card_no'] = 1;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/617aeeb949a1dac5eeb74c53a21fbf19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek2'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/c6a13b95bc64a2a1c73e0703e9aad3d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var SumOfHours, formatString, item, Description, Hour, j, OtherHours, SpecialProjects, ProgressReports, ShadowingHours, AdminHours, CurriculumDesign, HouseLeaderMeeting, MeetGreetMeeting, ExtraMeetings, OnboardingTraining, error, logger_name, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, manualTimeHours, eventTitle, event_title, manualTimeCategory, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, approvalName, _unused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', true);
  formatString = '';
  console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
  OnboardingTraining = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ExtraMeetings = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  MeetGreetMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  HouseLeaderMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  CurriculumDesign = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  AdminHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ShadowingHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ProgressReports = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  SpecialProjects = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  OtherHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OnboardingTraining.length) {
      for (var j_index in OnboardingTraining) {
        j = OnboardingTraining[j_index];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ExtraMeetings.length) {
      for (var j_index2 in ExtraMeetings) {
        j = ExtraMeetings[j_index2];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!MeetGreetMeeting.length) {
      for (var j_index3 in MeetGreetMeeting) {
        j = MeetGreetMeeting[j_index3];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',Hour / 0.5,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!HouseLeaderMeeting.length) {
      for (var j_index4 in HouseLeaderMeeting) {
        j = HouseLeaderMeeting[j_index4];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!CurriculumDesign.length) {
      for (var j_index5 in CurriculumDesign) {
        j = CurriculumDesign[j_index5];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!AdminHours.length) {
      for (var j_index6 in AdminHours) {
        j = AdminHours[j_index6];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ShadowingHours.length) {
      for (var j_index7 in ShadowingHours) {
        j = ShadowingHours[j_index7];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ProgressReports.length) {
      for (var j_index8 in ProgressReports) {
        j = ProgressReports[j_index8];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!SpecialProjects.length) {
      for (var j_index9 in SpecialProjects) {
        j = SpecialProjects[j_index9];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OtherHours.length) {
      for (var j_index10 in OtherHours) {
        j = OtherHours[j_index10];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  SumOfHours = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')).map(async item => {; return (getObjectProperty(item, 'manualMSTimeHours'));}))).reduce(function(x, y) {return x + y;});
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatExtraTime'] = (SumOfHours == 0 ? '' : formatString);
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatNoExtraTime'] = (SumOfHours == 0 ? 'No Extra Hours Added' : 'Review Extra Hours');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e6dcc3e1e7e4dd1a21f57ef92ecf7065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
    (function (message) { alert(message) })('There\'s no Microschool session to submit.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) == false) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ca3280537e60abefc51f52f46d2c4da')));
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var totalHours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  totalHours = (getObjectProperty(___arguments.context.pageData, 'payableMSHours')) + (getObjectProperty(___arguments.context.pageData, 'extraMSHours'));

  return (['Submit ',totalHours,totalHours > 1 || totalHours == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e41ae3499aa1023b7a456117a80b89ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/94a25aee66288cb122f76b6b70948052/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS MEETING' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : (await BackendlessUI.Functions.Custom['fn_20be5f297d6e7011d3eb8aacdd98716c']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')))).toUpperCase()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b2eda5d4da066dd2ed267037f345e274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/166f6de4ebe7c54f3fd9c3ab22d9b6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/0284b7b24a821e9cdb5b0b62a8ce04a9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.dataModel, 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#C1E1C1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#F1E8E7';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8f1dddc1ed6b68b74c36bbf9ea6cb832/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/9f09749e2f5815afcd4b1bd3294c8a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/d1c1a9931ef7177cfcc1a49fa16b13f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/887e6454024682c30a5f7e27755c472d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e5d7397d645689137cabd81d8d56d322/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  console.log(___arguments.value);
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/67d1b072060be60825b175a30b6c656e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
      return null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/a03846b3716b0d7b7292135aa3644e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/401aed0df3ca1a2b60919fbe4d451a09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/23bd7218dffe31de83fdef3e47facf37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/34f2b281028902c1f38a4af22386fdc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/54ae53f554d761b89e65dd07c6e2469d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/986513bd2dd43a1ed6e86a2ff4d1a5be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/2829d02674bea67c6e73c35550394e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e09301622cad56dce201c733ae5d579a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/09d624d5c24ea221fdc288d8f074fc4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09d624d5c24ea221fdc288d8f074fc4b')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f5e442d2527d7b0d002b8c05f7a28034/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f5e442d2527d7b0d002b8c05f7a28034')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ee02a47b3d4dc49cbdcd4edfd068e61d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee02a47b3d4dc49cbdcd4edfd068e61d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/9249997aa4c292a2f86be59f9cb11e83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9249997aa4c292a2f86be59f9cb11e83')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ed614d4ff047eb6a345a4e77b4dfd103/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed614d4ff047eb6a345a4e77b4dfd103')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/c53dff2850ec4ad6d6d9ab21f3aae558/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c53dff2850ec4ad6d6d9ab21f3aae558')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e73b9d72e48f95fc19669463d31eca01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e73b9d72e48f95fc19669463d31eca01')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/bf0ba5be04ac101781d6bf8eea7168bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf0ba5be04ac101781d6bf8eea7168bb')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/595fafa6a32ea512de22bd0df4485d21/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q5answer'] = [];
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q8answer'] = '';
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q9answer'] = '';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms/components/7ddac0256742e8f9124be8d5e157bb02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ddac0256742e8f9124be8d5e157bb02')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/42784913cf23a393b76fe0a91f9b136c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42784913cf23a393b76fe0a91f9b136c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/c9c32de38c2dc088b69ddc9f69060a3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9c32de38c2dc088b69ddc9f69060a3e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/5777f4435b3fc6eb3c3a045582e23d28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5777f4435b3fc6eb3c3a045582e23d28')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/09ce8b8e77b3d1b97265676a9082e899/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09ce8b8e77b3d1b97265676a9082e899')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/4b5c353f46d55f0892b33bbb74ceeb9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b5c353f46d55f0892b33bbb74ceeb9c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b3799dfeeb9796763c26ed41b22b5b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/7229ee6cecd4e7c44a9dbb6df89f2495/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length <= 50) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/2a32c8295622fcf5b005d0cb18bb6be4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q8answer')).length > 10)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/4cad321c51d3617e153bbba3013b0bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length > 50)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/dc8279e1eda851cc253f437e15af79d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, FL_Score, logger_name, LoggingStatus, durationPayable, j, PseudoCreatedTimestamp, studentEvent, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, item, CheckIfThere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', false);
  if (true) {
    logger_name = 'Submit MS Hours Button';
    LoggingStatus = false;
    try {
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', true);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#EBEBE4';

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      for (var studentEvent_index in studentContainer) {
        studentEvent = studentContainer[studentEvent_index];
        CheckIfThere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), async (item) => {


         return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
        }));
        if (!CheckIfThere.length) {
          continue;
        }
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          studentEvent['toBePaid'] = true;
        }
      }
      ___arguments.context.pageData['msStudentContainer'] = studentContainer;
      studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
      console.log(studentContainerIds);
      calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarMSListRaw'));
      for (var calendarEvent_index in calendarListRaw) {
        calendarEvent = calendarListRaw[calendarEvent_index];
        studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
        console.log('studentContainerPosition');
        console.log(studentContainerPosition);
        calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
        if (studentContainerPosition > 0) {
          calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
        }
      }
      ___arguments.context.pageData['calendarMSListRaw'] = calendarListRaw;
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      var studentEvent_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      for (var studentEvent_index2 in studentEvent_list) {
        studentEvent = studentEvent_list[studentEvent_index2];
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          if (typeof (getObjectProperty(studentEvent, 'toBePaidList')) === 'undefined') {
            studentEvent['toBePaidList'] = [];
          }
          addItemToList((getObjectProperty(studentEvent, 'toBePaidList')), (getObjectProperty(___arguments.context.pageData, 'userName')));
          studentEvent['toBePaid'] = true;
        }
      }
      await new Promise(r => setTimeout(r, 1000 || 0));
      console.log('payable hours');
      console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
        (function (message) { alert(message) })('You have no hours to be submitted');
      } else {
        PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/msHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')),[`tutorService`]: 'MS',[`MSAnswer`]: ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'),[`TutorName`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`msQuestioner`]: (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')),[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
        ___arguments.context.pageData['hoursMSStatusValue'] = 'Submitted!';
        durationPayable = 0;
        var j_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          durationPayable = (typeof durationPayable == 'number' ? durationPayable : 0) + (getObjectProperty(j, 'duration'));
        }
        ___arguments.context.pageData['submittedMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedMSHours')) + durationPayable);
        ___arguments.context.pageData['payableHoursFilteredMS'] = [];
        ___arguments.context.pageData['payableMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length);
        await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      ___arguments.context.pageData['extraMSHours'] = 0;
      ___arguments.context.pageData['msQuestionnaire'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8ac777b8772affc6e2ce2032e938bc1', true);
      await new Promise(r => setTimeout(r, 5000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = false;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#0a1352';

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the end sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'FScoreRaw')) === 'undefined')) {
        FL_Score = (Number((getObjectProperty(___arguments.context.pageData, 'FScoreRaw'))));
        console.log(String('Feeling Score: ') + String(FL_Score));
        if (typeof FL_Score === 'number' && !isNaN(FL_Score)) {
          _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/Low_Feeling_Score_Tutor`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`score`]: FL_Score }))));
        } else {
          console.log('Score not number. Please contact developer to check tutor dash. ');
        }
      }
      FL_Score = 0;

    } catch (error) {
      console.log(error);

    }
    try {
      if (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
        _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/One_on_One_App_Training`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`AppList`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')) }))));
      }

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/e2eb6cc9b2f36415c472018c6c9ddf3c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/601f5118947dd9e3f09faf4c5321da6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/d4947e4eab7b5685ef33742d5872fe9f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b532bb949a0a6a0220fbdcae9b8dbc62/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/2cdb27d75f9340271127dca71053ab35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/38bf97e56321eb774eae6fa844e4329e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1899137b4cdf7af97763cfc709761c86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ae044db4641eccaf4aa2da0b15a9480b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1a073794f27789130524b8fc60fa7c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1c2e819947b9ef743a531af229225184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/99527bf533d14ad7ce42d6fdd32a1c1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/26a5ef11960ccfbaaeafd4bb03f812d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/524374174fbfeb5c471ea1c8b9eda934/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/920459fd2fbd2d44c90c7dbfcb622d9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) != true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/204a99b4d8eca6c814ea9d02a16df748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: undefined,[`day`]: undefined,[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split('#')[0] : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')).startsWith('MAX')) ? ['Your ',localeDateString,' ',textToTitleCase(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).replace((new RegExp('MS_', '')), '')).replace((new RegExp('_', 'g')), ' ')),' School class'].join('') : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')).length) {
    return null;
  }
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12fe332cac06910a7c6d4801efd2981b')), 'display')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', false);
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8c6c6704422db291a4d470567b594934/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('12fe332cac06910a7c6d4801efd2981b'), 'student_list'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/03538403f3f7afc497a253c1c8d5c022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'currentTime'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1617628cbcbc4abb0e34a28bccf8cb2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/44cfadd5fcfe1efe234e0e52929ed598/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'submittedHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/5f999f1b796766cac0a891d51d1bae4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your questionnaire form for this week! You can submit your remaining hour.';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/6b6a055f8ace72c3c9a8ff4d0e42af3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your answer for questionnaire this week! You can submit your remaining hours now!';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/eb562517050d0e24f5c230c12475f8b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),' hour(s)','<br/>',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split((new RegExp('#\\d\\d\\d\\d-', '')), )).slice(-1)[0]].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/9ca3280537e60abefc51f52f46d2c4da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging' && (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, studentContainerFuture, msStudentContainerPast, studentContainerPast, msHoursList, dash, hoursList, dash2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    LoggerName = 'RefreshButton';
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
      ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
    } else {
      ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    if (((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    }
    dash = (await BackendlessUI.Functions.Custom['fn_0e8c594b4c753e562b1581b671ad6261']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
    dash2 = (await BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
    studentContainerPast = (await BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc'](dash, ___arguments.context.pageData));
    studentContainerFuture = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022'](dash2, ___arguments.context.pageData));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](dash, ___arguments.context.pageData));
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      msStudentContainerPast = (await BackendlessUI.Functions.Custom['fn_820247ba30fce60b7d176e0f4b04c337']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a'](msStudentContainerPast, ___arguments.context.pageData));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      ___arguments.context.pageData['studentContainer'] = studentContainerPast;
      if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        ___arguments.context.pageData['msStudentContainer'] = msStudentContainerPast;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
      ___arguments.context.pageData['studentContainer'] = studentContainerFuture;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    }
    if (((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (['Error encountered while refreshing the ',(getObjectProperty(___arguments.context.pageData, 'selector')),' container / UserName: ',(getObjectProperty(___arguments.context.pageData, 'userName')),' / UserEmail: ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_ms/components/00b276c2b0c5baaa9282670dd683dc65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/410f28513c7e12343ef1d956e9f6a294/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'card_no')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) < ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f885dc8d25c417286c1e1bfd663a8848/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 <= 1) {
    ___arguments.context.pageData['card_no'] = 1;
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 > 1) {
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) == 1)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) != 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/58d98c73120a88eac77b66836906df47/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var GetCurrentRepeater, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  GetCurrentRepeater = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '450px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) != 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b83298ed2753d53d622bdb5fbd6f0c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'UUID'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b83298ed2753d53d622bdb5fbd6f0c8e'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms/components/97eeff3b29311305a4e5e5fb2b65fb82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/bdcca712e5096c7193feabd5cbd6a52d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item, CheckHouseLeader, CreateSubjectList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'houseLeader')) === 'undefined') {
    return null;
  }
  CheckHouseLeader = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'houseLeader')), async (item) => {


   return (item == (getObjectProperty(___arguments.context.pageData, 'userName')));
  }));
  CreateSubjectList = (getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).split(',');
  if (((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined')) {
    ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    return null;
  }
  if (!!CheckHouseLeader.length) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  } else {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms/components/4a9fc23dae555ebd728bbfe169bdf0c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, records, GetCurrentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  records = [];
  GetCurrentData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(GetCurrentData, 'card_name')) == (getObjectProperty(j, 'card_name'))) {
      j['show_add_hours'] = true;
    } else {
      addItemToList(records, j);
    }
  }
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/f7bafd0b847e466d2b27a647b6ecf16d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, error, logger_name, _unused, approvalName, manualTimeCategory, event_title, manualTimeHours, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', false);
    logger_name = 'Adding Manual hours to list';
    LoggingStatus = false;
    manualTimeCategory = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name'));
    manualTimeHours = (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours'))));
    event_title = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription'));
    approvalName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', true);
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0) {
      (function (message) { alert(message) })('Hours need to be a positive number');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (manualTimeHours % 0.5 != 0) {
      (function (message) { alert(message) })('Hours need to be 0.5, 1, 1.5, 2, 2.5, and so on.');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      (function (message) { alert(message) })('Please choose a category');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof event_title === 'string')) {
      (function (message) { alert(message) })('Please add a short description');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 500)) {
      (function (message) { alert(message) })('Please keep your description between 10 to 500 characters');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if ((manualTimeCategory == 'Curriculum Design (Microschool Only)' || manualTimeCategory == 'Special Projects (Microschool Only)' || manualTimeCategory == 'Other Hours (Microschool Only)') && !(typeof approvalName === 'string')) {
      (function (message) { alert(message) })('Please add an Approval Name');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/39745d989538c85beed89f66cd65143c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var logger_name, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, error, j, eventTitle, item, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, FormatMSExtraTime, event_title, manualTimeCategory, manualTimeHours, _unused, approvalName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd955a1720296708a4c5aa9efec33999', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  logger_name = 'tutor_dash_submitMSManualHours';
  LoggingStatus = true;
  FormatMSExtraTime = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if (!FormatMSExtraTime.length) {
    return null;
  }
  TodayNumber = (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 2 || (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 1 ? (getObjectProperty(___arguments.context.pageData, 'todayNumber')) : 0;
  studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
  extraHours = [];
  tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
  if (false) {
  } else {
    for (var j_index in FormatMSExtraTime) {
      j = FormatMSExtraTime[j_index];
      try {
        eventTitle = [(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],'#',subsequenceFromEndFromEnd((JSON.stringify((((new Date()).valueOf()) - TodayNumber * 86400000))), 4, 1),'-',(getObjectProperty(j, 'msDescription'))].join('');
        CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/FrontendSaveMSCalendar`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`Description`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_date`]: (new Date((((new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))).toISOString()).slice(0, 10)))),[`event_title`]: eventTitle,[`status`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`approvalName`]: (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Curriculum Design' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Special Projects' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Other Hours' ? (getObjectProperty(j, 'approvalName')) : null }))));
        extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_time`]: (new Date((((new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))).toISOString()).slice(0, 10)))),[`event_title`]: eventTitle,[`sessionStatus`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`student_list`]: [],[`toBePaidList`]: [] });
        addItemToList(extraHours, extraTime);
        ___arguments.context.pageData['extraMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'extraMSHours')) + (getObjectProperty(extraTime, 'duration')));
        studentContainer.push(extraTime);
        (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).push(extraTime);
        await new Promise(r => setTimeout(r, 50 || 0));
        ___arguments.context.pageData['msStudentContainer'] = (await asyncListSort(studentContainer, 1, async (item) => {


         return (getObjectProperty(item, 'start_time'));
        }));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));

      }
      try {
        LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',(getObjectProperty(j, 'manualMSTimeHours')),(Number((getObjectProperty(j, 'manualMSTimeHours')))) == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],', ',(getObjectProperty(j, 'msDescription')),', ',eventTitle.split('-')[0].split('#').slice(-1)[0]].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' });
        ___arguments.context.pageData['payableMSHours'] = (Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours'))));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));

      }
    }
    ___arguments.context.pageData['MSExtraTimeList'] = [];
    ___arguments.context.pageData['card_no'] = 1;
    ___arguments.context.pageData['msCalendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a480ae62e306a535eeaf66a4e8e403', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  }
  console.log(___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/10b4dd1e2ab552a169337fbcfa757772/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Curriculum Design (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Special Projects (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Other Hours (Microschool Only)')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/61e494f398a8c43987fae7be42e96672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
  await new Promise(r => setTimeout(r, 10 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edb59f2e49f5518df1c18cc541d37a9e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b4bce7ddd4ca41aeac3bfd56f1f1f43e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/edac5e8a6da9a7b4eba642e8e289ea77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
  await new Promise(r => setTimeout(r, 10 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f1dddc1ed6b68b74c36bbf9ea6cb832', true);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/9be21fae0eef29a7b8cd16674d3411fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/8dbead2f0339fe91688571fa545216dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['tourState'], 'type')) == 'skip' || (getObjectProperty(___arguments['tourState'], 'type')) == 'tour:end' || (getObjectProperty(___arguments['tourState'], 'action')) == 'close') {
    await ( async function (componentUid, index) {  ___arguments.context.getComponentByUid(componentUid).goTo(index) })('8dbead2f0339fe91688571fa545216dc', 0);
    await new Promise(r => setTimeout(r, 100 || 0));
    if (!!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && !(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      if (((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      }
    } else if (!!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      if (((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      }
    } else if (!!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    } else {
      if (((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8dbead2f0339fe91688571fa545216dc');
  }

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TourGuideOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/tutor_dash_ms/components/0f4f2f61b94239ef4beae092ea8c3fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/711d2aae60d3eb21eddd3f02d0be19f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/?page=Main_Page', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/a6c5ef2fdd0bd2bd831b680eb5918ef6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var GetTutorData, error, urlParam, accessLevel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (await Backendless.UserService.getCurrentUser(false));
    urlParam = ({ [`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`fromPortal`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`email`]: (getObjectProperty(GetTutorData, 'email')) });
    accessLevel = ({ [`access_level`]: 'Teacher' });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParam['test'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['fromAP'] = true;
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParam['test'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test'))) {
      urlParam['test'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': accessLevel })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_dash_ms').debug((String('Problem occurs in breadcrumbs | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/1f360448c5246c7cc68704ada38198d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b369987b46aac3fba99d1988a3a3b29f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/71964ea6d526a89afe3c46c30376524f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  display = false;
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'userData')) === 'undefined')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userData')), 'tutorType')) != 'Flex' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userData')), 'tutorType')) != 'Flex/Certified') {
      display = true;
    }
  }

  return display

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/b4f9d3a828224a463fb785ac1249d85e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms/components/2fe6c39a7a6491f5bf91748770ab4657/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Class Duration: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),'h'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/ddf502158c577934a06cbfa8b1482677/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') ? null : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).indexOf('ESE') !== -1) ? 'ESE' : 'GENED'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/4697bcf97875d828829f5de3c4ed7a2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms/components/9499bd4f29b6c7cdc75c908bdf93e24a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')),[`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms/components/840c3d03d9810f46549b8dc2684b66f7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, userName, _unused, test, TutorName, messagingList, uniqueSlots, studentsToday, dash, GetFutureMSCalendar, msStudentContainer, studentContainer, hoursList, hoursMSList, announcements, tutor, welcomeNotes, DriveTokenObject, CounterValue, userData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    if (true) {
      userData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\' or MS_teacher_email = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\' and accountType=\'BACKENDLESS\''].join(''))).setProperties('name, email, MS_teacher_email, access_level, userType, tutorType').setPageSize(10)))[0];
      ___arguments.context.pageData['userData'] = userData;
    }
    try {

      ;(function() {
        const callback = async () => {
            ___arguments.context.pageData['currentTime'] = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: 'long',[`hour12`]: undefined,[`month`]: undefined,[`day`]: undefined,[`hour`]: undefined,[`minute`]: undefined,[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((new Date())));

        };

        const timerId = '';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
      ___arguments.context.pageData['LoginData'] = ({ [`user-token`]: (Backendless.getCurrentUserToken()) });
      userName = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      ___arguments.context.pageData['userName'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      CounterValue = 0;
      while (typeof userName === 'undefined') {
        userName = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      }
      console.log(['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''));
      tutor = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\' and subjects is not null'].join(''),[`property`]: ['name', 'tip_level', 'timezones.short_name', 'timezones.iana', 'zoom', 'zoomid', 'timezones.offSet', 'timezones.sign', '*'],[`pageSize`]: 1 })).setEncoding('utf8').send())[0];
      if ((tutor === null) || (typeof tutor === 'undefined')) {
        return null;
      }
      await BackendlessUI.Functions.Custom['fn_cad53b2c8115106fd3afcda20303acdc']('Page Enter / Tutor Dash', (['Tutor ',userName,' logged in on ',((new Date()).toUTCString()),' / ',((getObjectProperty(___arguments.context.pageData, 'userEmail')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userEmail')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) : (getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')));
      ___arguments.context.pageData['houseLeader'] = ['Jordan Knoetgen', 'Kelly Radigan', 'River Lotus'];
      ___arguments.context.pageData['card_no'] = 1;
      ___arguments.context.pageData['userName'] = ((userName === null) || (typeof userName === 'undefined') ? (getObjectProperty(tutor, 'name')) : userName);
      ___arguments.context.pageData['tutorSubjects'] = (getObjectProperty(tutor, 'subjects'));
      ___arguments.context.pageData['zoom'] = (getObjectProperty(tutor, 'zoom'));
      ___arguments.context.pageData['zoomid'] = (getObjectProperty(tutor, 'zoomid'));
      ___arguments.context.pageData['lead_id'] = (getObjectProperty(tutor, 'lead_id'));
      ___arguments.context.pageData['short_name'] = (getObjectProperty(tutor, 'short_name'));
      ___arguments.context.pageData['offSet'] = (getObjectProperty(tutor, 'offSet'));
      ___arguments.context.pageData['sign'] = (getObjectProperty(tutor, 'sign'));
      ___arguments.context.pageData['timezone'] = (getObjectProperty(tutor, 'timezone'));
      ___arguments.context.pageData['iana'] = (getObjectProperty(tutor, 'iana'));
      DriveTokenObject = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0];
      ___arguments.context.pageData['DriveTokenObject'] = DriveTokenObject;
      ___arguments.context.pageData['MSExtraTimeList'] = [];

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Page Enter / tutor_dash', (['Error found while getting user data / ',userName,' / ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

    }
    try {
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
        ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
      } else {
        ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
      }
      welcomeNotes = [', remember to start with a clear lesson objective!', ', remember to use crisp lesson segments in your session 🙂', ', just a reminder to use a "warm-up" today (aka \'Do Now\')', ', will you use an exit ticket at the end of your session today?', ', feel free to cold-call if your student is not talking enough.', ', try to have your student talk at least 50% of the time 🙏', ', just a reminder: precise is better than general praise!', ', a check for understanding can help you adjust your lesson mid-way...', ', may your session report be precise, thorough, and helpful for the student!'];
      ___arguments.context.pageData['loader'] = (['Hi ',userName.slice(0, (userName.indexOf(' ') + 1) - 1),listsGetRandomItem(welcomeNotes, false)].join(''));
      ___arguments.context.pageData['loading_spinnerVisible'] = true;
      ___arguments.context.pageData['tutorSelector'] = ({ [`value`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`label`]: (getObjectProperty(___arguments.context.pageData, 'userName')) });
      ___arguments.context.pageData['announcements'] = [];
      announcements = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/announcements')).query(({ [`where`]: ['(Tutor_Category = \'',((getObjectProperty(tutor, 'timezone')).indexOf('US') !== -1) ? 'US' : 'ROW','\' or Tutor_Category = \'ALL\') and announcement_live = true'].join(''),[`pageSize`]: 100 })).setEncoding('utf8').send());
      addItemToList((getObjectProperty(___arguments.context.pageData, 'announcements')), announcements);
      console.log('Get/Set data');
      dash = (await BackendlessUI.Functions.Custom['fn_0e8c594b4c753e562b1581b671ad6261']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      studentContainer = (await BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw')), ___arguments.context.pageData));
      ___arguments.context.pageData['studentContainer'] = studentContainer;
      ___arguments.context.pageData['msStudentContainer'] = [];
      msStudentContainer = (await BackendlessUI.Functions.Custom['fn_820247ba30fce60b7d176e0f4b04c337']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      ___arguments.context.pageData['msStudentContainer'] = msStudentContainer;
      console.log('msStudentContainer **************************************');
      console.log(msStudentContainer);
      console.log('msStudentContainer **************************************');
      ___arguments.context.pageData['msQuestionnaire'] = (await BackendlessUI.Functions.Custom['fn_ba7314e68c4b6abd4bdf1ad56bcd9a5d'](userName));
      hoursMSList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      console.log(___arguments.context.pageData);
      hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw')), ___arguments.context.pageData));
      ___arguments.context.pageData['title'] = (['Hi ',userName.slice(0, (userName.indexOf(' ') + 1) - 1),', welcome back!'].join(''));
      if (!msStudentContainer.length && !!studentContainer.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions.';
      } else if (!studentContainer.length && !!msStudentContainer.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = 'To locate your recently completed classes and confirm hours for payment, go to the \'Microschool\' tab for microschool classes.';
      } else if (!!studentContainer.length && !!msStudentContainer.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions, or the \'Microschool\' tab for microschool classes.';
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);
        ___arguments.context.pageData['LoadText'] = ' ';
      }
      ___arguments.context.pageData['selector'] = 'reports';

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Page Enter / tutor_dash', (['Error found while generating all past sessions / ',userName,' / ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

    }
    try {
      GetFutureMSCalendar = (await BackendlessUI.Functions.Custom['fn_163ad5c1239eb27a61ad4b15e1ea1022']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      console.log('future MS session');
      console.log(GetFutureMSCalendar);
      ___arguments.context.pageData['msFutureStudentContainer'] = GetFutureMSCalendar;
      dash = (await BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      studentsToday = [];
      uniqueSlots = [];
      messagingList = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')), ___arguments.context.pageData));
      ___arguments.context.pageData['extraHours'] = 0;
      console.log('future TS session');
      console.log(getObjectProperty(___arguments.context.pageData, 'calendarListRaw3'));
      if (true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('98c34b8e62aaeb432ada42173c02448b', true);
        await new Promise(r => setTimeout(r, 250 || 0));
        TutorName = (getObjectProperty(___arguments.context.pageData, 'userName'));
        test = [({ [`target`]: 'body',[`content`]: ['Hi ',TutorName,'! You can use this portal to review and submit your sessions or classes.'].join(''),[`disableBeacon`]: true,[`placement`]: 'center' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e')), 'el')),[`content`]: 'Click here to access your Tutoring & Private Sessions',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring & Private Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9be21fae0eef29a7b8cd16674d3411fe')), 'el')),[`content`]: 'Click here to access your Microschool Classes',[`placement`]: 'left',[`placementBeacon`]: 'left',[`title`]: 'Microschool Classes',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('39075dbc9d74db38793c3159bbf4fe59')), 'el')),[`content`]: 'Click here to see your past and current sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Past Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc17716809b5e5a5cd8913dd92bd72e9')), 'el')),[`content`]: 'Click here to see your future sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Future Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6f83a1196e4d9f887a4e0ba1e3b9284')), 'el')),[`content`]: 'Submit a ticket and we will get back to you within 24hrs.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Support',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db69da57441b0c5f05bee60c9ed3a0be')), 'el')),[`content`]: 'Click this to access more links/resources.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Explore',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79ab7744549adaff5491eed85f942c98')), 'el')),[`content`]: 'Click here to send your reports to the Student and Parent',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Reports',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2bc7badc91dd24529b363d8ac0c1338a')), 'el')),[`content`]: 'Click this plus button to access the tutoring extra hour section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac33164fd012e85afbe73d1e4c72c86f')), 'el')),[`content`]: 'This is where you can select a category for your extra hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Category',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d784a003d94b3000672f9938a65a8')), 'el')),[`content`]: 'This is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Input Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3287b7d1ed141a3e7ea27aa2c94652af')), 'el')),[`content`]: 'This is where you will add the description of the extra hour that you are going to enter',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e29cbb94966f7ad1371a1a0aa85e1f71')), 'el')),[`content`]: 'Click this button to add your extra hour in the hour to be submitted',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de')), 'el')),[`content`]: 'Submit your tutoring hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutor Hours Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34afc59ab7bf285faf9ac3f9c936faf9')), 'el')),[`content`]: 'Click the class name to see the student list of this specific class',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Student List',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('353be564809844c2ae8c2c66c1843b03')), 'el')),[`content`]: 'Click this bin icon to cancel a specific class before submitting it.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Cancel Class',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad13b5c129c3720e61ec643f4b8f52d8')), 'el')),[`content`]: 'Click this plus button to access the microschool extra hours section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('341e69ee2f6f94eb01681d5d151ffc67')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c03dd593e64185b5d0226e377eb0b31')), 'el')),[`content`]: 'This button will let you choose the next extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e80240f566633de7cda34bef372c9ff5')), 'el')),[`content`]: 'This button will let you choose the previous extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('389378220a8ed62cd0e392c2caeeac9a')), 'el')),[`content`]: 'This button will let you access the Add Hour Form of the chosen card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Add Hour Form',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a89e4ef41ca9a8ce33ff4dd20e93d95f')), 'el')),[`content`]: 'Input your extra hours here',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('82524489318c4a636811f3f45cacdd55')), 'el')),[`content`]: 'This is where you will enter the description of your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89bf71fbf8c4b4c7477c0139ab58584a')), 'el')),[`content`]: 'Click this to add your extra hours for review',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours to Review',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8d343d9778c0df6673d7d26cb0d0121')), 'el')),[`content`]: 'Click this to review your extra hours before submitting your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28b759ed749ebd638fcb7ed85a3981e7')), 'el')),[`content`]: 'This section is where you can review your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('71686cc3e1e32301badc353c2c9d8deb')), 'el')),[`content`]: 'Submit your MS Extra Hours once you are satisfied with the Extra Hours you input',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Submit MS Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065')), 'el')),[`content`]: 'Submit your Microschool Hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Hours',[`offset`]: 10,[`event`]: 'click' })];
        ___arguments.context.pageData['TourGuideOptions'] = test;
        ___arguments.context.pageData['loading_spinnerVisible'] = false;
        ___arguments.context.pageData['loader'] = '';
        await new Promise(r => setTimeout(r, 100 || 0));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).reset() })('8dbead2f0339fe91688571fa545216dc');
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).start() })('8dbead2f0339fe91688571fa545216dc');
      }

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Page Enter / tutor_dash', (['Error found while generating all future sessions / ',userName,' / ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/4756d4ddb332497515dc236f06169a05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'test_mode')) === null) && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page_Test_Mode', undefined);
  } else if (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/31852522e433679db69ddb12ee22dcf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) >= (new Date())) {
    (function (message) { alert(message) })('Can\'t send homework before start time');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'reportRowClick')) == false) {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = false;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var endTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  endTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 50;

  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/c53a30fa950184dccd71ea0fb4d8b60d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'is_cancelled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).startsWith('[OFFBOARDED]'))) && lateTime >= ((new Date()).valueOf()) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'messageRowClick')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ee1465bff9c2bec6941d08222ba5ec26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'parent_name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/66cd90547bf88f0ec556661ce6996da6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var slotsSlugText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) != 0) {
        slotsSlugText = String('Last homework was sent on ') + String(new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`year`]: 'numeric',[`timeZoneName`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
      }
    }
  } else if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    slotsSlugText = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug'));
    if (slotsSlugText == 'Substitute session' || slotsSlugText == 'Extra Session') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('66cd90547bf88f0ec556661ce6996da6'))['color'] = '#F4703C';
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) {
    slotsSlugText = 'Self-paced MS 1on1';
  }

  return slotsSlugText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/cc17716809b5e5a5cd8913dd92bd72e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, messagingList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')) === 'undefined')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    return null;
  }
  if (((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined')) {
    return null;
  }
  LoggerName = 'MessagingContainer';
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
      ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
    } else {
      ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    }
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !((getObjectProperty(___arguments.context.pageData, 'studentContainer')) === null) && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    }
    ___arguments.context.pageData['loader'] = (String((getObjectProperty(___arguments.context.pageData, 'userName')).slice(0, ((getObjectProperty(___arguments.context.pageData, 'userName')).indexOf(' ') + 1) - 1)) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('There was an error in the starting sequence / username: ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    ___arguments.context.pageData['selector'] = 'messaging';
    messagingList = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')), ___arguments.context.pageData));
    ___arguments.context.pageData['studentContainer'] = messagingList;
    ___arguments.context.pageData['msStudentContainer'] = (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer'));

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('There was an error while getting the messaging list / username: ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !((getObjectProperty(___arguments.context.pageData, 'studentContainer')) === null) && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === null) && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'There was an error in the ending sequence', error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/08770bb54b931f72b9a4291830a2fefe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://airtable.com/appY4H22rBsR5hG1g/shre8VCU9FnC23bFi/tblrD92p5tHt8Fq6u', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/56bc538f1eb9f9fd9bc6656fcf34eecb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, objectToDelete, Task, item, LeadHolder, LeadTask, studentContainer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  logger_name = 'deleteManualHour';
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHours2')), ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    removeItemInList(studentContainer, ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['payableHours2'] = (getObjectProperty(___arguments.context.pageData, 'payableHours2'));
    if ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) != 0) {
      ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) - 1);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['event_title = \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }
    if ((getObjectProperty(objectToDelete, 'slots_slug')) != 'Manual time') {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  try {
    await Backendless.Data.of('calendar').save( ({ [`scheduling`]: 'is_deleted',[`objectId`]: (getObjectProperty(objectToDelete, 'objectId')) }) );
    LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
       if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
      }


     return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
    }));
    Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/06391894f8d7144146e5b0413ef74286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  logger_name = 'tutor_dash_submitMessage';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (String('MessageContent - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent'))), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#d3d3d3';
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')) == null) {
      Backendless.Logging.getLogger(logger_name).debug('Message Content is Empty');
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the start sequence - Error / Parent Lead: ', error));

  }
  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/messaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })));
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Message Sent - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was a problem sending the message - Error / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), error));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a48471e0ee74216f8254f582a3438b1'))['color'] = '#fd6541';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Error';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageContent'] = '';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Submitted!';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6efdad730a47b90a1d6e79bbc2f53aa8', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the end sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/be21d4c346140134069b5ce1dc4c22ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')) === null) ? null : ['Hi ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),', this is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).indexOf(' ') + 1) - 1),' from Brilliant Grades. I\'m in the zoom room waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),'. Our session started 5 minutes ago. Are you joining? Thanks a ton!','\n_____\n\nzoom link: ',(getObjectProperty(___arguments.context.pageData, 'zoom')),'\n\nmeeting id: ',(getObjectProperty(___arguments.context.pageData, 'zoomid'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/edb59f2e49f5518df1c18cc541d37a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'studentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/39075dbc9d74db38793c3159bbf4fe59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, msFutureStudentContainer, MSStudentContainer, msHourBlock, messagingList, dash, StudentContainer, hourBlock, LoggerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'ReportContainer';
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
      ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
    } else {
      ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    }
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      console.log('msStudentContainer');
      console.log(getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      }
    }
    console.log('studentContainer');
    console.log(getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    }
    ___arguments.context.pageData['msStudentContainer'] = [];
    ___arguments.context.pageData['studentContainer'] = [];
    ___arguments.context.pageData['loader'] = (String((((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) : (getObjectProperty(___arguments.context.pageData, 'userName'))).slice(0, ((((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) : (getObjectProperty(___arguments.context.pageData, 'userName'))).indexOf(' ') + 1) - 1)) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    ___arguments.context.pageData['selector'] = 'reports';

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', (['There is an error in the start sequence / email: ',((getObjectProperty(___arguments.context.pageData, 'userEmail')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userEmail')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) : (getObjectProperty(___arguments.context.pageData, 'userEmail')),' / name: ',((getObjectProperty(___arguments.context.pageData, 'userName')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userName')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) : (getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));

  }
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'calendarListRaw')) === 'undefined')) {
      StudentContainer = (await BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw')), ___arguments.context.pageData));
      hourBlock = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](StudentContainer, ___arguments.context.pageData));
      ___arguments.context.pageData['studentContainer'] = StudentContainer;
      dash = (await BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash'));
      messagingList = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022']((getObjectProperty(___arguments.context.pageData, 'calendarListRaw3')), ___arguments.context.pageData));
    }
    if (((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) && !(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined')) {
      MSStudentContainer = (await BackendlessUI.Functions.Custom['fn_820247ba30fce60b7d176e0f4b04c337']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      msHourBlock = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a'](MSStudentContainer, ___arguments.context.pageData));
      ___arguments.context.pageData['msStudentContainer'] = MSStudentContainer;
      msFutureStudentContainer = (await BackendlessUI.Functions.Custom['fn_163ad5c1239eb27a61ad4b15e1ea1022']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      ___arguments.context.pageData['msFutureStudentContainer'] = msFutureStudentContainer;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', 'There is an error while getting the repots', error));

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    console.log('studentContainer');
    console.log(getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('MS_') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A2') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B2') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C2') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D1') !== -1) && !((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D2') !== -1)) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) != true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      console.log('msStudentContainer');
      console.log(getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && (((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('MS_') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_A2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_B2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_C2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D1') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).indexOf('_D2') !== -1))) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      } else if (!(typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      }
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', 'There is an error in the end sequence', error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e29cbb94966f7ad1371a1a0aa85e1f71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _unused, CalendarObject, customEventTitle, error, event_title, extraHours, extraTime, item, LeadHolder, LeadTask, logger_name, LoggingStatus, manualTimeCategory, manualTimeHours, message, payableHours, pendingHours, startTime, studentContainer, TodayNumber, tutorObject, uniqueSlots, x;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function generateAlert(message) {
  (function (message) { alert(message) })(message);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', true);
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', false);
    logger_name = 'tutor_dash_submitManualHours';
    LoggingStatus = false;
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    manualTimeCategory = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeCategory'));
    manualTimeHours = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeHours'))));
    event_title = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'event_title'));
    TodayNumber = (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 2 || (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 1 ? (getObjectProperty(___arguments.context.pageData, 'todayNumber')) : 0;
    extraHours = [];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0 || !(manualTimeHours % 1 == 0)) {
      await generateAlert('Hours need to be a positive whole number');
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      await generateAlert('Please choose a category');
      return null;
    }
    if (!(typeof event_title === 'string')) {
      await generateAlert('Please add a short description');
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 220)) {
      await generateAlert('Please keep your description between 10 to 250 characters');
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    for (var count = 0; count < manualTimeHours; count++) {
      startTime = ((new Date()).valueOf()) - TodayNumber * 86400000;
      customEventTitle = [manualTimeCategory,'#',subsequenceFromEndFromEnd((JSON.stringify(startTime)), 4, 1),'-',event_title].join('');
      CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/saveObjectToDB`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle }))));
      extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`subject`]: null,[`grade`]: null,[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor_name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle,[`student_name`]: null,[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`lastHmwrk`]: 0,[`messageRowClick`]: false,[`reportRowClick`]: false });
      await Backendless.Data.of('Users').addRelation(tutorObject, 'calendar', [(getObjectProperty(CalendarObject, 'objectId'))]);
      addItemToList(extraHours, extraTime);
      studentContainer.push(extraTime);
      (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).push(extraTime);
      await new Promise(r => setTimeout(r, 50 || 0));
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while adding manual hours for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',manualTimeHours,manualTimeHours == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',manualTimeCategory,', ',event_title,', ',customEventTitle.split('#').slice(-1)[0].split('-')[0]].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_3L0gg9cIHcped8UJj8eiZAgwRB7lF4DLpJLRUeGDrNo' });
    ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) + (Number(manualTimeHours)));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeCategory'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeHours'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['event_title'] = null;
    ___arguments.context.pageData['calendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ba3eeb1bed397379ff878c222e61cda', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    
  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/55fdb589c2cb251c7599918848144a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/05644c3fee79e4b5f2f8142ff511c59f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['MessageContentLength'] = (___arguments.value.length);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) < 1000) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) >= 10) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', false);
    }
  } else {
    (function (message) { alert(message) })('You have reached the limit');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8f91b6cb4293f2cdcdb6095aa07d7cb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('http://tutors.brilliantgrades.com/', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f91b6cb4293f2cdcdb6095aa07d7cb2'))['fontWeight'] = 700;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/eeba337b1abad2e2064a177d173eb112/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://zoom.us/signin', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/4cdc223f17b4a008501abf4bc2f579a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != '')

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null ? 'Companion Rubric' : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/55a2daa21ae3fd7d7c4344d11bf8e523/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.loom.com/share/e61474c1a9374f509c3586165875d842', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b2f38edae191dcee756e2c6e9e1f8f55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString, parentTimezone, tutorTimezone;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'tutor_away') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'tutor' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'contact' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') {
      localeDateString = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).split('#')[0];
    }
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/a6f83a1196e4d9f887a4e0ba1e3b9284/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/?page=tutor_ticketing','#firstname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ')[0],'&lastname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ').slice(-1)[0]].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/db69da57441b0c5f05bee60c9ed3a0be/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
  }

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64b22f2e967708cd2f23f0118fe71b96'))['marginTop'] = '0px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e7f84404d74f7eec8dd8f4b55566cdb1'))['fontWeight'] = 100;
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    }
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/98dd39b1912f926d6a0d7c5eef9e1773/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', false);

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e68a3f08b3383fbd9fa9cf9d6ee6ef67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2c3cfb8f9666b2d16976e8ac5ab77697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['requestHours'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/292e0c59fc5ab5ecbfed410e938466b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, TaskCreate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'RequestHours';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered on starting sequence', error));

  }
  try {
    TaskCreate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/requestHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ 'event': ({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'requestHours': (getObjectProperty(___arguments.context.pageData, 'requestHours')),'userName': (getObjectProperty(___arguments.context.pageData, 'userName')) }) }))));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered while requesting for hours', error));

  }
  try {
    if (TaskCreate == 'success') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', false);
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', true);
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('853804cc12dfa569027d0603dd724dc4'))['content'] = 'Error: Try Again';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered ending sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/960fd48380c22f77d3063aee7edecec3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) === null) ? 'Student On Pause' : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('Mock') !== -1) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/48be111a6e73f9496192001254069b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/a738b596c568ca5c432a97d459156531/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/855cb05fd1fc8512b116fa12718e647e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toLocaleString());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/6ba3eeb1bed397379ff878c222e61cda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/6c7ce06f475737eaf549e27facb992de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus, PseudoCreatedTimestamp, payableHoursMS, payableHoursTS, item, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, studentEvent, CheckIfTthere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  logger_name = 'Submit Hours Button';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#EBEBE4';

  } catch (error) {
    (function (message) { alert(message) })('Error encountered while submitting hours');
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    for (var studentEvent_index in studentContainer) {
      studentEvent = studentContainer[studentEvent_index];
      CheckIfTthere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
      }));
      if (!CheckIfTthere.length) {
        continue;
      }
      if ((getObjectProperty(studentEvent, 'homework_sent')) == true) {
        studentEvent['toBePaid'] = true;
      } else if ((getObjectProperty(studentEvent, 'slots_slug')) == 'Mock Session') {
        studentEvent['homework_sent'] = true;
        studentEvent['toBePaid'] = true;
      }
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarListRaw'));
    for (var calendarEvent_index in calendarListRaw) {
      calendarEvent = calendarListRaw[calendarEvent_index];
      studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
      if (studentContainerPosition > 0) {
        calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
      }
    }
    ___arguments.context.pageData['calendarListRaw'] = calendarListRaw;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length == 0) {
      (function (message) { alert(message) })('You have no hours to be submitted');
    } else {
      PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
      payableHoursMS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && !((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      payableHoursTS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (!((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) || ((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && ((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      if (!!payableHoursTS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursTS,[`tutorService`]: 'TS',[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      if (!!payableHoursMS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursMS,[`tutorService`]: 'MS',[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      ___arguments.context.pageData['hoursStatusValue'] = 'Submitted!';
      ___arguments.context.pageData['submittedHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedHours')) + (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      ___arguments.context.pageData['payableHoursFiltered'] = [];
      ___arguments.context.pageData['payableHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    ___arguments.context.pageData['extraHours'] = 0;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the end sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Submit ',(getObjectProperty(___arguments.context.pageData, 'payableHours')),(getObjectProperty(___arguments.context.pageData, 'payableHours')) > 1 || (getObjectProperty(___arguments.context.pageData, 'payableHours')) == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f6f1e22a76dcd32af28397b3a5a8fa29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) == 'scheduled') {
    isVisible = true;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    isVisible = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled') {
    isVisible = false;
  } else {
    isVisible = false;
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/820270be67d64d464a98818ff8f39324/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/6c382dc562077f3dc8158e63420bfc9d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')), 'display')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#C1E1C1';
    } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#F1E8E7';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#fffff';
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/d2229337fcf815d30396549f2cc39705/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/11f45aa3e9a459f987a5058dd938e974/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf()))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/7d43457eb75181be4f6b6c726fffaeae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) > ((new Date()).valueOf()))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/c18c5c114225502a47e3c9f98228e873/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true ? false : true) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b031feb6c1e3aca2c4925425596f4b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/7f13a0fb81a33d11c448d8c8b44774a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'studentsToday')),(getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 1 || (getObjectProperty(___arguments.context.pageData, 'studentsToday')) == 0 ? ' sessions ' : ' session ','today!'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/a702c6aef57358e195b6b50a731d96f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/fff98e419ad78ce4d61f9566a48e117b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e1430179fc6b6f21c9dc9c6f22ca4ad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true ? false : true) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000))) {
    content2 = 'Pending Homework';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8617494c75fd6e5a303d80d7d4b1d333/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var message, Slot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
    message = 'Cancelled session';
  } else if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
    message = 'Session did not occur';
  }

  return message

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/74fc1f77230994ed26cd09bf3af662fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/45cd08bfd6849c17b7389f4b5471f992/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/42d4dcea40048a699c427a9a854238bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f42f0f48f9bc1f49ff2641e976690d34/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (___arguments.value.length);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b3843647ae5862a445e1352bacc1471c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ed786cc2c66bb26c2f4c8813c6319276/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ca23ee2ee51cea994404dd26d03bd69e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/7e39c413d2c245c3a4c3fd548e489754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = 'The student(s) made progress';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/17dd941e77be48f6117d1392d966840a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/010c10094d98413c56497d23fafb8e17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e072bb290098c74cf7230c269dbc63db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f8d8039e403d93534ff14dac3a318f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b26c14ace999f11d509bd7364029d8e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b1d660f5bbf75c5d2dd8b04d8f965b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'isPresent')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1faed4cd936a8483af596d0462ef141a/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error, RenamedFile, GetFile, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (true) {
      RenamedFile = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName'));
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/authcodes')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }));
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      GetFile = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v3/files/') + String(getObjectProperty(___arguments.context.pageData, 'uploadedIdFile'))))).query(({ [`fields`]: ['webContentLink'] })).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send());
      await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
    } else {
      RenamedFile = (await Backendless.Files.renameFile( encodePath((String('homework/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName')))), encodePath((['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),'.',___arguments.uploadedFiles.split('/').slice(-1)[0].split('.').slice(-1)[0]].join(''))) ));
    }
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6fb5c65420f143dee94c402ec10a72ad', [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length < 3) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length >= 3) {
      (function (message) { alert(message) })('Please keep each homework to 3 attachments. You can send a second report to include additional attachments. Thank you.');
    }
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')).length);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_dash_upload_file').warn(([(JSON.parse(error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  }

  },
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (true) {
    try {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = 0;
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55df951b180944c84e9d0c54a82dac8e')), 'display')) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', false);
      }
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''),[`parents`]: ['1Je3aUb8YMYTsCW78CFsioOMSEVy25wbw'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
      ___arguments.context.pageData['uploadedIdFile'] = (getObjectProperty(Metadata, 'id'));
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''));

    } catch (error) {
      console.log(JSON.stringify(error));
      Backendless.Logging.getLogger('tutor_dash_before_upload_file').warn(([(JSON.stringify(error)),' - ',(JSON.stringify(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'))),' File Type:',(getObjectProperty((___arguments.files[0]), 'type')),' File Name:',(getObjectProperty((___arguments.files[0]), 'name')),' File:',(JSON.stringify((___arguments.files[0])))].join('')));

    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (getObjectProperty((___arguments.files[0]), 'name'));
  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')).length);
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8551301ddc6d2c2fae763ec3774f959f')), 'display'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
  }
  Backendless.Logging.getLogger('tutor_dash_failed_upload_file').warn(([(JSON.parse(___arguments.error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var filename;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  filename = ((getObjectProperty(___arguments.file, 'name')).replace((new RegExp('(?:\\.(?![^.]+$)|[^\\w.])+', 'g')), '_'));

  return filename

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/7745a3e392ad5ff6dbdae5f47933a651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onMouseOut */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['border-radius'] = '50%';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/55df951b180944c84e9d0c54a82dac8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b07e189d45cd1f8ab6d831c9c40dfbbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/0c879ba8c2de9b2613175df1f12162f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ff04f66b2abaa26cd40ac75a3bd40a8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['FeedbackBTNClicked'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ad1cc4046b92cdce3bef541b0b287011/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/83ee4ec93215aafe7376dc165717a9d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8551301ddc6d2c2fae763ec3774f959f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) > 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) < 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/6fb5c65420f143dee94c402ec10a72ad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined')) {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/d532e8462b3948653f0f9fc248526aef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/d97ebc8bcb09e1fdcc836c4ad1bac727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Student Issue';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/7cae4d7c127f4c5169edddfcdb625189/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Suggestions';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f9461ed7c0e9e0f3f60a3555d37d7d6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Other';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/0c389e7ff11c4e4ec227103b3dddc80d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/190c483fac06d0d5ab4ecabfbc016fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f7ad243951b8ae8d464590037c99e4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    setBoolean = false;
  } else {
    setBoolean = true;
  }

  return setBoolean

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1cd7e871600396535b2844fcbc2277d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, FL_Score, _unused, logger_name, calendarListRaw, studentContainer, hoursList, dash, studentContainerPast, LoggingStatus, student, calendarListRawPosition, studentContainerPosition, attachments, studentList, uniqueSlots, item, attachment;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    logger_name = 'tutor_dash_submitHomework';
    LoggingStatus = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit Button clicked - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#d3d3d3';
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).length) {
      attachments = null;
    } else {
      attachments = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).map(async attachment => {; return (getObjectProperty(attachment, 'file'));})));
    }
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Collect Attachments - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarListRaw'));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) == true) {
      studentList = (await asyncListFilter(studentContainer, async (item) => {


       return ((getObjectProperty(item, 'slots_slug')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')) && (getObjectProperty(item, 'start_time')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'start_time')));
      }));
    } else {
      studentList = [___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')];
    }
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Get data necessary for submission - SUCCESS',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in retrieving data for the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }
  try {
    for (var student_index in studentList) {
      student = studentList[student_index];
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/homework`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(student, 'parent_name')),[`student_name`]: (getObjectProperty(student, 'student_name')),[`homework_sent`]: true,[`subject`]: (getObjectProperty(student, 'subject')),[`grade`]: (getObjectProperty(student, 'grade')),[`tutor_name`]: (getObjectProperty(student, 'tutor_name')),[`report`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')),[`calendarObjectId`]: (getObjectProperty(student, 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(student, 'slots_slug')),[`sessionQuality`]: ['Q1 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q1Ans')),'\nQ2 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q2Ans')),'\nQ3 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q3Ans'))].join(''),[`bgFeedback`]: (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === null) ? null : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'bgFeedback'))].join(''),[`contactParent`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')),[`attachments`]: attachments })));

      })();
      await new Promise(r => setTimeout(r, 250 || 0));
      studentContainerPosition = studentContainer.indexOf(student) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(student) + 1;
      if (studentContainerPosition > 0) {
        studentContainer[(studentContainerPosition - 1)] = student;
        calendarListRaw[(calendarListRawPosition - 1)] = student;
      }
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit homework - Success / Parent Lead: ',(getObjectProperty(student, 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', true);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in submitting the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', false);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared progress report - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['bgFeedback'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared bg feedback - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Contact Parent set to false - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['homework_sent'] = true;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Homework set to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#0a1352';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Set status visibility to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d96e3562b933d045d64b180c471b7d11', true);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared docs - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Clear form fields - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in clearing the fields - Error / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), error));

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['reportRowClick'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](studentContainer, ___arguments.context.pageData));
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['calendarListRaw'] = calendarListRaw;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in updating the object in the raw list - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/498c21f9cb5f164912448c47d278a46c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/9418a1aba1fd4033450f16695735b1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b2132b5d8a74e88511b603ef358f5843/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8eae5cd8e32b77eb831fbb46a36676fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/984e2a28e63db3a68453ff794f68df03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.dataModel, 'read')) === 'string') && ((getObjectProperty(___arguments.context.dataModel, 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e76dd2cf23afcb977336e7ae69c2e423/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1c5529a18c276de5a74fec66241749b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/396350ff94ffb283fecee818981c9727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8ec186d9ea189f6782a2232bd55f0331/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/502108db508b967541ba142e40a79b81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/474be277ed82933a3a1218dbea262757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/a3ac1f9ed6db33d8afaab0d31f2a89eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/273aca3a2f47ec4254bd8974edbf5e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, LoggerName, _unused, studentContainerFuture, msStudentContainerPast, studentContainerPast, msHoursList, dash, hoursList, dash2;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2bc7badc91dd24529b363d8ac0c1338a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/de26e0bacccc43811e337c2354ef780a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    text = 'Was your student present?';
  } else {
    text = 'Were your students present?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/362d5467896a664a436ca45175ba9c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/346a274c03153293703e2f6cd9f3318f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = false;
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' was absent today. Please let me know if there is something I can do to support you. Otherwise, I will be waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' in our next session.'].join(''));
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2ba2eb34a96cc8b30bda933b45ca376c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['read'] = (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join(''));
    await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/BackendlessLoginAuthRestBlock`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`action`]: 'update',[`method`]: 'HR_Admin_Panel',[`databaseName`]: 'announcements',[`requestType`]: 'clientSide',[`query`]: ({ [`user-token`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LoginData')), 'user-token')) }),[`createObject`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'objectId')),[`read`]: !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('') }) })));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'Yes';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'No';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/dc5c3f24cb57a4539e2d77d9ac762071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    Value = 'No';
  } else {
    Value = 'Yes';
  }

  return Value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/6e11fc75c9b6e6382873be088a2e752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var show;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === null)) {
    show = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf())) {
    show = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')).indexOf('Partner') !== -1);
  } else {
    show = false;
  }

  return show

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/39174bc3cdf5a7b64801e1be2dc610cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var timeSlot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) == 0 ? '0' : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 100 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 10 ? ['0','0',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))].join('') : String('0') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/958b37f8fe89f72498d5e3e28c657cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 800;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/970b6c0790ab5e2533b198c248a7c47c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/3fe3fff351e3b7f33663ec02d3fbb18f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' || (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f7b151d3f20e3cc51195fba8032815af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/d2d5947e69b973cd56a3d61e3b4b587f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var FormatToTeacherTimezone, FormatToUTC, list, localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'School Closed') {
    FormatToTeacherTimezone = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    FormatToUTC = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: 'Etc/GMT',[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    localeDateString = [FormatToUTC[0],' ',FormatToUTC[1],' ',FormatToUTC[2],' ','00:00',' ',FormatToTeacherTimezone[4]].join('');
  } else {
    localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/fc5dd2dafd27503b990bdf0a7c412741/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'scheduled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))) == false && lateTime <= ((new Date()).valueOf()))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/a8abf4e79a810da4c4e4394e3bd9a801/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1d22c0a3a68461359766a57431328907/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'is_substituted')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b75e2b28827248f5a56e9f2753018984/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName'))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/85bd330ec0ef100ffb336893dd84761b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, NewData, TutorHours, ObjectIdToDelete, item, objectToDelete, Task, LeadHolder, LeadTask, CheckAssistantTeacher;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  console.log(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'));
  logger_name = 'cancelMSManualHour';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', true);
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
    ___arguments.context.pageData['payableHoursFilteredMS'] = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
    if ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) != 0) {
      ___arguments.context.pageData['payableMSHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'duration')));
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('ms_calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) != 'Planning Time') {
    try {
      CheckAssistantTeacher = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).query(({ [`where`]: ['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join('') })).setEncoding('utf8').send())[0];
      if ((getObjectProperty(CheckAssistantTeacher, 'assistant_teacher')) === null) {
        NewData = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),[`scheduling`]: 'is_cancelled' })));
        ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772')['scheduling'] = (getObjectProperty(NewData, 'scheduling'));
      } else {
        await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'slots_slug')) == 'Manual time') {
        LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
           if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
          }


         return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
        }));
        Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));
      }
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS MEETING' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) == 'Planning Time') {
    try {
      await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ad13b5c129c3720e61ec643f4b8f52d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b83298ed2753d53d622bdb5fbd6f0c8e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b62c065139737a347f7e7a27592589ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  ___arguments.context.pageData['MSExtraTimeList'] = [];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['show_add_hours'] = false;
    j['manualMSTimeHours'] = null;
    j['msDescription'] = null;
    j['approvalName'] = null;
  }
  ___arguments.context.pageData['card_no'] = 1;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/617aeeb949a1dac5eeb74c53a21fbf19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek2'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/c6a13b95bc64a2a1c73e0703e9aad3d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var SumOfHours, formatString, item, Description, Hour, j, OtherHours, SpecialProjects, ProgressReports, ShadowingHours, AdminHours, CurriculumDesign, HouseLeaderMeeting, MeetGreetMeeting, ExtraMeetings, OnboardingTraining, error, logger_name, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, manualTimeHours, eventTitle, event_title, manualTimeCategory, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, approvalName, _unused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', true);
  formatString = '';
  console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
  OnboardingTraining = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ExtraMeetings = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  MeetGreetMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  HouseLeaderMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  CurriculumDesign = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  AdminHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ShadowingHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ProgressReports = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  SpecialProjects = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  OtherHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OnboardingTraining.length) {
      for (var j_index in OnboardingTraining) {
        j = OnboardingTraining[j_index];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ExtraMeetings.length) {
      for (var j_index2 in ExtraMeetings) {
        j = ExtraMeetings[j_index2];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!MeetGreetMeeting.length) {
      for (var j_index3 in MeetGreetMeeting) {
        j = MeetGreetMeeting[j_index3];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',Hour / 0.5,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!HouseLeaderMeeting.length) {
      for (var j_index4 in HouseLeaderMeeting) {
        j = HouseLeaderMeeting[j_index4];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!CurriculumDesign.length) {
      for (var j_index5 in CurriculumDesign) {
        j = CurriculumDesign[j_index5];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!AdminHours.length) {
      for (var j_index6 in AdminHours) {
        j = AdminHours[j_index6];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ShadowingHours.length) {
      for (var j_index7 in ShadowingHours) {
        j = ShadowingHours[j_index7];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ProgressReports.length) {
      for (var j_index8 in ProgressReports) {
        j = ProgressReports[j_index8];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!SpecialProjects.length) {
      for (var j_index9 in SpecialProjects) {
        j = SpecialProjects[j_index9];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OtherHours.length) {
      for (var j_index10 in OtherHours) {
        j = OtherHours[j_index10];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  SumOfHours = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')).map(async item => {; return (getObjectProperty(item, 'manualMSTimeHours'));}))).reduce(function(x, y) {return x + y;});
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatExtraTime'] = (SumOfHours == 0 ? '' : formatString);
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatNoExtraTime'] = (SumOfHours == 0 ? 'No Extra Hours Added' : 'Review Extra Hours');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e6dcc3e1e7e4dd1a21f57ef92ecf7065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
    (function (message) { alert(message) })('There\'s no Microschool session to submit.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) == false) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ca3280537e60abefc51f52f46d2c4da')));
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var totalHours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  totalHours = (getObjectProperty(___arguments.context.pageData, 'payableMSHours')) + (getObjectProperty(___arguments.context.pageData, 'extraMSHours'));

  return (['Submit ',totalHours,totalHours > 1 || totalHours == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e41ae3499aa1023b7a456117a80b89ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/94a25aee66288cb122f76b6b70948052/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS MEETING' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : (await BackendlessUI.Functions.Custom['fn_20be5f297d6e7011d3eb8aacdd98716c']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')))).toUpperCase()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b2eda5d4da066dd2ed267037f345e274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/166f6de4ebe7c54f3fd9c3ab22d9b6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/0284b7b24a821e9cdb5b0b62a8ce04a9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.dataModel, 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#C1E1C1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#F1E8E7';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8f1dddc1ed6b68b74c36bbf9ea6cb832/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/9f09749e2f5815afcd4b1bd3294c8a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/d1c1a9931ef7177cfcc1a49fa16b13f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/887e6454024682c30a5f7e27755c472d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e5d7397d645689137cabd81d8d56d322/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  console.log(___arguments.value);
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/67d1b072060be60825b175a30b6c656e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
      return null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/a03846b3716b0d7b7292135aa3644e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/401aed0df3ca1a2b60919fbe4d451a09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/23bd7218dffe31de83fdef3e47facf37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/34f2b281028902c1f38a4af22386fdc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/54ae53f554d761b89e65dd07c6e2469d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/986513bd2dd43a1ed6e86a2ff4d1a5be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2829d02674bea67c6e73c35550394e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e09301622cad56dce201c733ae5d579a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/09d624d5c24ea221fdc288d8f074fc4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09d624d5c24ea221fdc288d8f074fc4b')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f5e442d2527d7b0d002b8c05f7a28034/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f5e442d2527d7b0d002b8c05f7a28034')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ee02a47b3d4dc49cbdcd4edfd068e61d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee02a47b3d4dc49cbdcd4edfd068e61d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/9249997aa4c292a2f86be59f9cb11e83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9249997aa4c292a2f86be59f9cb11e83')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ed614d4ff047eb6a345a4e77b4dfd103/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed614d4ff047eb6a345a4e77b4dfd103')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/c53dff2850ec4ad6d6d9ab21f3aae558/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c53dff2850ec4ad6d6d9ab21f3aae558')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e73b9d72e48f95fc19669463d31eca01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e73b9d72e48f95fc19669463d31eca01')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/bf0ba5be04ac101781d6bf8eea7168bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf0ba5be04ac101781d6bf8eea7168bb')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/595fafa6a32ea512de22bd0df4485d21/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q5answer'] = [];
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q8answer'] = '';
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q9answer'] = '';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/7ddac0256742e8f9124be8d5e157bb02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ddac0256742e8f9124be8d5e157bb02')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/42784913cf23a393b76fe0a91f9b136c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42784913cf23a393b76fe0a91f9b136c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/c9c32de38c2dc088b69ddc9f69060a3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9c32de38c2dc088b69ddc9f69060a3e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/5777f4435b3fc6eb3c3a045582e23d28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5777f4435b3fc6eb3c3a045582e23d28')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/09ce8b8e77b3d1b97265676a9082e899/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09ce8b8e77b3d1b97265676a9082e899')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/4b5c353f46d55f0892b33bbb74ceeb9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b5c353f46d55f0892b33bbb74ceeb9c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b3799dfeeb9796763c26ed41b22b5b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/7229ee6cecd4e7c44a9dbb6df89f2495/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length <= 50) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2a32c8295622fcf5b005d0cb18bb6be4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q8answer')).length > 10)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/4cad321c51d3617e153bbba3013b0bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length > 50)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/dc8279e1eda851cc253f437e15af79d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, FL_Score, logger_name, LoggingStatus, durationPayable, j, PseudoCreatedTimestamp, studentEvent, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, item, CheckIfThere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', false);
  if (true) {
    logger_name = 'Submit MS Hours Button';
    LoggingStatus = false;
    try {
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', true);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#EBEBE4';

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      for (var studentEvent_index in studentContainer) {
        studentEvent = studentContainer[studentEvent_index];
        CheckIfThere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), async (item) => {


         return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
        }));
        if (!CheckIfThere.length) {
          continue;
        }
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          studentEvent['toBePaid'] = true;
        }
      }
      ___arguments.context.pageData['msStudentContainer'] = studentContainer;
      studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
      console.log(studentContainerIds);
      calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarMSListRaw'));
      for (var calendarEvent_index in calendarListRaw) {
        calendarEvent = calendarListRaw[calendarEvent_index];
        studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
        console.log('studentContainerPosition');
        console.log(studentContainerPosition);
        calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
        if (studentContainerPosition > 0) {
          calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
        }
      }
      ___arguments.context.pageData['calendarMSListRaw'] = calendarListRaw;
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      var studentEvent_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      for (var studentEvent_index2 in studentEvent_list) {
        studentEvent = studentEvent_list[studentEvent_index2];
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          if (typeof (getObjectProperty(studentEvent, 'toBePaidList')) === 'undefined') {
            studentEvent['toBePaidList'] = [];
          }
          addItemToList((getObjectProperty(studentEvent, 'toBePaidList')), (getObjectProperty(___arguments.context.pageData, 'userName')));
          studentEvent['toBePaid'] = true;
        }
      }
      await new Promise(r => setTimeout(r, 1000 || 0));
      console.log('payable hours');
      console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
        (function (message) { alert(message) })('You have no hours to be submitted');
      } else {
        PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/msHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')),[`tutorService`]: 'MS',[`MSAnswer`]: ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'),[`TutorName`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`msQuestioner`]: (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')),[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
        ___arguments.context.pageData['hoursMSStatusValue'] = 'Submitted!';
        durationPayable = 0;
        var j_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          durationPayable = (typeof durationPayable == 'number' ? durationPayable : 0) + (getObjectProperty(j, 'duration'));
        }
        ___arguments.context.pageData['submittedMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedMSHours')) + durationPayable);
        ___arguments.context.pageData['payableHoursFilteredMS'] = [];
        ___arguments.context.pageData['payableMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length);
        await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      ___arguments.context.pageData['extraMSHours'] = 0;
      ___arguments.context.pageData['msQuestionnaire'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8ac777b8772affc6e2ce2032e938bc1', true);
      await new Promise(r => setTimeout(r, 5000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = false;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#0a1352';

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the end sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'FScoreRaw')) === 'undefined')) {
        FL_Score = (Number((getObjectProperty(___arguments.context.pageData, 'FScoreRaw'))));
        console.log(String('Feeling Score: ') + String(FL_Score));
        if (typeof FL_Score === 'number' && !isNaN(FL_Score)) {
          _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/Low_Feeling_Score_Tutor`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`score`]: FL_Score }))));
        } else {
          console.log('Score not number. Please contact developer to check tutor dash. ');
        }
      }
      FL_Score = 0;

    } catch (error) {
      console.log(error);

    }
    try {
      if (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
        _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/One_on_One_App_Training`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`AppList`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')) }))));
      }

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/e2eb6cc9b2f36415c472018c6c9ddf3c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/601f5118947dd9e3f09faf4c5321da6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/d4947e4eab7b5685ef33742d5872fe9f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b532bb949a0a6a0220fbdcae9b8dbc62/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2cdb27d75f9340271127dca71053ab35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/38bf97e56321eb774eae6fa844e4329e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1899137b4cdf7af97763cfc709761c86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ae044db4641eccaf4aa2da0b15a9480b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1a073794f27789130524b8fc60fa7c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1c2e819947b9ef743a531af229225184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/99527bf533d14ad7ce42d6fdd32a1c1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/26a5ef11960ccfbaaeafd4bb03f812d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/524374174fbfeb5c471ea1c8b9eda934/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/920459fd2fbd2d44c90c7dbfcb622d9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) != true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/204a99b4d8eca6c814ea9d02a16df748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: undefined,[`day`]: undefined,[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split('#')[0] : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')).startsWith('MAX')) ? ['Your ',localeDateString,' ',textToTitleCase(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).replace((new RegExp('MS_', '')), '')).replace((new RegExp('_', 'g')), ' ')),' School class'].join('') : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')).length) {
    return null;
  }
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12fe332cac06910a7c6d4801efd2981b')), 'display')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', false);
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8c6c6704422db291a4d470567b594934/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('12fe332cac06910a7c6d4801efd2981b'), 'student_list'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/03538403f3f7afc497a253c1c8d5c022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'currentTime'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1617628cbcbc4abb0e34a28bccf8cb2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/44cfadd5fcfe1efe234e0e52929ed598/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'submittedHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/5f999f1b796766cac0a891d51d1bae4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your questionnaire form for this week! You can submit your remaining hour.';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/6b6a055f8ace72c3c9a8ff4d0e42af3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your answer for questionnaire this week! You can submit your remaining hours now!';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/eb562517050d0e24f5c230c12475f8b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),' hour(s)','<br/>',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split((new RegExp('#\\d\\d\\d\\d-', '')), )).slice(-1)[0]].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/9ca3280537e60abefc51f52f46d2c4da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging' && (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, studentContainerFuture, msStudentContainerPast, studentContainerPast, msHoursList, dash, hoursList, dash2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    LoggerName = 'RefreshButton';
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test_mode')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
      ___arguments.context.pageData['DateToday'] = (getObjectProperty(___arguments.context.pageData, 'SystemDate'));
    } else {
      ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    if (((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    }
    dash = (await BackendlessUI.Functions.Custom['fn_0e8c594b4c753e562b1581b671ad6261']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
    dash2 = (await BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
    studentContainerPast = (await BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc'](dash, ___arguments.context.pageData));
    studentContainerFuture = (await BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022'](dash2, ___arguments.context.pageData));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](dash, ___arguments.context.pageData));
    if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
      msStudentContainerPast = (await BackendlessUI.Functions.Custom['fn_820247ba30fce60b7d176e0f4b04c337']((getObjectProperty(___arguments.context.pageData, 'userName')), ___arguments.context.pageData, 'tutor_dash_ms'));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a'](msStudentContainerPast, ___arguments.context.pageData));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      ___arguments.context.pageData['studentContainer'] = studentContainerPast;
      if ((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        ___arguments.context.pageData['msStudentContainer'] = msStudentContainerPast;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
      ___arguments.context.pageData['studentContainer'] = studentContainerFuture;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentContainer')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    }
    if (((getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'katie.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'lori.a@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'faith.d@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'andrew.c@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'kelly.r@brilliantmicroschool.org' || (getObjectProperty(___arguments.context.pageData, 'userEmail')) == 'michael.b@brilliantmicroschool.org' || ((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (['Error encountered while refreshing the ',(getObjectProperty(___arguments.context.pageData, 'selector')),' container / UserName: ',(getObjectProperty(___arguments.context.pageData, 'userName')),' / UserEmail: ',(getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')), error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/00b276c2b0c5baaa9282670dd683dc65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/410f28513c7e12343ef1d956e9f6a294/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'card_no')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) < ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f885dc8d25c417286c1e1bfd663a8848/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 <= 1) {
    ___arguments.context.pageData['card_no'] = 1;
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 > 1) {
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) == 1)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) != 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/58d98c73120a88eac77b66836906df47/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var GetCurrentRepeater, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  GetCurrentRepeater = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '450px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) != 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b83298ed2753d53d622bdb5fbd6f0c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'UUID'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b83298ed2753d53d622bdb5fbd6f0c8e'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/97eeff3b29311305a4e5e5fb2b65fb82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/bdcca712e5096c7193feabd5cbd6a52d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item, CheckHouseLeader, CreateSubjectList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'houseLeader')) === 'undefined') {
    return null;
  }
  CheckHouseLeader = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'houseLeader')), async (item) => {


   return (item == (getObjectProperty(___arguments.context.pageData, 'userName')));
  }));
  CreateSubjectList = (getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).split(',');
  if (((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined')) {
    ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    return null;
  }
  if (!!CheckHouseLeader.length) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  } else {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/4a9fc23dae555ebd728bbfe169bdf0c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, records, GetCurrentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  records = [];
  GetCurrentData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(GetCurrentData, 'card_name')) == (getObjectProperty(j, 'card_name'))) {
      j['show_add_hours'] = true;
    } else {
      addItemToList(records, j);
    }
  }
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/f7bafd0b847e466d2b27a647b6ecf16d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, error, logger_name, _unused, approvalName, manualTimeCategory, event_title, manualTimeHours, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', false);
    logger_name = 'Adding Manual hours to list';
    LoggingStatus = false;
    manualTimeCategory = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name'));
    manualTimeHours = (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours'))));
    event_title = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription'));
    approvalName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', true);
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0) {
      (function (message) { alert(message) })('Hours need to be a positive number');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (manualTimeHours % 0.5 != 0) {
      (function (message) { alert(message) })('Hours need to be 0.5, 1, 1.5, 2, 2.5, and so on.');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      (function (message) { alert(message) })('Please choose a category');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof event_title === 'string')) {
      (function (message) { alert(message) })('Please add a short description');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 500)) {
      (function (message) { alert(message) })('Please keep your description between 10 to 500 characters');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if ((manualTimeCategory == 'Curriculum Design (Microschool Only)' || manualTimeCategory == 'Special Projects (Microschool Only)' || manualTimeCategory == 'Other Hours (Microschool Only)') && !(typeof approvalName === 'string')) {
      (function (message) { alert(message) })('Please add an Approval Name');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/39745d989538c85beed89f66cd65143c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var logger_name, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, error, j, eventTitle, item, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, FormatMSExtraTime, event_title, manualTimeCategory, manualTimeHours, _unused, approvalName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd955a1720296708a4c5aa9efec33999', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  logger_name = 'tutor_dash_submitMSManualHours';
  LoggingStatus = true;
  FormatMSExtraTime = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if (!FormatMSExtraTime.length) {
    return null;
  }
  TodayNumber = (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 2 || (getObjectProperty(___arguments.context.pageData, 'todayNumber')) == 1 ? (getObjectProperty(___arguments.context.pageData, 'todayNumber')) : 0;
  studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
  extraHours = [];
  tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
  if (false) {
  } else {
    for (var j_index in FormatMSExtraTime) {
      j = FormatMSExtraTime[j_index];
      try {
        eventTitle = [(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],'#',subsequenceFromEndFromEnd((JSON.stringify((((new Date()).valueOf()) - TodayNumber * 86400000))), 4, 1),'-',(getObjectProperty(j, 'msDescription'))].join('');
        CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/FrontendSaveMSCalendar`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`Description`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_date`]: (new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))),[`event_title`]: eventTitle,[`status`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`approvalName`]: (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Curriculum Design' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Special Projects' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Other Hours' ? (getObjectProperty(j, 'approvalName')) : null }))));
        extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_time`]: (new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))),[`event_title`]: eventTitle,[`sessionStatus`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`student_list`]: [],[`toBePaidList`]: [] });
        addItemToList(extraHours, extraTime);
        ___arguments.context.pageData['extraMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'extraMSHours')) + (getObjectProperty(extraTime, 'duration')));
        studentContainer.push(extraTime);
        (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).push(extraTime);
        await new Promise(r => setTimeout(r, 50 || 0));
        ___arguments.context.pageData['msStudentContainer'] = (await asyncListSort(studentContainer, 1, async (item) => {


         return (getObjectProperty(item, 'start_time'));
        }));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));

      }
      try {
        LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',(getObjectProperty(j, 'manualMSTimeHours')),(Number((getObjectProperty(j, 'manualMSTimeHours')))) == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],', ',(getObjectProperty(j, 'msDescription')),', ',eventTitle.split('-')[0].split('#').slice(-1)[0]].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_3L0gg9cIHcped8UJj8eiZAgwRB7lF4DLpJLRUeGDrNo' });
        ___arguments.context.pageData['payableMSHours'] = (Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours'))));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));

      }
    }
    ___arguments.context.pageData['MSExtraTimeList'] = [];
    ___arguments.context.pageData['card_no'] = 1;
    ___arguments.context.pageData['msCalendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a480ae62e306a535eeaf66a4e8e403', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  }
  console.log(___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/10b4dd1e2ab552a169337fbcfa757772/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Curriculum Design (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Special Projects (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Other Hours (Microschool Only)')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/61e494f398a8c43987fae7be42e96672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
  await new Promise(r => setTimeout(r, 10 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edb59f2e49f5518df1c18cc541d37a9e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b4bce7ddd4ca41aeac3bfd56f1f1f43e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/edac5e8a6da9a7b4eba642e8e289ea77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
  await new Promise(r => setTimeout(r, 10 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f1dddc1ed6b68b74c36bbf9ea6cb832', true);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/9be21fae0eef29a7b8cd16674d3411fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/8dbead2f0339fe91688571fa545216dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['tourState'], 'type')) == 'skip' || (getObjectProperty(___arguments['tourState'], 'type')) == 'tour:end' || (getObjectProperty(___arguments['tourState'], 'action')) == 'close') {
    await ( async function (componentUid, index) {  ___arguments.context.getComponentByUid(componentUid).goTo(index) })('8dbead2f0339fe91688571fa545216dc', 0);
    await new Promise(r => setTimeout(r, 100 || 0));
    if (!!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && !(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length) {
      if (((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      }
    } else if (!!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      if (((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      }
    } else if (!!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    } else {
      if (((getObjectProperty(___arguments.context.pageData, 'userEmail')).indexOf('@brilliantmicroschool.org') !== -1) == true) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8dbead2f0339fe91688571fa545216dc');
  }

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TourGuideOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/0f4f2f61b94239ef4beae092ea8c3fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/711d2aae60d3eb21eddd3f02d0be19f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/?page=Main_Page', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/a6c5ef2fdd0bd2bd831b680eb5918ef6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam, accessLevel, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (await Backendless.UserService.getCurrentUser(false));
    urlParam = ({ [`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`fromPortal`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`email`]: (getObjectProperty(GetTutorData, 'email')) });
    accessLevel = ({ [`access_level`]: 'Teacher' });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParam['test'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['fromAP'] = true;
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParam['test'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'test')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test'))) {
      urlParam['test'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': accessLevel })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_dash_ms').debug((String('Problem occurs in breadcrumbs | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/1f360448c5246c7cc68704ada38198d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b369987b46aac3fba99d1988a3a3b29f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/71964ea6d526a89afe3c46c30376524f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  display = false;
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'userData')) === 'undefined')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userData')), 'tutorType')) != 'Flex' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userData')), 'tutorType')) != 'Flex/Certified') {
      display = true;
    }
  }

  return display

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/b4f9d3a828224a463fb785ac1249d85e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2fe6c39a7a6491f5bf91748770ab4657/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Class Duration: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),'h'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/ddf502158c577934a06cbfa8b1482677/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') ? null : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).indexOf('ESE') !== -1) ? 'ESE' : 'GENED'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/640d7d2f0c610ba2cf269d5dc9ad9f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/5b6dc9f23c5344cf1cb4cf5a1e774866/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParam = ({  });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParam['fromAP'] = (getObjectProperty(___arguments.context.pageData, 'fromAP'));
      urlParam['fromDashboard'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParam['fromSA'] = (getObjectProperty(___arguments.context.pageData, 'fromAP'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/61254efa158cbcc194ca783a6b658029/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/2683d1b6f76bf25567d59719e668632f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')),[`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_ms_refactored/components/c07d784a003d94b3000672f9938a65a8/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var tutor, userName, welcomeNotes, error, returnData, i, loadTextVal, hoursMSList, hoursList, announcements, checkUser, LoginData, test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

/**
 * Describe this function...
 */
async function initializePageData() {
  welcomeNotes = [', remember to start with a clear lesson objective!', ', remember to use crisp lesson segments in your session 🙂', ', just a reminder to use a "warm-up" today (aka \'Do Now\')', ', will you use an exit ticket at the end of your session today?', ', feel free to cold-call if your student is not talking enough.', ', try to have your student talk at least 50% of the time 🙏', ', just a reminder: precise is better than general praise!', ', a check for understanding can help you adjust your lesson mid-way...', ', may your session report be precise, thorough, and helpful for the student!'];
  return { [`houseLeader`]: ((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause('opp_status=\'enrolled\' and house_leader != null and house_leader != \'JomarTutor Live\'').setProperties('house_leader').setGroupBy('house_leader').setPageSize(100).setDistinct(true))).map(item => item['house_leader'])),[`card_no`]: 1,[`userName`]: userName,[`tutorSubjects`]: (getObjectProperty(tutor, 'subjects')),[`zoom`]: (getObjectProperty(tutor, 'zoom')),[`zoomid`]: (getObjectProperty(tutor, 'zoomid')),[`lead_id`]: (getObjectProperty(tutor, 'lead_id')),[`short_name`]: (getObjectProperty(tutor, 'short_name')),[`offSet`]: (getObjectProperty(tutor, 'offSet')),[`sign`]: (getObjectProperty(tutor, 'sign')),[`timezone`]: (getObjectProperty(tutor, 'timezone')),[`iana`]: (getObjectProperty(tutor, 'iana')),[`DriveTokenObject`]: (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0],[`MSExtraTimeList`]: [],[`DateToday`]: ((new Date()).valueOf()),[`loader`]: ['Hi ',userName.split(' ')[0],listsGetRandomItem(welcomeNotes, false)].join(''),[`loading_spinnerVisible`]: true,[`tutorSelector`]: ({ [`value`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`label`]: (getObjectProperty(___arguments.context.pageData, 'userName')) }),[`announcements`]: [],[`title`]: ['Hi ',userName.split(' ')[0],', welcome back!'].join(''),[`selector`]: 'reports',[`hasBMS`]: (typeof (getObjectProperty(tutor, 'MS_teacher_email')) === 'string') ? (((getObjectProperty(tutor, 'MS_teacher_email')).indexOf('@brilliantmicroschool.org') !== -1) ? true : false) : false }
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function showTest() {
  if (true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('98c34b8e62aaeb432ada42173c02448b', true);
    await new Promise(r => setTimeout(r, 250 || 0));
    test = [({ [`target`]: 'body',[`content`]: ['Hi ',userName,'! You can use this portal to review and submit your sessions or classes.'].join(''),[`disableBeacon`]: true,[`placement`]: 'center' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e')), 'el')),[`content`]: 'Click here to access your Tutoring & Private Sessions',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring & Private Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9be21fae0eef29a7b8cd16674d3411fe')), 'el')),[`content`]: 'Click here to access your Microschool Classes',[`placement`]: 'left',[`placementBeacon`]: 'left',[`title`]: 'Microschool Classes',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('39075dbc9d74db38793c3159bbf4fe59')), 'el')),[`content`]: 'Click here to see your past and current sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Past Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc17716809b5e5a5cd8913dd92bd72e9')), 'el')),[`content`]: 'Click here to see your future sessions or classes',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Future Sessions',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6f83a1196e4d9f887a4e0ba1e3b9284')), 'el')),[`content`]: 'Submit a ticket and we will get back to you within 24hrs.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Support',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db69da57441b0c5f05bee60c9ed3a0be')), 'el')),[`content`]: 'Click this to access more links/resources.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Explore',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79ab7744549adaff5491eed85f942c98')), 'el')),[`content`]: 'Click here to send your reports to the Student and Parent',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Reports',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2bc7badc91dd24529b363d8ac0c1338a')), 'el')),[`content`]: 'Click this plus button to access the tutoring extra hour section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutoring Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac33164fd012e85afbe73d1e4c72c86f')), 'el')),[`content`]: 'This is where you can select a category for your extra hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Category',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d784a003d94b3000672f9938a65a8')), 'el')),[`content`]: 'This is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Input Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3287b7d1ed141a3e7ea27aa2c94652af')), 'el')),[`content`]: 'This is where you will add the description of the extra hour that you are going to enter',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e29cbb94966f7ad1371a1a0aa85e1f71')), 'el')),[`content`]: 'Click this button to add your extra hour in the hour to be submitted',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de')), 'el')),[`content`]: 'Submit your tutoring hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Tutor Hours Submission',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34afc59ab7bf285faf9ac3f9c936faf9')), 'el')),[`content`]: 'Click the class name to see the student list of this specific class',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Student List',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('353be564809844c2ae8c2c66c1843b03')), 'el')),[`content`]: 'Click this bin icon to cancel a specific class before submitting it.',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Cancel Class',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad13b5c129c3720e61ec643f4b8f52d8')), 'el')),[`content`]: 'Click this plus button to access the microschool extra hours section',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('341e69ee2f6f94eb01681d5d151ffc67')), 'el')),[`content`]: 'This section is where you will add your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Extra Hours Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c03dd593e64185b5d0226e377eb0b31')), 'el')),[`content`]: 'This button will let you choose the next extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e80240f566633de7cda34bef372c9ff5')), 'el')),[`content`]: 'This button will let you choose the previous extra hour category card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Extra Hour Card Selection',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('389378220a8ed62cd0e392c2caeeac9a')), 'el')),[`content`]: 'This button will let you access the Add Hour Form of the chosen card',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Add Hour Form',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a89e4ef41ca9a8ce33ff4dd20e93d95f')), 'el')),[`content`]: 'Input your extra hours here',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('82524489318c4a636811f3f45cacdd55')), 'el')),[`content`]: 'This is where you will enter the description of your extra hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours Description',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89bf71fbf8c4b4c7477c0139ab58584a')), 'el')),[`content`]: 'Click this to add your extra hours for review',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Add Extra Hours to Review',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8d343d9778c0df6673d7d26cb0d0121')), 'el')),[`content`]: 'Click this to review your extra hours before submitting your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Access Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28b759ed749ebd638fcb7ed85a3981e7')), 'el')),[`content`]: 'This section is where you can review your MS Extra Hour',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Review Extra Hour Section',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('71686cc3e1e32301badc353c2c9d8deb')), 'el')),[`content`]: 'Submit your MS Extra Hours once you are satisfied with the Extra Hours you input',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Submit MS Extra Hour',[`offset`]: 10,[`event`]: 'click' }), ({ [`target`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065')), 'el')),[`content`]: 'Submit your Microschool Hours',[`placement`]: 'bottom',[`placementBeacon`]: 'bottom',[`title`]: 'Microschool Hours',[`offset`]: 10,[`event`]: 'click' })];
    ___arguments.context.pageData['TourGuideOptions'] = test;
    ___arguments.context.pageData['loading_spinnerVisible'] = false;
    ___arguments.context.pageData['loader'] = '';
    await new Promise(r => setTimeout(r, 100 || 0));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).reset() })('8dbead2f0339fe91688571fa545216dc');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).start() })('8dbead2f0339fe91688571fa545216dc');
  }
}


  ___arguments.context.pageData['hasLoaded'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) == true) {
    checkUser = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(((getObjectProperty(___arguments.context.pageData, 'tutorName')).replace((new RegExp('_', 'g')), ' ')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(1)))[0];
    console.log(checkUser);
    try {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'zoomid')), false  ));

    } catch (error) {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(checkUser, 'email')), (getObjectProperty(checkUser, 'MS_teacher_password')), false  ));

    }
  }
  try {
    Backendless.Logging.getLogger('tutor_dash_ms').info((['User Info','\nLogged in User Name: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),'\nEmail: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\nData: ',(JSON.stringify((await Backendless.UserService.getCurrentUser(true))))].join('')));

  } catch (error) {
    console.log(error);

  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    try {

      ;(function() {
        const callback = async () => {
            ___arguments.context.pageData['currentTime'] = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: 'long',[`hour12`]: undefined,[`month`]: undefined,[`day`]: undefined,[`hour`]: undefined,[`minute`]: undefined,[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((new Date())));

        };

        const timerId = '';
        const timerDelay = 1000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
      ___arguments.context.pageData['LoginData'] = ({ [`user-token`]: (Backendless.getCurrentUserToken()) });
      userName = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name'));
      ___arguments.context.pageData['userEmail'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email'));
      console.log(JSON.stringify(({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) })));
      tutor = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType = \'BACKENDLESS\' and subjects is not null'].join(''),[`property`]: ['name', 'tip_level', 'timezones.short_name', 'timezones.iana', 'zoom', 'zoomid', 'timezones.offSet', 'timezones.sign', '*'],[`pageSize`]: 1 })).setEncoding('utf8').send())[0];
      if (!(tutor !== null && !Array.isArray(tutor) && (typeof tutor === 'object'))) {
        return null;
      }
      Object.assign(___arguments.context.pageData, (await initializePageData()));
      await BackendlessUI.Functions.Custom['fn_cad53b2c8115106fd3afcda20303acdc']('Page Enter / Tutor Dash', (['Tutor ',userName,' logged in on ',((new Date()).toUTCString()),' / ',((getObjectProperty(___arguments.context.pageData, 'userEmail')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'userEmail')) === 'undefined') ? (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) : (getObjectProperty(___arguments.context.pageData, 'userEmail'))].join('')));
      announcements = (await Backendless.Data.of('announcements').find(Backendless.DataQueryBuilder.create().setWhereClause((['(Tutor_Category = \'',((getObjectProperty(tutor, 'timezone')).indexOf('US') !== -1) ? 'US' : 'ROW','\' or Tutor_Category = \'ALL\') and announcement_live = true'].join(''))).setPageSize(100)));
      addItemToList((getObjectProperty(___arguments.context.pageData, 'announcements')), announcements);

    } catch (error) {
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / Page Enter', (JSON.stringify(({ [`message`]: 'Error caught while initializing data',[`data`]: ({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) }) }))), error);

    }
    try {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowTS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowMS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      hoursMSList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msQuestionnaire'] = (await BackendlessUI.Functions.Custom['fn_ba7314e68c4b6abd4bdf1ad56bcd9a5d'](userName));
      loadTextVal = [({ [`condition`]: !(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length,[`text`]: 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions.' }), ({ [`condition`]: !(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length,[`text`]: 'To locate your recently completed classes and confirm hours for payment, go to the \'Microschool\' tab for microschool classes.' }), ({ [`condition`]: !!(getObjectProperty(___arguments.context.pageData, 'studentContainer')).length && !!(getObjectProperty(___arguments.context.pageData, 'msStudentContainer')).length,[`text`]: 'To find recent tutoring sessions for reporting or confirming hours for payment, navigate to the \'Tutoring\' tab for tutoring and private 1-1 sessions, or the \'Microschool\' tab for microschool classes.' })];
      ___arguments.context.pageData['LoadText'] = '';
      var i_end = loadTextVal.length;
      var i_inc = 1;
      if (1 > i_end) {
        i_inc = -i_inc;
      }
      for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
        if (getObjectProperty((loadTextVal[(i - 1)]), 'condition')) {
          ___arguments.context.pageData['LoadText'] = (getObjectProperty((loadTextVal[(i - 1)]), 'text'));
          break;
        }
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aae409ae0ac87091f64938d5ef9b883', true);

    } catch (error) {
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / Page Enter', (JSON.stringify(({ [`message`]: 'Error encountered while fetching past sessions',[`data`]: ({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) }) }))), error);

    }
    try {
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
      ___arguments.context.pageData['extraHours'] = 0;
      await showTest();

    } catch (error) {
      console.log(error);
      await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / Page Enter', (JSON.stringify(({ [`message`]: 'Error encountered while fetching future sessions',[`data`]: ({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')) }) }))), error);

    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/4756d4ddb332497515dc236f06169a05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.pageData, 'test_mode')) === null) && (getObjectProperty(___arguments.context.pageData, 'test_mode')) == true) {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page_Test_Mode', undefined);
  } else if (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/31852522e433679db69ddb12ee22dcf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) >= (new Date())) {
    (function (message) { alert(message) })('Can\'t send homework before start time');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'reportRowClick')) == false) {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['reportRowClick'] = false;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var endTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  endTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 50;

  return ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX1-') !== -1) ? true : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (false ? (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' : ((new Date()).valueOf()) > endTime) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/c53a30fa950184dccd71ea0fb4d8b60d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'is_cancelled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) != 'Manual time' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? null : !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')).startsWith('[OFFBOARDED]'))) && lateTime >= ((new Date()).valueOf()) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'messageRowClick')) == false) {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d')['messageRowClick'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ee1465bff9c2bec6941d08222ba5ec26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'parent_name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/66cd90547bf88f0ec556661ce6996da6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var slotsSlugText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) != 0) {
        slotsSlugText = String('Last homework was sent on ') + String(new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`year`]: 'numeric',[`timeZoneName`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
      }
    }
  } else if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX') !== -1) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MICROSCHOOL') !== -1)) {
    slotsSlugText = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug'));
    if (slotsSlugText == 'Substitute session' || slotsSlugText == 'Extra Session') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('66cd90547bf88f0ec556661ce6996da6'))['color'] = '#F4703C';
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('MAX1-MICROSCHOOL') !== -1) {
    slotsSlugText = 'Self-paced MS 1on1';
  }

  return slotsSlugText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/cc17716809b5e5a5cd8913dd92bd72e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'UI / Tutor Dash Page / messageMenu Block';
  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'hasLoaded')) || (typeof (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'futureStudentContainer')) === 'undefined')) {
      return null;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer')).length && !(getObjectProperty(___arguments.context.pageData, 'futureStudentContainer')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
      return null;
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at check content and user / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    ___arguments.context.pageData['loader'] = (String((getObjectProperty(___arguments.context.pageData, 'userName')).match((new RegExp('\\w+', '')))) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at set visibility to off / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    ___arguments.context.pageData['selector'] = 'messaging';
    ___arguments.context.pageData['studentContainer'] = (getObjectProperty(___arguments.context.pageData, 'futureStudentContainer'));
    ___arguments.context.pageData['msStudentContainer'] = (getObjectProperty(___arguments.context.pageData, 'msFutureStudentContainer'));

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at update containers and selectors / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered at set visiblity to on / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/08770bb54b931f72b9a4291830a2fefe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://airtable.com/appY4H22rBsR5hG1g/shre8VCU9FnC23bFi/tblrD92p5tHt8Fq6u', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad77a9c654da3d84c1ddad11b9bacdc1', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/56bc538f1eb9f9fd9bc6656fcf34eecb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) == 'scheduled' && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, objectToDelete, Task, item, LeadHolder, LeadTask, studentContainer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  logger_name = 'deleteManualHour';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9abceacc5bed5876e09f989a33d83bed', true);
  if (false) {
    try {
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHours2')), ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
      studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
      removeItemInList(studentContainer, ___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), '');
      ___arguments.context.pageData['studentContainer'] = studentContainer;
      ___arguments.context.pageData['payableHours2'] = (getObjectProperty(___arguments.context.pageData, 'payableHours2'));
      if ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) != 0) {
        ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) - 1);
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

    }
    try {
      objectToDelete = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['event_title = \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
      LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
      if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
        return null;
      }
      if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
        return null;
      }
      if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
        return null;
      }
      if ((getObjectProperty(objectToDelete, 'slots_slug')) != 'Manual time') {
        return null;
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

    }
    try {
      await Backendless.Data.of('calendar').save( ({ [`scheduling`]: 'is_deleted',[`objectId`]: (getObjectProperty(objectToDelete, 'objectId')) }) );
      LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
         if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
        }


       return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
      }));
      Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/06391894f8d7144146e5b0413ef74286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  logger_name = 'tutor_dash_submitMessage';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (String('MessageContent - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent'))), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#d3d3d3';
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')) == null) {
      Backendless.Logging.getLogger(logger_name).debug('Message Content is Empty');
      return null;
    }
    Backendless.Logging.getLogger(logger_name).info((String('tutor_dash_submitMessage Data: ') + String(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })))));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the start sequence - Error / Parent Lead: ', error));

  }
  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/messaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })));
    Backendless.Logging.getLogger(logger_name).info((String('tutor_dash_submitMessage sent') + String(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'subject')),[`grade`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'grade')),[`tutor_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')),[`message`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'messageContent')),[`calendarObjectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'slots_slug')) })))));
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Message Sent - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was a problem sending the message - Error / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'lead_id')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name'))].join('')), error));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a48471e0ee74216f8254f582a3438b1'))['color'] = '#fd6541';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Error';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageContent'] = '';
    ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['messageStatus'] = 'Submitted!';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06391894f8d7144146e5b0413ef74286'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a48471e0ee74216f8254f582a3438b1', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6efdad730a47b90a1d6e79bbc2f53aa8', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'There was a problem in the end sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/be21d4c346140134069b5ce1dc4c22ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')) === null) ? null : ['Hi ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'parent_name')),', this is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'tutor_name')).indexOf(' ') + 1) - 1),' from Brilliant Grades. I\'m in the zoom room waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6efdad730a47b90a1d6e79bbc2f53aa8'), 'student_name')),'. Our session started 5 minutes ago. Are you joining? Thanks a ton!','\n_____\n\nzoom link: ',(getObjectProperty(___arguments.context.pageData, 'zoom')),'\n\nmeeting id: ',(getObjectProperty(___arguments.context.pageData, 'zoomid'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/edb59f2e49f5518df1c18cc541d37a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'studentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/39075dbc9d74db38793c3159bbf4fe59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, msHourBlock, returnData, hourBlock, LoggerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'ReportContainer';
  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'hasLoaded')) || (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
      return null;
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 700;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    ___arguments.context.pageData['msStudentContainer'] = [];
    ___arguments.context.pageData['studentContainer'] = [];
    ___arguments.context.pageData['loader'] = (String((getObjectProperty(___arguments.context.pageData, 'userName')).match((new RegExp('\\w+', '')))) + String('\'s students are loading...'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    ___arguments.context.pageData['selector'] = 'reports';

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('ReportContainer', (String('Error encountered at set visibility to off / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'primarySessions')) === 'undefined')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowTS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      hourBlock = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    }
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowMS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      msHourBlock = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / reportsMenuBlock', (String('Error encountered at fetch sessions / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      console.log('msStudentContainer');
      console.log(getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('UI / Tutor Dash Page / reportsMenuBlock', (String('Error encountered at set visibility to on / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e29cbb94966f7ad1371a1a0aa85e1f71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, msHoursList, returnData, hoursList, resultMsg, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, manualTimeHours, customEventTitle, event_title, manualTimeCategory, item, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, tutorObject, TodayNumber, startTime, message;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function generateAlert(message) {
  (function (message) { alert(message) })(message);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', true);
}


  try {
    resultMsg = String('Extra hours added successfully!') + String((getObjectProperty(___arguments.context.pageData, 'dowTS')) < 3 ? ' You can find them in the FUTURE sessions tab.' : ' You can find them in the PAST sessions tab.');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', false);
    logger_name = 'tutor_dash_submitManualHours';
    LoggingStatus = false;
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    manualTimeCategory = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeCategory'));
    manualTimeHours = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'manualTimeHours'))));
    event_title = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12')), 'event_title'));
    TodayNumber = 0;
    extraHours = [];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0 || !(manualTimeHours % 1 == 0)) {
      await generateAlert('Hours need to be a positive whole number');
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      await generateAlert('Please choose a category');
      return null;
    }
    if (!(typeof event_title === 'string')) {
      await generateAlert('Please add a short description');
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 220)) {
      await generateAlert('Please keep your description between 10 to 250 characters');
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  try {
    for (var count = 0; count < manualTimeHours; count++) {
      startTime = ((new Date()).valueOf()) - TodayNumber * 86400000;
      customEventTitle = [manualTimeCategory,'#',subsequenceFromEndFromEnd((JSON.stringify(startTime)), 4, 1),'-',event_title].join('');
      CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/saveObjectToDB`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle }))));
      extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`subject`]: null,[`grade`]: null,[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor_name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`homework_sent`]: true,[`start_time`]: ((new Date()).valueOf()) - TodayNumber * 86400000,[`payable`]: true,[`event_title`]: customEventTitle,[`student_name`]: null,[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`lastHmwrk`]: 0,[`messageRowClick`]: false,[`reportRowClick`]: false,[`tutor_lifetime_slots`]: null,[`tutorType`]: 'Partner' });
      await Backendless.Data.of('Users').addRelation(tutorObject, 'calendar', [(getObjectProperty(CalendarObject, 'objectId'))]);
      addItemToList(extraHours, extraTime);
      studentContainer.push(extraTime);
      (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).push(extraTime);
      await new Promise(r => setTimeout(r, 50 || 0));
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while adding manual hours for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));
    resultMsg = 'Error encountered at Save manual hour object';

  }
  try {
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',manualTimeHours,manualTimeHours == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',manualTimeCategory,', ',event_title,', ',customEventTitle.split('#').slice(-1)[0].split('-')[0]].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' });
    ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) + (Number(manualTimeHours)));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeCategory'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['manualTimeHours'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12'))['event_title'] = null;
    ___arguments.context.pageData['calendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e29cbb94966f7ad1371a1a0aa85e1f71', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ba3eeb1bed397379ff878c222e61cda', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);

  } catch (error) {
    console.log(error);
    resultMsg = 'Error encountered at Task creation';

  }
  (function (message) { alert(message) })(resultMsg);
  try {
    ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while refreshing containers / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    
  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/55fdb589c2cb251c7599918848144a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/05644c3fee79e4b5f2f8142ff511c59f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf')['MessageContentLength'] = (___arguments.value.length);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) < 1000) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8905010942d788046fc8152379b238bf'), 'MessageContentLength')) >= 10) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06391894f8d7144146e5b0413ef74286', false);
    }
  } else {
    (function (message) { alert(message) })('You have reached the limit');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8f91b6cb4293f2cdcdb6095aa07d7cb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('http://tutors.brilliantgrades.com/', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f91b6cb4293f2cdcdb6095aa07d7cb2'))['fontWeight'] = 700;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b10db8afabae4c3f7e0ab15fbedcec28', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/eeba337b1abad2e2064a177d173eb112/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://zoom.us/signin', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8be9cd192adb5dd907ae7ac9d0d472d', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/4cdc223f17b4a008501abf4bc2f579a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != '')

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'rubric')) != null ? 'Companion Rubric' : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/55a2daa21ae3fd7d7c4344d11bf8e523/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.loom.com/share/e61474c1a9374f509c3586165875d842', true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6e6c371d5ff23a21fa4ad445c9fb2c', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b2f38edae191dcee756e2c6e9e1f8f55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString, parentTimezone, tutorTimezone;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'tutor_away') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'tutor' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'localeStartTime')) == 'contact' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) != 'Manual time') {
      localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') {
      localeDateString = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')).split('#')[0];
    }
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/a6f83a1196e4d9f887a4e0ba1e3b9284/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Backendless.Logging.getLogger('tutor_dash_ms').info((['Redirect to Tutor Ticket Page','\nLogged in User Name: ',(getObjectProperty(___arguments.context.pageData, 'userName')),'\nUser Data: ',(JSON.stringify((await Backendless.UserService.getCurrentUser(false))))].join('')));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/?page=tutor_ticketing','#firstname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ')[0],'&lastname=',(getObjectProperty(___arguments.context.pageData, 'userName')).split(' ').slice(-1)[0]].join('')), true, undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/db69da57441b0c5f05bee60c9ed3a0be/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
  }

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56ce472b3659c65611a0f5a918dc92c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97da6d39285798ca1f6f1e8dc441bf14', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64b22f2e967708cd2f23f0118fe71b96'))['marginTop'] = '0px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e7f84404d74f7eec8dd8f4b55566cdb1'))['fontWeight'] = 100;
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe3fff351e3b7f33663ec02d3fbb18f', true);
    }
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c')), 'fontWeight')) == 700) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7b151d3f20e3cc51195fba8032815af', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d268c69202eedb09885361684e799e9e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e56ce472b3659c65611a0f5a918dc92c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/98dd39b1912f926d6a0d7c5eef9e1773/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', true);

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5046805a713daf76c72ce5e05bd2804', false);

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e68a3f08b3383fbd9fa9cf9d6ee6ef67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/2c3cfb8f9666b2d16976e8ac5ab77697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['requestHours'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/292e0c59fc5ab5ecbfed410e938466b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, TaskCreate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LoggerName = 'RequestHours';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered on starting sequence', error));

  }
  try {
    TaskCreate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/requestHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ 'event': ({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'requestHours': (getObjectProperty(___arguments.context.pageData, 'requestHours')),'userName': (getObjectProperty(___arguments.context.pageData, 'userName')) }) }))));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered while requesting for hours', error));

  }
  try {
    if (TaskCreate == 'success') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', false);
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c1986feb74b3b3fa041cc6d4c8f38825', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79139285bd4658535b5f10fdbee20ce', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('532ce0b74af9950f4e256587922df9d9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f643d520b87eb650633e10ed9b7a4d8', true);
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2c3cfb8f9666b2d16976e8ac5ab77697'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('853804cc12dfa569027d0603dd724dc4'))['content'] = 'Error: Try Again';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('292e0c59fc5ab5ecbfed410e938466b7', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68a3f08b3383fbd9fa9cf9d6ee6ef67', true);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, 'Error encountered ending sequence', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/960fd48380c22f77d3063aee7edecec3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) === null) ? (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) === null) ? 'Student On Pause' : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')).indexOf('Mock') !== -1) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'event_title')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/48be111a6e73f9496192001254069b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'grade')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/a738b596c568ca5c432a97d459156531/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/855cb05fd1fc8512b116fa12718e647e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toLocaleString());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/6ba3eeb1bed397379ff878c222e61cda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/6c7ce06f475737eaf549e27facb992de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, LoggingStatus, PseudoCreatedTimestamp, payableHoursMS, payableHoursTS, item, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, studentEvent, CheckIfTthere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  logger_name = 'Submit Hours Button';
  LoggingStatus = false;
  try {
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#EBEBE4';

  } catch (error) {
    (function (message) { alert(message) })('Error encountered while submitting hours');
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    for (var studentEvent_index in studentContainer) {
      studentEvent = studentContainer[studentEvent_index];
      CheckIfTthere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
      }));
      if (!CheckIfTthere.length) {
        continue;
      }
      if ((getObjectProperty(studentEvent, 'homework_sent')) == true) {
        studentEvent['toBePaid'] = true;
      } else if ((getObjectProperty(studentEvent, 'slots_slug')) == 'Mock Session') {
        studentEvent['homework_sent'] = true;
        studentEvent['toBePaid'] = true;
      }
    }
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'primarySessions'));
    for (var calendarEvent_index in calendarListRaw) {
      calendarEvent = calendarListRaw[calendarEvent_index];
      studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
      if (studentContainerPosition > 0) {
        calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
      }
    }
    ___arguments.context.pageData['primarySessions'] = calendarListRaw;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length == 0) {
      (function (message) { alert(message) })('You have no hours to be submitted');
    } else {
      PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
      payableHoursMS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && !((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      payableHoursTS = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')), async (item) => {


       return (!((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) || ((getObjectProperty(item, 'slots_slug')).indexOf('-MS_') !== -1) && ((getObjectProperty(item, 'slots_slug')).indexOf('MAX1-') !== -1));
      }));
      if (!!payableHoursTS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursTS,[`tutorService`]: 'TS',[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      if (!!payableHoursMS.length) {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/hours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: payableHoursMS,[`tutorService`]: 'MS',[`PseudoCreatedTimestamp`]: false ? PseudoCreatedTimestamp : null,[`CreatedTimestamp`]: (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))),[`DateTodayTimestamp`]: (getObjectProperty(___arguments.context.pageData, 'DateToday')),[`iana`]: (getObjectProperty(___arguments.context.pageData, 'iana')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
      }
      ___arguments.context.pageData['hoursStatusValue'] = 'Submitted!';
      ___arguments.context.pageData['submittedHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedHours')) + (getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      ___arguments.context.pageData['payableHoursFiltered'] = [];
      ___arguments.context.pageData['payableHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered')).length);
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), error));

  }
  try {
    ___arguments.context.pageData['extraHours'] = 0;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c7ce06f475737eaf549e27facb992de'))['background'] = '#0a1352';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850fc17d783d27b3db9bdd5dfb97d2f4', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Submit ',(getObjectProperty(___arguments.context.pageData, 'payableHours')),(getObjectProperty(___arguments.context.pageData, 'payableHours')) > 1 || (getObjectProperty(___arguments.context.pageData, 'payableHours')) == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f6f1e22a76dcd32af28397b3a5a8fa29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'student_name')) != null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) == 'scheduled') {
    isVisible = true;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'subject')) == 'Manual time') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    isVisible = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled') {
    isVisible = false;
  } else {
    isVisible = false;
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/6c382dc562077f3dc8158e63420bfc9d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')), 'display')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#C1E1C1';
    } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#F1E8E7';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c382dc562077f3dc8158e63420bfc9d'))['background'] = '#fffff';
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11f45aa3e9a459f987a5058dd938e974')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')) === 'undefined') || !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2229337fcf815d30396549f2cc39705')) === 'undefined'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/d2229337fcf815d30396549f2cc39705/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b031feb6c1e3aca2c4925425596f4b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/7f13a0fb81a33d11c448d8c8b44774a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'studentsToday')),(getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 1 || (getObjectProperty(___arguments.context.pageData, 'studentsToday')) == 0 ? ' sessions ' : ' session ','today!'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/a702c6aef57358e195b6b50a731d96f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/fff98e419ad78ce4d61f9566a48e117b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'studentsToday')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e1430179fc6b6f21c9dc9c6f22ca4ad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('820270be67d64d464a98818ff8f39324')), 'display')) == true ? false : true) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000))) {
    content2 = 'Pending Homework';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session') {
    content2 = 'Report Sent';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8617494c75fd6e5a303d80d7d4b1d333/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var message, Slot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging') {
    message = 'Cancelled session';
  } else if ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports') {
    message = 'Session did not occur';
  }

  return message

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/74fc1f77230994ed26cd09bf3af662fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/45cd08bfd6849c17b7389f4b5471f992/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/42d4dcea40048a699c427a9a854238bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f42f0f48f9bc1f49ff2641e976690d34/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f42f0f48f9bc1f49ff2641e976690d34'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength(___arguments.value));
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b3843647ae5862a445e1352bacc1471c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['background'] = '#EAF1F8';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['color'] = '#32325D';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3843647ae5862a445e1352bacc1471c'))['font-size'] = '12px';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ed786cc2c66bb26c2f4c8813c6319276/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ca23ee2ee51cea994404dd26d03bd69e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/7e39c413d2c245c3a4c3fd548e489754/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = 'The student(s) made progress';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/17dd941e77be48f6117d1392d966840a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/010c10094d98413c56497d23fafb8e17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e072bb290098c74cf7230c269dbc63db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '1';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f8d8039e403d93534ff14dac3a318f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b26c14ace999f11d509bd7364029d8e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b1d660f5bbf75c5d2dd8b04d8f965b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'isPresent')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1faed4cd936a8483af596d0462ef141a/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error, RenamedFile, GetFile, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  try {
    if (true) {
      RenamedFile = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName'));
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/authcodes')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }));
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      GetFile = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v3/files/') + String(getObjectProperty(___arguments.context.pageData, 'uploadedIdFile'))))).query(({ [`fields`]: ['webContentLink'] })).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send());
      await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
    } else {
      RenamedFile = (await Backendless.Files.renameFile( encodePath((String('homework/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'fileName')))), encodePath((['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),'.',___arguments.uploadedFiles.split('/').slice(-1)[0].split('.').slice(-1)[0]].join(''))) ));
    }
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6fb5c65420f143dee94c402ec10a72ad', [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length < 3) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), [({ [`objectId`]: undefined,[`id`]: ((new Date()).valueOf()),[`file`]: (getObjectProperty(GetFile, 'webContentLink')),[`fileName`]: RenamedFile })]);
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['files'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad'));
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1faed4cd936a8483af596d0462ef141a');
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')).length >= 3) {
      (function (message) { alert(message) })('Please keep each homework to 3 attachments. You can send a second report to include additional attachments. Thank you.');
    }
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport'))));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_dash_upload_file').warn(([(JSON.parse(error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  }

  },
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (true) {
    try {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = 0;
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55df951b180944c84e9d0c54a82dac8e')), 'display')) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', false);
      }
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''),[`parents`]: ['1Je3aUb8YMYTsCW78CFsioOMSEVy25wbw'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
      ___arguments.context.pageData['uploadedIdFile'] = (getObjectProperty(Metadata, 'id'));
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (['Brilliant-Grades-',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')).replace((new RegExp('\'', 'g')), '')),'-',((new Date()).valueOf()),subsequenceFromStartLast((getObjectProperty((___arguments.files[0]), 'name')), (((getObjectProperty((___arguments.files[0]), 'name')).lastIndexOf('.') + 1) - 1))].join(''));

    } catch (error) {
      console.log(JSON.stringify(error));
      Backendless.Logging.getLogger('tutor_dash_before_upload_file').warn(([(JSON.stringify(error)),' - ',(JSON.stringify(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'))),' File Type:',(getObjectProperty((___arguments.files[0]), 'type')),' File Name:',(getObjectProperty((___arguments.files[0]), 'name')),' File:',(JSON.stringify((___arguments.files[0])))].join('')));

    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['fileName'] = (getObjectProperty((___arguments.files[0]), 'name'));
  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')).length);
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8551301ddc6d2c2fae763ec3774f959f')), 'display'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55df951b180944c84e9d0c54a82dac8e', true);
  }
  Backendless.Logging.getLogger('tutor_dash_failed_upload_file').warn(([(JSON.parse(___arguments.error)),' - ',(JSON.parse(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')))].join('')));

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var filename;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  filename = ((getObjectProperty(___arguments.file, 'name')).replace((new RegExp('(?:\\.(?![^.]+$)|[^\\w.])+', 'g')), '_'));

  return filename

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/7745a3e392ad5ff6dbdae5f47933a651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6fb5c65420f143dee94c402ec10a72ad')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')), ___arguments.context.getComponentDataStoreByUid('70071652c4db03cd0a0e73a88835318a'), '');

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onMouseOut */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7745a3e392ad5ff6dbdae5f47933a651'))['border-radius'] = '50%';

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/55df951b180944c84e9d0c54a82dac8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) >= 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b07e189d45cd1f8ab6d831c9c40dfbbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/0c879ba8c2de9b2613175df1f12162f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c879ba8c2de9b2613175df1f12162f5'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07e189d45cd1f8ab6d831c9c40dfbbf'))['box-shadow'] = '0px 0px 0px 0px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ff04f66b2abaa26cd40ac75a3bd40a8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['FeedbackBTNClicked'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ad1cc4046b92cdce3bef541b0b287011/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcf10b6c785bb1d74fbe3ea8c7e95942', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/83ee4ec93215aafe7376dc165717a9d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85aaeb55bb522fcd634fe1787a2e2a9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8551301ddc6d2c2fae763ec3774f959f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) > 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReportLength')) < 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/6fb5c65420f143dee94c402ec10a72ad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined')) {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/d532e8462b3948653f0f9fc248526aef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57490ff4d45f433403315002a424f4fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/d97ebc8bcb09e1fdcc836c4ad1bac727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Student Issue';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/7cae4d7c127f4c5169edddfcdb625189/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Suggestions';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f9461ed7c0e9e0f3f60a3555d37d7d6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f9461ed7c0e9e0f3f60a3555d37d7d6a'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7cae4d7c127f4c5169edddfcdb625189'))['box-shadow'] = '0px 0px 0px 0px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d97ebc8bcb09e1fdcc836c4ad1bac727'))['box-shadow'] = '0px 0px 0px 0px';
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['feedbackCategory'] = 'Other';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/0c389e7ff11c4e4ec227103b3dddc80d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c389e7ff11c4e4ec227103b3dddc80d'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['groupEmail'] = true;
  }
  console.log('groupEmail');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/190c483fac06d0d5ab4ecabfbc016fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f7ad243951b8ae8d464590037c99e4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var setBoolean;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    setBoolean = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    setBoolean = false;
  } else {
    setBoolean = true;
  }

  return setBoolean

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1cd7e871600396535b2844fcbc2277d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, FL_Score, _unused, logger_name, calendarListRaw, studentContainer, hoursList, dash, studentContainerPast, LoggingStatus, student, calendarListRawPosition, studentContainerPosition, attachments, studentList, uniqueSlots, item, attachment;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    logger_name = 'tutor_dash_submitHomework';
    LoggingStatus = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit Button clicked - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#d3d3d3';
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).length) {
      attachments = null;
    } else {
      attachments = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'homeworkContainer')).map(async attachment => {; return (getObjectProperty(attachment, 'file'));})));
    }
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Collect Attachments - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'primarySessions'));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'groupEmail')) == true) {
      studentList = (await asyncListFilter(studentContainer, async (item) => {


       return ((getObjectProperty(item, 'slots_slug')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')) && (getObjectProperty(item, 'start_time')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'start_time')));
      }));
    } else {
      studentList = [___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')];
    }
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Get data necessary for submission - SUCCESS',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in retrieving data for the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }
  try {
    for (var student_index in studentList) {
      student = studentList[student_index];
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/homework`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`data`]: undefined,[`parent_name`]: (getObjectProperty(student, 'parent_name')),[`student_name`]: (getObjectProperty(student, 'student_name')),[`homework_sent`]: true,[`subject`]: (getObjectProperty(student, 'subject')),[`grade`]: (getObjectProperty(student, 'grade')),[`tutor_name`]: (getObjectProperty(student, 'tutor_name')),[`report`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport')),[`calendarObjectId`]: (getObjectProperty(student, 'calendarObjectId')),[`slots_slug`]: (getObjectProperty(student, 'slots_slug')),[`sessionQuality`]: ['Q1 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q1Ans')),'\nQ2 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q2Ans')),'\nQ3 Answer - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'Q3Ans'))].join(''),[`bgFeedback`]: (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')) === null) ? null : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'feedbackCategory')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'bgFeedback'))].join(''),[`contactParent`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')),[`attachments`]: attachments })));

      })();
      await new Promise(r => setTimeout(r, 250 || 0));
      studentContainerPosition = studentContainer.indexOf(student) + 1;
      calendarListRawPosition = calendarListRaw.indexOf(student) + 1;
      if (studentContainerPosition > 0) {
        studentContainer[(studentContainerPosition - 1)] = student;
        calendarListRaw[(calendarListRawPosition - 1)] = student;
      }
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submit homework - Success / Parent Lead: ',(getObjectProperty(student, 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    }

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', true);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in submitting the homework - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469e7b5986444a0d56dbc916e2658b9f', false);

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared progress report - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['bgFeedback'] = '';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared bg feedback - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Contact Parent set to false - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['homework_sent'] = true;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Homework set to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cd7e871600396535b2844fcbc2277d2'))['background'] = '#0a1352';
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Set status visibility to true - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f6c429b88fc19b14ecda6a46d61286', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d96e3562b933d045d64b180c471b7d11', true);
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['homeworkContainer'] = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Cleared docs - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Clear form fields - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in clearing the fields - Error / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), error));

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f')['reportRowClick'] = false;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success / Parent Lead: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name')),' / Tutor: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'tutor_name'))].join('')), 'INFO', LoggingStatus);
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de'](studentContainer, ___arguments.context.pageData));
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['primarySessions'] = calendarListRaw;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('There was an error in updating the object in the raw list - Error / ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'parent_name'))), error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/498c21f9cb5f164912448c47d278a46c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['contactParent'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('498c21f9cb5f164912448c47d278a46c'))['box-shadow'] = '0px 0px 0px 0px';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/9418a1aba1fd4033450f16695735b1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'contactParent')) ? 'Yes' : 'No')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b2132b5d8a74e88511b603ef358f5843/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8eae5cd8e32b77eb831fbb46a36676fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'announcements')) === 'undefined') && !!(getObjectProperty(___arguments.context.pageData, 'announcements')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/984e2a28e63db3a68453ff794f68df03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.dataModel, 'read')) === 'string') && ((getObjectProperty(___arguments.context.dataModel, 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e76dd2cf23afcb977336e7ae69c2e423/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1c5529a18c276de5a74fec66241749b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q2Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/396350ff94ffb283fecee818981c9727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8ec186d9ea189f6782a2232bd55f0331/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q1Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('610b87d9d62c3981380e160738e5b513', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/502108db508b967541ba142e40a79b81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/474be277ed82933a3a1218dbea262757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['Q3Ans'] = '5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e95ad837344c077f54e653e90669906', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/a3ac1f9ed6db33d8afaab0d31f2a89eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'scheduling')) != 'scheduled')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/273aca3a2f47ec4254bd8974edbf5e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, LoggerName, _unused, studentContainerFuture, msStudentContainerPast, studentContainerPast, msHoursList, dash, hoursList, dash2;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/2bc7badc91dd24529b363d8ac0c1338a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c7ce06f475737eaf549e27facb992de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95aa2bbd6d0dfc7c16e9e1bedfa91e12', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73735b3f96389339d848a4f7a7c6e721', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/de26e0bacccc43811e337c2354ef780a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('MAX1-') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Extra') !== -1) {
    text = 'Was your student present?';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'slots_slug')).indexOf('Substitute') !== -1) {
    text = 'Was your student present?';
  } else {
    text = 'Were your students present?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/362d5467896a664a436ca45175ba9c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/346a274c03153293703e2f6cd9f3318f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd2632b82b3845e2411e775bca7ea8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da6883e2264e80f67deb0614823e3b2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ede45c3a5863b7f40fbb0133be91718', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45fd3b47a0b223a434073573b0be7f42', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7eee3ac869d012f50644c5ab069c995', false);
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['isPresent'] = false;
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReport'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' was absent today. Please let me know if there is something I can do to support you. Otherwise, I will be waiting for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74af280c2758c7decc57d9e21b64f37f'), 'student_name')),' in our next session.'].join(''));
  ___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3')['ProgressReportLength'] = (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dc849e36a231695622bcf856aa5b9e3'), 'ProgressReport'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/2ba2eb34a96cc8b30bda933b45ca376c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('984e2a28e63db3a68453ff794f68df03'))['background'] = '#D6F6CD';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['read'] = (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join(''));
    await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/BackendlessLoginAuthRestBlock`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`action`]: 'update',[`method`]: 'HR_Admin_Panel',[`databaseName`]: 'announcements',[`requestType`]: 'clientSide',[`query`]: ({ [`user-token`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LoginData')), 'user-token')) }),[`createObject`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'objectId')),[`read`]: !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.pageData, 'userName')) : [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')),',',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('') }) })));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')).indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px 0px 0px 2px #F5713C inset';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'Yes';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ba2eb34a96cc8b30bda933b45ca376c'))['box-shadow'] = '0px';
    ___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03')['announcementRead'] = 'No';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/dc5c3f24cb57a4539e2d77d9ac762071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) === 'string') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('984e2a28e63db3a68453ff794f68df03'), 'read')) : '').indexOf((getObjectProperty(___arguments.context.pageData, 'userName'))) !== -1)) {
    Value = 'No';
  } else {
    Value = 'Yes';
  }

  return Value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/6e11fc75c9b6e6382873be088a2e752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var show;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')) === null)) {
    show = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf())) {
    show = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutorType')).indexOf('Partner') !== -1);
  } else {
    show = false;
  }

  return show

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/39174bc3cdf5a7b64801e1be2dc610cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) == 0 ? '0' : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 100 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots')) < 10 ? ['0','0',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))].join('') : String('0') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'tutor_lifetime_slots'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/958b37f8fe89f72498d5e3e28c657cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('958b37f8fe89f72498d5e3e28c657cb7'))['fontWeight'] = 800;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/970b6c0790ab5e2533b198c248a7c47c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('970b6c0790ab5e2533b198c248a7c47c'))['fontWeight'] = 100;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/3fe3fff351e3b7f33663ec02d3fbb18f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports' || (typeof (getObjectProperty(___arguments.context.pageData, 'selector')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f7b151d3f20e3cc51195fba8032815af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'reports')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/d2d5947e69b973cd56a3d61e3b4b587f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var FormatToTeacherTimezone, FormatToUTC, list, localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'School Closed') {
    FormatToTeacherTimezone = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    FormatToUTC = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: 'Etc/GMT',[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')))).split(' ');
    localeDateString = [FormatToUTC[0],' ',FormatToUTC[1],' ',FormatToUTC[2],' ','00:00',' ',FormatToTeacherTimezone[4]].join('');
  } else {
    localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: 'short',[`day`]: '2-digit',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: 'short',[`weekday`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));
  }

  return localeDateString

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/fc5dd2dafd27503b990bdf0a7c412741/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var lateTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lateTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time')) + 1000 * 60 * 20;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'scheduled' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))) == false && lateTime <= ((new Date()).valueOf()) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'scheduled' && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/a8abf4e79a810da4c4e4394e3bd9a801/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1d22c0a3a68461359766a57431328907/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'scheduling')) == 'is_substituted')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b75e2b28827248f5a56e9f2753018984/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName'))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/85bd330ec0ef100ffb336893dd84761b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, NewData, TutorHours, ObjectIdToDelete, item, objectToDelete, Task, LeadHolder, LeadTask, CheckAssistantTeacher;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  console.log(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'));
  logger_name = 'cancelMSManualHour';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', true);
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
    ___arguments.context.pageData['payableHoursFilteredMS'] = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'slots_slug')) == 'Manual time') {
      if ((Number((getObjectProperty(___arguments.context.pageData, 'extraMSHours')))) != 0) {
        ___arguments.context.pageData['extraMSHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'extraMSHours')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'duration')));
      }
    } else if ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) != 0) {
      ___arguments.context.pageData['payableMSHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'duration')));
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('ms_calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) != 'Planning Time') {
    try {
      CheckAssistantTeacher = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).query(({ [`where`]: ['objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),'\''].join('') })).setEncoding('utf8').send())[0];
      if ((getObjectProperty(CheckAssistantTeacher, 'assistant_teacher')) === null) {
        NewData = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/699C3010-37C5-47FC-9AAE-5C73309071EA/data/ms_calendar')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')),[`scheduling`]: 'is_cancelled' })));
        ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772')['scheduling'] = (getObjectProperty(NewData, 'scheduling'));
      } else {
        await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'slots_slug')) == 'Manual time') {
        LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
           if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
          }


         return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
        }));
        Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' }));
      }
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'sessionStatus')) == 'MS MEETING' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'event_title')) == 'Planning Time') {
    try {
      await Backendless.Data.of('ms_calendar').deleteRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'calendarObjectId')), 'tutor_relations', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), 'tutorObjectId'))]);
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

    }
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.getComponentDataStoreByUid('16743e85acabdb8412cf535271f1f772'), '');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ab14a294b0dedd7f9bce20fa9867a106', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1377cb88cfcd1dff1f8c96830ac855d2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16743e85acabdb8412cf535271f1f772', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ad13b5c129c3720e61ec643f4b8f52d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b83298ed2753d53d622bdb5fbd6f0c8e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b62c065139737a347f7e7a27592589ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  ___arguments.context.pageData['MSExtraTimeList'] = [];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['show_add_hours'] = false;
    j['manualMSTimeHours'] = null;
    j['msDescription'] = null;
    j['approvalName'] = null;
  }
  ___arguments.context.pageData['card_no'] = 1;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/617aeeb949a1dac5eeb74c53a21fbf19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`weekday`]: 'short',[`year`]: 'numeric',[`day`]: '2-digit',[`month`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'startWeek2'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/c6a13b95bc64a2a1c73e0703e9aad3d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var SumOfHours, formatString, item, Description, Hour, j, OtherHours, SpecialProjects, ProgressReports, ShadowingHours, AdminHours, CurriculumDesign, HouseLeaderMeeting, MeetGreetMeeting, ExtraMeetings, OnboardingTraining, error, logger_name, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, manualTimeHours, eventTitle, event_title, manualTimeCategory, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, approvalName, _unused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3ed4eaf428e0738adc2fada706d1537', true);
  formatString = '';
  console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
  OnboardingTraining = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ExtraMeetings = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  MeetGreetMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  HouseLeaderMeeting = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  CurriculumDesign = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  AdminHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ShadowingHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  ProgressReports = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  SpecialProjects = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  OtherHours = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Onboarding Training (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OnboardingTraining.length) {
      for (var j_index in OnboardingTraining) {
        j = OnboardingTraining[j_index];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Onboarding Training (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Gradeband, Prep Time, PD Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ExtraMeetings.length) {
      for (var j_index2 in ExtraMeetings) {
        j = ExtraMeetings[j_index2];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Gradeband, Prep Time, PD Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Meet & Greets (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!MeetGreetMeeting.length) {
      for (var j_index3 in MeetGreetMeeting) {
        j = MeetGreetMeeting[j_index3];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',Hour / 0.5,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Meet & Greets (Microschool Only)','\n','Number of meet and greets: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'House Leader (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!HouseLeaderMeeting.length) {
      for (var j_index4 in HouseLeaderMeeting) {
        j = HouseLeaderMeeting[j_index4];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['House Leader (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Curriculum Design (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!CurriculumDesign.length) {
      for (var j_index5 in CurriculumDesign) {
        j = CurriculumDesign[j_index5];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Curriculum Design (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Admin Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!AdminHours.length) {
      for (var j_index6 in AdminHours) {
        j = AdminHours[j_index6];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Admin Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Shadowing Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ShadowingHours.length) {
      for (var j_index7 in ShadowingHours) {
        j = ShadowingHours[j_index7];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Shadowing Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Progress Reports (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!ProgressReports.length) {
      for (var j_index8 in ProgressReports) {
        j = ProgressReports[j_index8];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Progress Reports (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Special Projects (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!SpecialProjects.length) {
      for (var j_index9 in SpecialProjects) {
        j = SpecialProjects[j_index9];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Special Projects (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'card_name')) == 'Other Hours (Microschool Only)');
  })).length > 0) {
    Hour = 0;
    Description = '';
    if (!!OtherHours.length) {
      for (var j_index10 in OtherHours) {
        j = OtherHours[j_index10];
        Hour = (typeof Hour == 'number' ? Hour : 0) + (Number((getObjectProperty(j, 'manualMSTimeHours'))));
        if (getValueLength(Description) != 0) {
          Description = String(Description) + String(', ');
        }
        Description = String(Description) + String(getObjectProperty(j, 'msDescription'));
      }
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',Hour,'\n','Description: ',Description].join(''));
    } else {
      if (getValueLength(formatString) != 0) {
        formatString = String(formatString) + String('\n\n');
      }
      formatString = String(formatString) + String(['Other Hours (Microschool Only)','\n','Hours: ',0,'\n','Description: ','N/A'].join(''));
    }
  }
  SumOfHours = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')).map(async item => {; return (getObjectProperty(item, 'manualMSTimeHours'));}))).reduce(function(x, y) {return x + y;});
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatExtraTime'] = (SumOfHours == 0 ? '' : formatString);
  ___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d')['formatNoExtraTime'] = (SumOfHours == 0 ? 'No Extra Hours Added' : 'Review Extra Hours');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e6dcc3e1e7e4dd1a21f57ef92ecf7065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
    (function (message) { alert(message) })('There\'s no Microschool session to submit.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) == false) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ca3280537e60abefc51f52f46d2c4da')));
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var totalHours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  totalHours = (getObjectProperty(___arguments.context.pageData, 'payableMSHours')) + (getObjectProperty(___arguments.context.pageData, 'extraMSHours'));

  return (['Submit ',totalHours,totalHours > 1 || totalHours == 0 ? ' hours' : ' hour'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e41ae3499aa1023b7a456117a80b89ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Manual time has been added to the period starting ',((new Date((getObjectProperty(___arguments.context.pageData, 'startWeek')))).toDateString()),'. \nAt the end of the week, submit your hours for payment. ','. \nTo modify manual time before then, click the bin icon.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/94a25aee66288cb122f76b6b70948052/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'sessionStatus')) == 'MS MEETING' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'School Closed' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) : (await BackendlessUI.Functions.Custom['fn_20be5f297d6e7011d3eb8aacdd98716c']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')))).toUpperCase()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b2eda5d4da066dd2ed267037f345e274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFiltered'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/166f6de4ebe7c54f3fd9c3ab22d9b6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/0284b7b24a821e9cdb5b0b62a8ce04a9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc5dd2dafd27503b990bdf0a7c412741')), 'display')) == false && ((getObjectProperty(___arguments.context.dataModel, 'toBePaid')) == true || (!!(getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).length || !(typeof (getObjectProperty(___arguments.context.dataModel, 'toBePaidList')) === 'undefined')) && ((getObjectProperty(___arguments.context.dataModel, 'toBePaidList')).includes((getObjectProperty(___arguments.context.pageData, 'userName')))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#C1E1C1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'scheduling')) != 'scheduled') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#F1E8E7';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0284b7b24a821e9cdb5b0b62a8ce04a9'))['background'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8f1dddc1ed6b68b74c36bbf9ea6cb832/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/9f09749e2f5815afcd4b1bd3294c8a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f09749e2f5815afcd4b1bd3294c8a4e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/d1c1a9931ef7177cfcc1a49fa16b13f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d1c1a9931ef7177cfcc1a49fa16b13f6')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/887e6454024682c30a5f7e27755c472d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e5d7397d645689137cabd81d8d56d322/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  console.log(___arguments.value);
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5d7397d645689137cabd81d8d56d322')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/67d1b072060be60825b175a30b6c656e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
      return null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/a03846b3716b0d7b7292135aa3644e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03846b3716b0d7b7292135aa3644e1e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/401aed0df3ca1a2b60919fbe4d451a09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('401aed0df3ca1a2b60919fbe4d451a09')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/23bd7218dffe31de83fdef3e47facf37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23bd7218dffe31de83fdef3e47facf37')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/34f2b281028902c1f38a4af22386fdc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34f2b281028902c1f38a4af22386fdc8')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cb42845742231adaf8b7fbbbf49217b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/54ae53f554d761b89e65dd07c6e2469d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('54ae53f554d761b89e65dd07c6e2469d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/986513bd2dd43a1ed6e86a2ff4d1a5be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('986513bd2dd43a1ed6e86a2ff4d1a5be')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/2829d02674bea67c6e73c35550394e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2829d02674bea67c6e73c35550394e16')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e09301622cad56dce201c733ae5d579a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    ___arguments.context.pageData['FScoreRaw'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e09301622cad56dce201c733ae5d579a')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/09d624d5c24ea221fdc288d8f074fc4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09d624d5c24ea221fdc288d8f074fc4b')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f5e442d2527d7b0d002b8c05f7a28034/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f5e442d2527d7b0d002b8c05f7a28034')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ee02a47b3d4dc49cbdcd4edfd068e61d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee02a47b3d4dc49cbdcd4edfd068e61d')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/9249997aa4c292a2f86be59f9cb11e83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9249997aa4c292a2f86be59f9cb11e83')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ed614d4ff047eb6a345a4e77b4dfd103/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed614d4ff047eb6a345a4e77b4dfd103')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/c53dff2850ec4ad6d6d9ab21f3aae558/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q2answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c53dff2850ec4ad6d6d9ab21f3aae558')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e73b9d72e48f95fc19669463d31eca01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e73b9d72e48f95fc19669463d31eca01')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/bf0ba5be04ac101781d6bf8eea7168bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q3answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf0ba5be04ac101781d6bf8eea7168bb')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/595fafa6a32ea512de22bd0df4485d21/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q5answer'] = [];
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q8answer'] = '';
  ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q9answer'] = '';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/7ddac0256742e8f9124be8d5e157bb02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ddac0256742e8f9124be8d5e157bb02')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/42784913cf23a393b76fe0a91f9b136c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q4answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42784913cf23a393b76fe0a91f9b136c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/c9c32de38c2dc088b69ddc9f69060a3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9c32de38c2dc088b69ddc9f69060a3e')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/5777f4435b3fc6eb3c3a045582e23d28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q6answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5777f4435b3fc6eb3c3a045582e23d28')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/09ce8b8e77b3d1b97265676a9082e899/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09ce8b8e77b3d1b97265676a9082e899')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/4b5c353f46d55f0892b33bbb74ceeb9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q7answer'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b5c353f46d55f0892b33bbb74ceeb9c')), 'el')), 'outerText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b3799dfeeb9796763c26ed41b22b5b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/7229ee6cecd4e7c44a9dbb6df89f2495/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length <= 50) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/2a32c8295622fcf5b005d0cb18bb6be4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q8answer')).length > 10)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/4cad321c51d3617e153bbba3013b0bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q9answer')).length > 50)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/dc8279e1eda851cc253f437e15af79d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, _unused, FL_Score, logger_name, LoggingStatus, durationPayable, j, PseudoCreatedTimestamp, studentEvent, calendarListRaw, studentContainerPosition, studentContainer, calendarListRawPosition, calendarEvent, studentContainerIds, item, CheckIfThere;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', false);
  if (true) {
    logger_name = 'Submit MS Hours Button';
    LoggingStatus = false;
    try {
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Show loading spinner',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', true);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#EBEBE4';

    } catch (error) {
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the start sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
      for (var studentEvent_index in studentContainer) {
        studentEvent = studentContainer[studentEvent_index];
        CheckIfThere = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')), async (item) => {


         return ((getObjectProperty(item, 'calendarObjectId')) == (getObjectProperty(studentEvent, 'calendarObjectId')));
        }));
        if (!CheckIfThere.length) {
          continue;
        }
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          studentEvent['toBePaid'] = true;
        }
      }
      ___arguments.context.pageData['msStudentContainer'] = studentContainer;
      studentContainerIds = (await Promise.all(studentContainer.map(async item => {; return (getObjectProperty(item, 'calendarObjectId'));})));
      console.log(studentContainerIds);
      calendarListRaw = (getObjectProperty(___arguments.context.pageData, 'calendarMSListRaw'));
      for (var calendarEvent_index in calendarListRaw) {
        calendarEvent = calendarListRaw[calendarEvent_index];
        studentContainerPosition = studentContainerIds.indexOf(getObjectProperty(calendarEvent, 'calendarObjectId')) + 1;
        console.log('studentContainerPosition');
        console.log(studentContainerPosition);
        calendarListRawPosition = calendarListRaw.indexOf(calendarEvent) + 1;
        if (studentContainerPosition > 0) {
          calendarListRaw[(calendarListRawPosition - 1)] = studentContainer[(studentContainerPosition - 1)];
        }
      }
      ___arguments.context.pageData['calendarMSListRaw'] = calendarListRaw;
      await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Updated the object in the raw list - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in updating the object in the rawlist - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      var studentEvent_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      for (var studentEvent_index2 in studentEvent_list) {
        studentEvent = studentEvent_list[studentEvent_index2];
        if ((getObjectProperty(studentEvent, 'scheduling')) == 'scheduled') {
          if (typeof (getObjectProperty(studentEvent, 'toBePaidList')) === 'undefined') {
            studentEvent['toBePaidList'] = [];
          }
          addItemToList((getObjectProperty(studentEvent, 'toBePaidList')), (getObjectProperty(___arguments.context.pageData, 'userName')));
          studentEvent['toBePaid'] = true;
        }
      }
      await new Promise(r => setTimeout(r, 1000 || 0));
      console.log('payable hours');
      console.log(getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
      if ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length == 0) {
        (function (message) { alert(message) })('You have no hours to be submitted');
      } else {
        PseudoCreatedTimestamp = ((new Date((String(((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) + String(' GMT+0')))).valueOf());
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/msHours`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`submittedHours`]: (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')),[`tutorService`]: 'MS',[`MSAnswer`]: ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'),[`TutorName`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`msQuestioner`]: (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')),[`PseudoCreatedTimestamp`]: PseudoCreatedTimestamp,[`CreatedTimestamp`]: (((new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: true,[`month`]: 'long',[`day`]: '2-digit',[`year`]: 'numeric',[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'DateToday')))).replace((new RegExp(' at ', 'g')), ' ')).replace((new RegExp('24:', 'g')), '00:')) })));

        })();
        await new Promise(r => setTimeout(r, 250 || 0));
        ___arguments.context.pageData['hoursMSStatusValue'] = 'Submitted!';
        durationPayable = 0;
        var j_list = (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          durationPayable = (typeof durationPayable == 'number' ? durationPayable : 0) + (getObjectProperty(j, 'duration'));
        }
        ___arguments.context.pageData['submittedMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'submittedMSHours')) + durationPayable);
        ___arguments.context.pageData['payableHoursFilteredMS'] = [];
        ___arguments.context.pageData['payableMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).length);
        await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Submitted the hours - Success',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), 'INFO', LoggingStatus);
      }

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in submitting the hours - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      ___arguments.context.pageData['extraMSHours'] = 0;
      ___arguments.context.pageData['msQuestionnaire'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8ac777b8772affc6e2ce2032e938bc1', true);
      await new Promise(r => setTimeout(r, 5000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('595fafa6a32ea512de22bd0df4485d21', false);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['disabled'] = false;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc8279e1eda851cc253f437e15af79d4'))['background'] = '#0a1352';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);

    } catch (error) {
      console.log(error);
      _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (['There was an error in the end sequence - Error / ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'userName'))].join('')), error));
      (function (message) { alert(message) })('Error encountered while submitting hours');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28c4759b6de95e32791be26fe8829dae', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bc1f563beafcf19cb1279dae05c4df5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('920459fd2fbd2d44c90c7dbfcb622d9e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc8279e1eda851cc253f437e15af79d4', true);
      return null;

    }
    try {
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'FScoreRaw')) === 'undefined')) {
        FL_Score = (Number((getObjectProperty(___arguments.context.pageData, 'FScoreRaw'))));
        console.log(String('Feeling Score: ') + String(FL_Score));
        if ((typeof FL_Score === 'number' && !isNaN(FL_Score)) && FL_Score <= 6) {
          _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/Low_Feeling_Score_Tutor`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`score`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q1answer')) }))));
        } else {
        }
      }
      FL_Score = 0;

    } catch (error) {
      console.log(error);

    }
    try {
      if (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')).length) {
        _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/HR_Recruiting/One_on_One_App_Training`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`AppList`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')) }))));
      }

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e2eb6cc9b2f36415c472018c6c9ddf3c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2eb6cc9b2f36415c472018c6c9ddf3c')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/601f5118947dd9e3f09faf4c5321da6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('601f5118947dd9e3f09faf4c5321da6d')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/d4947e4eab7b5685ef33742d5872fe9f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4947e4eab7b5685ef33742d5872fe9f')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b532bb949a0a6a0220fbdcae9b8dbc62/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b532bb949a0a6a0220fbdcae9b8dbc62')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/2cdb27d75f9340271127dca71053ab35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cdb27d75f9340271127dca71053ab35')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/38bf97e56321eb774eae6fa844e4329e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1899137b4cdf7af97763cfc709761c86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c4f3e7aee38d48fee915ed6018d4bc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ae044db4641eccaf4aa2da0b15a9480b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1a073794f27789130524b8fc60fa7c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb76ead29a1bd57ed647607ec33425db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97d32fb19b379f8379d9be4493e3f6c1', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1c2e819947b9ef743a531af229225184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/99527bf533d14ad7ce42d6fdd32a1c1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26a2d878adff04db164f176f814a378', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/26a5ef11960ccfbaaeafd4bb03f812d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5b64b5dd32a3551d50788d7e38b0116', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/524374174fbfeb5c471ea1c8b9eda934/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2a5eb9da7616683ecf277eafd2e7192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/920459fd2fbd2d44c90c7dbfcb622d9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e10421556f0dc75ece5113c336ec2b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f6597e1aeb3c49b22ddb7cc01bcb66d', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) != true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/204a99b4d8eca6c814ea9d02a16df748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var localeDateString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  localeDateString = (new Intl.DateTimeFormat('en', ({ [`timeZone`]: (getObjectProperty(___arguments.context.pageData, 'iana')),[`dateStyle`]: undefined,[`timeStyle`]: undefined,[`hour12`]: false,[`month`]: undefined,[`day`]: undefined,[`hour`]: '2-digit',[`minute`]: '2-digit',[`timeZoneName`]: undefined,[`weekday`]: undefined })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'start_time'))));

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split('#')[0] : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')).startsWith('MAX')) ? ['Your ',localeDateString,' ',textToTitleCase(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).replace((new RegExp('MS_', '')), '')).replace((new RegExp('_', 'g')), ' ')),' School class'].join('') : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug'))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'student_list')).length) {
    return null;
  }
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12fe332cac06910a7c6d4801efd2981b')), 'display')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', false);
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12fe332cac06910a7c6d4801efd2981b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8c6c6704422db291a4d470567b594934/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('12fe332cac06910a7c6d4801efd2981b'), 'student_list'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/03538403f3f7afc497a253c1c8d5c022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'currentTime'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1617628cbcbc4abb0e34a28bccf8cb2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'payableHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/44cfadd5fcfe1efe234e0e52929ed598/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'submittedHours'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/5f999f1b796766cac0a891d51d1bae4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your questionnaire form for this week! You can submit your remaining hour.';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/6b6a055f8ace72c3c9a8ff4d0e42af3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'msQuestionnaire')) {
    content2 = 'You already submitted your answer for questionnaire this week! You can submit your remaining hours now!';
  } else {
    content2 = 'Thank you for taking your time to complete everything.';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/eb562517050d0e24f5c230c12475f8b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'slots_slug')) == 'Manual time' ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),' hour(s)','<br/>',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'event_title')).split((new RegExp('#\\d\\d\\d\\d-', '')), )).slice(-1)[0]].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/9ca3280537e60abefc51f52f46d2c4da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging' && (getObjectProperty(___arguments.context.pageData, 'selector')) == 'reports')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoggerName, _unused, msHoursList, returnData, hoursList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    LoggerName = 'UI / Tutor Dash Page / refreshBlock';
    ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
    ___arguments.context.pageData['dowTS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      ___arguments.context.pageData['dowMS'] = (getObjectProperty(___arguments.context.pageData, 'todayNumber'));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](LoggerName, (String('Error encountered while refreshing containers / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/00b276c2b0c5baaa9282670dd683dc65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0f9799bb7a041107bf1bb6cce434486f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/410f28513c7e12343ef1d956e9f6a294/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', true);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    console.log(getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList'));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'card_no')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: 0,[`msDescription`]: 'N/A',[`approvalName`]: 'N/A',[`card_name`]: (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'card_name')) }));
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) >= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) < ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f885dc8d25c417286c1e1bfd663a8848/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 <= 1) {
    ___arguments.context.pageData['card_no'] = 1;
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1 > 1) {
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) == 1)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'card_no')) != 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/58d98c73120a88eac77b66836906df47/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var GetCurrentRepeater, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  GetCurrentRepeater = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) == 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '450px';
  } else if ((getObjectProperty(GetCurrentRepeater, 'card_name')) != 'Other Hours (Microschool Only)' && (getObjectProperty(GetCurrentRepeater, 'show_add_hours')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '400px';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))['height'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b83298ed2753d53d622bdb5fbd6f0c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'UUID'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b83298ed2753d53d622bdb5fbd6f0c8e'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/97eeff3b29311305a4e5e5fb2b65fb82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('58d98c73120a88eac77b66836906df47'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/bdcca712e5096c7193feabd5cbd6a52d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item, CheckHouseLeader, CreateSubjectList, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'houseLeader')) === 'undefined') {
    return null;
  }
  CheckHouseLeader = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'houseLeader')), async (item) => {


   return (item == (getObjectProperty(___arguments.context.pageData, 'userName')));
  }));
  CreateSubjectList = (getObjectProperty(___arguments.context.pageData, 'tutorSubjects')).split(',');
  if (((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'msStudentContainer')) === 'undefined')) {
    ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    return null;
  }
  if (!!CheckHouseLeader.length) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  } else {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), async (item) => {


     return ((getObjectProperty(item, 'sessionStatus')) == 'MS SESSION' && (getObjectProperty(item, 'slots_slug')) != 'Manual time');
    })).length) {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    } else {
      ___arguments.context.dataModel['records'] = [({ [`UUID`]: (generateUUID().short()),[`number`]: 1,[`card_name`]: 'Gradeband, Prep Time, PD Hours (Microschool Only)',[`card_instruction`]: 'Use this card to add your 1hr Prep time, the Gradeband Meeting and/or the PD Meeting. Proceed?',[`card_instruction2`]: '',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 2,[`card_name`]: 'Meet & Greets (Microschool Only)',[`card_instruction`]: 'Were there any Meet & Greets scheduled for the week?',[`card_instruction2`]: 'If so, please specify the number of hours (1 session equals 0.5 hours) and provide a brief description for each session, including the name of the parent and student involved.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false }), ({ [`UUID`]: (generateUUID().short()),[`number`]: 3,[`card_name`]: 'Other Hours (Microschool Only)',[`card_instruction`]: 'Have you worked on any projects that do not fit into the previous categories?',[`card_instruction2`]: 'If so, please specify the number of hours allocated and provide a description.',[`card_instruction3`]: '',[`card_warning`]: '',[`card_warning1`]: '',[`show_add_hours`]: false })];
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/4a9fc23dae555ebd728bbfe169bdf0c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, records, GetCurrentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  records = [];
  GetCurrentData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(GetCurrentData, 'card_name')) == (getObjectProperty(j, 'card_name'))) {
      j['show_add_hours'] = true;
    } else {
      addItemToList(records, j);
    }
  }
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f7bafd0b847e466d2b27a647b6ecf16d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, error, logger_name, _unused, approvalName, manualTimeCategory, event_title, manualTimeHours, LoggingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', false);
    logger_name = 'Adding Manual hours to list';
    LoggingStatus = false;
    manualTimeCategory = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name'));
    manualTimeHours = (Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours'))));
    event_title = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription'));
    approvalName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', true);
    if (!(typeof manualTimeHours === 'number' && !isNaN(manualTimeHours)) || manualTimeHours <= 0) {
      (function (message) { alert(message) })('Hours need to be a positive number');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (manualTimeHours % 0.5 != 0) {
      (function (message) { alert(message) })('Hours need to be 0.5, 1, 1.5, 2, 2.5, and so on.');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof manualTimeCategory === 'string')) {
      (function (message) { alert(message) })('Please choose a category');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(typeof event_title === 'string')) {
      (function (message) { alert(message) })('Please add a short description');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if (!(event_title.length > 10 && event_title.length < 500)) {
      (function (message) { alert(message) })('Please keep your description between 10 to 500 characters');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }
    if ((manualTimeCategory == 'Curriculum Design (Microschool Only)' || manualTimeCategory == 'Special Projects (Microschool Only)' || manualTimeCategory == 'Other Hours (Microschool Only)') && !(typeof approvalName === 'string')) {
      (function (message) { alert(message) })('Please add an Approval Name');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7bafd0b847e466d2b27a647b6ecf16d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
      return null;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered during the process for ') + String(getObjectProperty(___arguments.context.pageData, 'userName'))), error));

  }
  if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 > ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1 <= ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47')).length) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), ({ [`manualMSTimeHours`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'manualMSTimeHours')),[`msDescription`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'msDescription')),[`approvalName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'approvalName')),[`card_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) }));
    ___arguments.context.pageData['card_no'] = ((getObjectProperty(___arguments.context.pageData, 'card_no')) + 1);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cff178789d93cb63d2f64d67d7e253f', false);
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['show_add_hours'] = false;
      j['manualMSTimeHours'] = null;
      j['msDescription'] = null;
      j['approvalName'] = null;
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('58d98c73120a88eac77b66836906df47'))[((getObjectProperty(___arguments.context.pageData, 'card_no')) - 1)]), 'UUID')))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/39745d989538c85beed89f66cd65143c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, msHoursList, returnData, hoursList, resultMsg, LoggingStatus, uniqueSlots, pendingHours, payableHours, studentContainer, isSuccessful, eventTitle, j, item, LeadHolder, LeadTask, extraTime, extraHours, CalendarObject, TodayNumber, tutorObject, FormatMSExtraTime, event_title, manualTimeCategory, manualTimeHours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  resultMsg = String('Extra hours added successfully!') + String((getObjectProperty(___arguments.context.pageData, 'dowMS')) < 3 ? ' You can find them in the FUTURE sessions tab.' : ' You can find them in the PAST sessions tab.');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd955a1720296708a4c5aa9efec33999', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d98c73120a88eac77b66836906df47', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('170d7a6794ad749936597f7b3e9cf946', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6a13b95bc64a2a1c73e0703e9aad3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39745d989538c85beed89f66cd65143c', false);
  logger_name = 'tutor_dash_submitMSManualHours';
  LoggingStatus = true;
  FormatMSExtraTime = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'MSExtraTimeList')), async (item) => {


   return ((getObjectProperty(item, 'manualMSTimeHours')) > 0);
  }));
  if (!FormatMSExtraTime.length) {
    return null;
  }
  TodayNumber = 0;
  studentContainer = (getObjectProperty(___arguments.context.pageData, 'msStudentContainer'));
  extraHours = [];
  tutorObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: ['name = \'',((getObjectProperty(___arguments.context.pageData, 'userName')).replace((new RegExp('\'', '')), '\'\'')),'\''].join(''),[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
  if (false) {
  } else {
    for (var j_index in FormatMSExtraTime) {
      j = FormatMSExtraTime[j_index];
      try {
        eventTitle = [(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],'#',subsequenceFromEndFromEnd((JSON.stringify((((new Date()).valueOf()) - TodayNumber * 86400000))), 4, 1),'-',(getObjectProperty(j, 'msDescription'))].join('');
        CalendarObject = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/FrontendSaveMSCalendar`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`toBePaid`]: false,[`Description`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_date`]: (new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))),[`event_title`]: eventTitle,[`status`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`approvalName`]: (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Curriculum Design' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Special Projects' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Other Hours' ? (getObjectProperty(j, 'approvalName')) : null }))));
        extraTime = ({ [`tutorObjectId`]: (getObjectProperty(tutorObject, 'objectId')),[`toBePaid`]: false,[`slots_slug`]: 'Manual time',[`tutor`]: (getObjectProperty(___arguments.context.pageData, 'userName')),[`scheduling`]: 'scheduled',[`start_time`]: ((new Date((new Date()).getTime() - ((TodayNumber * 86400) * 1000))).valueOf()),[`event_title`]: eventTitle,[`sessionStatus`]: 'MS SESSION',[`duration`]: (Number((getObjectProperty(j, 'manualMSTimeHours')))),[`calendarObjectId`]: (getObjectProperty(CalendarObject, 'objectId')),[`student_list`]: [],[`toBePaidList`]: [] });
        addItemToList(extraHours, extraTime);
        ___arguments.context.pageData['extraMSHours'] = ((getObjectProperty(___arguments.context.pageData, 'extraMSHours')) + (getObjectProperty(extraTime, 'duration')));
        studentContainer.push(extraTime);
        (getObjectProperty(___arguments.context.pageData, 'payableHoursFilteredMS')).push(extraTime);
        await new Promise(r => setTimeout(r, 50 || 0));
        ___arguments.context.pageData['msStudentContainer'] = (await asyncListSort(studentContainer, 1, async (item) => {


         return (getObjectProperty(item, 'start_time'));
        }));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));
        resultMsg = 'Error encountered at Save object to calendar db';

      }
      try {
        LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' added ',(getObjectProperty(j, 'manualMSTimeHours')),(Number((getObjectProperty(j, 'manualMSTimeHours')))) == 1 ? ' manual hour ' : ' manual hours ',', Reason code: ',(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0],', ',(getObjectProperty(j, 'msDescription')),', ',eventTitle.split('-')[0].split('#').slice(-1)[0],(getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Curriculum Design' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Special Projects' || (getObjectProperty(j, 'card_name')).split(' (Microschool Only)')[0] == 'Other Hours' ? String(', Approved by: ') + String(getObjectProperty(j, 'approvalName')) : ''].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_oXgczYo8xB8vEIJ8or9pj9WgiOnwnJgUJuHciefU9RH' });
        ___arguments.context.pageData['payableMSHours'] = (Number((getObjectProperty(___arguments.context.pageData, 'payableMSHours'))));

      } catch (error) {
        console.log(error);
        Backendless.Logging.getLogger('tutor_dash_submitMSManualHours').error(((error !== null && !Array.isArray(error) && (typeof error === 'object')) ? (JSON.stringify(error)) : error));
        isSuccessful = false;
        resultMsg = 'Error encountered at Task creation';

      }
    }
    console.log('here');
    ___arguments.context.pageData['MSExtraTimeList'] = [];
    ___arguments.context.pageData['card_no'] = 1;
    ___arguments.context.pageData['msCalendarListRaw'] = studentContainer;
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Added Manual Hours to UI - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    payableHours = [];
    pendingHours = [];
    uniqueSlots = [];
    await BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'](logger_name, (['Recounted payable & pending hours - Success / Tutor: ',' / Tutor: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')), 'INFO', LoggingStatus);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a480ae62e306a535eeaf66a4e8e403', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd456c067cb674a5387d23bac966abc3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e6dcc3e1e7e4dd1a21f57ef92ecf7065', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcca712e5096c7193feabd5cbd6a52d', false);
  }
  console.log(___arguments.context.getComponentDataStoreByUid('bdcca712e5096c7193feabd5cbd6a52d'));
  (function (message) { alert(message) })(resultMsg);
  try {
    ___arguments.context.pageData['DateToday'] = ((new Date()).valueOf());
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, false, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`studentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`mondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`primarySessions`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'primarySessions')),[`startWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
    hoursList = (await BackendlessUI.Functions.Custom['fn_3521069f96c6b8ece43c6bd9a07ba2de']((getObjectProperty(___arguments.context.pageData, 'primarySessions')), ___arguments.context.pageData));
    returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](false, true, ___arguments.context.pageData));
    Object.assign(___arguments.context.pageData, ({ [`futureStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`studentsToday`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'studentsToday')),[`MessageLimit`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'MessageLimit')) }));
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      returnData = (await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, false, ___arguments.context.pageData));
      Object.assign(___arguments.context.pageData, ({ [`msStudentContainer`]: (getObjectProperty(returnData, 'sessions')),[`todayNumber`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'dayOfTheWeek')),[`msMondayTimestamp`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayTimestamp')),[`MondayThisWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayThisWeek')),[`MondayLastWeek`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'mondayLastWeek')),[`startWeek2`]: (getObjectProperty((getObjectProperty(returnData, 'additionalData')), 'startWeek')) }));
      msHoursList = (await BackendlessUI.Functions.Custom['fn_7fe619c987b8390c2af590e97037475a']((getObjectProperty(___arguments.context.pageData, 'msStudentContainer')), ___arguments.context.pageData));
      ___arguments.context.pageData['msFutureStudentContainer'] = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_86b47202747aa38f566615595cf46822'](true, true, ___arguments.context.pageData)), 'sessions'));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5ab4c5590b0d8cd22aa5b841badc3b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613e0e86e195f954003e19f4490d4eeb', false);

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, (String('Error encountered while refreshing containers / lead_id: ') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/10b4dd1e2ab552a169337fbcfa757772/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Curriculum Design (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Special Projects (Microschool Only)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b83298ed2753d53d622bdb5fbd6f0c8e'), 'card_name')) == 'Other Hours (Microschool Only)')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/61e494f398a8c43987fae7be42e96672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', true);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', true);
  await new Promise(r => setTimeout(r, 10 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edb59f2e49f5518df1c18cc541d37a9e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b4bce7ddd4ca41aeac3bfd56f1f1f43e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/edac5e8a6da9a7b4eba642e8e289ea77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', true);
    if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', true);
    await new Promise(r => setTimeout(r, 1 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f1dddc1ed6b68b74c36bbf9ea6cb832', true);

  } catch (error) {
    console.log('error at microschool-show-on');
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/9be21fae0eef29a7b8cd16674d3411fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
  if ((getObjectProperty(___arguments.context.pageData, 'selector')) != 'messaging') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/8dbead2f0339fe91688571fa545216dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments['tourState'], 'type')) == 'skip' || (getObjectProperty(___arguments['tourState'], 'type')) == 'tour:end' || (getObjectProperty(___arguments['tourState'], 'action')) == 'close') {
    await ( async function (componentUid, index) {  ___arguments.context.getComponentByUid(componentUid).goTo(index) })('8dbead2f0339fe91688571fa545216dc', 0);
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('979b25ea16d7f1b22e5c049340168f6b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b9675876032104e96f7c80f6b9cab96', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4bce7ddd4ca41aeac3bfd56f1f1f43e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e494f398a8c43987fae7be42e96672', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca02f3ee763cab0f6809927d761e5e3c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9163c01b96ce91ba7dc761715a3c559', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18e26f2c4ca4abd7ecb2b38b802e442c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b2cd69e36b2770ae745c5b9b0c66e54', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0cc26e4a61f3f5e1e6c0a78a29599d5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be21fae0eef29a7b8cd16674d3411fe', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', false);
    if (getObjectProperty(___arguments.context.pageData, 'hasBMS')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1a82f6a18367a2f6f4d441208ed4a9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edac5e8a6da9a7b4eba642e8e289ea77', true);
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8dbead2f0339fe91688571fa545216dc');
  }
  ___arguments.context.pageData['hasLoaded'] = true;

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TourGuideOptions'))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/0f4f2f61b94239ef4beae092ea8c3fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8dbead2f0339fe91688571fa545216dc'));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging' ? 'TUTORING - Here you can view your upcoming private sessions' : 'TUTORING - Here you can review and submit your private sessions')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/711d2aae60d3eb21eddd3f02d0be19f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/?page=Main_Page', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/a6c5ef2fdd0bd2bd831b680eb5918ef6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  GetTutorData = (await Backendless.UserService.getCurrentUser(false));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=tutor_sso','','','','',''].join('')), false, ({ [`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`fromPortal`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`email`]: (getObjectProperty(GetTutorData, 'email')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/1f360448c5246c7cc68704ada38198d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b369987b46aac3fba99d1988a3a3b29f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) == 'COTEACHING' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/71964ea6d526a89afe3c46c30376524f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  display = (await Backendless.UserService.isValidLogin()) && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tutorType')) == 'Microschool';

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b4f9d3a828224a463fb785ac1249d85e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')));
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q5answer')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4f9d3a828224a463fb785ac1249d85e')), 'label')), '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/fa09f342d838a30d9bde856d099665d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Class Duration: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'duration')),'h'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/55d95ee477bf968d8c1ae31445de508c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')) === null) ? null : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0284b7b24a821e9cdb5b0b62a8ce04a9'), 'subject')).indexOf('ESE') !== -1) ? 'ESE' : 'GENED'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/35d7a958121fbbd8c7a5b3a3f5acff0d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'submittedHours'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e25c40ca7bf7e3ff85efc315e5df783f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'submittedMSHours'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/cd03689f63f1814eacd114427e6e8139/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, logger_name, _unused, objectToDelete, Task, item, LeadHolder, LeadTask, studentContainer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  logger_name = 'deleteManualHour';
  try {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'payableHours2')), ___arguments.context.getComponentDataStoreByUid('9abceacc5bed5876e09f989a33d83bed'), '');
    studentContainer = (getObjectProperty(___arguments.context.pageData, 'studentContainer'));
    removeItemInList(studentContainer, ___arguments.context.getComponentDataStoreByUid('9abceacc5bed5876e09f989a33d83bed'), '');
    ___arguments.context.pageData['studentContainer'] = studentContainer;
    ___arguments.context.pageData['payableHours2'] = (getObjectProperty(___arguments.context.pageData, 'payableHours2'));
    if ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) != 0) {
      ___arguments.context.pageData['payableHours'] = ((Number((getObjectProperty(___arguments.context.pageData, 'payableHours')))) - 1);
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour in the app', error));

  }
  try {
    objectToDelete = (await Backendless.Data.of('calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['event_title = \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9abceacc5bed5876e09f989a33d83bed'), 'event_title')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
    LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'lead_id')))));
    if (!(objectToDelete !== null && !Array.isArray(objectToDelete) && (typeof objectToDelete === 'object'))) {
      return null;
    }
    if (!(LeadHolder !== null && !Array.isArray(LeadHolder) && (typeof LeadHolder === 'object'))) {
      return null;
    }
    if (!(typeof (getObjectProperty(objectToDelete, 'objectId')) === 'string')) {
      return null;
    }
    if ((getObjectProperty(objectToDelete, 'slots_slug')) != 'Manual time') {
      return null;
    }

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while getting manual hour to be delete from calendar DB', error));

  }
  try {
    await Backendless.Data.of('calendar').save( ({ [`scheduling`]: 'is_deleted',[`objectId`]: (getObjectProperty(objectToDelete, 'objectId')) }) );
    LeadTask = (await asyncListFilter((getObjectProperty(LeadHolder, 'tasks')), async (item) => {
       if ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1)) {
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskDeleteUi`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(item, 'id'))));
      }


     return ((getObjectProperty(item, 'is_complete')) == false && ((getObjectProperty(item, 'text')).indexOf('manual hour') !== -1) && ((getObjectProperty(item, 'text')).indexOf('added') !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#')[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('-').slice(-1)[0])) !== -1) && ((getObjectProperty(item, 'text')).indexOf(((getObjectProperty(objectToDelete, 'event_title')).split('#').slice(-1)[0].split('-')[0])) !== -1));
    }));
    Task = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'text': ([(getObjectProperty(___arguments.context.pageData, 'userName')),' removed ',' a ','manual hour',', Reason code: ',subsequenceFirstFromEnd((getObjectProperty(objectToDelete, 'event_title')).slice(0, ((getObjectProperty(objectToDelete, 'event_title')).indexOf('-') + 1) - 1), 5),', ',(getObjectProperty(objectToDelete, 'event_title'))].join('')),'date': ((new Date()).valueOf()),'is_complete': false,'assigned_to': 'user_3L0gg9cIHcped8UJj8eiZAgwRB7lF4DLpJLRUeGDrNo' }));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'](logger_name, 'Error while deleting manual hour from the calendar', error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/e22e8a2df3a6e667a61623ab19b5db47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9abceacc5bed5876e09f989a33d83bed', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/7b232a98944de94b6699782409517e77/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var isComplete;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isComplete = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) < ((new Date()).valueOf());
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11f45aa3e9a459f987a5058dd938e974', isComplete);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d43457eb75181be4f6b6c726fffaeae', (!isComplete));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/12b70fec6504de450c0da255355691c8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var isComplete;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isComplete = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'slots_slug')) == 'Mock Session';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('820270be67d64d464a98818ff8f39324', isComplete);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18c5c114225502a47e3c9f98228e873', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'homework_sent')) == false || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) == 0 ? isComplete : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'toBePaid')) == true ? false : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'lastHmwrk')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c382dc562077f3dc8158e63420bfc9d'), 'start_time')) - 86400000))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/bd27f88e163dc6d59d6ec131135dfb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    ___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d')['q1answer'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1abb4bea0742a2dbd851930825a91b7d'), 'q1answer')),' - ',(getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8cb44e6a1a433963c1cbe981ff6e20d')), 'el')), 'value'))].join(''));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cde06549f3ad3213fd8e079c3e414f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d06e60b10ecb20952513d4d9e9ab904', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/b8cb44e6a1a433963c1cbe981ff6e20d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd27f88e163dc6d59d6ec131135dfb4f', (getValueLength(___arguments.value) > 10));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/94e167dff2636b31875deccb8b5dba86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/4bfcdf5346279e4629740d933a2d0dce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParam = ({  });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParam['fromAP'] = (getObjectProperty(___arguments.context.pageData, 'fromAP'));
      urlParam['fromDashboard'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParam['fromSA'] = (getObjectProperty(___arguments.context.pageData, 'fromAP'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/6c25abc61e44caa4676a35e740e11715/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')),[`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/ec968a07d84761b209e54436b188956c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/f025db93b28eea7cacc558cfeb4d72a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selector')) == 'messaging' ? 'MICROSCHOOL - Here you can view your upcoming Microschool Classes' : 'MICROSCHOOL - Here you can review and submit your Microschool Classes')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_dash_refactoring_austin/components/d90beb9afbca0f8e56214252140f2aed/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hasBMS')) ? 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/images/bms-logo.png' : 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/images/logo_name.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/tutor_ticketing/components/aa5ec6b26959789632aa6b9734128439/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, submitConfirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16772a6713f35fd9fa95e8c3169324b5', true);
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'ticket_title')) === 'string')) {
        (function (message) { alert(message) })('Title cannot be blank');
        return null;
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'issueReason')) === 'string')) {
        (function (message) { alert(message) })('Issue description cannot be blank');
        return null;
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'issueType')) === 'string')) {
        (function (message) { alert(message) })('Type of issue cannot be blank');
        return null;
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'priorityLevel')) === 'string')) {
        (function (message) { alert(message) })('Priority level cannot be blank');
        return null;
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'department')) === 'string')) {
        (function (message) { alert(message) })('Department cannot be blank');
        return null;
      }
      submitConfirmation = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_14_TICKETING_SYSTEM/ticketing_tutor_dash_v2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`issueReason`]: (getObjectProperty(___arguments.context.pageData, 'issueReason')),[`issueType`]: (getObjectProperty(___arguments.context.pageData, 'issueType')),[`priorityLevel`]: (getObjectProperty(___arguments.context.pageData, 'priorityLevel')),[`screenshots`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('69bae8285aaf95fdf495403165d5bc6c')),[`tutor`]: (([(getObjectProperty(___arguments.context.pageData, 'firstname')),' ',(getObjectProperty(___arguments.context.pageData, 'lastname'))].join('')).replace((new RegExp('\'', 'g')), '\'\'')),[`department`]: (getObjectProperty(___arguments.context.pageData, 'department')),[`title`]: (getObjectProperty(___arguments.context.pageData, 'ticket_title')) }))));
      console.log(submitConfirmation);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16772a6713f35fd9fa95e8c3169324b5', false);
      if (submitConfirmation == 'Success') {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da742fed29715d384c56aead0ee1478a', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91595c0f4d97c454d103d02c9139fc4e', false);
        ___arguments.context.pageData['issueReason'] = '';
        ___arguments.context.pageData['issueType'] = '';
        ___arguments.context.pageData['priorityLevel'] = '';
        ___arguments.context.pageData['department'] = '';
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('69bae8285aaf95fdf495403165d5bc6c', []);
        await new Promise(r => setTimeout(r, 5000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da742fed29715d384c56aead0ee1478a', false);
      } else if (submitConfirmation == 'Error') {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91595c0f4d97c454d103d02c9139fc4e', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da742fed29715d384c56aead0ee1478a', false);
        await new Promise(r => setTimeout(r, 5000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91595c0f4d97c454d103d02c9139fc4e', false);
      }
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_ticketing/components/fb3afafa6784a8c31452d5214d4b89f3/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('69bae8285aaf95fdf495403165d5bc6c')).length) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('69bae8285aaf95fdf495403165d5bc6c', [___arguments.uploadedFiles]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9a31cc361c07b18422e39b917a769084', true);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fb3afafa6784a8c31452d5214d4b89f3');
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9a31cc361c07b18422e39b917a769084', false);
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('69bae8285aaf95fdf495403165d5bc6c')).length < 2) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('69bae8285aaf95fdf495403165d5bc6c')), ___arguments.uploadedFiles);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9a31cc361c07b18422e39b917a769084', true);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('fb3afafa6784a8c31452d5214d4b89f3');
    await new Promise(r => setTimeout(r, 5000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9a31cc361c07b18422e39b917a769084', false);
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('69bae8285aaf95fdf495403165d5bc6c')).length >= 2) {
    (function (message) { alert(message) })('Please keep each ticket to 2 attachments. You can send a second ticket to include additional attachments. Thank you.');
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('078ceadcdb9d87d1d255088cdb02149c', true);

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/tutor_ticketing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var parameter, parameterList, utmValue, utmName, answeredQuestion, parameters, url;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  url = ((function () { return window.location.href })());
  if (url.indexOf('#') !== -1) {
    parameters = url.slice(((url.indexOf('#') + 1 + 1) - 1), url.length);
    parameterList = (await Promise.all((parameters.split('&')).map(async answeredQuestion => {  utmName = answeredQuestion.slice(0, (answeredQuestion.indexOf('=') + 1) - 1);
      utmValue = answeredQuestion.slice(((answeredQuestion.indexOf('=') + 1 + 1) - 1), answeredQuestion.length);
    ; return ({ 'utmName': utmName,'utmValue': utmValue });})));
    for (var parameter_index in parameterList) {
      parameter = parameterList[parameter_index];
      ___arguments.context.pageData[(getObjectProperty(parameter, 'utmName'))] = (getObjectProperty(parameter, 'utmValue'));
    }
    console.log(___arguments.context.pageData);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/tutor_ticketing/components/42ebcdbb63f86ad86b538a2eeb0e4468/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);

  },
  /* handler:onClick */
  /* content */
}))

